(function() {
  'use strict';

  angular.module('Education', [ 'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'pascalprecht.translate', 'datatables',
      'multipleSelect', 'angularFileUpload', 'angulartics.google.analytics', 'angular-progress-button-styles', 'ngMaterial', 'dn.sha', 'ui.select' ]);

})();

(function() {
  'use strict';

  angular.module('Education').controller('SynergisticTeamsSynteamController', SynergisticTeamsSynteamController);

  /** @ngInject */
  function SynergisticTeamsSynteamController(serverService, $log, $q, $scope) {

    var vm = this;

    vm.studentsPerTeam = 2;
    vm.personalityQuestionnaire = null;
    vm.personalityTestStatus = []
    vm.competenceQuestionnaire = null;
    vm.competenceTestStatus = []
    vm.assignment = null;
    

    vm.personalityQuestionnaires = [];
    vm.loadingPersonalityQuestionnaires = true;
    serverService.getPersonalityQuestionnaires().then(function(data) {

      serverService.addAllModelsTo(data, vm.personalityQuestionnaires);
      if (vm.personalityQuestionnaires.length == 1) {

        vm.personalityQuestionnaire = vm.personalityQuestionnaires[0];

      }
      vm.loadingPersonalityQuestionnaires = false;

    }, function(error) {
      $log.error(error);
      vm.loadingPersonalityQuestionnaires = false;
    });

    vm.competenceQuestionnaires = [];
    vm.loadingCompetenceQuestionnaires = true;
    serverService.getCompetenceQuestionnaires().then(function(data) {

      serverService.addAllModelsTo(data, vm.competenceQuestionnaires);
      if (vm.competenceQuestionnaires.length == 1) {

        vm.competenceQuestionnaire = vm.competenceQuestionnaires[0];

      }
      vm.loadingCompetenceQuestionnaires = false;

    }, function(error) {
      $log.error(error);
      vm.loadingCompetenceQuestionnaires = false;
    });
    vm.teams = [];
    vm.assignments = [];
    vm.loadingAssignments = true;
    serverService.getAssignments().then(function(data) {

      serverService.addAllModelsTo(data, vm.assignments);
      if (vm.assignments.length == 1) {

        vm.assignment = vm.assignments[0];

      }
      vm.loadingAssignments = false;

    }, function(error) {
      $log.error(error);
      vm.loadingAssignments = false;
    });

    $scope.$watch('vm.assignment', assignmentUpdated);
    /**
     * Called when the assignment has been updated.
     */
    function assignmentUpdated() {

      vm.teams.splice(0, vm.teams.length);
      if (angular.isObject(vm.assignment)) {

        serverService.getAssignmentTeamsOn(vm.assignment).then(function(data) {
          serverService.addAllModelsTo(data, vm.teams);
        }, function(error) {
          $log.error(error);
        });

      }
      personalityQuestionnaireUpdated();
      competenceQuestionnaireUpdated();

    }

    $scope.$watch('vm.personalityQuestionnaire', personalityQuestionnaireUpdated);
    /**
     * Called when the personality questionnaire has been updated.
     */
    function personalityQuestionnaireUpdated() {

      vm.personalityTestStatus.splice(0, vm.personalityTestStatus.length);
      if (angular.isObject(vm.assignment) && angular.isObject(vm.personalityQuestionnaire)) {

        for ( var i in vm.assignment.group.students) {

          (function(index) {

            serverService.getStudentPersonalityAnswersOnQuestionnaire(vm.assignment.group.students[index], vm.personalityQuestionnaire, 0, vm.personalityQuestionnaire.questions.length).then(function(data) {

              var answers = data.length;
              if (answers == 0) {

                vm.personalityTestStatus[index] = 'toDo';

              } else if (answers == vm.personalityQuestionnaire.questions.length) {

                vm.personalityTestStatus[index] = 'done';

              } else {

                vm.personalityTestStatus[index] = 'partial';
              }

            }, function(error) {
              $log.error(error);
            });

          })(i);
        }

      }
    }

    $scope.$watch('vm.competenceQuestionnaire', competenceQuestionnaireUpdated);
    /**
     * Called when the competence questionnaire has been updated.
     */
    function competenceQuestionnaireUpdated() {

      vm.competenceTestStatus.splice(0, vm.competenceTestStatus.length);
      if (angular.isObject(vm.assignment) && angular.isObject(vm.competenceQuestionnaire)) {

        for ( var i in vm.assignment.group.students) {

          (function(index) {

            serverService.getStudentCompetenceAnswersOnQuestionnaire(vm.assignment.group.students[index], vm.competenceQuestionnaire, 0, vm.competenceQuestionnaire.questions.length).then(function(data) {

              var answers = data.length;
              if (answers == 0) {

                vm.competenceTestStatus[index] = 'toDo';

              } else if (answers == vm.competenceQuestionnaire.questions.length) {

                vm.competenceTestStatus[index] = 'done';

              } else {

                vm.competenceTestStatus[index] = 'partial';
              }

            }, function(error) {
              $log.error(error);
            });

          })(i);
        }

      }
    }
    /**
     * Called when want to form the assignments.
     */
    vm.synergisticTeams = function(form) {

      var deferred = $q.defer();
      form.studentsPerTeam = {
        $error : {
          required : false
        }
      };
      var valid = true;
      if (!angular.isNumber(vm.studentsPerTeam) || vm.studentsPerTeam < 2) {

        valid = false;
      }

      if (valid) {
        serverService.synergisticTeams(vm.personalityQuestionnaire, vm.competenceQuestionnaire, vm.assignment, vm.studentsPerTeam).then(function(teams) {

          vm.teams.splice(0, vm.teams.length);
          serverService.addAllModelsTo(teams, vm.teams);
          deferred.resolve();

        }, function(error) {

          $log.error(error);
          deferred.reject();

        });

      } else {

        deferred.reject();
      }

      return deferred.promise;

    };

    /**
     * Called when want to form the assignments.
     */
    vm.lpTeams = function(form) {

      var deferred = $q.defer();
      form.studentsPerTeam = {
        $error : {
          required : false
        }
      };
      var valid = true;
      if (!angular.isNumber(vm.studentsPerTeam) || vm.studentsPerTeam < 2) {

        valid = false;
      }

      if (valid) {
        serverService.lpTeams(vm.personalityQuestionnaire, vm.competenceQuestionnaire, vm.assignment, vm.studentsPerTeam).then(function(teams) {

          vm.teams.splice(0, vm.teams.length);
          serverService.addAllModelsTo(teams, vm.teams);
          deferred.resolve();

        }, function(error) {

          $log.error(error);
          deferred.reject();

        });

      } else {

        deferred.reject();
      }

      return deferred.promise;

    };
  }

})();
(function() {
	'use strict';

	angular.module('Education').controller('SynergisticTeamsPersonalityTestController', SynergisticTeamsPersonalityTestController);

	/** @ngInject */
	function SynergisticTeamsPersonalityTestController($scope, serverService, $stateParams, $translate) {

		var vm = this;

		vm.loadingStudents = false;
		vm.loadingStudentsError = false;
		vm.student = null;
		vm.students = [];
		vm.loadStudentsError = false;
		if (angular.isDefined($stateParams.studentId)) {

			serverService.getStudent($stateParams.studentId).then(function(student) {

				vm.student = student;
				vm.loadingStudents = false;

			}, function() {

				loadStudents();

			});

		} else {

			loadStudents();
		}

		/**
		 * Load the student information.
		 */
		function loadStudents() {

			vm.loadingStudents = false;
			vm.student = null;
			vm.students.splice(0, vm.students.length);

			serverService.getStudents().then(function(data) {

				serverService.addAllModelsTo(data, vm.students);
				if (vm.students.length == 1) {

					vm.student = vm.students[0];
				}
				vm.loadStudent = false;

			}, function() {

				vm.loadingStudents = false;

			});

		}

		vm.loadingQuestionnaires = false;
		vm.questionnaire = null;
		vm.questionnaires = [];
		vm.loadQuestionnairesError = false;
		if (angular.isDefined($stateParams.questionnaireId)) {

			serverService.getPersonalityQuestionnaire($stateParams.questionnaireId).then(function(questionnaire) {

				vm.questionnaire = questionnaire;
				vm.loadingQuestionnaires = false;

			}, function() {

				loadQuestionnaires();

			});

		} else {

			loadQuestionnaires();
		}

		/**
		 * Load the questionnaire information.
		 */
		function loadQuestionnaires() {

			vm.loadingQuestionnaires = false;
			vm.questionnaire = null;
			vm.questionnaires.splice(0, vm.questionnaires.length);

			serverService.getPersonalityQuestionnaires().then(function(data) {

				serverService.addAllModelsTo(data, vm.questionnaires);
				if (vm.questionnaires.length == 1) {

					vm.questionnaire = vm.questionnaires[0];
				}
				vm.loadQuestionnaire = false;

			}, function() {

				vm.loadingQuestionnaires = false;

			});

		}

		vm.studentPersonalityAnswers = [];
		vm.studentPersonalityAnswersError = null;

		/**
		 * Update the student personality answers.
		 */
		function updateStudentPersonalityAnswers() {

			vm.studentPersonalityAnswers.splice(0, vm.studentPersonalityAnswers.length);
			vm.studentPersonalityAnswersError = null;
			if (angular.isObject(vm.student) && angular.isObject(vm.questionnaire)) {

				serverService.getStudentPersonalityAnswersOnQuestionnaire(vm.student, vm.questionnaire).then(updateStudentPersonalityAnswersWith, function() {

					vm.studentPersonalityAnswersError = $translate.instant('synergisticTeams.personalityTest.error.loadPrevious');
					updateStudentPersonalityAnswersWith([]);
				});
			}

		}
		/**
		 * Update the student personality answers with the specified answers.
		 */
		function updateStudentPersonalityAnswersWith(studentAnswers) {

			for ( var i in vm.questionnaire.questions) {

				var question = vm.questionnaire.questions[i];
				var found = false;
				for ( var j in studentAnswers) {

					var studentAnswer = studentAnswers[j];
					if (studentAnswer.question.id === question.id) {

						studentAnswer.question = question;
						if (studentAnswer.answer != null) {

							for ( var k in question.possibleAnswerValues) {

								var value = question.possibleAnswerValues[k];
								if (value.id === studentAnswer.answer.id) {

									studentAnswer.answer = value;
									break;
								}
							}

						}
						vm.studentPersonalityAnswers.push(studentAnswer);
						found = true;
						break;
					}

				}
				if (!found) {

					var newStudentAnswer = {
						id : 0,
						student : vm.student,
						questionnaire : vm.questionnaire,
						question : question,
						answer : null
					};
					vm.studentPersonalityAnswers.push(newStudentAnswer);
				}
			}

		}
		updateStudentPersonalityAnswers();
		$scope.$watch('vm.student', updateStudentPersonalityAnswers);
		$scope.$watch('vm.questionnaire', updateStudentPersonalityAnswers);

		/**
		 * Called when a student personality answer has changed.
		 */
		vm.changedStudentPersonalityAnswer = function(studentAnswer) {

			if (studentAnswer.id == 0) {
				// add
				serverService.addStudentPersonalityAnswer(studentAnswer).then(function(addedStudentAnswer) {

					studentAnswer.id = addedStudentAnswer.id;

				}, function() {
					vm.studentPersonalityAnswersError = $translate.instant('synergisticTeams.personalityTest.error.add');
				});

			} else {
				// update
				serverService.updateStudentPersonalityAnswer(studentAnswer).then(function(updateedStudentAnswer) {

					studentAnswer.id = updateedStudentAnswer.id;

				}, function() {
					vm.studentPersonalityAnswersError = $translate.instant('synergisticTeams.personalityTest.error.update');
				});
			}

		};

		/**
		 * Remove all the answers for the student.
		 */
		vm.removeStudentPersonalityAnswers = function() {

			for ( var i in vm.studentPersonalityAnswers) {

				var studentAnswer = vm.studentPersonalityAnswers[i];
				if (studentAnswer.id != 0) {
					// remove
					serverService.removeStudentPersonalityAnswer(studentAnswer).then(function() {
						// Nothing to do
					}, function() {
						vm.studentPersonalityAnswersError = $translate.instant('synergisticTeams.personalityTest.error.remove');
					});

				}
				studentAnswer.id = 0;
				studentAnswer.answer = null;

			}

		};
	}

})();
(function() {
	'use strict';

	angular.module('Education').controller('SynergisticTeamsCompetenceTestController', SynergisticTeamsCompetenceTestController);

	/** @ngInject */
	function SynergisticTeamsCompetenceTestController($scope, serverService, $stateParams, $translate) {

		var vm = this;

		vm.loadingStudents = false;
		vm.loadingStudentsError = false;
		vm.student = null;
		vm.students = [];
		vm.loadStudentsError = false;
		if (angular.isDefined($stateParams.studentId)) {

			serverService.getStudent($stateParams.studentId).then(function(student) {

				vm.student = student;
				vm.loadingStudents = false;

			}, function() {

				loadStudents();

			});

		} else {

			loadStudents();
		}

		/**
		 * Load the student information.
		 */
		function loadStudents() {

			vm.loadingStudents = false;
			vm.student = null;
			vm.students.splice(0, vm.students.length);

			serverService.getStudents().then(function(data) {

				serverService.addAllModelsTo(data, vm.students);
				if (vm.students.length == 1) {

					vm.student = vm.students[0];
				}
				vm.loadStudent = false;

			}, function() {

				vm.loadingStudents = false;

			});

		}

		vm.loadingQuestionnaires = false;
		vm.questionnaire = null;
		vm.questionnaires = [];
		vm.loadQuestionnairesError = false;
		if (angular.isDefined($stateParams.questionnaireId)) {

			serverService.getCompetenceQuestionnaire($stateParams.questionnaireId).then(function(questionnaire) {

				vm.questionnaire = questionnaire;
				vm.loadingQuestionnaires = false;

			}, function() {

				loadQuestionnaires();

			});

		} else {

			loadQuestionnaires();
		}

		/**
		 * Load the questionnaire information.
		 */
		function loadQuestionnaires() {

			vm.loadingQuestionnaires = false;
			vm.questionnaire = null;
			vm.questionnaires.splice(0, vm.questionnaires.length);

			serverService.getCompetenceQuestionnaires().then(function(data) {

				serverService.addAllModelsTo(data, vm.questionnaires);
				if (vm.questionnaires.length == 1) {

					vm.questionnaire = vm.questionnaires[0];
				}
				vm.loadQuestionnaire = false;

			}, function() {

				vm.loadingQuestionnaires = false;

			});

		}

		vm.studentCompetenceAnswers = [];
		vm.studentCompetenceAnswersError = null;

		/**
		 * Update the student competence answers.
		 */
		function updateStudentCompetenceAnswers() {

			vm.studentCompetenceAnswers.splice(0, vm.studentCompetenceAnswers.length);
			vm.studentCompetenceAnswersError = null;
			if (angular.isObject(vm.student) && angular.isObject(vm.questionnaire)) {

				serverService.getStudentCompetenceAnswersOnQuestionnaire(vm.student, vm.questionnaire).then(updateStudentCompetenceAnswersWith, function() {

					vm.studentCompetenceAnswersError = $translate.instant('synergisticTeams.competenceTest.error.loadPrevious');
					updateStudentCompetenceAnswersWith([]);
				});
			}

		}
		/**
		 * Update the student competence answers with the specified answers.
		 */
		function updateStudentCompetenceAnswersWith(studentAnswers) {

			for ( var i in vm.questionnaire.questions) {

				var question = vm.questionnaire.questions[i];
				var found = false;
				for ( var j in studentAnswers) {

					var studentAnswer = studentAnswers[j];
					if (studentAnswer.question.id === question.id) {

						studentAnswer.question = question;
						if (studentAnswer.answer != null) {

							for ( var k in question.possibleAnswerValues) {

								var value = question.possibleAnswerValues[k];
								if (value.id === studentAnswer.answer.id) {

									studentAnswer.answer = value;
									break;
								}
							}

						}
						vm.studentCompetenceAnswers.push(studentAnswer);
						found = true;
						break;
					}

				}
				if (!found) {

					var newStudentAnswer = {
						id : 0,
						student : vm.student,
						questionnaire : vm.questionnaire,
						question : question,
						answer : null
					};
					vm.studentCompetenceAnswers.push(newStudentAnswer);
				}
			}

		}
		updateStudentCompetenceAnswers();
		$scope.$watch('vm.student', updateStudentCompetenceAnswers);
		$scope.$watch('vm.questionnaire', updateStudentCompetenceAnswers);

		/**
		 * Called when a student competence answer has changed.
		 */
		vm.changedStudentCompetenceAnswer = function(studentAnswer) {

			if (studentAnswer.id == 0) {
				// add
				serverService.addStudentCompetenceAnswer(studentAnswer).then(function(addedStudentAnswer) {

					studentAnswer.id = addedStudentAnswer.id;

				}, function() {
					vm.studentCompetenceAnswersError = $translate.instant('synergisticTeams.competenceTest.error.add');
				});

			} else {
				// update
				serverService.updateStudentCompetenceAnswer(studentAnswer).then(function(updateedStudentAnswer) {

					studentAnswer.id = updateedStudentAnswer.id;

				}, function() {
					vm.studentCompetenceAnswersError = $translate.instant('synergisticTeams.competenceTest.error.update');
				});
			}

		};

		/**
		 * Remove all the answers for the student.
		 */
		vm.removeStudentCompetenceAnswers = function() {

			for ( var i in vm.studentCompetenceAnswers) {

				var studentAnswer = vm.studentCompetenceAnswers[i];
				if (studentAnswer.id != 0) {
					// remove
					serverService.removeStudentCompetenceAnswer(studentAnswer).then(function() {
						// Nothing to do
					}, function() {
						vm.studentCompetenceAnswersError = $translate.instant('synergisticTeams.competenceTest.error.remove');
					});

				}
				studentAnswer.id = 0;
				studentAnswer.answer = null;

			}

		};
	}

})();
(function() {
	'use strict';

	angular.module('Education').directive('teacherList', teacherList);

	/** @ngInject */
	function teacherList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/teacher/teacherList.html',
			controller : TeacherListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function TeacherListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getTeachers().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('Teacher.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('Teacher.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedTeacher, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('Teacher.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeTeacher(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('Teacher.action.remove.error');
					$log.error(error);

				});
			};

		}// End TeacherListController

	}// End teacherList

})();
(function() {
	'use strict';

	angular.module('Education').directive('teacherEditor', teacherEditor);

	/** @ngInject */
	function teacherEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/teacher/teacherEditor.html',
			controller : TeacherEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function TeacherEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS, PERSON_SEX) {

			var vm = this;
			vm.PERSON_SEX = PERSON_SEX;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyTeacher();

			}

			$scope.dateOfBirthOptions = {
				maxDate : new Date()
			};
			$scope.showDateOfBirthPicker = false;

			/**
			 * Create an empty new teacher.
			 */
			function createEmptyTeacher() {

				var year = new Date().getFullYear();
				year -= 23;
				vm.model = {
					id : 0,
					name : '',
					sex : 'FEMALE',
					dateOfBirth : new Date(year,0)
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.sex = {
					$error : {
						required : false
					}
				};
				form.dateOfBirth = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.sex !== 'MALE' && vm.model.sex !== 'FEMALE') {

					form.sex.$error.required = true;
					validForm = false;
				}
				if (!angular.isDate(vm.model.dateOfBirth)) {

					form.dateOfBirth.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the teacher.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addTeacher(vm.model).then(function(addedTeacher) {

						createEmptyTeacher();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedTeacher, addedTeacher);
						deferred.resolve(addedTeacher);

					}, function(error) {

						vm.error = $translate.instant('Teacher.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the teacher.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateTeacher(vm.model).then(function(updatedTeacher) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedTeacher, updatedTeacher);
						deferred.resolve(updatedTeacher);

					}, function(error) {

						vm.error = $translate.instant('Teacher.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('studentGroupList', studentGroupList);

	/** @ngInject */
	function studentGroupList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/studentGroup/studentGroupList.html',
			controller : StudentGroupListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function StudentGroupListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getStudentGroups().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('StudentGroup.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('StudentGroup.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedStudentGroup, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('StudentGroup.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeStudentGroup(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('StudentGroup.action.remove.error');
					$log.error(error);

				});
			};

		}// End StudentGroupListController

	}// End studentGroupList

})();
(function() {
	'use strict';

	angular.module('Education').directive('studentGroupEditor', studentGroupEditor);

	/** @ngInject */
	function studentGroupEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/studentGroup/studentGroupEditor.html',
			controller : StudentGroupEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function StudentGroupEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;

			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyStudentGroup();

			}
			vm.teachers = [];
			serverService.getTeachers().then(function(models) {

				serverService.addAllModelsTo(models, vm.teachers);

			});
      vm.students = [];
      serverService.getStudents().then(function(models) {

        serverService.addAllModelsTo(models, vm.students);

      });

			/**
			 * Create an empty new StudentGroup.
			 */
			function createEmptyStudentGroup() {

				vm.model = {
					id : 0,
					name : '',
					teachers:[],
					students : []
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.teachers = {
					$error : {
						required : false
					}
				};
        form.students = {
            $error : {
              required : false
            }
          };

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}

        if (vm.model.teachers.length < 1 ) {

          form.teachers.$error.required = true;
          validForm = false;
        }

				if (vm.model.students.length < 3 ) {

					form.students.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the StudentGroup.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addStudentGroup(vm.model).then(function(addedStudentGroup) {

						createEmptyStudentGroup();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedStudentGroup, addedStudentGroup);
						deferred.resolve(addedStudentGroup);

					}, function(error) {

						vm.error = $translate.instant('StudentGroup.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the StudentGroup.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateStudentGroup(vm.model).then(function(updatedStudentGroup) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedStudentGroup, updatedStudentGroup);
						deferred.resolve(updatedStudentGroup);

					}, function(error) {

						vm.error = $translate.instant('StudentGroup.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('studentList', studentList);

	/** @ngInject */
	function studentList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/student/studentList.html',
			controller : StudentListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function StudentListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getStudents().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('Student.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('Student.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedStudent, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('Student.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeStudent(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('Student.action.remove.error');
					$log.error(error);

				});
			};

		}// End StudentListController

	}// End studentList

})();
(function() {
	'use strict';

	angular.module('Education').directive('studentEditor', studentEditor);

	/** @ngInject */
	function studentEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/student/studentEditor.html',
			controller : StudentEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function StudentEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS, PERSON_SEX) {

			var vm = this;
			vm.PERSON_SEX = PERSON_SEX;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyStudent();

			}

			$scope.dateOfBirthOptions = {
				maxDate : new Date()
			};
			$scope.showDateOfBirthPicker = false;

			/**
			 * Create an empty new student.
			 */
			function createEmptyStudent() {

				var year = new Date().getFullYear();
				year -= 7;
				vm.model = {
					id : 0,
					name : '',
					sex : 'FEMALE',
					dateOfBirth : new Date(year,0)
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.sex = {
					$error : {
						required : false
					}
				};
				form.dateOfBirth = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.sex !== 'MALE' && vm.model.sex !== 'FEMALE') {

					form.sex.$error.required = true;
					validForm = false;
				}
				if (!angular.isDate(vm.model.dateOfBirth)) {

					form.dateOfBirth.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the student.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addStudent(vm.model).then(function(addedStudent) {

						createEmptyStudent();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedStudent, addedStudent);
						deferred.resolve(addedStudent);

					}, function(error) {

						vm.error = $translate.instant('Student.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the student.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateStudent(vm.model).then(function(updatedStudent) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedStudent, updatedStudent);
						deferred.resolve(updatedStudent);

					}, function(error) {

						vm.error = $translate.instant('Student.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('rubricList', rubricList);

	/** @ngInject */
	function rubricList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/rubric/rubricList.html',
			controller : RubricListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function RubricListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getRubrics().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('Rubric.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('Rubric.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedRubric, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('Rubric.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeRubric(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('Rubric.action.remove.error');
					$log.error(error);

				});
			};

		}// End RubricListController

	}// End rubricList

})();
(function() {
	'use strict';

	angular.module('Education').directive('rubricEditor', rubricEditor);

	/** @ngInject */
	function rubricEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/rubric/rubricEditor.html',
			controller : RubricEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel',
				hideHeading : '@?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function RubricEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyRubric();

			}
			vm.criteria = [];
			serverService.getCriteria().then(function(models) {

				serverService.addAllModelsTo(models, vm.criteria);

			});

			/**
			 * Create an empty new Rubric.
			 */
			function createEmptyRubric() {

				vm.model = {
					id : 0,
					name : '',
					minMark : 1,
					maxMark : 4,
					criteria : []
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.minMark = {
					$error : {
						required : false
					}
				};
				form.maxMark = {
					$error : {
						required : false
					}
				};
				form.criteria = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.maxMark <= vm.model.minMark) {

					form.maxMark.$error.required = true;
					form.minMark.$error.required = true;
					validForm = false;
				}
				if (vm.model.criteria.length == 0) {

					form.criteria.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the Rubric.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addRubric(vm.model).then(function(addedRubric) {

						createEmptyRubric();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedRubric, addedRubric);
						deferred.resolve(addedRubric);

					}, function(error) {

						vm.error = $translate.instant('Rubric.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the Rubric.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateRubric(vm.model).then(function(updatedRubric) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedRubric, updatedRubric);
						deferred.resolve(updatedRubric);

					}, function(error) {

						vm.error = $translate.instant('Rubric.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('importRubric', importRubric);

	/** @ngInject */
	function importRubric() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/rubric/importRubric.html',
			controller : importRubricController,
			controllerAs : 'vm',
			scope : {
				hideHeading : '@?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function importRubricController($scope, $q, SERVER, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS, FileUploader) {

			var vm = this;
			vm.model = {
				name : ''
			};
			vm.importError = false;
			vm.uploader = new FileUploader({
				url : SERVER + 'rubric/file',
				method : 'POST',
				headers : {
					'Accept' : 'application/json'
				},
				removeAfterUpload : true,
				queueLimit : 1,
				onSuccessItem : function(item, addedRubric) {

					vm.model.name = '';
					angular.element('#importFile').prop('value', null);
					$rootScope.$broadcast(EDUCATION_EVENTS.addedRubric, addedRubric);

				},
				onErrorItem : function() {
					vm.importError = true;
				},
				alias : 'file'
			});

			/**
			 * Import rubric.
			 */
			vm.importRubric = function(importForm) {

				vm.importError = false;
				importForm.name = {
					$error : {
						required : false
					}
				};
				importForm.file = {
					$error : {
						required : false
					}
				};
				var error = false;
				if (vm.model.name.length == 0) {

					importForm.name.$error.required = true;
					error = true;
				}
				if (vm.uploader.queue.length == 0) {

					importForm.file.$error.required = true;
					error = true;
				}
				if (!error) {

					var item = vm.uploader.queue[0];
					item.formData = [ {
						rubricName : vm.model.name
					} ];
					item.upload();

				}
			}
		}
	}

})();
(function() {
	'use strict';

	angular.module('Education').directive('personalityQuestionnaireList', personalityQuestionnaireList);

	/** @ngInject */
	function personalityQuestionnaireList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/personalityQuestionnaire/personalityQuestionnaireList.html',
			controller : PersonalityQuestionnaireListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function PersonalityQuestionnaireListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getPersonalityQuestionnaires().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('PersonalityQuestionnaire.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('PersonalityQuestionnaire.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedPersonalityQuestionnaire, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('PersonalityQuestionnaire.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removePersonalityQuestionnaire(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('PersonalityQuestionnaire.action.remove.error');
					$log.error(error);

				});
			};

		}// End PersonalityQuestionnaireListController

	}// End personalityQuestionnaireList

})();
(function() {
	'use strict';

	angular.module('Education').directive('personalityQuestionnaireEditor', personalityQuestionnaireEditor);

	/** @ngInject */
	function personalityQuestionnaireEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/personalityQuestionnaire/personalityQuestionnaireEditor.html',
			controller : PersonalityQuestionnaireEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function PersonalityQuestionnaireEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyPersonalityQuestionnaire();

			}
			vm.personalityQuestions = [];
			serverService.getPersonalityQuestions().then(function(models) {

				serverService.addAllModelsTo(models, vm.personalityQuestions);

			});

			/**
			 * Create an empty new PersonalityQuestionnaire.
			 */
			function createEmptyPersonalityQuestionnaire() {

				vm.model = {
					id : 0,
					factor : '',
					questionnaire : '',
					description : '',
					questions : []
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};
				form.questions = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				if (vm.model.questions.length == 0) {

					form.questions.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the PersonalityQuestionnaire.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addPersonalityQuestionnaire(vm.model).then(function(addedPersonalityQuestionnaire) {

						createEmptyPersonalityQuestionnaire();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedPersonalityQuestionnaire, addedPersonalityQuestionnaire);
						deferred.resolve(addedPersonalityQuestionnaire);

					}, function(error) {

						vm.error = $translate.instant('PersonalityQuestionnaire.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the PersonalityQuestionnaire.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updatePersonalityQuestionnaire(vm.model).then(function(updatedPersonalityQuestionnaire) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedPersonalityQuestionnaire, updatedPersonalityQuestionnaire);
						deferred.resolve(updatedPersonalityQuestionnaire);

					}, function(error) {

						vm.error = $translate.instant('PersonalityQuestionnaire.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('personalityQuestionList', personalityQuestionList);

	/** @ngInject */
	function personalityQuestionList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/personalityQuestion/personalityQuestionList.html',
			controller : PersonalityQuestionListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function PersonalityQuestionListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getPersonalityQuestions().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('PersonalityQuestion.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('PersonalityQuestion.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedPersonalityQuestion, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('PersonalityQuestion.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removePersonalityQuestion(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('PersonalityQuestion.action.remove.error');
					$log.error(error);

				});
			};

		}// End PersonalityQuestionListController

	}// End personalityQuestionList

})();
(function() {
	'use strict';

	angular.module('Education').directive('personalityQuestionEditor', personalityQuestionEditor);

	/** @ngInject */
	function personalityQuestionEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/personalityQuestion/personalityQuestionEditor.html',
			controller : PersonalityQuestionEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function PersonalityQuestionEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS, PERSONALITY_FACTORS) {

			var vm = this;
			vm.PERSONALITY_FACTORS = PERSONALITY_FACTORS;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyPersonalityQuestion();

			}
			vm.personalityAnswerValues = [];
			serverService.getPersonalityAnswerValues().then(function(models) {

				serverService.addAllModelsTo(models, vm.personalityAnswerValues);

			});

			/**
			 * Create an empty new PersonalityQuestion.
			 */
			function createEmptyPersonalityQuestion() {

				vm.model = {
					id : 0,
					factor : '',
					question : '',
					description : '',
					possibleAnswerValues : []
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.factor = {
					$error : {
						required : false
					}
				};
				form.question = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};
				form.possibleAnswerValues = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.factor.length == 0) {

					form.factor.$error.required = true;
					validForm = false;
				}
				if (vm.model.question.length == 0) {

					form.question.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				if (vm.model.possibleAnswerValues.length == 0) {

					form.possibleAnswerValues.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the PersonalityQuestion.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addPersonalityQuestion(vm.model).then(function(addedPersonalityQuestion) {

						createEmptyPersonalityQuestion();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedPersonalityQuestion, addedPersonalityQuestion);
						deferred.resolve(addedPersonalityQuestion);

					}, function(error) {

						vm.error = $translate.instant('PersonalityQuestion.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the PersonalityQuestion.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updatePersonalityQuestion(vm.model).then(function(updatedPersonalityQuestion) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedPersonalityQuestion, updatedPersonalityQuestion);
						deferred.resolve(updatedPersonalityQuestion);

					}, function(error) {

						vm.error = $translate.instant('PersonalityQuestion.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('personalityAnswerValueList', personalityAnswerValueList);

	/** @ngInject */
	function personalityAnswerValueList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/personalityAnswerValue/personalityAnswerValueList.html',
			controller : PersonalityAnswerValueListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function PersonalityAnswerValueListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getPersonalityAnswerValues().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('PersonalityAnswerValue.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('PersonalityAnswerValue.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedPersonalityAnswerValue, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('PersonalityAnswerValue.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removePersonalityAnswerValue(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('PersonalityAnswerValue.action.remove.error');
					$log.error(error);

				});
			};

		}// End PersonalityAnswerValueListController

	}// End personalityAnswerValueList

})();
(function() {
	'use strict';

	angular.module('Education').directive('personalityAnswerValueEditor', personalityAnswerValueEditor);

	/** @ngInject */
	function personalityAnswerValueEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/personalityAnswerValue/personalityAnswerValueEditor.html',
			controller : PersonalityAnswerValueEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function PersonalityAnswerValueEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyPersonalityAnswerValue();

			}

			/**
			 * Create an empty new PersonalityAnswerValue.
			 */
			function createEmptyPersonalityAnswerValue() {

				vm.model = {
					id : 0,
					name : '',
					description : '',
					value : 0
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};
				form.value = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				if (!angular.isNumber(vm.model.value) ||vm.model.value <-1 || vm.model.value>1) {

					form.value.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the PersonalityAnswerValue.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addPersonalityAnswerValue(vm.model).then(function(addedPersonalityAnswerValue) {

						createEmptyPersonalityAnswerValue();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedPersonalityAnswerValue, addedPersonalityAnswerValue);
						deferred.resolve(addedPersonalityAnswerValue);

					}, function(error) {

						vm.error = $translate.instant('PersonalityAnswerValue.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the PersonalityAnswerValue.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updatePersonalityAnswerValue(vm.model).then(function(updatedPersonalityAnswerValue) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedPersonalityAnswerValue, updatedPersonalityAnswerValue);
						deferred.resolve(updatedPersonalityAnswerValue);

					}, function(error) {

						vm.error = $translate.instant('PersonalityAnswerValue.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('criterionList', criterionList);

	/** @ngInject */
	function criterionList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/criterion/criterionList.html',
			controller : CriterionListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CriterionListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getCriteria().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('Criterion.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('Criterion.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedCriterion, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('Criterion.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeCriterion(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('Criterion.action.remove.error');
					$log.error(error);

				});
			};

		}// End CriterionListController

	}// End criterionList

})();
(function() {
	'use strict';

	angular.module('Education').directive('criterionEditor', criterionEditor);

	/** @ngInject */
	function criterionEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/criterion/criterionEditor.html',
			controller : CriterionEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CriterionEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyCriterion();

			}
			vm.personalityAnswerValues = [];
			serverService.getPersonalityAnswerValues().then(function(models) {

				serverService.addAllModelsTo(models, vm.personalityAnswerValues);

			});

			/**
			 * Create an empty new Criterion.
			 */
			function createEmptyCriterion() {

				vm.model = {
					id : 0,
					name : '',
					description : ''
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the Criterion.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addCriterion(vm.model).then(function(addedCriterion) {

						createEmptyCriterion();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedCriterion, addedCriterion);
						deferred.resolve(addedCriterion);

					}, function(error) {

						vm.error = $translate.instant('Criterion.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the Criterion.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateCriterion(vm.model).then(function(updatedCriterion) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedCriterion, updatedCriterion);
						deferred.resolve(updatedCriterion);

					}, function(error) {

						vm.error = $translate.instant('Criterion.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
  'use strict';

  angular.module('Education').filter('localizeCompetenceRequestLevel', localizeCompetenceRequestLevel);

  /** @ngInject */
  function localizeCompetenceRequestLevel($translate) {

    return function(input) {

      var level = Math.round(input * 4);
      if( level < 0 ){
        
        level = 0;
      
      }else if( level > 4 ){
        
        level = 4;
      }
      return $translate.instant('CompetenceRequest.att.level.fs.' + level);
    }
  }

})();

(function() {
  'use strict';

  angular.module('Education').filter('localizeCompetenceRequestImportance', localizeCompetenceRequestImportance);

  /** @ngInject */
  function localizeCompetenceRequestImportance($translate) {

    return function(input) {

      var importance = Math.round(input * 4);
      if (importance < 0) {

        importance = 0;

      } else if (importance > 4) {

        importance = 4;
      }
      return $translate.instant('CompetenceRequest.att.importance.fs.' + importance);
    }
  }

})();

(function() {
	'use strict';

	angular.module('Education').directive('competenceRequestList', competenceRequestList);

	/** @ngInject */
	function competenceRequestList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceRequest/competenceRequestList.html',
			controller : CompetenceRequestListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceRequestListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getCompetenceRequests().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('CompetenceRequest.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('CompetenceRequest.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedCompetenceRequest, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('CompetenceRequest.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeCompetenceRequest(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('CompetenceRequest.action.remove.error');
					$log.error(error);

				});
			};

		}// End CompetenceRequestListController

	}// End competenceRequestList

})();
(function() {
  'use strict';

  angular.module('Education').directive('competenceRequestEditor', competenceRequestEditor);

  /** @ngInject */
  function competenceRequestEditor() {
    var directive = {
      restrict : 'E',
      templateUrl : 'app/tool/data/competenceRequest/competenceRequestEditor.html',
      controller : CompetenceRequestEditorController,
      controllerAs : 'vm',
      scope : {
        model : '=?ngModel'
      },
      bindToController : true
    };

    return directive;

    /** @ngInject */
    function CompetenceRequestEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS, COMPETENCE_FACTORS, BASIC_SCALE) {

      var vm = this;
      vm.BASIC_SCALE = BASIC_SCALE;
      vm.COMPETENCE_FACTORS = COMPETENCE_FACTORS;
      vm.error = null;
      if (angular.isObject($scope.model)) {

        vm.model = $scope.model;

      } else {

        createEmptyCompetenceRequest();

      }
      vm.competenceAnswerValues = [];
      serverService.getCompetenceAnswerValues().then(function(models) {

        serverService.addAllModelsTo(models, vm.competenceAnswerValues);

      });

      /**
       * Create an empty new CompetenceRequest.
       */
      function createEmptyCompetenceRequest() {

        vm.model = {
          id : 0,
          factor : 'VERBAL',
          level : 0.5,
          importance : 0.5
        };

      }

      /**
       * Check the form values are right and commit the result.
       */
      vm.checkForm = function(form) {

        vm.error = null;
        form.submit = {
          $error : null
        };
        form.factor = {
          $error : {
            required : false
          }
        };
        form.level = {
          $error : {
            required : false
          }
        };
        form.importance = {
          $error : {
            required : false
          }
        };

        var validForm = true;
        if (!angular.isString(vm.model.factor)) {

          form.factor.$error.required = true;
          validForm = false;
        }
        if (!angular.isNumber(vm.model.level)) {

          form.level.$error.required = true;
          validForm = false;
        }
        if (!angular.isNumber(vm.model.importance)) {

          form.importance.$error.required = true;
          validForm = false;
        }
        return validForm;
      };

      /**
       * Verify the form and add the CompetenceRequest.
       */
      vm.checkFormAndAdd = function(form) {

        var deferred = $q.defer();
        if (!vm.checkForm(form)) {

          deferred.reject();

        } else {

          serverService.addCompetenceRequest(vm.model).then(function(addedCompetenceRequest) {

            createEmptyCompetenceRequest();
            $rootScope.$broadcast(EDUCATION_EVENTS.addedCompetenceRequest, addedCompetenceRequest);
            deferred.resolve(addedCompetenceRequest);

          }, function(error) {

            vm.error = $translate.instant('CompetenceRequest.action.add.error');
            $log.error(error);
            deferred.reject(error);

          });
        }

        return deferred.promise;

      };

      /**
       * Verify the form and update the CompetenceRequest.
       */
      vm.checkFormAndUpdate = function(form) {

        var deferred = $q.defer();
        if (!vm.checkForm(form)) {

          deferred.reject();

        } else {

          serverService.updateCompetenceRequest(vm.model).then(function(updatedCompetenceRequest) {

            $rootScope.$broadcast(EDUCATION_EVENTS.updatedCompetenceRequest, updatedCompetenceRequest);
            deferred.resolve(updatedCompetenceRequest);

          }, function(error) {

            vm.error = $translate.instant('CompetenceRequest.action.update.error');
            $log.error(error);
            deferred.reject(error);

          });
        }

        return deferred.promise;

      };

    }
  }

})();

(function() {
	'use strict';

	angular.module('Education').directive('competenceQuestionnaireList', competenceQuestionnaireList);

	/** @ngInject */
	function competenceQuestionnaireList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceQuestionnaire/competenceQuestionnaireList.html',
			controller : CompetenceQuestionnaireListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceQuestionnaireListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getCompetenceQuestionnaires().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('CompetenceQuestionnaire.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('CompetenceQuestionnaire.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedCompetenceQuestionnaire, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('CompetenceQuestionnaire.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeCompetenceQuestionnaire(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('CompetenceQuestionnaire.action.remove.error');
					$log.error(error);

				});
			};

		}// End CompetenceQuestionnaireListController

	}// End competenceQuestionnaireList

})();
(function() {
	'use strict';

	angular.module('Education').directive('competenceQuestionnaireEditor', competenceQuestionnaireEditor);

	/** @ngInject */
	function competenceQuestionnaireEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceQuestionnaire/competenceQuestionnaireEditor.html',
			controller : CompetenceQuestionnaireEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceQuestionnaireEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyCompetenceQuestionnaire();

			}
			vm.competenceQuestions = [];
			serverService.getCompetenceQuestions().then(function(models) {

				serverService.addAllModelsTo(models, vm.competenceQuestions);

			});

			/**
			 * Create an empty new CompetenceQuestionnaire.
			 */
			function createEmptyCompetenceQuestionnaire() {

				vm.model = {
					id : 0,
					factor : '',
					questionnaire : '',
					description : '',
					questions : []
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};
				form.questions = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				if (vm.model.questions.length == 0) {

					form.questions.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the CompetenceQuestionnaire.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addCompetenceQuestionnaire(vm.model).then(function(addedCompetenceQuestionnaire) {

						createEmptyCompetenceQuestionnaire();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedCompetenceQuestionnaire, addedCompetenceQuestionnaire);
						deferred.resolve(addedCompetenceQuestionnaire);

					}, function(error) {

						vm.error = $translate.instant('CompetenceQuestionnaire.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the CompetenceQuestionnaire.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateCompetenceQuestionnaire(vm.model).then(function(updatedCompetenceQuestionnaire) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedCompetenceQuestionnaire, updatedCompetenceQuestionnaire);
						deferred.resolve(updatedCompetenceQuestionnaire);

					}, function(error) {

						vm.error = $translate.instant('CompetenceQuestionnaire.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('competenceQuestionList', competenceQuestionList);

	/** @ngInject */
	function competenceQuestionList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceQuestion/competenceQuestionList.html',
			controller : CompetenceQuestionListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceQuestionListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getCompetenceQuestions().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('CompetenceQuestion.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('CompetenceQuestion.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedCompetenceQuestion, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('CompetenceQuestion.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeCompetenceQuestion(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('CompetenceQuestion.action.remove.error');
					$log.error(error);

				});
			};

		}// End CompetenceQuestionListController

	}// End competenceQuestionList

})();
(function() {
	'use strict';

	angular.module('Education').directive('competenceQuestionEditor', competenceQuestionEditor);

	/** @ngInject */
	function competenceQuestionEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceQuestion/competenceQuestionEditor.html',
			controller : CompetenceQuestionEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceQuestionEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS, COMPETENCE_FACTORS) {

			var vm = this;
			vm.COMPETENCE_FACTORS = COMPETENCE_FACTORS;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyCompetenceQuestion();

			}
			vm.competenceAnswerValues = [];
			serverService.getCompetenceAnswerValues().then(function(models) {

				serverService.addAllModelsTo(models, vm.competenceAnswerValues);

			});

			/**
			 * Create an empty new CompetenceQuestion.
			 */
			function createEmptyCompetenceQuestion() {

				vm.model = {
					id : 0,
					factor : '',
					question : '',
					description : '',
					possibleAnswerValues : []
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.factor = {
					$error : {
						required : false
					}
				};
				form.question = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};
				form.possibleAnswerValues = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.factor.length == 0) {

					form.factor.$error.required = true;
					validForm = false;
				}
				if (vm.model.question.length == 0) {

					form.question.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				if (vm.model.possibleAnswerValues.length == 0) {

					form.possibleAnswerValues.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the CompetenceQuestion.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addCompetenceQuestion(vm.model).then(function(addedCompetenceQuestion) {

						createEmptyCompetenceQuestion();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedCompetenceQuestion, addedCompetenceQuestion);
						deferred.resolve(addedCompetenceQuestion);

					}, function(error) {

						vm.error = $translate.instant('CompetenceQuestion.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the CompetenceQuestion.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateCompetenceQuestion(vm.model).then(function(updatedCompetenceQuestion) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedCompetenceQuestion, updatedCompetenceQuestion);
						deferred.resolve(updatedCompetenceQuestion);

					}, function(error) {

						vm.error = $translate.instant('CompetenceQuestion.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('competenceAnswerValueList', competenceAnswerValueList);

	/** @ngInject */
	function competenceAnswerValueList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceAnswerValue/competenceAnswerValueList.html',
			controller : CompetenceAnswerValueListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceAnswerValueListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getCompetenceAnswerValues().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('CompetenceAnswerValue.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('CompetenceAnswerValue.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedCompetenceAnswerValue, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('CompetenceAnswerValue.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeCompetenceAnswerValue(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('CompetenceAnswerValue.action.remove.error');
					$log.error(error);

				});
			};

		}// End CompetenceAnswerValueListController

	}// End competenceAnswerValueList

})();
(function() {
	'use strict';

	angular.module('Education').directive('competenceAnswerValueEditor', competenceAnswerValueEditor);

	/** @ngInject */
	function competenceAnswerValueEditor() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/competenceAnswerValue/competenceAnswerValueEditor.html',
			controller : CompetenceAnswerValueEditorController,
			controllerAs : 'vm',
			scope : {
				model : '=?ngModel'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function CompetenceAnswerValueEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.error = null;
			if (angular.isObject($scope.model)) {

				vm.model = $scope.model;

			} else {

				createEmptyCompetenceAnswerValue();

			}

			/**
			 * Create an empty new CompetenceAnswerValue.
			 */
			function createEmptyCompetenceAnswerValue() {

				vm.model = {
					id : 0,
					name : '',
					description : '',
					value : 0
				};

			}

			/**
			 * Check the form values are right and commit the result.
			 */
			vm.checkForm = function(form) {

				vm.error = null;
				form.submit = {
					$error : null
				};
				form.name = {
					$error : {
						required : false
					}
				};
				form.description = {
					$error : {
						required : false
					}
				};
				form.value = {
					$error : {
						required : false
					}
				};

				var validForm = true;
				if (vm.model.name.length == 0) {

					form.name.$error.required = true;
					validForm = false;
				}
				if (vm.model.description.length == 0) {

					form.description.$error.required = true;
					validForm = false;
				}
				if (!angular.isNumber(vm.model.value) ||vm.model.value <-1 || vm.model.value>1) {

					form.value.$error.required = true;
					validForm = false;
				}
				return validForm;
			};

			/**
			 * Verify the form and add the CompetenceAnswerValue.
			 */
			vm.checkFormAndAdd = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.addCompetenceAnswerValue(vm.model).then(function(addedCompetenceAnswerValue) {

						createEmptyCompetenceAnswerValue();
						$rootScope.$broadcast(EDUCATION_EVENTS.addedCompetenceAnswerValue, addedCompetenceAnswerValue);
						deferred.resolve(addedCompetenceAnswerValue);

					}, function(error) {

						vm.error = $translate.instant('CompetenceAnswerValue.action.add.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

			/**
			 * Verify the form and update the CompetenceAnswerValue.
			 */
			vm.checkFormAndUpdate = function(form) {

				var deferred = $q.defer();
				if (!vm.checkForm(form)) {

					deferred.reject();

				} else {

					serverService.updateCompetenceAnswerValue(vm.model).then(function(updatedCompetenceAnswerValue) {

						$rootScope.$broadcast(EDUCATION_EVENTS.updatedCompetenceAnswerValue, updatedCompetenceAnswerValue);
						deferred.resolve(updatedCompetenceAnswerValue);

					}, function(error) {

						vm.error = $translate.instant('CompetenceAnswerValue.action.update.error');
						$log.error(error);
						deferred.reject(error);

					});
				}

				return deferred.promise;

			};

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').directive('assignmentList', assignmentList);

	/** @ngInject */
	function assignmentList() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/tool/data/assignment/assignmentList.html',
			controller : AssignmentListController,
			controllerAs : 'vm',
			scope : {
				models : '=?'
			},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function AssignmentListController($scope, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

			var vm = this;
			vm.loading = true;
			vm.error = null;
			if (angular.isObject($scope.models)) {

				vm.models = $scope.models;
				vm.loading = false;

			} else {

				vm.models = [];
				serverService.getAssignments().then(function(models) {

					serverService.addAllModelsTo(models, vm.models);
					vm.loading = false;
					if (vm.models.length == 0) {

						vm.error = $translate.instant('Assignment.list.noData');
					}

				}, function() {
					vm.loading = false;
					vm.error = $translate.instant('Assignment.list.noLoadData');
				});
			}

			/**
			 * Called when a new answer has been added.
			 */
			var listener = $rootScope.$on(EDUCATION_EVENTS.addedAssignment, function(event, model) {

				serverService.addModelTo(model, vm.models);
				if (vm.models.length == 0) {

					vm.error = $translate.instant('Assignment.list.noData');

				} else {

					vm.error = null;
				}

			});
			$scope.$on('$destroy', function() {
				listener();
			});

			/**
			 * Remove an answer.
			 */
			vm.remove = function(model) {

				serverService.removeAssignment(model).then(function() {

					serverService.removeModel(model, vm.models);

				}, function(error) {

					vm.error = $translate.instant('Assignment.action.remove.error');
					$log.error(error);

				});
			};

		}// End AssignmentListController

	}// End assignmentList

})();
(function() {
  'use strict';

  angular.module('Education').directive('assignmentEditor', assignmentEditor);

  /** @ngInject */
  function assignmentEditor() {
    var directive = {
      restrict : 'E',
      templateUrl : 'app/tool/data/assignment/assignmentEditor.html',
      controller : AssignmentEditorController,
      controllerAs : 'vm',
      scope : {
        model : '=?ngModel'
      },
      bindToController : true
    };

    return directive;

    /** @ngInject */
    function AssignmentEditorController($scope, $q, serverService, $translate, $log, $rootScope, EDUCATION_EVENTS) {

      var vm = this;
      vm.error = null;
      vm.teachers = [];
      vm.rubrics = [];
      vm.groups = [];
      vm.competenceRequests = [];
      if (angular.isObject($scope.model)) {

        vm.model = $scope.model;

      } else {

        createEmptyAssignment();

      }

      serverService.getTeachers().then(function(models) {

        serverService.addAllModelsTo(models, vm.teachers);
        if (vm.model.teacher == null && vm.teachers.length == 1) {

          vm.model.teacher = vm.teachers[0];
        }

      });
      serverService.getRubrics().then(function(models) {

        serverService.addAllModelsTo(models, vm.rubrics);
        if (vm.model.rubric == null && vm.rubrics.length == 1) {

          vm.model.rubric = vm.rubrics[0];
        }

      });
      serverService.getStudentGroups().then(function(models) {

        serverService.addAllModelsTo(models, vm.groups);
        if (vm.model.group == null && vm.groups.length == 1) {

          vm.model.group = vm.groups[0];
        }

      });
      serverService.getCompetenceRequests().then(function(models) {

        serverService.addAllModelsTo(models, vm.competenceRequests);
        if (vm.model.request == null && vm.competenceRequests.length == 1) {

          vm.model.request = vm.competenceRequests[0];
        }

      });

      /**
       * Create an empty new Assignment.
       */
      function createEmptyAssignment() {

        vm.model = {
          id : 0,
          name : '',
          teacher : null,
          rubric : null,
          group : null
        };
        if (vm.teachers.length == 1) {

          vm.model.teacher = vm.teachers[0];
        }
        if (vm.rubrics.length == 1) {

          vm.model.rubric = vm.rubrics[0];
        }
        if (vm.groups.length == 1) {

          vm.model.group = vm.groups[0];
        }

      }

      /**
       * Check the form values are right and commit the result.
       */
      vm.checkForm = function(form) {

        vm.error = null;
        form.submit = {
          $error : null
        };
        form.name = {
          $error : {
            required : false
          }
        };
        form.teacher = {
          $error : {
            required : false
          }
        };
        form.rubric = {
          $error : {
            required : false
          }
        };
        form.group = {
          $error : {
            required : false
          }
        };

        var validForm = true;
        if (vm.model.name.length == 0) {

          form.name.$error.required = true;
          validForm = false;
        }
        if (!angular.isObject(vm.model.teacher)) {

          form.teacher.$error.required = true;
          validForm = false;
        }
        if (!angular.isObject(vm.model.rubric)) {

          form.rubric.$error.required = true;
          validForm = false;
        }
        if (!angular.isObject(vm.model.group)) {

          form.group.$error.required = true;
          validForm = false;
        }
        return validForm;
      };

      /**
       * Verify the form and add the Assignment.
       */
      vm.checkFormAndAdd = function(form) {

        var deferred = $q.defer();
        if (!vm.checkForm(form)) {

          deferred.reject();

        } else {

          serverService.addAssignment(vm.model).then(function(addedAssignment) {

            createEmptyAssignment();
            $rootScope.$broadcast(EDUCATION_EVENTS.addedAssignment, addedAssignment);
            deferred.resolve(addedAssignment);

          }, function(error) {

            vm.error = $translate.instant('Assignment.action.add.error');
            $log.error(error);
            deferred.reject(error);

          });
        }

        return deferred.promise;

      };

      /**
       * Verify the form and update the Assignment.
       */
      vm.checkFormAndUpdate = function(form) {

        var deferred = $q.defer();
        if (!vm.checkForm(form)) {

          deferred.reject();

        } else {

          serverService.updateAssignment(vm.model).then(function(updatedAssignment) {

            $rootScope.$broadcast(EDUCATION_EVENTS.updatedAssignment, updatedAssignment);
            deferred.resolve(updatedAssignment);

          }, function(error) {

            vm.error = $translate.instant('Assignment.action.update.error');
            $log.error(error);
            deferred.reject(error);

          });
        }

        return deferred.promise;

      };

    }
  }

})();

(function() {
	'use strict';

	angular.module('Education').controller('CongenialTeamsPersonalityTestController', CongenialTeamsPersonalityTestController);

	/** @ngInject */
	function CongenialTeamsPersonalityTestController($scope, serverService, $stateParams, $translate) {

		var vm = this;

		vm.loadingStudents = false;
		vm.loadingStudentsError = false;
		vm.student = null;
		vm.students = [];
		vm.loadStudentsError = false;
		if (angular.isDefined($stateParams.studentId)) {

			serverService.getStudent($stateParams.studentId).then(function(student) {

				vm.student = student;
				vm.loadingStudents = false;

			}, function() {

				loadStudents();

			});

		} else {

			loadStudents();
		}

		/**
		 * Load the student information.
		 */
		function loadStudents() {

			vm.loadingStudents = false;
			vm.student = null;
			vm.students.splice(0, vm.students.length);

			serverService.getStudents().then(function(data) {

				serverService.addAllModelsTo(data, vm.students);
				if (vm.students.length == 1) {

					vm.student = vm.students[0];
				}
				vm.loadStudent = false;

			}, function() {

				vm.loadingStudents = false;

			});

		}

		vm.loadingQuestionnaires = false;
		vm.questionnaire = null;
		vm.questionnaires = [];
		vm.loadQuestionnairesError = false;
		if (angular.isDefined($stateParams.questionnaireId)) {

			serverService.getPersonalityQuestionnaire($stateParams.questionnaireId).then(function(questionnaire) {

				vm.questionnaire = questionnaire;
				vm.loadingQuestionnaires = false;

			}, function() {

				loadQuestionnaires();

			});

		} else {

			loadQuestionnaires();
		}

		/**
		 * Load the questionnaire information.
		 */
		function loadQuestionnaires() {

			vm.loadingQuestionnaires = false;
			vm.questionnaire = null;
			vm.questionnaires.splice(0, vm.questionnaires.length);

			serverService.getPersonalityQuestionnaires().then(function(data) {

				serverService.addAllModelsTo(data, vm.questionnaires);
				if (vm.questionnaires.length == 1) {

					vm.questionnaire = vm.questionnaires[0];
				}
				vm.loadQuestionnaire = false;

			}, function() {

				vm.loadingQuestionnaires = false;

			});

		}

		vm.studentPersonalityAnswers = [];
		vm.studentPersonalityAnswersError = null;

		/**
		 * Update the student personality answers.
		 */
		function updateStudentPersonalityAnswers() {

			vm.studentPersonalityAnswers.splice(0, vm.studentPersonalityAnswers.length);
			vm.studentPersonalityAnswersError = null;
			if (angular.isObject(vm.student) && angular.isObject(vm.questionnaire)) {

				serverService.getStudentPersonalityAnswersOnQuestionnaire(vm.student, vm.questionnaire).then(updateStudentPersonalityAnswersWith, function() {

					vm.studentPersonalityAnswersError = $translate.instant('congenialTeams.personalityTest.error.loadPrevious');
					updateStudentPersonalityAnswersWith([]);
				});
			}

		}
		/**
		 * Update the student personality answers with the specified answers.
		 */
		function updateStudentPersonalityAnswersWith(studentAnswers) {

			for ( var i in vm.questionnaire.questions) {

				var question = vm.questionnaire.questions[i];
				var found = false;
				for ( var j in studentAnswers) {

					var studentAnswer = studentAnswers[j];
					if (studentAnswer.question.id === question.id) {

						studentAnswer.question = question;
						if (studentAnswer.answer != null) {

							for ( var k in question.possibleAnswerValues) {

								var value = question.possibleAnswerValues[k];
								if (value.id === studentAnswer.answer.id) {

									studentAnswer.answer = value;
									break;
								}
							}

						}
						vm.studentPersonalityAnswers.push(studentAnswer);
						found = true;
						break;
					}

				}
				if (!found) {

					var newStudentAnswer = {
						id : 0,
						student : vm.student,
						questionnaire : vm.questionnaire,
						question : question,
						answer : null
					};
					vm.studentPersonalityAnswers.push(newStudentAnswer);
				}
			}

		}
		updateStudentPersonalityAnswers();
		$scope.$watch('vm.student', updateStudentPersonalityAnswers);
		$scope.$watch('vm.questionnaire', updateStudentPersonalityAnswers);

		/**
		 * Called when a student personality answer has changed.
		 */
		vm.changedStudentPersonalityAnswer = function(studentAnswer) {

			if (studentAnswer.id == 0) {
				// add
				serverService.addStudentPersonalityAnswer(studentAnswer).then(function(addedStudentAnswer) {

					studentAnswer.id = addedStudentAnswer.id;

				}, function() {
					vm.studentPersonalityAnswersError = $translate.instant('congenialTeams.personalityTest.error.add');
				});

			} else {
				// update
				serverService.updateStudentPersonalityAnswer(studentAnswer).then(function(updateedStudentAnswer) {

					studentAnswer.id = updateedStudentAnswer.id;

				}, function() {
					vm.studentPersonalityAnswersError = $translate.instant('congenialTeams.personalityTest.error.update');
				});
			}

		};

		/**
		 * Remove all the answers for the student.
		 */
		vm.removeStudentPersonalityAnswers = function() {

			for ( var i in vm.studentPersonalityAnswers) {

				var studentAnswer = vm.studentPersonalityAnswers[i];
				if (studentAnswer.id != 0) {
					// remove
					serverService.removeStudentPersonalityAnswer(studentAnswer).then(function() {
						// Nothing to do
					}, function() {
						vm.studentPersonalityAnswersError = $translate.instant('congenialTeams.personalityTest.error.remove');
					});

				}
				studentAnswer.id = 0;
				studentAnswer.answer = null;

			}

		};
	}

})();
(function() {
	'use strict';

	angular.module('Education').controller('CongenialTeamsConteamController', CongenialTeamsConteamController);

	/** @ngInject */
	function CongenialTeamsConteamController(serverService, $log, $q, $scope) {

		var vm = this;

		vm.studentsPerGroup = 2;
		vm.questionnaire = null;
		vm.group = null;
		vm.testStatus = []

		vm.questionnaires = [];
		vm.loadingQuestionnaires = true;
		serverService.getPersonalityQuestionnaires().then(function(data) {

			serverService.addAllModelsTo(data, vm.questionnaires);
			if (vm.questionnaires.length == 1) {

				vm.questionnaire = vm.questionnaires[0];

			}
			vm.loadingQuestionnaires = false;

		}, function(error) {
			$log.error(error);
			vm.loadingQuestionnaires = false;
		});

		vm.teams = [];
		vm.groups = [];
		vm.loadingGroups = true;
		serverService.getStudentGroups().then(function(data) {

			serverService.addAllModelsTo(data, vm.groups);
			if (vm.groups.length == 1) {

				vm.group = vm.groups[0];

			}
			vm.loadingGroups = false;

		}, function(error) {
			$log.error(error);
			vm.loadingGroups = false;
		});

		$scope.$watch('vm.group', groupUpdated);
		/**
		 * Called when the group has been updated.
		 */
		function groupUpdated() {

			vm.teams.splice(0, vm.teams.length);
			if (angular.isObject(vm.group)) {

				serverService.getTeamsOn(vm.group).then(function(data) {
					serverService.addAllModelsTo(data, vm.teams);
				}, function(error) {
					$log.error(error);
				});

			}
			questionnaireUpdated();

		}
		$scope.$watch('vm.questionnaire', questionnaireUpdated);
		/**
		 * Called when the questionnaire has been updated.
		 */
		function questionnaireUpdated() {

			vm.testStatus.splice(0, vm.testStatus.length);
			if (angular.isObject(vm.group) && angular.isObject(vm.questionnaire)) {

				for ( var i in vm.group.students) {

					(function(index) {

						serverService.getStudentPersonalityAnswersOnQuestionnaire(vm.group.students[index], vm.questionnaire, 0, vm.questionnaire.questions.length).then(function(data) {

							var answers = data.length;
							if (answers == 0) {

								vm.testStatus[index] = 'toDo';

							} else if (answers == vm.questionnaire.questions.length) {

								vm.testStatus[index] = 'done';

							} else {

								vm.testStatus[index] = 'partial';
							}

						}, function(error) {
							$log.error(error);
						});

					})(i);
				}

			}
		}

		/**
		 * Called when want to form the groups.
		 */
		vm.congenialTeams = function(form) {

			var deferred = $q.defer();
			form.studentsPerGroup = {
				$error : {
					required : false
				}
			};
			var valid = true;
			if (!angular.isNumber(vm.studentsPerGroup) || vm.studentsPerGroup < 2) {

				valid = false;
			}

			if (valid) {
				serverService.congenialTeams(vm.questionnaire, vm.group, vm.studentsPerGroup).then(function(teams) {

					vm.teams.splice(0, vm.teams.length);
					serverService.addAllModelsTo(teams, vm.teams);
					deferred.resolve();

				}, function(error) {

					$log.error(error);
					deferred.reject();

				});

			} else {

				deferred.reject();
			}

			return deferred.promise;

		};

	}

})();
(function() {
	'use strict';

	angular.module('Education').controller('CollaborativeAssessmentEvaluateController', CollaborativeAssessmentEvaluateController);

	/** @ngInject */
	function CollaborativeAssessmentEvaluateController(serverService, $translate, $log) {

		var vm = this;
		vm.loading = true;
		vm.error = false;
		vm.assignments = [];
		serverService.getAssignments().then(function(data) {

			vm.loading = false;
			serverService.addAllModelsTo(data, vm.assignments);
			
			
		}, function(error) {
			
			vm.error = true;
			$log.error(error);
			vm.loading = false;
		});

	}

})();
(function() {
	'use strict';

	angular.module('Education').controller('CollaborativeAssessmentComasController', CollaborativeAssessmentComasController);

	/** @ngInject */
	function CollaborativeAssessmentComasController(serverService, $translate, $log, $stateParams) {

		var vm = this;
		vm.error = null;
		vm.loading = true;
		vm.assignment = null;
		vm.assessments = [];

		var loadError = function(error) {
			vm.error = $translate.instant('collaborativeAssessment.comas.errorLoading');
			$log.error(error);
			vm.loading = false;
		}

		serverService.getAssignment($stateParams.assignmentId).then(function(assignment) {

			vm.assignment = assignment;
			serverService.doComas(vm.assignment).then(function(assessments) {

				vm.assessments = assessments;
				vm.loading = false;

			}, loadError);

		}, loadError);

	}

})();
(function() {
  'use strict';

  angular.module('Education').directive('markInput', markInput);

  /** @ngInject */
  function markInput() {
    var directive = {
      restrict : 'E',
      template : '<div class="alert" ng-class="{\'alert-danger\':vm.error}" role="alert"><input class="number" ng-model="vm.mark" type="number" required ng-change="vm.updateAssessment()" min="vm.assignment.rubric.minMark" max="vm.assignment.rubric.maxMark"></div>',
      scope : {
        assessment : '=',
        criterion : '='
      },
      controller : MarkInputController,
      controllerAs : 'vm',
      bindToController : true
    };

    return directive;

    /** @ngInject */
    function MarkInputController(serverService, $log,$timeout) {
      var vm = this;
      vm.error = false;
      vm.mark = 0;
      updateMark($timeout);

      /**
       * Update the mark value;
       */
      function updateMark($timeout) {
      
        if (typeof vm.assessment != 'undefined') {
          
          for (var i in vm.assessment.marks) {

            if (vm.assessment.marks[i].criterion.id == vm.criterion.id) {

              vm.mark = vm.assessment.marks[i].value;
              break;
            }
          }
        
        }else{
          
          $timeout(function(){updateMark($timeout);},100);
        }

      }

      /**
       * Update an assessment.
       */
      vm.updateAssessment = function() {

        vm.error = false;
        if (angular.isNumber(vm.mark)) {

          for (var i in vm.assessment.marks) {

            if (vm.assessment.marks[i].criterion.id == vm.criterion.id) {

              vm.assessment.marks[i].value = vm.mark;
              var successAction = function(assessment) {

                angular.copy(assessment, vm.assessment);

              };
              var failureAction = function(error) {
                vm.error = true;
                $log.error(error);
              };

              if (vm.assessment.id == "L0") {

                serverService.addAssessment(vm.assessment).then(successAction, failureAction);

              } else {

                serverService.updateAssessment(vm.assessment).then(successAction, failureAction);
              }
              break;
            }
          }
        }

      };

    }
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('CollaborativeAssessmentAssessmentsController', CollaborativeAssessmentAssessmentsController);

  /** @ngInject */
  function CollaborativeAssessmentAssessmentsController(serverService, $translate, $log, $stateParams, $uibModal, $window) {
    var vm = this;
    vm.error = null;
    vm.loading = true;
    vm.assignment = null;
    vm.teacherAssessments = [];
    vm.studentAssessments = [];

    var loadError = function(error) {
      vm.error = $translate.instant('collaborativeAssessment.assessments.errorLoading');
      $log.error(error);
      vm.loading = false;
    }
    var assignmentId = $stateParams.assignmentId;
    serverService.getAssignment(assignmentId).then(function(assignment) {

      serverService.getTeacherAssessments(assignmentId).then(function(teacherAssessments) {

        serverService.getStudentAssessments(assignmentId).then(function(studentAssessments) {

          vm.studentAssessments = studentAssessments;
          vm.teacherAssessments = teacherAssessments;
          vm.assignment = assignment;
          vm.loading = false;

        }, loadError);

      }, loadError);

    }, loadError);

    /**
     * Return the teacher assessment for the specified student.
     * 
     * @param student
     *          to get the teacher assessment.
     */
    vm.getTeacherAssessment = function(student) {

      for (var i in vm.teacherAssessments) {

        if (vm.teacherAssessments[i].evaluated.id == student.id) {

          return vm.teacherAssessments[i];
        }
      }

      var assessment = {
        id : "L0",
        type : 'teacherAssessment',
        assignment : vm.assignment,
        assessor : vm.assignment.teacher,
        evaluated : student,
        marks : []
      };
      for (var j in vm.assignment.rubric.criteria) {

        var mark = {
          id : "L0",
          criterion : vm.assignment.rubric.criteria[j],
          value : 0
        };
        assessment.marks.push(mark);
      }

      vm.teacherAssessments.push(assessment);
      return assessment;
    };

    /**
     * Return the student assessment for the specified student.
     * 
     * @param student
     *          to get the student assessment.
     */
    vm.getStudentAssessment = function(assessor, student) {

      for (var i in vm.studentAssessments) {

        if (vm.studentAssessments[i].assessor.id == assessor.id && vm.studentAssessments[i].evaluated.id == student.id) {

          return vm.studentAssessments[i];
        }
      }

      var assessment = {
        id : "L0",
        type : 'studentAssessment',
        assignment : vm.assignment,
        assessor : assessor,
        evaluated : student,
        marks : []
      };
      for (var j in vm.assignment.rubric.criteria) {

        var mark = {
          id : "L0",
          criterion : vm.assignment.rubric.criteria[j],
          value : 0
        };
        assessment.marks.push(mark);
      }

      vm.studentAssessments.push(assessment);
      return assessment;
    };

    /**
     * Remove all the assessments.
     */
    vm.removeAllAssesssments = function() {

      var modalInstance = $uibModal.open({
        animation : true,
        templateUrl : 'confirmRemoveAll.html',
        controller : function($uibModalInstance) {
          var vm = this;
          vm.ok = function() {

            $uibModalInstance.close();
          };

          vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs : 'vm',
        size : 'sm'
      });

      modalInstance.result.then(function() {

        var result = {
          max : vm.teacherAssessments.length + vm.studentAssessments.length
        };
        var successAction = function() {

          result.max--;
          if (result.max <= 0) {

            $window.location.reload();
          }

        };
        var failureAction = function(error) {

          $log.error(error);
          result.max--;
          if (result.max <= 0) {

            $window.location.reload();

          } else {

            vm.error = true;

          }

        };
        for (var i in vm.teacherAssessments) {

          if (vm.teacherAssessments[i].id == "L0") {

            result.max--;

          } else {

            serverService.removeAssessment(vm.teacherAssessments[i]).then(successAction, failureAction);
          }
        }
        vm.teacherAssessments = [];

        for (var j in vm.studentAssessments) {

          if (vm.studentAssessments[j].id == "L0") {

            result.max--;

          } else {

            serverService.removeAssessment(vm.studentAssessments[j]).then(successAction, failureAction);
          }
        }
        vm.studentAssessments = [];

        if (result.max <= 0) {

          $window.location.reload();

        }

      });
    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherRubricsController', PlatformTeacherRubricsController);

  /** @ngInject */
  function PlatformTeacherRubricsController(platformService, httpService,$state) {

    var vm = this;
    vm.rubrics = null;
    vm.errorMessage = null;

    platformService.teacherGetRubrics().then(function(rubrics) {

      vm.rubrics = [];
      httpService.addAllModelsTo(rubrics, vm.rubrics);

    }, function() {

      vm.errorMessage = 'platform.teacher.rubrics.errorLoad';

    });

    /**
     * Called when want to remove an rubric.
     */
    vm.removeRubric = function(rubric) {

      platformService.teacherRemoveRubric(rubric).then(function() {

        httpService.removeModel(rubric, vm.rubrics);

      }, function() {

        vm.errorMessage = 'platform.teacher.rubrics.errorRemove';

      });

    };

    /**
     * Called when want to add a new rubric.
     */
    vm.addRubric = function() {

      var rubric = {
        id : 0,
        name : '',
        minMark : 1,
        maxMark : 4,
        criteria : []
      };
      platformService.teacherUpdateRubric(rubric).then(function(newRubric) {

        $state.go('platform.teacher.rubric', {
          rubricId : newRubric.id
        })

      }, function() {

        vm.errorMessage = 'platform.teacher.rubrics.errorAdd';

      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherRubricController', PlatformTeacherRubricController);

  /** @ngInject */
  function PlatformTeacherRubricController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.rubric = null;
    vm.errorMessage = null;

    platformService.teacherGetRubric($stateParams.rubricId).then(function(rubric) {

      vm.rubric = rubric;

    }, function() {

      vm.errorMessage = 'platform.teacher.rubric.errorLoad';

    });

    /**
     * Add a criterion
     */
    vm.addCriterion = function() {

      var criterion = {
        id : 0,
        name : '',
        description : ''
      };
      platformService.teacherUpdateCriterion(criterion).then(function(newCriterion) {

        vm.rubric.criteria.push(newCriterion);
        platformService.teacherUpdateRubric(vm.rubric).then(function() {

          $state.go('platform.teacher.criterion', {
            criterionId : newCriterion.id,
            rubricId : vm.rubric.id
          });

        }, function() {

          vm.errorMessage = 'platform.teacher.rubric.errorAddCriterion';
          platformService.teacherRemoveCriterion(newCriterion);
          httpService.removeModel(newCriterion, vm.rubric.criteria);

        });

      }, function() {

        vm.errorMessage = 'platform.teacher.rubric.errorAddCriterion';

      });

    };

    /**
     * Add a criterion
     */
    vm.removeCriterion = function(criterion) {

      httpService.removeModel(criterion, vm.rubric.criteria);
      platformService.teacherUpdateRubric(vm.rubric).then(function() {

        platformService.teacherRemoveCriterion(criterion).then(function() {
          // nothing to do

        }, function() {
          httpService.addModelTo(criterion, vm.rubric.criteria);
          vm.errorMessage = 'platform.teacher.rubric.errorRemoveCriterion';

        });

      }, function() {

        httpService.addModelTo(criterion, vm.rubric.criteria);
        vm.errorMessage = 'platform.teacher.rubric.errorRemoveCriterion';

      });

    };

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.name = {
        $error : {
          required : false
        }
      };
      form.minMark = {
        $error : {
          required : false
        }
      };
      form.maxMark = {
        $error : {
          required : false
        }
      };
      form.criteria = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (vm.rubric.name.length == 0) {

        form.name.$error.required = true;
        validForm = false;
      }
      if (vm.rubric.maxMark <= vm.rubric.minMark) {

        form.maxMark.$error.required = true;
        form.minMark.$error.required = true;
        validForm = false;
      }
      if (vm.rubric.criteria.length == 0) {

        form.criteria.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Verify the form and update the Rubric.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.teacherUpdateRubric(vm.rubric).then(function(updatedRubric) {

          $state.go('platform.teacher.rubrics');
          deferred.resolve(updatedRubric);

        }, function(error) {

          vm.error = 'Rubric.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherCriterionController', PlatformTeacherCriterionController);

  /** @ngInject */
  function PlatformTeacherCriterionController(platformService, $state, $stateParams, $q) {

    var vm = this;
    vm.criterion = null;
    vm.rubricId = $stateParams.rubricId;
    vm.errorMessage = null;

    platformService.teacherGetCriterion($stateParams.criterionId).then(function(criterion) {

      vm.criterion = criterion;

    }, function() {

      vm.errorMessage = 'platform.teacher.criterion.errorLoad';

    });

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.name = {
        $error : {
          required : false
        }
      };
      form.description = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (vm.criterion.name.length == 0) {

        form.name.$error.required = true;
        validForm = false;
      }
      if (vm.criterion.description.length == 0) {

        form.description.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Update the criterion.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.teacherUpdateCriterion(vm.criterion).then(function() {

          $state.go('platform.teacher.rubric', {
            rubricId : vm.rubricId
          })
          deferred.resolve();

        }, function(error) {

          vm.error = 'Criterion.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherProfileController', PlatformTeacherProfileController);

  /** @ngInject */
  function PlatformTeacherProfileController(platformService, $q, $state, $uibModal, PERSON_SEX) {

    var vm = this;
    vm.PERSON_SEX = PERSON_SEX;
    vm.user = platformService.getSignedUser();
    vm.email = vm.user.email;
    vm.password = '';
    vm.confirmPassword = '';
    vm.user.person.dateOfBirth = new Date(vm.user.person.dateOfBirth);

    /**
     * Remove user.
     */
    vm.removeProfile = function() {

      $uibModal.open({
        animation : true,
        templateUrl : 'confirmRemove.html',
        controller : function($uibModalInstance) {
          var $ctrl = this;
          $ctrl.cancel = function() {

            $uibModalInstance.close();
          };

          $ctrl.ok = function() {
            platformService.removeProfile(vm.user).then(function() {
              $state.go('welcome.main');
              $uibModalInstance.close();
            }, function() {
              vm.errorMessage = 'platform.teacher.profile.remove.error';
              $uibModalInstance.close();
            });
          };
        },
        controllerAs : '$ctrl',
        size : 'lg'
      });

    };

    /**
     * Update profile.
     */
    vm.updateProfile = function() {

      vm.errorMessage = null;
      var deferred = $q.defer();
      if (vm.email != vm.user.email && vm.password.length == 0) {

        vm.errorMessage = 'platform.teacher.profile.update.errorEMail';
        deferred.reject();

      } else if (vm.password.length > 0 && vm.password.length < 6) {

        vm.errorMessage = 'platform.teacher.profile.update.errorPassword';
        deferred.reject();

      } else if (vm.password.length > 0 && vm.password != vm.confirmPassword) {

        vm.errorMessage = 'platform.teacher.profile.update.errorConfirmPassword';
        deferred.reject();

      } else {

        if (vm.email != vm.user.person.email) {

          vm.user.email = vm.email;

        }
        if (vm.password.length > 0) {

          vm.user.password = platformService.codePassword(vm.email, vm.password);
        }

        platformService.updateProfile(vm.user).then(function() {
          deferred.resolve();
        }, function() {
          vm.errorMessage = 'platform.teacher.profile.update.error';
          deferred.reject();
        });
      }

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherStudentTeamsController', PlatformTeacherStudentTeamsController);

  /** @ngInject */
  function PlatformTeacherStudentTeamsController(platformService, httpService, $state, $stateParams, $q, FEEDBACK_FOR_TEAMS) {

    var vm = this;
    vm.teams = null;
    vm.errorMessage = null;
    vm.groupId = $stateParams.groupId;
    vm.studentsPerTeam = 2;
    vm.FEEDBACK_FOR_TEAMS = FEEDBACK_FOR_TEAMS;

    platformService.teacherGetStudentTeams(vm.groupId).then(function(teams) {

      vm.teams = [];
      httpService.addAllModelsTo(teams, vm.teams);

    }, function() {

      vm.errorMessage = 'platform.teacher.studentTeams.errorLoad';

    });

    /**
     * Call the congenial team composition.
     */
    vm.teamComposition = function() {

      var deferred = $q.defer();
      platformService.teacherConteam(vm.groupId, vm.studentsPerTeam).then(function(teams) {

        vm.teams.splice(0, vm.teams.length);
        httpService.addAllModelsTo(teams, vm.teams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.teacher.studentTeams.errorComposition';
        deferred.reject();

      });

      return deferred.promise;

    };
    
    /**
     * Update a team.
     */
    vm.updateTeam = function(team){
      
      platformService.teacherUpdateStudentTeam(team).then(function() {
      
      }, function() {

        vm.errorMessage = 'platform.teacher.studentTeams.errorUpdateTeam';

      });
      
    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherGroupsController', PlatformTeacherGroupsController);

  /** @ngInject */
  function PlatformTeacherGroupsController(platformService,httpService, $state, $uibModal) {

    var vm = this;
    vm.groups = null;
    vm.sessions = null;
    vm.errorMessage = null;

    platformService.teacherGetStudentGroups().then(function(groups) {

      vm.groups = [];
      vm.sessions = [];
      httpService.addAllModelsTo(groups, vm.groups);
      for ( var i in vm.groups) {

        vm.updateSession(i);

      }

    }, function() {

      vm.errorMessage = 'platform.teacher.groups.errorLoad';

    });

    /**
     * Called when want to remove a group.
     */
    vm.remove = function(group) {

      platformService.teacherRemoveStudentGroup(group).then(function() {

        for ( var i in vm.groups) {

          if (vm.groups[i].id == group.id) {
            vm.groups.splice(i, 1);
            vm.sessions.splice(i, 1);
            break;
          }
        }

      }, function() {

        vm.errorMessage = 'platform.teacher.groups.errorRemove';

      });

    };

    /**
     * Called when want to update a session.
     */
    vm.updateSession = function(index, create) {

      vm.sessions[index] = {};
      platformService.teacherGetSessionOfStudentGroup(vm.groups[index], create).then(function(data) {

        vm.sessions[index] = data;
        vm.sessions[index].status = 'active';

      }, function() {

        vm.sessions[index] = {
          status : 'expired'
        };
      });

    };

    /**
     * Called when want to remove a session.
     */
    vm.removeSession = function(index) {

      platformService.teacherRemoveStudentGroupSession(vm.sessions[index]).then(function() {

        vm.sessions[index] = {
          status : 'expired'
        };

      }, function() {

        vm.errorMessage = 'platform.teacher.groups.errorRemoveSession';

      });

    };

    /**
     * Called when want to edit a session.
     */
    vm.editSession = function(index) {

      var session = vm.sessions[index];
      $uibModal.open({
        animation : true,
        templateUrl : 'editSessionModal.html',
        controller : function($uibModalInstance, platformService) {
          var vm = this;
          vm.session = session;
          vm.options = {
            minDate : new Date()
          };
          vm.ok = function() {

            platformService.teacherUpdateStudentGroupSession(vm.session).then(function() {

              $uibModalInstance.close();

            }, function() {

              vm.errorMessage = 'platform.teacher.groups.errorUpdateSession';
              $uibModalInstance.close();

            });
          };

          vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs : 'vm',
        size : 'lg'
      });

    };

    /**
     * Add a group.
     */
    vm.addGroup = function() {

      var group = {
        id : 0,
        name : '',
        teachers : [],
        students : []
      };
      group.teachers.push(platformService.getSignedPerson());
      platformService.teacherUpdateStudentGroup(group).then(function(addedGroup) {

        $state.go('platform.teacher.group', {
          'groupId' : addedGroup.id
        });

      }, function() {

        vm.errorMessage = 'platform.teacher.groups.errorAdd';
      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherGroupController', PlatformTeacherGroupController);

  /** @ngInject */
  function PlatformTeacherGroupController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.group = null;
    vm.personalityTestStatus = [];
    vm.competenceTestStatus = [];

    platformService.teacherGetStudentGroup($stateParams.groupId).then(function(group) {

      vm.group = group;
      platformService.teacherGetTestStatus(vm.group).then(function(data) {

        for ( var i in data) {

          vm.personalityTestStatus[i] = data[i].personalityQuestionnaire;
          vm.competenceTestStatus[i] = data[i].competenceQuestionnaire;

        }

      });

    }, function() {
      vm.errorMessage = 'platform.teacher.group.errorLoad';
    });

    /**
     * Remove answer value.
     */
    vm.removeStudent = function(student) {

      for ( var i in vm.group.students) {

        if (vm.group.students[i].id == student.id) {

          vm.group.students.splice(i, 1);
          vm.personalityTestStatus.splice(i, 1);
          vm.competenceTestStatus.splice(i, 1);
          break;
        }
      }

    };

    /**
     * Update group.
     */
    vm.updateGroup = function() {

      var deferred = $q.defer();
      platformService.teacherUpdateStudentGroup(vm.group).then(function() {
        $state.go('platform.teacher.groups');
        deferred.resolve();
      }, function() {
        vm.errorMessage = 'platform.teacher.group.errorUpdate';
        deferred.reject();
      });

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherCompetenceRequestController', PlatformTeacherCompetenceRequestController);

  /** @ngInject */
  function PlatformTeacherCompetenceRequestController(platformService, $state, $stateParams, $q, COMPETENCE_FACTORS, BASIC_SCALE) {

    var vm = this;
    vm.BASIC_SCALE = BASIC_SCALE;
    vm.COMPETENCE_FACTORS = COMPETENCE_FACTORS;
    vm.competenceRequest = null;
    vm.assignmentId = $stateParams.assignmentId;
    vm.errorMessage = null;

    platformService.teacherGetCompetenceRequest($stateParams.competenceRequestId).then(function(competenceRequest) {

      vm.competenceRequest = competenceRequest;

    }, function() {

      vm.errorMessage = 'platform.teacher.competenceRequest.errorLoad';

    });

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.factor = {
        $error : {
          required : false
        }
      };
      form.level = {
        $error : {
          required : false
        }
      };
      form.importance = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (!angular.isString(vm.competenceRequest.factor)) {

        form.factor.$error.required = true;
        validForm = false;
      }
      if (!angular.isNumber(vm.competenceRequest.level)) {

        form.level.$error.required = true;
        validForm = false;
      }
      if (!angular.isNumber(vm.competenceRequest.importance)) {

        form.importance.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Update the competence request.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.teacherUpdateCompetenceRequest(vm.competenceRequest).then(function() {

          $state.go('platform.teacher.assignment', {
            assignmentId : vm.assignmentId
          })
          deferred.resolve();

        }, function(error) {

          vm.error = 'CompetenceRequest.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherAssignmentsController', PlatformTeacherAssignmentsController);

  /** @ngInject */
  function PlatformTeacherAssignmentsController(platformService, httpService) {

    var vm = this;
    vm.assignments = null;
    vm.errorMessage = null;

    platformService.teacherGetAssignments().then(function(assignments) {

      vm.assignments = [];
      httpService.addAllModelsTo(assignments, vm.assignments);

    }, function() {

      vm.errorMessage = 'platform.teacher.assignments.errorLoad';

    });

    /**
     * Called when want to remove an assignment.
     */
    vm.remove = function(assignment) {

      platformService.teacherRemoveAssignment(assignment).then(function() {

        httpService.removeModel(assignment, vm.assignments);

      }, function() {

        vm.errorMessage = 'platform.teacher.assignments.errorRemove';

      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherAssignmentTeamsController', PlatformTeacherAssignmentTeamsController);

  /** @ngInject */
  function PlatformTeacherAssignmentTeamsController(platformService, httpService, $state, $stateParams, $q, FEEDBACK_FOR_TEAMS) {

    var vm = this;
    vm.teams = null;
    vm.errorMessage = null;
    vm.assignmentId = $stateParams.assignmentId;
    vm.studentsPerTeam = 2;
    vm.FEEDBACK_FOR_TEAMS = FEEDBACK_FOR_TEAMS;

    platformService.teacherGetAssignmentTeams(vm.assignmentId).then(function(teams) {

      vm.teams = [];
      httpService.addAllModelsTo(teams, vm.teams);

    }, function() {

      vm.errorMessage = 'platform.teacher.assignmentTeams.errorLoad';

    });

    /**
     * Call the congenial team composition.
     */
    vm.teamComposition = function() {

      var deferred = $q.defer();
      platformService.teacherSynteam(vm.assignmentId, vm.studentsPerTeam).then(function(teams) {

        vm.teams.splice(0, vm.teams.length);
        httpService.addAllModelsTo(teams, vm.teams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.teacher.assignmentTeams.errorComposition';
        deferred.reject();

      });

      return deferred.promise;

    };

    /**
     * Update a team.
     */
    vm.updateTeam = function(team) {

      platformService.teacherUpdateAssignmentTeam(team).then(function() {

      }, function() {

        vm.errorMessage = 'platform.teacher.assignmentTeams.errorUpdateTeam';

      });

    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformTeacherAssignmentController', PlatformTeacherAssignmentController);

  /** @ngInject */
  function PlatformTeacherAssignmentController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.assignment = null;
    vm.errorMessage = null;
    vm.rubrics = [];
    vm.groups = [];

    platformService.teacherGetStudentGroups().then(function(definedGroups) {

      httpService.addAllModelsTo(definedGroups, vm.groups);
      if (definedGroups.length > 0 && angular.isObject(vm.assignment) && !angular.isObject(vm.assignment.group)) {

        vm.assignment.group = definedGroups[0];
      }

    });

    platformService.teacherGetRubrics().then(function(definedRubrics) {

      httpService.addAllModelsTo(definedRubrics, vm.rubrics);
      if (definedRubrics.length > 0 && angular.isObject(vm.assignment) && !angular.isObject(vm.assignment.rubric)) {

        vm.assignment.rubric = definedRubrics[0];
      }

    });

    if ($stateParams.assignmentId == 0) {

      vm.assignment = {
        id : 0,
        name : '',
        teacher : platformService.getSignedPerson(),
        rubric : null,
        group : null,
        requests : []
      };

    } else {
      platformService.teacherGetAssignment($stateParams.assignmentId).then(function(assignment) {

        vm.assignment = assignment;

      }, function() {

        vm.errorMessage = 'platform.teacher.assignment.errorLoad';

      });
    }

    /**
     * Add a competenceRequest
     */
    vm.addCompetenceRequest = function() {

      var competenceRequest = {
        id : 0,
        factor : 'VERBAL',
        level : 0.5,
        importance : 0.5
      };
      platformService.teacherUpdateCompetenceRequest(competenceRequest).then(function(newCompetenceRequest) {

        vm.assignment.requests.push(newCompetenceRequest);
        platformService.teacherUpdateAssignment(vm.assignment).then(function(updated) {

          $state.go('platform.teacher.competenceRequest', {
            competenceRequestId : newCompetenceRequest.id,
            assignmentId : updated.id
          });

        }, function() {

          vm.errorMessage = 'platform.teacher.assignment.errorAddCompetenceRequest';
          platformService.teacherRemoveCompetenceRequest(newCompetenceRequest);
          httpService.removeModel(newCompetenceRequest, vm.assignment.requests);

        });

      }, function() {

        vm.errorMessage = 'platform.teacher.assignment.errorAddCompetenceRequest';

      });

    };

    /**
     * Add a competenceRequest
     */
    vm.removeCompetenceRequest = function(competenceRequest) {

      httpService.removeModel(competenceRequest, vm.assignment.requests);
      platformService.teacherUpdateAssignment(vm.assignment).then(function() {

        platformService.teacherRemoveCompetenceRequest(competenceRequest).then(function() {
          // nothing to do

        }, function() {
          httpService.addModelTo(competenceRequest, vm.assignment.requests);
          vm.errorMessage = 'platform.teacher.assignment.errorRemoveCompetenceRequest';

        });

      }, function() {

        httpService.addModelTo(competenceRequest, vm.assignment.requests);
        vm.errorMessage = 'platform.teacher.assignment.errorRemoveCompetenceRequest';

      });

    };

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.name = {
        $error : {
          required : false
        }
      };
      form.teacher = {
        $error : {
          required : false
        }
      };
      form.rubric = {
        $error : {
          required : false
        }
      };
      form.group = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (vm.assignment.name.length == 0) {

        form.name.$error.required = true;
        validForm = false;
      }
      if (!angular.isObject(vm.assignment.teacher)) {

        form.teacher.$error.required = true;
        validForm = false;
      }
      if (!angular.isObject(vm.assignment.rubric)) {

        form.rubric.$error.required = true;
        validForm = false;
      }
      if (!angular.isObject(vm.assignment.group)) {

        form.group.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Verify the form and update the Assignment.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.teacherUpdateAssignment(vm.assignment).then(function(updatedAssignment) {

          $state.go('platform.teacher.assignments');
          deferred.resolve(updatedAssignment);

        }, function(error) {

          vm.error = 'Assignment.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformStudentProfileController', PlatformStudentProfileController);

  /** @ngInject */
  function PlatformStudentProfileController(platformService, $q, $state, $uibModal, PERSON_SEX) {

    var vm = this;
    vm.PERSON_SEX = PERSON_SEX;
    vm.user = platformService.getSignedUser();
    vm.email = vm.user.email;
    vm.password = '';
    vm.confirmPassword = '';
    vm.user.person.dateOfBirth = new Date(vm.user.person.dateOfBirth);

    /**
     * Remove user.
     */
    vm.removeProfile = function() {

      $uibModal.open({
        animation : true,
        templateUrl : 'confirmRemove.html',
        controller : function($uibModalInstance) {
          var $ctrl = this;
          $ctrl.cancel = function() {

            $uibModalInstance.close();
          };

          $ctrl.ok = function() {
            platformService.removeProfile(vm.user).then(function() {
              $state.go('welcome.main');
              $uibModalInstance.close();
            }, function() {
              vm.errorMessage = 'platform.student.profile.remove.error';
              $uibModalInstance.close();
            });
          };
        },
        controllerAs : '$ctrl',
        size : 'lg'
      });

    };

    /**
     * Update profile.
     */
    vm.updateProfile = function() {

      vm.errorMessage = null;
      var deferred = $q.defer();
      if (vm.email != vm.user.email && vm.password.length == 0) {

        vm.errorMessage = 'platform.student.profile.update.errorEMail';
        deferred.reject();

      } else if (vm.password.length > 0 && vm.password.length < 6) {

        vm.errorMessage = 'platform.student.profile.update.errorPassword';
        deferred.reject();

      } else if (vm.password.length > 0 && vm.password != vm.confirmPassword) {

        vm.errorMessage = 'platform.student.profile.update.errorConfirmPassword';
        deferred.reject();

      } else {

        if (vm.email != vm.user.person.email) {

          vm.user.email = vm.email;

        }
        if (vm.password.length > 0) {

          vm.user.password = platformService.codePassword(vm.email, vm.password);
        }

        platformService.updateProfile(vm.user).then(function() {
          deferred.resolve();
        }, function() {
          vm.errorMessage = 'platform.student.profile.update.error';
          deferred.reject();
        });
      }

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformStudentPersonalityTestController', PlatformStudentPersonalityTestController);

  /** @ngInject */
  function PlatformStudentPersonalityTestController(platformService, $uibModal) {

    var vm = this;

    vm.personalityQuestionnaire = null;
    vm.studentPersonalityAnswersError = null;

    platformService.studentGetPersonalityTest().then(function(questionnaire) {

      vm.personalityQuestionnaire = questionnaire;
      updateStudentPersonalityAnswers();

    }, function() {

      vm.studentPersonalityAnswersError = 'platform.student.personalityTest.loadError';

    });

    vm.studentPersonalityAnswers = [];
    vm.studentPersonalityAnswersError = null;
    vm.answered = 0;

    /**
     * Update the student personality answers.
     */
    function updateStudentPersonalityAnswers() {

      vm.studentPersonalityAnswers.splice(0, vm.studentPersonalityAnswers.length);
      vm.studentPersonalityAnswersError = null;
      platformService.getStudentPersonalityAnswers().then(updateStudentPersonalityAnswersWith, function() {

        vm.studentPersonalityAnswersError = 'platform.student.personalityTest.loadAnswerError';
        updateStudentPersonalityAnswersWith([]);
      });

    }
    /**
     * Update the student personality answers with the specified answers.
     */
    function updateStudentPersonalityAnswersWith(studentAnswers) {

      for ( var i in vm.personalityQuestionnaire.questions) {

        var question = vm.personalityQuestionnaire.questions[i];
        var found = false;
        for ( var j in studentAnswers) {

          var studentAnswer = studentAnswers[j];
          if (studentAnswer.question.id === question.id) {

            studentAnswer.question = question;
            if (studentAnswer.answer != null) {

              for ( var k in question.possibleAnswerValues) {

                var value = question.possibleAnswerValues[k];
                if (value.id === studentAnswer.answer.id) {

                  studentAnswer.answer = value;
                  break;
                }
              }

            }
            vm.answered++;
            vm.studentPersonalityAnswers.push(studentAnswer);
            found = true;
            break;
          }

        }
        if (!found) {

          var newStudentAnswer = {
            id : 0,
            student : platformService.getSignedPerson(),
            questionnaire : vm.personalityQuestionnaire,
            question : question,
            answer : null
          };
          vm.studentPersonalityAnswers.push(newStudentAnswer);
        }
      }

    }

    /**
     * Called when a student personality answer has changed.
     */
    vm.changedStudentPersonalityAnswer = function(studentAnswer) {

      platformService.updateStudentPersonalityAnswer(studentAnswer).then(function(updateedStudentAnswer) {

        if (studentAnswer.id == 0) {

          vm.answered++;
        }
        studentAnswer.id = updateedStudentAnswer.id;

      }, function() {
        vm.studentPersonalityAnswersError = 'platform.student.personalityTest.updateAnswerError';
      });

    };

    /**
     * Called when want to show information of a question.
     */
    vm.showQuestionInfo = function(question) {

      $uibModal.open({
        animation : true,
        templateUrl : 'questionInfoModal.html',
        controller : function($uibModalInstance) {
          var $ctrl = this;
          $ctrl.question = question;
          $ctrl.close = function() {

            $uibModalInstance.close();
          };
        },
        controllerAs : '$ctrl',
        size : 'lg'
      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformStudentGroupsController', PlatformStudentGroupsController);

  /** @ngInject */
  function PlatformStudentGroupsController(platformService, httpService, $state, $uibModal) {

    var vm = this;
    vm.groups = null;
    vm.teams = [];
    vm.errorMessage = null;
    vm.groupCode = null;

    platformService.studentGetStudentGroups().then(function(groups) {

      vm.groups = [];
      httpService.addAllModelsTo(groups, vm.groups);
      for ( var i in vm.groups) {

        vm.updateTeam(i);

      }

    }, function() {

      vm.errorMessage = 'platform.student.groups.errorLoad';

    });

    /**
     * Get the team associated to a group.
     */
    vm.updateTeam = function(index) {

      platformService.studentGetStudentTeam(vm.groups[index]).then(function(team) {

        vm.teams[index] = team;

      }, function() {

        vm.teams[index] = {};

      });
    };

    /**
     * Join into a group.
     */
    vm.joinGroup = function() {

      platformService.studentJoinToStudentGroup(vm.groupCode).then(function(joinedGroup) {

        var index = httpService.addModelTo(joinedGroup, vm.groups);
        vm.teams[index] = {};
        vm.groupCode = null;

      }, function() {

        vm.errorMessage = 'platform.student.groups.errorJoin';
      });

    };

    /**
     * Show info of the code.
     */
    vm.showInfoCode = function() {

      $uibModal.open({
        animation : true,
        templateUrl : 'InfoCodeModal.html',
        controller : function($uibModalInstance) {
          var vm = this;
          vm.close = function() {

            $uibModalInstance.close();
          };

        },
        controllerAs : 'vm',
        size : 'sm'
      });

    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformStudentCompetenceTestController', PlatformStudentCompetenceTestController);

  /** @ngInject */
  function PlatformStudentCompetenceTestController(platformService, $uibModal) {

    var vm = this;

    vm.competenceQuestionnaire = null;
    vm.studentCompetenceAnswersError = null;

    platformService.studentGetCompetenceTest().then(function(questionnaire) {

      vm.competenceQuestionnaire = questionnaire;
      updateStudentCompetenceAnswers();

    }, function() {

      vm.studentCompetenceAnswersError = 'platform.student.competenceTest.loadError';

    });

    vm.studentCompetenceAnswers = [];
    vm.studentCompetenceAnswersError = null;
    vm.answered = 0;

    /**
     * Update the student competence answers.
     */
    function updateStudentCompetenceAnswers() {

      vm.studentCompetenceAnswers.splice(0, vm.studentCompetenceAnswers.length);
      vm.studentCompetenceAnswersError = null;
      platformService.getStudentCompetenceAnswers().then(updateStudentCompetenceAnswersWith, function() {

        vm.studentCompetenceAnswersError = 'platform.student.competenceTest.loadAnswerError';
        updateStudentCompetenceAnswersWith([]);
      });

    }
    /**
     * Update the student competence answers with the specified answers.
     */
    function updateStudentCompetenceAnswersWith(studentAnswers) {

      for ( var i in vm.competenceQuestionnaire.questions) {

        var question = vm.competenceQuestionnaire.questions[i];
        var found = false;
        for ( var j in studentAnswers) {

          var studentAnswer = studentAnswers[j];
          if (studentAnswer.question.id === question.id) {

            studentAnswer.question = question;
            if (studentAnswer.answer != null) {

              for ( var k in question.possibleAnswerValues) {

                var value = question.possibleAnswerValues[k];
                if (value.id === studentAnswer.answer.id) {

                  studentAnswer.answer = value;
                  break;
                }
              }

            }
            vm.studentCompetenceAnswers.push(studentAnswer);
            found = true;
            vm.answered++;
            break;
          }

        }
        if (!found) {

          var newStudentAnswer = {
            id : 0,
            student : platformService.getSignedPerson(),
            questionnaire : vm.competenceQuestionnaire,
            question : question,
            answer : null
          };
          vm.studentCompetenceAnswers.push(newStudentAnswer);
        }
      }

    }

    /**
     * Called when a student competence answer has changed.
     */
    vm.changedStudentCompetenceAnswer = function(studentAnswer) {

      platformService.updateStudentCompetenceAnswer(studentAnswer).then(function(updateedStudentAnswer) {

        if (studentAnswer.id == 0) {

          vm.answered++;
        }
        studentAnswer.id = updateedStudentAnswer.id;

      }, function() {
        vm.studentCompetenceAnswersError = 'platform.student.competenceTest.updateAnswerError';
      });

    };

    /**
     * Called when want to show information of a question.
     */
    vm.showQuestionInfo = function(question) {

      $uibModal.open({
        animation : true,
        templateUrl : 'questionInfoModal.html',
        controller : function($uibModalInstance) {
          var $ctrl = this;
          $ctrl.question = question;
          $ctrl.close = function() {

            $uibModalInstance.close();
          };
        },
        controllerAs : '$ctrl',
        size : 'lg'
      });

    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformStudentAssignmentsController', PlatformStudentAssignmentsController);

  /** @ngInject */
  function PlatformStudentAssignmentsController(platformService, httpService) {

    var vm = this;
    vm.assignments = null;
    vm.errorMessage = null;
    vm.teams = [];

    platformService.studentGetAssignments().then(function(assignments) {

      vm.assignments = [];
      httpService.addAllModelsTo(assignments, vm.assignments);
      for ( var i in vm.assignments) {

        vm.updateTeam(i);

      }

    }, function() {

      vm.errorMessage = 'platform.student.assignments.errorLoad';

    });

    /**
     * Get the team associated to an assignment.
     */
    vm.updateTeam = function(index) {

      platformService.studentGetAssignmentTeam(vm.assignments[index]).then(function(team) {

        vm.teams[index] = team;

      }, function() {

        vm.teams[index] = {};

      });
    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminUsersController', PlatformAdminUsersController);

  /** @ngInject */
  function PlatformAdminUsersController(platformService, httpService) {

    var vm = this;
    vm.users = [];
    vm.firstUserIndex = 0;
    vm.MAX_RESULT = 100;
    vm.errorMessage = null;

    platformService.getUsers(vm.firstUserIndex, vm.MAX_RESULT).then(function(users) {

      httpService.addAllModelsTo(users, vm.users);

    }, function() {

      vm.errorMessage = 'platform.admin.users.error';

    });

    /**
     * Called when want to remove an user.
     */
    vm.remove = function(user) {

      platformService.removeUser(user).then(function() {

        httpService.removeModel(user, vm.users);

      }, function() {
        vm.errorMessage = 'platform.admin.users.removeError';
      });

    };

    /**
     * Load the previous users.
     */
    vm.previousUsers = function() {

      vm.firstUserIndex = Math.max(0, vm.firstUserIndex - vm.MAX_RESULT);
      platformService.getUsers(vm.firstUserIndex, vm.MAX_RESULT).then(function(users) {

        vm.users.splice(0, vm.users.length);
        httpService.addAllModelsTo(users, vm.users);

      }, function() {

        vm.errorMessage = 'platform.admin.users.error';

      });

    };

    /**
     * Load the next users.
     */
    vm.nextUsers = function() {

      vm.firstUserIndex = vm.firstUserIndex + vm.MAX_RESULT;
      platformService.getUsers(vm.firstUserIndex, vm.MAX_RESULT).then(function(users) {

        vm.users.splice(0, vm.users.length);
        httpService.addAllModelsTo(users, vm.users);

      }, function() {

        vm.errorMessage = 'platform.admin.users.error';

      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminUserController', PlatformAdminUserController);

  /** @ngInject */
  function PlatformAdminUserController(platformService, httpService, $state, $stateParams, PERSON_SEX, $q) {

    var vm = this;
    vm.PERSON_SEX = PERSON_SEX;
    vm.user = null;
    vm.errorMessage = null;
    vm.definedUser = {
      email : null,
      password : null
    };
    vm.errorGroupMessage = null;
    vm.playingGroups = null;
    vm.definedGroups = null;
    vm.selectedGroup = null;

    if ($stateParams.userId != 0) {

      platformService.getUser($stateParams.userId).then(function(user) {

        vm.definedUser = user;
        vm.user = {
          id : user.id,
          email : user.email,
          password : '',
          repeatpassword : ''
        };

        if (angular.isObject(user.person)) {

          vm.user.person = {
            type : user.person.type,
            id : user.person.id,
            name : user.person.name,
            sex : user.person.sex,
            dateOfBirth : new Date(user.person.dateOfBirth)
          };

          if (vm.user.person.type == 'student') {

            platformService.adminGetGroupsOfStudent(vm.user.person).then(function(groups) {

              vm.playingGroups = groups;
              httpService.removeAllModels(vm.playingGroups, vm.definedGroups);

            }, function() {

              vm.errorGroupMessage = 'platform.admin.user.errorLoadPlayGroups';
            });

            platformService.adminGetStudentGroups().then(function(groups) {

              vm.definedGroups = groups;
              httpService.removeAllModels(vm.playingGroups, vm.definedGroups);

            }, function() {

              vm.errorGroupMessage = 'platform.admin.user.errorLoadGroups';
            });
          }

        } else {

          vm.user.person = {
            id : 0,
            type : 'admin',
            sex : PERSON_SEX[0],
            dateOfBirth : new Date()
          };

        }

      }, function() {

        vm.errorMessage = 'platform.admin.user.errorLoad';

      });

    } else {

      vm.user = {
        id : 0,
        person : {
          id : 0,
          type : 'admin',
          sex : PERSON_SEX[0],
          dateOfBirth : new Date()
        }
      };

    }

    /**
     * Add the user to the platform.
     */
    vm.updateUser = function() {

      var deferred = $q.defer();
      vm.errorMessage = null;
      if (!angular.isString(vm.user.email) || vm.user.email.length > 255) {

        vm.errorMessage = 'platform.admin.user.errorEMail';
        deferred.reject();

      } else if (vm.user.email != vm.definedUser.email && (!angular.isString(vm.user.password) || vm.user.password.length > 255 || vm.user.password.length < 6)) {

        vm.errorMessage = 'platform.admin.user.errorPassword';
        deferred.reject();

      } else if (vm.user.email != vm.definedUser.email && vm.user.password != vm.user.repeatpassword) {

        vm.errorMessage = 'platform.admin.user.errorRepeatPassword';
        deferred.reject();

      } else if (vm.user.person.type != 'admin' && (!angular.isString(vm.user.person.name) || vm.user.person.name.length > 255 || vm.user.person.name.length == 0)) {

        vm.errorMessage = 'platform.admin.user.errorName';
        deferred.reject();

      } else {

        var user = {
          id : vm.user.id,
          email : vm.user.email,
          password : vm.definedUser.password
        };
        if (angular.isString(vm.user.password) && vm.user.password.length > 0) {

          user.password = platformService.codePassword(vm.user.email, vm.user.password);

        }
        if (vm.user.person.type != 'admin') {

          user.person = vm.user.person;
        }

        platformService.updateUser(user).then(function() {

          $state.go('platform.admin.users');
          deferred.resolve();

        }, function() {
          vm.errorMessage = 'platform.admin.user.errorSubmit';
          deferred.reject();
        });

      }
      return deferred.promise;

    };

    /**
     * Join the user to a group.
     */
    vm.joinToGroup = function() {

      var deferred = $q.defer();
      platformService.adminJoinStudentToGroup(vm.user.person, vm.selectedGroup).then(function() {

        httpService.removeModel(vm.selectedGroup, vm.definedGroups);
        httpService.addModelTo(vm.selectedGroup, vm.playingGroups);
        vm.selectedGroup = null;
        deferred.resolve();

      }, function() {
        vm.errorGroupMessage = 'platform.admin.user.errorJoinToGroup';
        deferred.reject();
      });
      return deferred.promise;

    };

    /**
     * Join the user to a group.
     */
    vm.removeFromGroup = function(group) {

      platformService.adminLeaveStudentFromGroup(vm.user.person, group).then(function() {

        httpService.removeModel(group, vm.playingGroups);
        httpService.addModelTo(group, vm.definedGroups);

      }, function() {
        vm.errorGroupMessage = 'platform.admin.user.errorRemoveFromGroup';
      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminRubricsController', PlatformAdminRubricsController);

  /** @ngInject */
  function PlatformAdminRubricsController(platformService, httpService,$state) {

    var vm = this;
    vm.rubrics = null;
    vm.errorMessage = null;

    platformService.adminGetRubrics().then(function(rubrics) {

      vm.rubrics = [];
      httpService.addAllModelsTo(rubrics, vm.rubrics);

    }, function() {

      vm.errorMessage = 'platform.admin.rubrics.errorLoad';

    });

    /**
     * Called when want to remove an rubric.
     */
    vm.removeRubric = function(rubric) {

      platformService.adminRemoveRubric(rubric).then(function() {

        httpService.removeModel(rubric, vm.rubrics);

      }, function() {

        vm.errorMessage = 'platform.admin.rubrics.errorRemove';

      });

    };

    /**
     * Called when want to add a new rubric.
     */
    vm.addRubric = function() {

      var rubric = {
        id : 0,
        name : '',
        minMark : 1,
        maxMark : 4,
        criteria : []
      };
      platformService.adminUpdateRubric(rubric).then(function(newRubric) {

        $state.go('platform.admin.rubric', {
          rubricId : newRubric.id
        })

      }, function() {

        vm.errorMessage = 'platform.admin.rubrics.errorAdd';

      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminRubricController', PlatformAdminRubricController);

  /** @ngInject */
  function PlatformAdminRubricController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.rubric = null;
    vm.errorMessage = null;

    platformService.adminGetRubric($stateParams.rubricId).then(function(rubric) {

      vm.rubric = rubric;

    }, function() {

      vm.errorMessage = 'platform.admin.rubric.errorLoad';

    });

    /**
     * Add a criterion
     */
    vm.addCriterion = function() {

      var criterion = {
        id : 0,
        name : '',
        description : ''
      };
      platformService.adminUpdateCriterion(criterion).then(function(newCriterion) {

        vm.rubric.criteria.push(newCriterion);
        platformService.adminUpdateRubric(vm.rubric).then(function() {

          $state.go('platform.admin.criterion', {
            criterionId : newCriterion.id,
            rubricId : vm.rubric.id
          });

        }, function() {

          vm.errorMessage = 'platform.admin.rubric.errorAddCriterion';
          platformService.adminRemoveCriterion(newCriterion);
          httpService.removeModel(newCriterion, vm.rubric.criteria);

        });

      }, function() {

        vm.errorMessage = 'platform.admin.rubric.errorAddCriterion';

      });

    };

    /**
     * Add a criterion
     */
    vm.removeCriterion = function(criterion) {

      httpService.removeModel(criterion, vm.rubric.criteria);
      platformService.adminUpdateRubric(vm.rubric).then(function() {

        platformService.adminRemoveCriterion(criterion).then(function() {
          // nothing to do

        }, function() {
          httpService.addModelTo(criterion, vm.rubric.criteria);
          vm.errorMessage = 'platform.admin.rubric.errorRemoveCriterion';

        });

      }, function() {

        httpService.addModelTo(criterion, vm.rubric.criteria);
        vm.errorMessage = 'platform.admin.rubric.errorRemoveCriterion';

      });

    };

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.name = {
        $error : {
          required : false
        }
      };
      form.minMark = {
        $error : {
          required : false
        }
      };
      form.maxMark = {
        $error : {
          required : false
        }
      };
      form.criteria = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (vm.rubric.name.length == 0) {

        form.name.$error.required = true;
        validForm = false;
      }
      if (vm.rubric.maxMark <= vm.rubric.minMark) {

        form.maxMark.$error.required = true;
        form.minMark.$error.required = true;
        validForm = false;
      }
      if (vm.rubric.criteria.length == 0) {

        form.criteria.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Verify the form and update the Rubric.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.adminUpdateRubric(vm.rubric).then(function(updatedRubric) {

          $state.go('platform.admin.rubrics');
          deferred.resolve(updatedRubric);

        }, function(error) {

          vm.error = 'Rubric.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminCriterionController', PlatformAdminCriterionController);

  /** @ngInject */
  function PlatformAdminCriterionController(platformService, $state, $stateParams, $q) {

    var vm = this;
    vm.criterion = null;
    vm.rubricId = $stateParams.rubricId;
    vm.errorMessage = null;

    platformService.adminGetCriterion($stateParams.criterionId).then(function(criterion) {

      vm.criterion = criterion;

    }, function() {

      vm.errorMessage = 'platform.admin.criterion.errorLoad';

    });

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.name = {
        $error : {
          required : false
        }
      };
      form.description = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (vm.criterion.name.length == 0) {

        form.name.$error.required = true;
        validForm = false;
      }
      if (vm.criterion.description.length == 0) {

        form.description.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Update the criterion.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.adminUpdateCriterion(vm.criterion).then(function() {

          $state.go('platform.admin.rubric', {
            rubricId : vm.rubricId
          })
          deferred.resolve();

        }, function(error) {

          vm.error = 'Criterion.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminPersonalityQuestionController', PlatformAdminPersonalityQuestionController);

  /** @ngInject */
  function PlatformAdminPersonalityQuestionController(platformService, httpService, $state, $stateParams, $q, PERSONALITY_FACTORS) {

    var vm = this;
    vm.question = null;
    vm.PERSONALITY_FACTORS = PERSONALITY_FACTORS;
    vm.answerValues = [];

    platformService.adminGetPersonalityQuestion($stateParams.questionId).then(function(question) {
      vm.question = question;
    }, function() {
      vm.errorMessage = 'platform.admin.personalityQuestion.loadError';
    });

    platformService.adminGetPersonalityAnswerValues().then(function(answerValues) {
      httpService.addAllModelsTo(answerValues, vm.answerValues);
    }, function() {
      vm.errorMessage = 'platform.admin.personalityQuestion.loadAnswerValuesError';
    });

    /**
     * Add answer value.
     */
    vm.addAnswerValue = function() {

      var answerValue = {
        id : 0,
        name : '',
        description : '',
        value : 0
      };
      platformService.adminUpdatePersonalityAnswerValue(answerValue).then(function(addedAnswerValue) {

        httpService.addModelTo(addedAnswerValue, vm.question.possibleAnswerValues);
        platformService.adminUpdatePersonalityQuestion(vm.question).then(function() {

          $state.go('platform.admin.personalityAnswerValue', {
            'questionId' : vm.question.id,
            'answerValueId' : addedAnswerValue.id
          });

        }, function() {

          vm.errorMessage = 'platform.admin.personalityQuestion.addAnswerValueError';
          httpService.removeModel(addedAnswerValue, vm.question.possibleAnswerValues);

        });

      }, function() {

        vm.errorMessage = 'platform.admin.personalityQuestion.addAnswerValueError';
      });
    };

    /**
     * Update question.
     */
    vm.updateQuestion = function() {

      var deferred = $q.defer();
      platformService.adminUpdatePersonalityQuestion(vm.question).then(function() {
        $state.go('platform.admin.personalityTest');
        deferred.resolve();
      }, function() {
        vm.errorMessage = 'platform.admin.personalityQuestion.updateError';
        deferred.reject();
      });

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminPersonalityTestController', PlatformAdminPersonalityTestController);

  /** @ngInject */
  function PlatformAdminPersonalityTestController(platformService, httpService, $state, $q, PERSONALITY_FACTORS) {

    var vm = this;

    vm.personalityQuestionnaire = null;
    vm.errorMessage = null;

    platformService.adminGetPersonalityTest().then(function(questionnaire) {

      vm.personalityQuestionnaire = questionnaire;

    }, function() {

      vm.errorMessage = 'platform.admin.personalityTest.loadError';

    });

    /**
     * Add a question.
     */
    vm.addQuestion = function() {

      var question = {
        id : 0,
        question : '',
        description : '',
        factor : PERSONALITY_FACTORS[0],
        possibleAnswerValues : []
      };
      platformService.adminUpdatePersonalityQuestion(question).then(function(addedQuestion) {

        httpService.addModelTo(addedQuestion, vm.personalityQuestionnaire.questions);
        platformService.adminUpdatePersonalityTest(vm.personalityQuestionnaire).then(function() {

          $state.go('platform.admin.personalityQuestion', {
            'questionId' : addedQuestion.id,
            'question' : addedQuestion
          });

        }, function() {

          vm.errorMessage = 'platform.admin.personalityTest.addQuestionError';
          httpService.removeModel(addedQuestion, vm.personalityQuestionnaire.questions);

        });

      }, function() {

        vm.errorMessage = 'platform.admin.personalityTest.addQuestionError';
      });

    };

    /**
     * Remove a question.
     */
    vm.removeQuestion = function(question) {

      httpService.removeModel(question, vm.personalityQuestionnaire.questions);

    };

    /**
     * Update the personality test.
     */
    vm.updatePersonalityTest = function() {

      var deferred = $q.defer();
      platformService.adminUpdatePersonalityTest(vm.personalityQuestionnaire).then(function(updated) {

        vm.personalityQuestionnaire = updated;
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.personalityTest.updateError';
        deferred.reject();

      });

      return deferred.promise;
    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminPersonalityAnswerValueController', PlatformAdminPersonalityAnswerValueController);

  /** @ngInject */
  function PlatformAdminPersonalityAnswerValueController(platformService, $state, $stateParams, $q) {

    var vm = this;
    vm.answerValue = null;
    vm.questionId = $stateParams.questionId;

    platformService.adminGetPersonalityAnswerValue($stateParams.answerValueId).then(function(answerValue) {
      vm.answerValue = answerValue;
    }, function() {
      vm.errorMessage = 'platform.admin.personalityAnswerValue.loadError';
    });

    /**
     * Update answer value.
     */
    vm.updateAnswerValue = function() {

      var deferred = $q.defer();
      platformService.adminUpdatePersonalityAnswerValue(vm.answerValue).then(function() {
        $state.go('platform.admin.personalityQuestion', {
          questionId : vm.questionId
        });
        deferred.resolve();
      }, function() {
        vm.errorMessage = 'platform.admin.personalityAnswerValue.updateError';
        deferred.reject();
      });

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminStudentTeamsController', PlatformAdminStudentTeamsController);

  /** @ngInject */
  function PlatformAdminStudentTeamsController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.teams = null;
    vm.errorMessage = null;
    vm.groupId = $stateParams.groupId;
    vm.studentsPerTeam = 2;
    vm.defaultAssignemnt = null;
    vm.assignmentTeams = null;

    platformService.adminGetStudentTeams(vm.groupId).then(function(teams) {

      vm.teams = [];
      httpService.addAllModelsTo(teams, vm.teams);

    }, function() {

      vm.errorMessage = 'platform.admin.studentTeams.errorLoad';

    });

    platformService.adminGetDefaultAssignmentOf(vm.groupId).then(function(assignment) {

      vm.defaultAssignemnt = assignment;
      platformService.adminGetAssignmentTeams(vm.defaultAssignemnt).then(function(teams) {

        vm.assignmentTeams = [];
        httpService.addAllModelsTo(teams, vm.assignmentTeams);

      }, function() {

        vm.errorMessage = 'platform.admin.studentTeams.errorLoadAssignemnts';

      });

    }, function() {

      vm.errorMessage = 'platform.admin.studentTeams.errorLoadAssignemnt';

    });

    /**
     * Call the congenial team composition.
     */
    vm.conteamComposition = function() {

      var deferred = $q.defer();
      platformService.adminConteam(vm.groupId, vm.studentsPerTeam).then(function(teams) {

        vm.teams.splice(0, vm.teams.length);
        httpService.addAllModelsTo(teams, vm.teams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.studentTeams.errorConteam';
        deferred.reject();

      });

      return deferred.promise;

    };

    /**
     * Call the synergistic team composition.
     */
    vm.synteamComposition = function() {

      var deferred = $q.defer();
      platformService.adminSynteam(vm.defaultAssignemnt, vm.studentsPerTeam).then(function(teams) {

        vm.assignmentTeams.splice(0, vm.assignmentTeams.length);
        httpService.addAllModelsTo(teams, vm.assignmentTeams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.studentTeams.errorSynteam';
        deferred.reject();

      });

      return deferred.promise;

    };

    /**
     * Call the synergistic team composition.
     */
    vm.lpteamComposition = function() {

      var deferred = $q.defer();
      platformService.adminLpteam(vm.defaultAssignemnt, vm.studentsPerTeam).then(function(teams) {

        vm.assignmentTeams.splice(0, vm.assignmentTeams.length);
        httpService.addAllModelsTo(teams, vm.assignmentTeams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.studentTeams.errorLpteam';
        deferred.reject();

      });

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminStudentPersonalityTestController', PlatformAdminStudentPersonalityTestController);

  /** @ngInject */
  function PlatformAdminStudentPersonalityTestController(platformService, $stateParams) {

    var vm = this;

    vm.groupId = $stateParams.groupId;
    vm.studentId = $stateParams.studentId;
    vm.personalityQuestionnaire = null;
    vm.errorMsg = null;
    vm.studentPersonalityAnswers = [];
    vm.answered = 0;
    vm.student = null;

    platformService.adminGetPersonalityTest().then(function(questionnaire) {

      platformService.adminGetStudent(vm.studentId).then(function(student) {
        platformService.adminGetStudentPersonalityAnswers(vm.studentId).then(function(studentAnswers) {

          vm.personalityQuestionnaire = questionnaire;
          vm.student = student;
          updateStudentPersonalityAnswersWith(studentAnswers);

        }, function() {

          vm.errorMsg = 'platform.admin.studentPersonalityTest.errroLoadAnswers';

        });

      }, function() {

        vm.errorMsg = 'platform.admin.studentPersonalityTest.errroLoadStudent';

      });
    }, function() {

      vm.errorMsg = 'platform.admin.studentPersonalityTest.errroLoadQuestionnaire';

    });

    /**
     * Update the student personality answers with the specified answers.
     */
    function updateStudentPersonalityAnswersWith(studentAnswers) {

      for ( var i in vm.personalityQuestionnaire.questions) {

        var question = vm.personalityQuestionnaire.questions[i];
        var found = false;
        for ( var j in studentAnswers) {

          var studentAnswer = studentAnswers[j];
          if (studentAnswer.question.id === question.id) {

            studentAnswer.question = question;
            if (studentAnswer.answer != null) {

              for ( var k in question.possibleAnswerValues) {

                var value = question.possibleAnswerValues[k];
                if (value.id === studentAnswer.answer.id) {

                  studentAnswer.answer = value;
                  break;
                }
              }

            }
            vm.answered++;
            vm.studentPersonalityAnswers.push(studentAnswer);
            found = true;
            break;
          }

        }
        if (!found) {

          var newStudentAnswer = {
            id : 0,
            student : vm.student,
            questionnaire : vm.personalityQuestionnaire,
            question : question,
            answer : null
          };
          vm.studentPersonalityAnswers.push(newStudentAnswer);
        }
      }

    }

    /**
     * Called when a student personality answer has changed.
     */
    vm.changedStudentPersonalityAnswer = function(studentAnswer) {

      vm.errorMsg = null;
      platformService.adminUpdateStudentPersonalityAnswer(studentAnswer).then(function(updateedStudentAnswer) {

        if (studentAnswer.id == 0) {

          vm.answered++;
        }
        studentAnswer.id = updateedStudentAnswer.id;

      }, function() {
        vm.errorMsg = 'platform.admin.studentPersonalityTest.errorUpdateAnswer';
      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminStudentCompetenceTestController', PlatformAdminStudentCompetenceTestController);

  /** @ngInject */
  function PlatformAdminStudentCompetenceTestController(platformService, $stateParams) {

    var vm = this;

    vm.groupId = $stateParams.groupId;
    vm.studentId = $stateParams.studentId;
    vm.competenceQuestionnaire = null;
    vm.errorMsg = null;
    vm.studentCompetenceAnswers = [];
    vm.answered = 0;
    vm.student = null;

    platformService.adminGetCompetenceTest().then(function(questionnaire) {

      platformService.adminGetStudent(vm.studentId).then(function(student) {

        platformService.adminGetStudentCompetenceAnswers(vm.studentId).then(function(studentAnswers) {

          vm.competenceQuestionnaire = questionnaire;
          vm.student = student;
          updateStudentCompetenceAnswersWith(studentAnswers);

        }, function() {

          vm.errorMsg = 'platform.admin.studentCompetenceTest.errroLoadAnswers';

        });

      }, function() {

        vm.errorMsg = 'platform.admin.studentCompetenceTest.errroLoadStudent';

      });

    }, function() {

      vm.errorMsg = 'platform.admin.studentCompetenceTest.errroLoadQuestionnaire';

    });

    /**
     * Update the student competence answers with the specified answers.
     */
    function updateStudentCompetenceAnswersWith(studentAnswers) {

      for ( var i in vm.competenceQuestionnaire.questions) {

        var question = vm.competenceQuestionnaire.questions[i];
        var found = false;
        for ( var j in studentAnswers) {

          var studentAnswer = studentAnswers[j];
          if (studentAnswer.question.id === question.id) {

            studentAnswer.question = question;
            if (studentAnswer.answer != null) {

              for ( var k in question.possibleAnswerValues) {

                var value = question.possibleAnswerValues[k];
                if (value.id === studentAnswer.answer.id) {

                  studentAnswer.answer = value;
                  break;
                }
              }

            }
            vm.answered++;
            vm.studentCompetenceAnswers.push(studentAnswer);
            found = true;
            break;
          }

        }
        if (!found) {

          var newStudentAnswer = {
            id : 0,
            student : vm.student,
            questionnaire : vm.competenceQuestionnaire,
            question : question,
            answer : null
          };
          vm.studentCompetenceAnswers.push(newStudentAnswer);
        }
      }

    }

    /**
     * Called when a student competence answer has changed.
     */
    vm.changedStudentCompetenceAnswer = function(studentAnswer) {

      vm.errorMsg = null;
      platformService.adminUpdateStudentCompetenceAnswer(studentAnswer).then(function(updateedStudentAnswer) {

        if (studentAnswer.id == 0) {

          vm.answered++;
        }
        studentAnswer.id = updateedStudentAnswer.id;

      }, function() {
        vm.errorMsg = 'platform.admin.studentCompetenceTest.errorUpdateAnswer';
      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminGroupsController', PlatformAdminGroupsController);

  /** @ngInject */
  function PlatformAdminGroupsController(platformService, httpService, $state, $uibModal) {

    var vm = this;
    vm.groups = null;
    vm.sessions = null;
    vm.errorMessage = null;

    platformService.adminGetStudentGroups().then(function(groups) {

      vm.groups = [];
      vm.sessions = [];
      httpService.addAllModelsTo(groups, vm.groups);
      for ( var i in vm.groups) {

        vm.updateSession(i);

      }

    }, function() {

      vm.errorMessage = 'platform.admin.groups.errorLoad';

    });

    /**
     * Called when want to remove a group.
     */
    vm.remove = function(group) {

      platformService.adminRemoveStudentGroup(group).then(function() {

        for ( var i in vm.groups) {

          if (vm.groups[i].id == group.id) {
            vm.groups.splice(i, 1);
            vm.sessions.splice(i, 1);
            break;
          }
        }

      }, function() {

        vm.errorMessage = 'platform.admin.groups.errorRemove';

      });

    };

    /**
     * Called when want to update a session.
     */
    vm.updateSession = function(index, create) {

      vm.sessions[index] = {};
      platformService.adminGetSessionOfStudentGroup(vm.groups[index], create).then(function(data) {

        vm.sessions[index] = data;
        vm.sessions[index].status = 'active';

      }, function() {

        vm.sessions[index] = {
          status : 'expired'
        };
      });

    };

    /**
     * Called when want to remove a session.
     */
    vm.removeSession = function(index) {

      platformService.adminRemoveStudentGroupSession(vm.sessions[index]).then(function() {

        vm.sessions[index] = {
          status : 'expired'
        };

      }, function() {

        vm.errorMessage = 'platform.admin.groups.errorRemoveSession';

      });

    };

    /**
     * Called when want to edit a session.
     */
    vm.editSession = function(index) {

      var session = vm.sessions[index];
      $uibModal.open({
        animation : true,
        templateUrl : 'editSessionModal.html',
        controller : function($uibModalInstance, platformService) {
          var vm = this;
          vm.session = session;
          vm.options = {
            minDate : new Date()
          };
          vm.ok = function() {

            platformService.adminUpdateStudentGroupSession(vm.session).then(function() {

              $uibModalInstance.close();

            }, function() {

              vm.errorMessage = 'platform.admin.groups.errorUpdateSession';
              $uibModalInstance.close();

            });
          };

          vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs : 'vm',
        size : 'lg'
      });

    };

    /**
     * Add a group.
     */
    vm.addGroup = function() {

      var group = {
        id : 0,
        name : '',
        students : []
      };
      platformService.adminUpdateStudentGroup(group).then(function(addedGroup) {

        $state.go('platform.admin.group', {
          'groupId' : addedGroup.id
        });

      }, function() {

        vm.errorMessage = 'platform.admin.groups.errorAdd';
      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminGroupController', PlatformAdminGroupController);

  /** @ngInject */
  function PlatformAdminGroupController(platformService, httpService, $state, $stateParams, $q, $uibModal) {

    var vm = this;
    vm.group = null;
    vm.groups = [];
    vm.students = [];
    vm.selectedStudent = null;
    vm.teachers = [];
    vm.selectedTeacher = null;
    vm.personalityTestStatus = [];
    vm.competenceTestStatus = [];

    platformService.adminGetStudentGroups().then(function(groups) {

      httpService.addAllModelsTo(groups, vm.groups);

    }, function() {

      vm.errorMessage = 'platform.admin.groups.errorLoad';

    });

    platformService.adminGetStudentGroup($stateParams.groupId).then(function(group) {
      vm.group = group;
      for ( var i in vm.group.students) {

        (function(student, i) {

          platformService.adminGetTestStatus(student).then(function(data) {

            vm.personalityTestStatus[i] = data.personalityQuestionnaire;
            vm.competenceTestStatus[i] = data.competenceQuestionnaire;

          });

        })(vm.group.students[i], i);
      }

      platformService.adminGetStudentGroups().then(function(groups) {

        httpService.addAllModelsTo(groups, vm.groups);
        httpService.removeModel(vm.group, vm.groups);

      }, function() {

        vm.errorMessage = 'platform.admin.groups.errorLoad';

      });

    }, function() {
      vm.errorMessage = 'platform.admin.group.errorLoad';
    });

    platformService.getUsers().then(function(users) {

      for ( var i in users) {

        var person = users[i].person;
        if (angular.isObject(person) && person.type == 'student') {

          httpService.addModelTo(person, vm.students);

        } else if (angular.isObject(person) && person.type == 'teacher') {

          httpService.addModelTo(person, vm.teachers);

        }
      }

    }, function() {
      vm.errorMessage = 'platform.admin.group.errorLoadStudents';
    });

    /**
     * Add answer value.
     */
    vm.addStudent = function() {

      if (angular.isObject(vm.selectedStudent)) {

        httpService.addModelTo(vm.selectedStudent, vm.group.students);
        platformService.adminGetTestStatus(vm.selectedStudent).then(function(data) {
          for ( var i in vm.group.students) {

            if (vm.group.students[i].id == vm.selectedStudent.id) {
              vm.personalityTestStatus[i] = data.personalityQuestionnaire;
              vm.competenceTestStatus[i] = data.competenceQuestionnaire;
              break;
            }
          }

        });
      }

    };

    /**
     * Remove answer value.
     */
    vm.removeStudent = function(student) {

      for ( var i in vm.group.students) {

        if (vm.group.students[i].id == student.id) {

          vm.group.students.splice(i, 1);
          vm.personalityTestStatus.splice(i, 1);
          vm.competenceTestStatus.splice(i, 1);
          break;
        }
      }

    };

    /**
     * Add answer value.
     */
    vm.addTeacher = function() {

      if (angular.isObject(vm.selectedTeacher)) {
        httpService.addModelTo(vm.selectedTeacher, vm.group.teachers);
      }

    };

    /**
     * Remove answer value.
     */
    vm.removeTeacher = function(teacher) {

      httpService.removeModel(teacher, vm.group.teachers);

    };

    /**
     * Update group.
     */
    vm.updateGroup = function() {

      var deferred = $q.defer();
      platformService.adminUpdateStudentGroup(vm.group).then(function() {
        $state.go('platform.admin.groups');
        deferred.resolve();
      }, function() {
        vm.errorMessage = 'platform.admin.group.errorUpdate';
        deferred.reject();
      });

      return deferred.promise;
    };

    /**
     * move an student to another group.
     */
    vm.moveStudent = function(student) {

      $uibModal.open({
        animation : true,
        templateUrl : 'selectGroup.html',
        controller : function($uibModalInstance) {
          var $ctrl = this;
          $ctrl.student = student;
          $ctrl.groups = vm.groups;
          $ctrl.group = vm.groups[0];
          $ctrl.cancel = function() {

            $uibModalInstance.close();
          };

          $ctrl.ok = function() {

            httpService.removeModel(student, vm.group.students);
            platformService.adminUpdateStudentGroup(vm.group).then(function() {

              httpService.addModelTo(student, $ctrl.group.students);
              platformService.adminUpdateStudentGroup($ctrl.group).then(function() {

                $uibModalInstance.close();

              }, function() {

                httpService.removeModel(student, $ctrl.group.students);
                httpService.addModelTo(student, vm.group.students);
                vm.errorMessage = 'platform.admin.group.moveStudent.error';
                $uibModalInstance.close();

              });

            }, function() {
              vm.errorMessage = 'platform.admin.group.moveStudent.error';
              $uibModalInstance.close();
            });
          };
        },
        controllerAs : '$ctrl',
        size : 'lg'
      });
    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminCompetenceQuestionController', PlatformAdminCompetenceQuestionController);

  /** @ngInject */
  function PlatformAdminCompetenceQuestionController(platformService, httpService, $state, $stateParams, $q, COMPETENCE_FACTORS) {

    var vm = this;
    vm.question = null;
    vm.COMPETENCE_FACTORS = COMPETENCE_FACTORS;
    vm.answerValues = [];

    platformService.adminGetCompetenceQuestion($stateParams.questionId).then(function(question) {
      vm.question = question;
    }, function() {
      vm.errorMessage = 'platform.admin.competenceQuestion.loadError';
    });

    platformService.adminGetCompetenceAnswerValues().then(function(answerValues) {
      httpService.addAllModelsTo(answerValues, vm.answerValues);
    }, function() {
      vm.errorMessage = 'platform.admin.competenceQuestion.loadAnswerValuesError';
    });

    /**
     * Add answer value.
     */
    vm.addAnswerValue = function() {

      var answerValue = {
        id : 0,
        name : '',
        description : '',
        value : 0
      };
      platformService.adminUpdateCompetenceAnswerValue(answerValue).then(function(addedAnswerValue) {

        httpService.addModelTo(addedAnswerValue, vm.question.possibleAnswerValues);
        platformService.adminUpdateCompetenceQuestion(vm.question).then(function() {

          $state.go('platform.admin.competenceAnswerValue', {
            'questionId' : vm.question.id,
            'answerValueId' : addedAnswerValue.id
          });

        }, function() {

          vm.errorMessage = 'platform.admin.competenceQuestion.addAnswerValueError';
          httpService.removeModel(addedAnswerValue, vm.question.possibleAnswerValues);

        });

      }, function() {

        vm.errorMessage = 'platform.admin.competenceQuestion.addAnswerValueError';
      });
    };

    /**
     * Update question.
     */
    vm.updateQuestion = function() {

      var deferred = $q.defer();
      platformService.adminUpdateCompetenceQuestion(vm.question).then(function() {
        $state.go('platform.admin.competenceTest');
        deferred.resolve();
      }, function() {
        vm.errorMessage = 'platform.admin.competenceQuestion.updateError';
        deferred.reject();
      });

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminCompetenceTestController', PlatformAdminCompetenceTestController);

  /** @ngInject */
  function PlatformAdminCompetenceTestController(platformService, httpService, $state, $q, COMPETENCE_FACTORS) {

    var vm = this;

    vm.competenceQuestionnaire = null;
    vm.errorMessage = null;

    platformService.adminGetCompetenceTest().then(function(questionnaire) {

      vm.competenceQuestionnaire = questionnaire;

    }, function() {

      vm.errorMessage = 'platform.admin.competenceTest.loadError';

    });

    /**
     * Add a question.
     */
    vm.addQuestion = function() {

      var question = {
        id : 0,
        question : '',
        description : '',
        factor : COMPETENCE_FACTORS[0],
        possibleAnswerValues : []
      };
      platformService.adminUpdateCompetenceQuestion(question).then(function(addedQuestion) {

        httpService.addModelTo(addedQuestion, vm.competenceQuestionnaire.questions);
        platformService.adminUpdateCompetenceTest(vm.competenceQuestionnaire).then(function() {

          $state.go('platform.admin.competenceQuestion', {
            'questionId' : addedQuestion.id,
            'question' : addedQuestion
          });

        }, function() {

          vm.errorMessage = 'platform.admin.competenceTest.addQuestionError';
          httpService.removeModel(addedQuestion, vm.competenceQuestionnaire.questions);

        });

      }, function() {

        vm.errorMessage = 'platform.admin.competenceTest.addQuestionError';
      });

    };

    /**
     * Remove a question.
     */
    vm.removeQuestion = function(question) {

      httpService.removeModel(question, vm.competenceQuestionnaire.questions);

    };

    /**
     * Update the competence test.
     */
    vm.updateCompetenceTest = function() {

      var deferred = $q.defer();
      platformService.adminUpdateCompetenceTest(vm.competenceQuestionnaire).then(function(updated) {

        vm.competenceQuestionnaire = updated;
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.competenceTest.updateError';
        deferred.reject();

      });

      return deferred.promise;
    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminCompetenceAnswerValueController', PlatformAdminCompetenceAnswerValueController);

  /** @ngInject */
  function PlatformAdminCompetenceAnswerValueController(platformService, $state, $stateParams, $q) {

    var vm = this;
    vm.answerValue = null;
    vm.questionId = $stateParams.questionId;

    platformService.adminGetCompetenceAnswerValue($stateParams.answerValueId).then(function(answerValue) {
      vm.answerValue = answerValue;
    }, function() {
      vm.errorMessage = 'platform.admin.competenceAnswerValue.loadError';
    });

    /**
     * Update answer value.
     */
    vm.updateAnswerValue = function() {

      var deferred = $q.defer();
      platformService.adminUpdateCompetenceAnswerValue(vm.answerValue).then(function() {
        $state.go('platform.admin.competenceQuestion', {
          questionId : vm.questionId
        });
        deferred.resolve();
      }, function() {
        vm.errorMessage = 'platform.admin.competenceAnswerValue.updateError';
        deferred.reject();
      });

      return deferred.promise;
    };
  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminCompetenceRequestController', PlatformAdminCompetenceRequestController);

  /** @ngInject */
  function PlatformAdminCompetenceRequestController(platformService, $state, $stateParams, $q, COMPETENCE_FACTORS, BASIC_SCALE) {

    var vm = this;
    vm.BASIC_SCALE = BASIC_SCALE;
    vm.COMPETENCE_FACTORS = COMPETENCE_FACTORS;
    vm.competenceRequest = null;
    vm.assignmentId = $stateParams.assignmentId;
    vm.errorMessage = null;

    platformService.adminGetCompetenceRequest($stateParams.competenceRequestId).then(function(competenceRequest) {

      vm.competenceRequest = competenceRequest;

    }, function() {

      vm.errorMessage = 'platform.admin.competenceRequest.errorLoad';

    });

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.factor = {
        $error : {
          required : false
        }
      };
      form.level = {
        $error : {
          required : false
        }
      };
      form.importance = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (!angular.isString(vm.competenceRequest.factor)) {

        form.factor.$error.required = true;
        validForm = false;
      }
      if (!angular.isNumber(vm.competenceRequest.level)) {

        form.level.$error.required = true;
        validForm = false;
      }
      if (!angular.isNumber(vm.competenceRequest.importance)) {

        form.importance.$error.required = true;
        validForm = false;
      }
      return validForm;
    };

    /**
     * Update the competence request.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.adminUpdateCompetenceRequest(vm.competenceRequest).then(function() {

          $state.go('platform.admin.assignment', {
            assignmentId : vm.assignmentId
          })
          deferred.resolve();

        }, function(error) {

          vm.error = 'CompetenceRequest.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminAssignmentsController', PlatformAdminAssignmentsController);

  /** @ngInject */
  function PlatformAdminAssignmentsController(platformService, httpService) {

    var vm = this;
    vm.assignments = null;
    vm.errorMessage = null;

    platformService.adminGetAssignments().then(function(assignments) {

      vm.assignments = [];
      httpService.addAllModelsTo(assignments, vm.assignments);

    }, function() {

      vm.errorMessage = 'platform.admin.assignments.errorLoad';

    });

    /**
     * Called when want to remove an assignment.
     */
    vm.remove = function(assignment) {

      platformService.adminRemoveAssignment(assignment).then(function() {

        httpService.removeModel(assignment, vm.assignments);

      }, function() {

        vm.errorMessage = 'platform.admin.assignments.errorRemove';

      });

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminAssignmentTeamsController', PlatformAdminAssignmentTeamsController);

  /** @ngInject */
  function PlatformAdminAssignmentTeamsController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.teams = null;
    vm.errorMessage = null;
    vm.assignmentId = $stateParams.assignmentId;
    vm.studentsPerTeam = 2;

    platformService.adminGetAssignmentTeams(vm.assignmentId).then(function(teams) {

      vm.teams = [];
      httpService.addAllModelsTo(teams, vm.teams);

    }, function() {

      vm.errorMessage = 'platform.admin.assignmentTeams.errorLoad';

    });

    /**
     * Call the synergial team composition.
     */
    vm.synteamComposition = function() {

      var deferred = $q.defer();
      platformService.adminSynteam(vm.assignmentId, vm.studentsPerTeam).then(function(teams) {

        vm.teams.splice(0,vm.teams.length);
        httpService.addAllModelsTo(teams, vm.teams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.assignmentTeams.errorSynteam';
        deferred.reject();

      });

      return deferred.promise;

    };
    
    /**
     * Call the lp team composition.
     */
    vm.lpteamComposition = function() {

      var deferred = $q.defer();
      platformService.adminLpteam(vm.assignmentId, vm.studentsPerTeam).then(function(teams) {

        vm.teams.splice(0,vm.teams.length);
        httpService.addAllModelsTo(teams, vm.teams);
        deferred.resolve();

      }, function() {

        vm.errorMessage = 'platform.admin.assignmentTeams.errorLpteam';
        deferred.reject();

      });

      return deferred.promise;

    };

  }

})();
(function() {
  'use strict';

  angular.module('Education').controller('PlatformAdminAssignmentController', PlatformAdminAssignmentController);

  /** @ngInject */
  function PlatformAdminAssignmentController(platformService, httpService, $state, $stateParams, $q) {

    var vm = this;
    vm.assignment = null;
    vm.errorMessage = null;
    vm.rubrics = [];
    vm.groups = [];
    vm.teachers = [];

    platformService.adminGetStudentGroups().then(function(definedGroups) {

      httpService.addAllModelsTo(definedGroups, vm.groups);
      if (definedGroups.length > 0 && angular.isObject(vm.assignment) && !angular.isObject(vm.assignment.group)) {

        vm.assignment.group = definedGroups[0];
      }

    });

    platformService.adminGetRubrics().then(function(definedRubrics) {

      httpService.addAllModelsTo(definedRubrics, vm.rubrics);
      if (definedRubrics.length > 0 && angular.isObject(vm.assignment) && !angular.isObject(vm.assignment.rubric)) {

        vm.assignment.rubric = definedRubrics[0];
      }

    });

    platformService.getUsers().then(function(users) {

      for ( var i in users) {

        var person = users[i].person;
        if (angular.isObject(person) && person.type == 'teacher') {

          httpService.addModelTo(person, vm.teachers);

        }
      }

      if (angular.isObject(vm.assignment) && !angular.isObject(vm.assignment.teacher) && vm.teachers.length > 0) {

        vm.assignment.teacher = vm.teachers[0];
      }

    }, function() {
      vm.errorMessage = 'platform.admin.group.errorLoadStudents';
    });

    if ($stateParams.assignmentId == 0) {

      vm.assignment = {
        id : 0,
        name : '',
        teacher : null,
        rubric : null,
        group : null,
        requests : []
      };

    } else {
      platformService.adminGetAssignment($stateParams.assignmentId).then(function(assignment) {

        vm.assignment = assignment;

      }, function() {

        vm.errorMessage = 'platform.admin.assignment.errorLoad';

      });
    }

    /**
     * Add a competenceRequest
     */
    vm.addCompetenceRequest = function() {

      var competenceRequest = {
        id : 0,
        factor : 'VERBAL',
        level : 0.5,
        importance : 0.5
      };
      platformService.adminUpdateCompetenceRequest(competenceRequest).then(function(newCompetenceRequest) {

        vm.assignment.requests.push(newCompetenceRequest);
        platformService.adminUpdateAssignment(vm.assignment).then(function(updated) {

          $state.go('platform.admin.competenceRequest', {
            competenceRequestId : newCompetenceRequest.id,
            assignmentId : updated.id
          });

        }, function() {

          vm.errorMessage = 'platform.admin.assignment.errorAddCompetenceRequest';
          platformService.adminRemoveCompetenceRequest(newCompetenceRequest);
          httpService.removeModel(newCompetenceRequest, vm.assignment.requests);

        });

      }, function() {

        vm.errorMessage = 'platform.admin.assignment.errorAddCompetenceRequest';

      });

    };

    /**
     * Add a competenceRequest
     */
    vm.removeCompetenceRequest = function(competenceRequest) {

      httpService.removeModel(competenceRequest, vm.assignment.requests);
      platformService.adminUpdateAssignment(vm.assignment).then(function() {

        platformService.adminRemoveCompetenceRequest(competenceRequest).then(function() {
          // nothing to do

        }, function() {
          httpService.addModelTo(competenceRequest, vm.assignment.requests);
          vm.errorMessage = 'platform.admin.assignment.errorRemoveCompetenceRequest';

        });

      }, function() {

        httpService.addModelTo(competenceRequest, vm.assignment.requests);
        vm.errorMessage = 'platform.admin.assignment.errorRemoveCompetenceRequest';

      });

    };

    /**
     * Check the form values are right and commit the result.
     */
    vm.checkForm = function(form) {

      vm.error = null;
      form.submit = {
        $error : null
      };
      form.name = {
        $error : {
          required : false
        }
      };
      form.admin = {
        $error : {
          required : false
        }
      };
      form.rubric = {
        $error : {
          required : false
        }
      };
      form.teacher = {
        $error : {
          required : false
        }
      };
      form.group = {
        $error : {
          required : false
        }
      };
      form.requests = {
        $error : {
          required : false
        }
      };

      var validForm = true;
      if (vm.assignment.name.length == 0) {

        form.name.$error.required = true;
        validForm = false;
      }
      if (!angular.isObject(vm.assignment.teacher)) {

        form.teacher.$error.required = true;
        validForm = false;
      }
      if (!angular.isObject(vm.assignment.rubric)) {

        form.rubric.$error.required = true;
        validForm = false;
      }
      if (!angular.isObject(vm.assignment.group)) {

        form.group.$error.required = true;
        validForm = false;
      }
      if (vm.assignment.requests.length == 0) {

        form.requests.$error.required = true;
        validForm = false;
      }

      return validForm;
    };

    /**
     * Verify the form and update the Assignment.
     */
    vm.checkFormAndUpdate = function(form) {

      var deferred = $q.defer();
      if (!vm.checkForm(form)) {

        deferred.reject();

      } else {

        platformService.adminUpdateAssignment(vm.assignment).then(function(updatedAssignment) {

          $state.go('platform.admin.assignments');
          deferred.resolve(updatedAssignment);

        }, function(error) {

          vm.error = 'Assignment.action.update.error';
          deferred.reject(error);

        });
      }

      return deferred.promise;

    };

  }

})();
(function() {
	'use strict';

	angular.module('Education').controller('WelcomeTeamsController', WelcomeTeamsController);

	/** @ngInject */
	function WelcomeTeamsController() {
	}
})();

(function() {
  'use strict';

  angular.module('Education').controller('WelcomePlatformController', WelcomePlatformController);

  /** @ngInject */
  function WelcomePlatformController($translate, $rootScope, EDUCATION_EVENTS) {

    var vm = this;

    vm.lang = $translate.use();

    $rootScope.$on(EDUCATION_EVENTS.changedLanguage, function() {
      vm.lang = $translate.use();
    });

  }
})();

(function() {
  'use strict';

  angular.module('Education').directive('faq', faq);

  /** @ngInject */
  function faq() {
    var directive = {
      restrict : 'A',
      transclude : true,
      templateUrl : 'app/welcome/platform/faq.html',
      controller : FaqController,
      controllerAs : 'vm',
      scope : {
        question : '@'
      }
    };

    return directive;

    /** @ngInject */
    function FaqController() {

      var vm = this;
      vm.open = false;

    }// End FaqController

  }// End faq

})();

(function() {
	'use strict';

	angular.module('Education').controller('WelcomeMainController', WelcomeMainController);

	/** @ngInject */
	function WelcomeMainController() {
	}
})();

(function() {
  'use strict';

  angular.module('Education').controller('WelcomeLoginController', WelcomeLoginController);

  /** @ngInject */
  function WelcomeLoginController($q, $uibModal, $state, platformService, PERSON_SEX) {

    var vm = this;
    vm.create = false;
    vm.model = {
      error : false,
      sex : PERSON_SEX[0],
      dateOfBirth : new Date()
    };
    vm.errorMessage = null;
    vm.PERSON_SEX = PERSON_SEX;

    /**
     * Go to the next view depending of the user role.
     */
    function goToNextView() {

      if (platformService.isTeacher()) {

        $state.go('platform.teacher.main');

      } else if (platformService.isStudent()) {

        $state.go('platform.student.main');

      } else {

        $state.go('platform.admin.main');
      }

    }

    /**
     * Try to sign in.
     */
    vm.signIn = function() {

      vm.errorMessage = null;
      var deferred = $q.defer();
      var signedIn = function() {

        goToNextView()
        deferred.resolve();

      };
      var signError = function() {

        vm.model.error = true;
        deferred.reject();

      };
      platformService.signIn(vm.model.email, vm.model.password).then(signedIn, signError);
      return deferred.promise;
    };

    /**
     * Try to create an account.
     */
    vm.createAccount = function() {

      vm.errorMessage = null;
      var deferred = $q.defer();
      if (!angular.isString(vm.model.name) || vm.model.name.length == 0) {

        vm.errorMessage = 'welcome.login.create.errorName';
        deferred.reject();

      } else if (!angular.isString(vm.model.email) || vm.model.email.length == 0) {

        vm.errorMessage = 'welcome.login.create.errorEmail';
        deferred.reject();

      } else if (!angular.isString(vm.model.password) || vm.model.password.length < 6) {

        vm.errorMessage = 'welcome.login.create.errorPassword';
        deferred.reject();

      } else if (!angular.isString(vm.model.checkpassword) || vm.model.checkpassword !== vm.model.password) {

        vm.errorMessage = 'welcome.login.create.errorCheckpassword';
        deferred.reject();

      } else if (vm.create == 'student' && (!angular.isString(vm.model.code) || vm.model.code.length == 0)) {

        vm.errorMessage = 'welcome.login.create.errorCode';
        deferred.reject();

      } else if (vm.create == 'student') {

        var newStudent = {
          email : vm.model.email,
          password : vm.model.password,
          person : {
            type : 'student',
            name : vm.model.name,
            sex : vm.model.sex,
            dateOfBirth : vm.model.dateOfBirth
          }
        };
        platformService.createStudent(newStudent, vm.model.code).then(function() {

          $state.go('platform.student.main');
          deferred.resolve();

        }, function(error) {

          if (error.status == 401) {

            vm.errorMessage = 'welcome.login.create.errorCode';

          } else {

            vm.errorMessage = 'welcome.login.create.errorUserExist';

          }

          deferred.reject();

        });

      } else {

        var newTeacher = {
          email : vm.model.email,
          password : vm.model.password,
          person : {
            type : 'teacher',
            name : vm.model.name,
            sex : vm.model.sex,
            dateOfBirth : vm.model.dateOfBirth
          }
        };
        platformService.createTeacher(newTeacher, vm.model.code).then(function() {

          $state.go('platform.teacher.main');
          deferred.resolve();

        }, function() {

          vm.errorMessage = 'welcome.login.create.errorUserExist';
          deferred.reject();

        });
      }

      return deferred.promise;
    };

    /**
     * Show info of the code.
     */
    vm.showInfoCode = function() {

      $uibModal.open({
        animation : true,
        templateUrl : 'InfoCodeModal.html',
        controller : function($uibModalInstance) {
          var vm = this;
          vm.close = function() {

            $uibModalInstance.close();
          };

          vm.goToContacts = function() {
            $uibModalInstance.close();
            $state.go("welcome.main", {
              '#' : 'contact'
            });
          };
        },
        controllerAs : 'vm',
        size : 'sm'
      });

    };

    /**
     * Try to reset the password.
     */
    vm.resetPassword = function() {

      $uibModal.open({
        animation : true,
        templateUrl : 'resetPassword.html',
        controller : function($uibModalInstance) {
          var vm = this;
          vm.close = function() {

            $uibModalInstance.close();
          };

          vm.goToContacts = function() {
            $uibModalInstance.close();
            $state.go("welcome.main", {
              '#' : 'contact'
            });
          };
        },
        controllerAs : 'vm',
        size : 'sm'
      });
    };

  }
})();

(function() {
	'use strict';

	angular.module('Education').controller('WelcomeLessonPlansController', WelcomeLessonPlansController);

	/** @ngInject */
	function WelcomeLessonPlansController() {
	}
})();

(function() {
	'use strict';

	angular.module('Education').controller('WelcomeAssessmentsController', WelcomeAssessmentsController);

	/** @ngInject */
	function WelcomeAssessmentsController($translate) {

		var vm = this;
		vm.lang = $translate.use();

	}
})();

(function() {
	'use strict';

	angular.module('Education').filter('localizePersonalityFactor', localizePersonalityFactor);

	/** @ngInject */
	function localizePersonalityFactor($translate) {

		return function(input) {
			
			return $translate.instant('PersonalityFactor.'+input);
		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').filter('localizePersonSex', localizePersonSex);

	/** @ngInject */
	function localizePersonSex($translate) {

		return function(input) {
			
			return $translate.instant('PersonSex.'+input);
		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').filter('localizeCompetenceFactor', localizeCompetenceFactor);

	/** @ngInject */
	function localizeCompetenceFactor($translate) {

		return function(input) {
			
			return $translate.instant('CompetenceFactor.'+input);
		}
	}

})();

(function() {
  'use strict';

  angular.module('Education').directive('mainNavbar', mainNavbar);

  /** @ngInject */
  function mainNavbar() {
    var directive = {
      restrict : 'E',
      templateUrl : 'app/components/mainNavbar/mainNavbar.html',
      controller : MainNavbarController,
      controllerAs : 'vm',
      scope : {},
      bindToController : true
    };

    return directive;

    /** @ngInject */
    function MainNavbarController($translate, EDUCATION_EVENTS, $rootScope, $scope, $state, $locale, $log) {

      var vm = this;
      vm.menuCollapsed = true;
      vm.stateName = $state.current.name;

      var stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function(event, toState) {

        vm.stateName = toState.name;

      });
      $scope.$on('$destroy', stateChangeSuccessListener);

      /**
       * Change the locale.
       */
      vm.changeLanguage = function(lang) {

        vm.collapseMenu();
        $translate.use(lang).then(function() {
          $rootScope.$broadcast(EDUCATION_EVENTS.changedLanguage, lang);
          $locale.id = lang;
        }, function(error) {
          $log.error('Could not change language becuase ' + error);
        });

      };

      /**
       * Collapse the menu.
       */
      vm.collapseMenu = function() {
        vm.menuCollapsed = true;
      };

      vm.isCollaborativeAssessments = function() {

        return false;
      };

    }// End MainNavbarController

  }// End mainNavbar

})();

(function() {
	'use strict';

	angular.module('Education').directive('mainFooter', mainFooter);

	/** @ngInject */
	function mainFooter() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/components/mainFooter/mainFooter.html',
			controller : MainFooterController,
			controllerAs : 'vm',
			scope : {},
			bindToController : true
		};

		return directive;

		/** @ngInject */
		function MainFooterController(moment) {

			var vm = this;
			vm.year = moment().year();

		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').controller('WelcomeController', WelcomeController);

	/** @ngInject */
	function WelcomeController() {
	}
})();

(function() {
	'use strict';

	angular.module('Education').controller('ToolController', ToolController);

	/** @ngInject */
	function ToolController() {
	}
})();

(function() {
  'use strict';

  angular.module('Education').directive('platformNavbar', platformNavbar);

  /** @ngInject */
  function platformNavbar() {
    var directive = {
      restrict : 'E',
      templateUrl : 'app/platform/platformNavbar.html',
      controller : PlatformNavbarController,
      controllerAs : 'vm',
      scope : {},
      bindToController : true
    };

    return directive;

    /** @ngInject */
    function PlatformNavbarController($translate, EDUCATION_EVENTS, $rootScope, $scope, $state, $uibModal, platformService,$locale) {

      var vm = this;
      vm.menuCollapsed = true;
      vm.stateName = $state.current.name;

      var stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function(event, toState) {

        vm.stateName = toState.name;

      });
      $scope.$on('$destroy', stateChangeSuccessListener);

      /**
       * Change the locale.
       */
      vm.changeLanguage = function(lang) {

        vm.collapseMenu();
        $translate.use(lang).then(function() {
          $rootScope.$broadcast(EDUCATION_EVENTS.changedLanguage, lang);
          $locale.id = lang;
        });

      };

      /**
       * Collapse the menu.
       */
      vm.collapseMenu = function() {
        vm.menuCollapsed = true;
      };

      vm.isCollaborativeAssessments = function() {

        return false;
      };

      /**
       * Log out of the platform.
       */
      vm.logout = function() {

        $uibModal.open({
          animation : true,
          templateUrl : 'confirmLogout.html',
          controller : function($uibModalInstance) {
            var vm = this;
            vm.ok = function() {

              $state.go('welcome.login');
              platformService.signOut();
              $uibModalInstance.close();
            };

            vm.cancel = function() {
              $uibModalInstance.dismiss('cancel');
            };
          },
          controllerAs : 'vm',
          size : 'sm'
        });

      };

    }// End PlatformNavbarController

  }// End platformNavbar

})();

(function() {
  'use strict';

  angular.module('Education').filter('localizePlatformUserRole', localizePlatformUserRole);

  /** @ngInject */
  function localizePlatformUserRole($translate) {

    return function(input) {

      if (!angular.isObject(input)) {

        return '';

      } else if (angular.isObject(input.person)) {

        if (input.person.type == 'teacher') {

          return $translate.instant('platform.role.teacher');

        } else if (input.person.type == 'student') {

          return $translate.instant('platform.role.student');

        } else {

          return '';
        }

      } else {

        return $translate.instant('platform.role.admin');
      }
    }
  }

})();

(function() {
  'use strict';

  angular.module('Education').filter('localizeFeedback', localizeFeedback);

  /** @ngInject */
  function localizeFeedback($translate) {

    return function(input) {

      var level = Math.round(input*4);
      return $translate.instant('feedbackForTeam.'+level);
      
    }
  }

})();

(function() {
	'use strict';

	angular.module('Education').factory('serverService', serverService);

	/** @ngInject */
	function serverService(httpService, SERVER) {

		var service = {
			addModelTo : httpService.addModelTo,
			removeModel : httpService.removeModel,
			addAllModelsTo : httpService.addAllModelsTo,
			addAssignment : addAssignment,
			getAssignments : getAssignments,
			removeAssignment : removeAssignment,
			addTeacher : addTeacher,
			removeTeacher : removeTeacher,
			getTeachers : getTeachers,
			addStudent : addStudent,
			updateStudent : updateStudent,
			removeStudent : removeStudent,
			getStudents : getStudents,
			getStudent : getStudent,
			addRubric : addRubric,
			removeRubric : removeRubric,
			getRubrics : getRubrics,
			addStudentGroup : addStudentGroup,
			removeStudentGroup : removeStudentGroup,
			getStudentGroups : getStudentGroups,
			addCriterion : addCriterion,
			removeCriterion : removeCriterion,
			getCriteria : getCriteria,
			getAssignment : getAssignment,
			getTeacherAssessments : getTeacherAssessments,
			getStudentAssessments : getStudentAssessments,
			doComas : doComas,
			addAssessment : addAssessment,
			updateAssessment : updateAssessment,
			removeAssessment : removeAssessment,
			addPersonalityQuestionnaire : addPersonalityQuestionnaire,
			updatePersonalityQuestionnaire : updatePersonalityQuestionnaire,
			removePersonalityQuestionnaire : removePersonalityQuestionnaire,
			getPersonalityQuestionnaires : getPersonalityQuestionnaires,
			getPersonalityQuestionnaire : getPersonalityQuestionnaire,
			addPersonalityQuestion : addPersonalityQuestion,
			updatePersonalityQuestion : updatePersonalityQuestion,
			removePersonalityQuestion : removePersonalityQuestion,
			getPersonalityQuestions : getPersonalityQuestions,
			getPersonalityQuestion : getPersonalityQuestion,
			addPersonalityAnswerValue : addPersonalityAnswerValue,
			updatePersonalityAnswerValue : updatePersonalityAnswerValue,
			removePersonalityAnswerValue : removePersonalityAnswerValue,
			getPersonalityAnswerValues : getPersonalityAnswerValues,
			getPersonalityAnswerValue : getPersonalityAnswerValue,
			getStudentPersonalityAnswersOnQuestionnaire : getStudentPersonalityAnswersOnQuestionnaire,
			addStudentPersonalityAnswer : addStudentPersonalityAnswer,
			updateStudentPersonalityAnswer : updateStudentPersonalityAnswer,
			removeStudentPersonalityAnswer : removeStudentPersonalityAnswer,
			formGroups : formGroups,
			congenialTeams : congenialTeams,
			getTeamsOn : getTeamsOn,
			addCompetenceQuestionnaire : addCompetenceQuestionnaire,
			updateCompetenceQuestionnaire : updateCompetenceQuestionnaire,
			removeCompetenceQuestionnaire : removeCompetenceQuestionnaire,
			getCompetenceQuestionnaires : getCompetenceQuestionnaires,
			getCompetenceQuestionnaire : getCompetenceQuestionnaire,
			addCompetenceQuestion : addCompetenceQuestion,
			updateCompetenceQuestion : updateCompetenceQuestion,
			removeCompetenceQuestion : removeCompetenceQuestion,
			getCompetenceQuestions : getCompetenceQuestions,
			getCompetenceQuestion : getCompetenceQuestion,
			addCompetenceAnswerValue : addCompetenceAnswerValue,
			updateCompetenceAnswerValue : updateCompetenceAnswerValue,
			removeCompetenceAnswerValue : removeCompetenceAnswerValue,
			getCompetenceAnswerValues : getCompetenceAnswerValues,
			getCompetenceAnswerValue : getCompetenceAnswerValue,
			getStudentCompetenceAnswersOnQuestionnaire : getStudentCompetenceAnswersOnQuestionnaire,
			addStudentCompetenceAnswer : addStudentCompetenceAnswer,
			updateStudentCompetenceAnswer : updateStudentCompetenceAnswer,
			removeStudentCompetenceAnswer : removeStudentCompetenceAnswer,
			synergisticTeams : synergisticTeams,
			addCompetenceRequest : addCompetenceRequest,
			updateCompetenceRequest : updateCompetenceRequest,
			removeCompetenceRequest : removeCompetenceRequest,
			getCompetenceRequests : getCompetenceRequests,
			getCompetenceRequest : getCompetenceRequest,
			getAssignmentTeamsOn : getAssignmentTeamsOn,
			lpTeams : lpTeams
		};

		return service;

		/**
		 * Post the specified content to the server.
		 * 
		 * @param path
		 *            to the resource.
		 * @param content
		 *            to post or parameters if it is a 'GET'.
		 */
		function callHttp(method, path, content) {

			return httpService.callHttp(SERVER, method, path, content);

		}

		/**
		 * Return the assignments defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getAssignments(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'assignment', params);

		}

		/**
		 * Add a new assignment.
		 */
		function addAssignment(assignment) {

			return callHttp('POST', 'assignment', assignment);

		}

		/**
		 * Remove a assignment.
		 * 
		 * @param assignment
		 *            to remove.
		 */
		function removeAssignment(assignment) {

			var id = httpService.extractId(assignment);
			return callHttp('DELETE', 'assignment/' + id);

		}

		/**
		 * Return the teachers defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first teacher to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of teacher to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getTeachers(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'teacher', params);

		}

		/**
		 * Remove a teacher.
		 * 
		 * @param teacher
		 *            to remove.
		 */
		function removeTeacher(teacher) {

			var id = httpService.extractId(teacher);
			return callHttp('DELETE', 'teacher/' + id);

		}

		/**
		 * Add a new teacher.
		 */
		function addTeacher(teacher) {

			return callHttp('POST', 'teacher', teacher);

		}

		/**
		 * Return the students defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getStudents(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'student', params);

		}

		/**
		 * Return the student with the specified identifier.
		 * 
		 * @param studentId
		 *            identifier of the student to get.
		 */
		function getStudent(studentId) {

			return callHttp('GET', 'student/' + studentId);

		}

		/**
		 * Remove a student.
		 * 
		 * @param student
		 *            to remove.
		 */
		function removeStudent(student) {

			var id = httpService.extractId(student);
			return callHttp('DELETE', 'student/' + id);

		}

		/**
		 * Add a new student.
		 */
		function addStudent(student) {

			return callHttp('POST', 'student', student);

		}

		/**
		 * Update a student.
		 */
		function updateStudent(student) {

			return callHttp('PUT', 'student', student);

		}

		/**
		 * Return the rubrics defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getRubrics(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'rubric', params);

		}

		/**
		 * Remove a rubric.
		 * 
		 * @param rubric
		 *            to remove.
		 */
		function removeRubric(rubric) {

			var id = httpService.extractId(rubric);
			return callHttp('DELETE', 'rubric/' + id);

		}

		/**
		 * Add a new rubric.
		 */
		function addRubric(rubric) {

			return callHttp('POST', 'rubric', rubric);

		}

		/**
		 * Return the student groups defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getStudentGroups(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'studentgroup', params);

		}

		/**
		 * Remove a student group.
		 * 
		 * @param group
		 *            to remove.
		 */
		function removeStudentGroup(group) {

			var id = httpService.extractId(group);
			return callHttp('DELETE', 'studentgroup/' + id);

		}

		/**
		 * Add a new student group.
		 */
		function addStudentGroup(group) {

			return callHttp('POST', 'studentgroup', group);

		}

		/**
		 * Return the criteria defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getCriteria(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'criterion', params);

		}

		/**
		 * Remove a criterion.
		 * 
		 * @param criterion
		 *            to remove.
		 */
		function removeCriterion(criterion) {

			var id = httpService.extractId(criterion);
			return callHttp('DELETE', 'criterion/' + id);

		}

		/**
		 * Add a new criterion.
		 */
		function addCriterion(criterion) {

			return callHttp('POST', 'criterion', criterion);

		}

		/**
		 * Return the assignment associated to the id.
		 * 
		 * @param assignment
		 *            to get.
		 */
		function getAssignment(assignment) {

			var id = httpService.extractId(assignment);
			return callHttp('GET', 'assignment/' + id);

		}

		/**
		 * Return the teacher assessments on an assignment.
		 * 
		 * @param assignment
		 *            to get the teacher assessments.
		 */
		function getTeacherAssessments(assignment) {

			var id = httpService.extractId(assignment);
			return callHttp('GET', 'assessment/teacher/assignment/' + id);

		}

		/**
		 * Return the student assessments on an assignment.
		 * 
		 * @param assignment
		 *            to get the student assessments.
		 */
		function getStudentAssessments(assignment) {

			var id = httpService.extractId(assignment);
			return callHttp('GET', 'assessment/student/assignment/' + id);

		}

		/**
		 * Do the COMAS calculus over an assignment.
		 * 
		 * @param assignment
		 *            to get the COMAS assessments.
		 */
		function doComas(assignment) {

			var id = httpService.extractId(assignment);
			return callHttp('GET', 'comas/assignment/' + id);

		}

		/**
		 * Return the type of an assessment.
		 */
		function extractAssessmentType(assessment) {

			if ('teacherAssessment' == assessment.type) {

				return 'teacher';

			} else {

				return 'student';
			}

		}

		/**
		 * Add an assessment.
		 */
		function addAssessment(assessment) {

			var type = extractAssessmentType(assessment);
			return callHttp('POST', 'assessment/' + type, assessment);

		}

		/**
		 * Update an assessment.
		 */
		function updateAssessment(assessment) {

			var type = extractAssessmentType(assessment);
			return callHttp('PUT', 'assessment/' + type, assessment);

		}

		/**
		 * Remove an assessment.
		 */
		function removeAssessment(assessment) {

			var type = extractAssessmentType(assessment);
			var id = httpService.extractId(assessment);
			return callHttp('DELETE', 'assessment/' + type + "/" + id);

		}

		/**
		 * Return the questionnaires defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getPersonalityQuestionnaires(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'personalityQuestionnaire', params);

		}

		/**
		 * Return the questionnaire with the specified identifier.
		 * 
		 * @param questionnaireId
		 *            identifier of the questionnaire to get.
		 */
		function getPersonalityQuestionnaire(questionnaireId) {

			return callHttp('GET', 'personalityQuestionnaire/'
					+ questionnaireId);

		}
		/**
		 * Remove a questionnaire.
		 * 
		 * @param questionnaire
		 *            to remove.
		 */
		function removePersonalityQuestionnaire(questionnaire) {

			var id = httpService.extractId(questionnaire);
			return callHttp('DELETE', 'personalityQuestionnaire/' + id);

		}

		/**
		 * Add a new questionnaire.
		 */
		function addPersonalityQuestionnaire(questionnaire) {

			return callHttp('POST', 'personalityQuestionnaire', questionnaire);

		}

		/**
		 * Update a questionnaire.
		 */
		function updatePersonalityQuestionnaire(questionnaire) {

			return callHttp('PUT', 'personalityQuestionnaire', questionnaire);

		}

		/**
		 * Return the questions defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getPersonalityQuestions(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'personalityQuestion', params);

		}

		/**
		 * Return the question with the specified identifier.
		 * 
		 * @param questionId
		 *            identifier of the question to get.
		 */
		function getPersonalityQuestion(questionId) {

			return callHttp('GET', 'personalityQuestion/' + questionId);

		}
		/**
		 * Remove a question.
		 * 
		 * @param question
		 *            to remove.
		 */
		function removePersonalityQuestion(question) {

			var id = httpService.extractId(question);
			return callHttp('DELETE', 'personalityQuestion/' + id);

		}

		/**
		 * Add a new question.
		 */
		function addPersonalityQuestion(question) {

			return callHttp('POST', 'personalityQuestion', question);

		}

		/**
		 * Update a question.
		 */
		function updatePersonalityQuestion(question) {

			return callHttp('PUT', 'personalityQuestion', question);

		}

		/**
		 * Return the answer values defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getPersonalityAnswerValues(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'personalityAnswerValue', params);

		}

		/**
		 * Return the answer value with the specified identifier.
		 * 
		 * @param answervalueId
		 *            identifier of the answer value to get.
		 */
		function getPersonalityAnswerValue(answervalueId) {

			return callHttp('GET', 'personalityAnswerValue/' + answervalueId);

		}
		/**
		 * Remove a answer value.
		 * 
		 * @param answervalue
		 *            to remove.
		 */
		function removePersonalityAnswerValue(answervalue) {

			var id = httpService.extractId(answervalue);
			return callHttp('DELETE', 'personalityAnswerValue/' + id);

		}

		/**
		 * Add a new answer value.
		 */
		function addPersonalityAnswerValue(answervalue) {

			return callHttp('POST', 'personalityAnswerValue', answervalue);

		}

		/**
		 * Update a answer value.
		 */
		function updatePersonalityAnswerValue(answervalue) {

			return callHttp('PUT', 'personalityAnswerValue', answervalue);

		}

		/**
		 * Get the student answers for a questionnaire.
		 */
		function getStudentPersonalityAnswersOnQuestionnaire(student,
				questionnaire, startPosition, maxResult) {

			var studentId = httpService.extractId(student);
			var questionnaireId = httpService.extractId(questionnaire);
			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'studentPersonalityAnswer/student/'
					+ studentId + '/questionnaire/' + questionnaireId, params);

		}

		/**
		 * Remove a student answer value.
		 * 
		 * @param answervalue
		 *            to remove.
		 */
		function removeStudentPersonalityAnswer(studentPersonalityAnswer) {

			var id = httpService.extractId(studentPersonalityAnswer);
			return callHttp('DELETE', 'studentPersonalityAnswer/' + id);

		}

		/**
		 * Add a new student answer value.
		 */
		function addStudentPersonalityAnswer(studentPersonalityAnswer) {

			return callHttp('POST', 'studentPersonalityAnswer',
					studentPersonalityAnswer);

		}

		/**
		 * Update a student answer value.
		 */
		function updateStudentPersonalityAnswer(studentPersonalityAnswer) {

			return callHttp('PUT', 'studentPersonalityAnswer',
					studentPersonalityAnswer);

		}

		/**
		 * From the groups for a set of students.
		 */
		function formGroups(parameters) {

			return callHttp('POST', 'conteam', parameters);
		}

		/**
		 * Team composition.
		 */
		function congenialTeams(questionnaire, group, studentsPerTeam) {

			var questionnaireId = httpService.extractId(questionnaire);
			var groupId = httpService.extractId(group);
			var parameters = {
				studentsPerTeam : studentsPerTeam
			};
			return callHttp('GET', 'conteam/questionnaire/' + questionnaireId
					+ '/group/' + groupId, parameters);
		}

		/**
		 * Return the reams defined on a group.
		 */
		function getTeamsOn(group, startPosition, maxResult) {

			var groupId = httpService.extractId(group);
			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'studentgroup/' + groupId + '/team', params);

		}

		/**
		 * Return the questionnaires defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getCompetenceQuestionnaires(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'competenceQuestionnaire', params);

		}

		/**
		 * Return the questionnaire with the specified identifier.
		 * 
		 * @param questionnaireId
		 *            identifier of the questionnaire to get.
		 */
		function getCompetenceQuestionnaire(questionnaireId) {

			return callHttp('GET', 'competenceQuestionnaire/' + questionnaireId);

		}
		/**
		 * Remove a questionnaire.
		 * 
		 * @param questionnaire
		 *            to remove.
		 */
		function removeCompetenceQuestionnaire(questionnaire) {

			var id = httpService.extractId(questionnaire);
			return callHttp('DELETE', 'competenceQuestionnaire/' + id);

		}

		/**
		 * Add a new questionnaire.
		 */
		function addCompetenceQuestionnaire(questionnaire) {

			return callHttp('POST', 'competenceQuestionnaire', questionnaire);

		}

		/**
		 * Update a questionnaire.
		 */
		function updateCompetenceQuestionnaire(questionnaire) {

			return callHttp('PUT', 'competenceQuestionnaire', questionnaire);

		}

		/**
		 * Return the questions defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getCompetenceQuestions(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'competenceQuestion', params);

		}

		/**
		 * Return the question with the specified identifier.
		 * 
		 * @param questionId
		 *            identifier of the question to get.
		 */
		function getCompetenceQuestion(questionId) {

			return callHttp('GET', 'competenceQuestion/' + questionId);

		}
		/**
		 * Remove a question.
		 * 
		 * @param question
		 *            to remove.
		 */
		function removeCompetenceQuestion(question) {

			var id = httpService.extractId(question);
			return callHttp('DELETE', 'competenceQuestion/' + id);

		}

		/**
		 * Add a new question.
		 */
		function addCompetenceQuestion(question) {

			return callHttp('POST', 'competenceQuestion', question);

		}

		/**
		 * Update a question.
		 */
		function updateCompetenceQuestion(question) {

			return callHttp('PUT', 'competenceQuestion', question);

		}

		/**
		 * Return the answer values defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getCompetenceAnswerValues(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'competenceAnswerValue', params);

		}

		/**
		 * Return the answer value with the specified identifier.
		 * 
		 * @param answervalueId
		 *            identifier of the answer value to get.
		 */
		function getCompetenceAnswerValue(answervalueId) {

			return callHttp('GET', 'competenceAnswerValue/' + answervalueId);

		}
		/**
		 * Remove a answer value.
		 * 
		 * @param answervalue
		 *            to remove.
		 */
		function removeCompetenceAnswerValue(answervalue) {

			var id = httpService.extractId(answervalue);
			return callHttp('DELETE', 'competenceAnswerValue/' + id);

		}

		/**
		 * Add a new answer value.
		 */
		function addCompetenceAnswerValue(answervalue) {

			return callHttp('POST', 'competenceAnswerValue', answervalue);

		}

		/**
		 * Update a answer value.
		 */
		function updateCompetenceAnswerValue(answervalue) {

			return callHttp('PUT', 'competenceAnswerValue', answervalue);

		}

		/**
		 * Get the student answers for a questionnaire.
		 */
		function getStudentCompetenceAnswersOnQuestionnaire(student,
				questionnaire, startPosition, maxResult) {

			var studentId = httpService.extractId(student);
			var questionnaireId = httpService.extractId(questionnaire);
			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'studentCompetenceAnswer/student/'
					+ studentId + '/questionnaire/' + questionnaireId, params);

		}

		/**
		 * Remove a student answer value.
		 * 
		 * @param answervalue
		 *            to remove.
		 */
		function removeStudentCompetenceAnswer(studentCompetenceAnswer) {

			var id = httpService.extractId(studentCompetenceAnswer);
			return callHttp('DELETE', 'studentCompetenceAnswer/' + id);

		}

		/**
		 * Add a new student answer value.
		 */
		function addStudentCompetenceAnswer(studentCompetenceAnswer) {

			return callHttp('POST', 'studentCompetenceAnswer',
					studentCompetenceAnswer);

		}

		/**
		 * Update a student answer value.
		 */
		function updateStudentCompetenceAnswer(studentCompetenceAnswer) {

			return callHttp('PUT', 'studentCompetenceAnswer',
					studentCompetenceAnswer);

		}

		/**
		 * Synergistic team composition.
		 */
		function synergisticTeams(personalityQuestionnaire,
				competenceQuestionnaire, assignment, studentsPerTeam) {

			var personalityQuestionnaireId = httpService
					.extractId(personalityQuestionnaire);
			var competenceQuestionnaireId = httpService
					.extractId(competenceQuestionnaire);
			var assignmentId = httpService.extractId(assignment);
			var parameters = {
				studentsPerTeam : studentsPerTeam
			};
			return callHttp('GET',
					'synteam/personalityQuestionnaire/'
							+ personalityQuestionnaireId
							+ '/competenceQuestionnaire/'
							+ competenceQuestionnaireId + '/assignment/'
							+ assignmentId, parameters);
		}

		/**
		 * Return the requests defined in the specified range.
		 * 
		 * @param startPosition
		 *            index of the first friend to return. If it is not defined
		 *            it use {@code 0}.
		 * @param maxResult
		 *            the number maximum of friends to return. If it is not
		 *            defined it use {@code 100}.
		 */
		function getCompetenceRequests(startPosition, maxResult) {

			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'competenceRequest', params);

		}

		/**
		 * Return the request with the specified identifier.
		 * 
		 * @param requestId
		 *            identifier of the request to get.
		 */
		function getCompetenceRequest(requestId) {

			return callHttp('GET', 'competenceRequest/' + requestId);

		}
		/**
		 * Remove a request.
		 * 
		 * @param request
		 *            to remove.
		 */
		function removeCompetenceRequest(request) {

			var id = httpService.extractId(request);
			return callHttp('DELETE', 'competenceRequest/' + id);

		}

		/**
		 * Add a new request.
		 */
		function addCompetenceRequest(request) {

			return callHttp('POST', 'competenceRequest', request);

		}

		/**
		 * Update a request.
		 */
		function updateCompetenceRequest(request) {

			return callHttp('PUT', 'competenceRequest', request);

		}

		/**
		 * Return the teams associated to an assignment.
		 */
		function getAssignmentTeamsOn(assignment, startPosition, maxResult) {

			var assignmentId = httpService.extractId(assignment);
			var params = httpService.toGetParams(startPosition, maxResult);
			return callHttp('GET', 'assignment/' + assignmentId + '/team',
					params);

		}

		/**
		 * Lp team composition.
		 */
		function lpTeams(personalityQuestionnaire, competenceQuestionnaire,
				assignment, studentsPerTeam) {

			var personalityQuestionnaireId = httpService
					.extractId(personalityQuestionnaire);
			var competenceQuestionnaireId = httpService
					.extractId(competenceQuestionnaire);
			var assignmentId = httpService.extractId(assignment);
			var parameters = {
				studentsPerTeam : studentsPerTeam
			};
			return callHttp('GET',
					'lpteam/personalityQuestionnaire/'
							+ personalityQuestionnaireId
							+ '/competenceQuestionnaire/'
							+ competenceQuestionnaireId + '/assignment/'
							+ assignmentId, parameters);
		}
	}

})();
(function() {
  'use strict';

  angular.module('Education').factory('platformService', platformService);

  /** @ngInject */
  function platformService(httpService, PLATFORM, $sha, $q, $http, $state) {

    var vm = this;
    vm.user = null;
    var service = {
      signIn : signIn,
      createStudent : createStudent,
      createTeacher : createTeacher,
      codePassword : codePassword,
      signOut : signOut,
      isSignedIn : isSignedIn,
      isAdmin : isAdmin,
      isTeacher : isTeacher,
      isStudent : isStudent,
      getSignedUser : getSignedUser,
      getSignedPerson : getSignedPerson,
      getUser : getUser,
      getUsers : getUsers,
      updateUser : updateUser,
      removeUser : removeUser,
      updateStudentPersonalityAnswer : updateStudentPersonalityAnswer,
      getStudentPersonalityAnswers : getStudentPersonalityAnswers,
      studentGetPersonalityTest : studentGetPersonalityTest,
      updateStudentCompetenceAnswer : updateStudentCompetenceAnswer,
      getStudentCompetenceAnswers : getStudentCompetenceAnswers,
      studentGetCompetenceTest : studentGetCompetenceTest,
      adminGetPersonalityTest : adminGetPersonalityTest,
      adminGetCompetenceTest : adminGetCompetenceTest,
      adminUpdatePersonalityTest : adminUpdatePersonalityTest,
      adminGetPersonalityQuestion : adminGetPersonalityQuestion,
      adminUpdatePersonalityQuestion : adminUpdatePersonalityQuestion,
      adminGetPersonalityAnswerValue : adminGetPersonalityAnswerValue,
      adminUpdatePersonalityAnswerValue : adminUpdatePersonalityAnswerValue,
      adminGetPersonalityAnswerValues : adminGetPersonalityAnswerValues,
      adminUpdateCompetenceTest : adminUpdateCompetenceTest,
      adminGetCompetenceQuestion : adminGetCompetenceQuestion,
      adminUpdateCompetenceQuestion : adminUpdateCompetenceQuestion,
      adminGetCompetenceAnswerValue : adminGetCompetenceAnswerValue,
      adminUpdateCompetenceAnswerValue : adminUpdateCompetenceAnswerValue,
      adminGetCompetenceAnswerValues : adminGetCompetenceAnswerValues,
      adminUpdateStudentGroup : adminUpdateStudentGroup,
      adminGetStudentGroup : adminGetStudentGroup,
      adminGetStudentGroups : adminGetStudentGroups,
      adminRemoveStudentGroup : adminRemoveStudentGroup,
      adminGetSessionOfStudentGroup : adminGetSessionOfStudentGroup,
      adminUpdateStudentGroupSession : adminUpdateStudentGroupSession,
      adminRemoveStudentGroupSession : adminRemoveStudentGroupSession,
      teacherUpdateStudentGroup : teacherUpdateStudentGroup,
      teacherGetStudentGroup : teacherGetStudentGroup,
      teacherGetStudentGroups : teacherGetStudentGroups,
      teacherRemoveStudentGroup : teacherRemoveStudentGroup,
      teacherGetSessionOfStudentGroup : teacherGetSessionOfStudentGroup,
      teacherUpdateStudentGroupSession : teacherUpdateStudentGroupSession,
      teacherRemoveStudentGroupSession : teacherRemoveStudentGroupSession,
      adminGetStudentTeams : adminGetStudentTeams,
      adminConteam : adminConteam,
      teacherGetStudentTeams : teacherGetStudentTeams,
      teacherConteam : teacherConteam,
      adminGetAssignmentTeams : adminGetAssignmentTeams,
      adminSynteam : adminSynteam,
      teacherGetAssignmentTeams : teacherGetAssignmentTeams,
      teacherSynteam : teacherSynteam,
      adminGetTestStatus : adminGetTestStatus,
      teacherGetTestStatus : teacherGetTestStatus,
      teacherGetAssignment : teacherGetAssignment,
      teacherGetAssignments : teacherGetAssignments,
      teacherRemoveAssignment : teacherRemoveAssignment,
      teacherUpdateAssignment : teacherUpdateAssignment,
      teacherGetRubric : teacherGetRubric,
      teacherGetRubrics : teacherGetRubrics,
      teacherRemoveRubric : teacherRemoveRubric,
      teacherUpdateRubric : teacherUpdateRubric,
      teacherGetCriterion : teacherGetCriterion,
      teacherRemoveCriterion : teacherRemoveCriterion,
      teacherUpdateCriterion : teacherUpdateCriterion,
      teacherGetCompetenceRequest : teacherGetCompetenceRequest,
      teacherRemoveCompetenceRequest : teacherRemoveCompetenceRequest,
      teacherUpdateCompetenceRequest : teacherUpdateCompetenceRequest,
      removeProfile : removeProfile,
      updateProfile : updateProfile,
      adminGetAssignment : adminGetAssignment,
      adminGetAssignments : adminGetAssignments,
      adminRemoveAssignment : adminRemoveAssignment,
      adminUpdateAssignment : adminUpdateAssignment,
      adminGetRubric : adminGetRubric,
      adminGetRubrics : adminGetRubrics,
      adminRemoveRubric : adminRemoveRubric,
      adminUpdateRubric : adminUpdateRubric,
      adminGetCriterion : adminGetCriterion,
      adminRemoveCriterion : adminRemoveCriterion,
      adminUpdateCriterion : adminUpdateCriterion,
      adminGetCompetenceRequest : adminGetCompetenceRequest,
      adminRemoveCompetenceRequest : adminRemoveCompetenceRequest,
      adminUpdateCompetenceRequest : adminUpdateCompetenceRequest,
      adminGetStudentPersonalityAnswers : adminGetStudentPersonalityAnswers,
      adminGetStudentCompetenceAnswers : adminGetStudentCompetenceAnswers,
      adminUpdateStudentPersonalityAnswer : adminUpdateStudentPersonalityAnswer,
      adminUpdateStudentCompetenceAnswer : adminUpdateStudentCompetenceAnswer,
      adminGetStudent : adminGetStudent,
      studentGetStudentGroups : studentGetStudentGroups,
      studentGetAssignments : studentGetAssignments,
      studentJoinToStudentGroup : studentJoinToStudentGroup,
      studentGetStudentTeam : studentGetStudentTeam,
      studentGetAssignmentTeam : studentGetAssignmentTeam,
      adminGetDefaultAssignmentOf : adminGetDefaultAssignmentOf,
      adminGetGroupsOfStudent : adminGetGroupsOfStudent,
      adminJoinStudentToGroup : adminJoinStudentToGroup,
      adminLeaveStudentFromGroup : adminLeaveStudentFromGroup,
      teacherUpdateAssignmentTeam : teacherUpdateAssignmentTeam,
      teacherUpdateStudentTeam : teacherUpdateStudentTeam,
      adminLpteam : adminLpteam,
      teacherLpteam : teacherLpteam
    };

    return service;

    /**
     * Post the specified content to the platform.
     * 
     * @param path
     *          to the resource.
     * @param content
     *          to post or parameters if it is a 'GET'.
     */
    function callHttp(method, path, content) {

      var deferred = $q.defer();
      httpService.callHttp(PLATFORM, method, path, content).then(function(data) {

        deferred.resolve(data);

      }, function(error) {

        if (error.status == 401) {

          $state.go('welcome.login');
        }
        deferred.reject(error);

      });

      return deferred.promise;
    }

    /**
     * Try to sign in.
     */
    function signIn(email, password) {

      var deferred = $q.defer();

      var credentials = {
        email : email,
        password : codePassword(email, password)
      };
      httpService.callHttp(PLATFORM, 'POST', 'user', credentials).then(function(data) {
        vm.user = data.user;
        $http.defaults.headers.common['Session-Id'] = data.sessionId;
        deferred.resolve();

      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    /**
     * Create a new student
     */
    function createStudent(newStudentUser, groupCode) {

      var deferred = $q.defer();

      newStudentUser.password = codePassword(newStudentUser.email, newStudentUser.password);
      httpService.callHttp(PLATFORM, 'POST', 'user/Student/' + groupCode, newStudentUser).then(function(data) {
        vm.user = data.user;
        $http.defaults.headers.common['Session-Id'] = data.sessionId;
        deferred.resolve();

      }, function(error) {
        deferred.reject(error);
      });
      return deferred.promise;

    }

    /**
     * Create a new teacher
     */
    function createTeacher(newTeacherUser) {

      var deferred = $q.defer();

      newTeacherUser.password = codePassword(newTeacherUser.email, newTeacherUser.password);
      httpService.callHttp(PLATFORM, 'POST', 'user/Teacher', newTeacherUser).then(function(data) {
        vm.user = data.user;
        $http.defaults.headers.common['Session-Id'] = data.sessionId;
        deferred.resolve();

      }, function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    /**
     * Return the coded password.
     */
    function codePassword(email, password) {

      $sha.setConfig({
        algorithm : 'SHA-256',
        inputType : 'tEXT',
        returnType : 'HEX',
        secretType : 'tEXT'
      });
      return $sha.hash(email + password);

    }

    /**
     * Try to sign out.
     */
    function signOut() {

      var deferred = $q.defer();

      callHttp('DELETE', 'user').then(function() {
        vm.user = null;
        delete $http.defaults.headers.common['Session-Id'];
        deferred.resolve();
      }, function() {
        deferred.reject();
      });

      return deferred.promise;
    }

    /**
     * Check if the user is signed in.
     */
    function isSignedIn() {

      return vm.user != null;

    }

    /**
     * Check if play as admin.
     */
    function isAdmin() {

      return isSignedIn() && !angular.isObject(vm.user.person);

    }

    /**
     * Check if play as teacher
     */
    function isTeacher() {

      return isSignedIn() && angular.isObject(vm.user.person) && vm.user.person.type == 'teacher';

    }

    /**
     * Check if play as student
     */
    function isStudent() {

      return isSignedIn() && angular.isObject(vm.user.person) && vm.user.person.type == 'student';

    }

    /**
     * Return the signed user.
     */
    function getSignedUser() {

      return vm.user;
    }

    /**
     * Return the signed person.
     */
    function getSignedPerson() {

      return vm.user.person;
    }
    /**
     * Return an user.
     */
    function getUser(user) {

      var userId = httpService.extractId(user);
      return callHttp('GET', 'user/' + userId);

    }

    /**
     * Return the users.
     * 
     * @param startPosition
     *          index of the first user to return. If it is not defined it use
     *          {@code 0}.
     * @param maxResult
     *          the number maximum of users to return. If it is not defined it
     *          use {@code 100}.
     */
    function getUsers(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'user', params);

    }

    /**
     * Update an user.
     */
    function updateUser(user) {

      return callHttp('PUT', 'user/' + user.id, user);

    }

    /**
     * Remove an user.
     */
    function removeUser(user) {

      var userId = httpService.extractId(user);
      return callHttp('DELETE', 'user/' + userId);

    }

    /**
     * Update student personality answer.
     */
    function updateStudentPersonalityAnswer(studentPersonalityAnswer) {

      var id = httpService.extractId(studentPersonalityAnswer);
      return callHttp('PUT', 'student/personality/answer/' + id, studentPersonalityAnswer);

    }

    /**
     * Get student personality answers.
     */
    function getStudentPersonalityAnswers(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'student/personality/answer', params);

    }

    /**
     * Get student personality questionnaire.
     */
    function studentGetPersonalityTest() {

      return callHttp('GET', 'student/personality/questionnaire');
    }

    /**
     * Update student competence answer.
     */
    function updateStudentCompetenceAnswer(studentCompetenceAnswer) {

      var id = httpService.extractId(studentCompetenceAnswer);
      return callHttp('PUT', 'student/competence/answer/' + id, studentCompetenceAnswer);

    }

    /**
     * Get student competence answers.
     */
    function getStudentCompetenceAnswers(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'student/competence/answer', params);

    }

    /**
     * Get student competence questionnaire.
     */
    function studentGetCompetenceTest() {

      return callHttp('GET', 'student/competence/questionnaire');
    }

    /**
     * Get admin personality questionnaire.
     */
    function adminGetPersonalityTest() {

      return callHttp('GET', 'admin/personality/questionnaire');
    }

    /**
     * Get admin competence questionnaire.
     */
    function adminGetCompetenceTest() {

      return callHttp('GET', 'admin/competence/questionnaire');
    }

    /**
     * Admin user update personality test.
     */
    function adminUpdatePersonalityTest(personalityTest) {

      return callHttp('PUT', 'admin/personality/questionnaire', personalityTest);

    }

    /**
     * Admin user get personality question.
     */
    function adminGetPersonalityQuestion(personalityQuestion) {

      var id = httpService.extractId(personalityQuestion);
      return callHttp('GET', 'Admin/personalityQuestion/' + id);

    }

    /**
     * Admin user update personality question.
     */
    function adminUpdatePersonalityQuestion(personalityQuestion) {

      var id = httpService.extractId(personalityQuestion);
      if (id == 0) {

        return callHttp('POST', 'Admin/personalityQuestion', personalityQuestion);

      } else {

        return callHttp('PUT', 'Admin/personalityQuestion', personalityQuestion);

      }

    }

    /**
     * Admin user get personality answer value.
     */
    function adminGetPersonalityAnswerValue(personalityAnswerValue) {

      var id = httpService.extractId(personalityAnswerValue);
      return callHttp('GET', 'Admin/personalityAnswerValue/' + id);

    }

    /**
     * Admin user update personality answer value.
     */
    function adminUpdatePersonalityAnswerValue(personalityAnswerValue) {

      var id = httpService.extractId(personalityAnswerValue);
      if (id == 0) {

        return callHttp('POST', 'Admin/personalityAnswerValue', personalityAnswerValue);

      } else {

        return callHttp('PUT', 'Admin/personalityAnswerValue', personalityAnswerValue);

      }

    }

    /**
     * Admin user get the personality answer values.
     */
    function adminGetPersonalityAnswerValues(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'Admin/personalityAnswerValue', params);

    }

    /**
     * Admin user update competence test.
     */
    function adminUpdateCompetenceTest(competenceTest) {

      return callHttp('PUT', 'admin/competence/questionnaire', competenceTest);

    }

    /**
     * Admin user get competence question.
     */
    function adminGetCompetenceQuestion(competenceQuestion) {

      var id = httpService.extractId(competenceQuestion);
      return callHttp('GET', 'Admin/competenceQuestion/' + id);

    }

    /**
     * Admin user update competence question.
     */
    function adminUpdateCompetenceQuestion(competenceQuestion) {

      var id = httpService.extractId(competenceQuestion);
      if (id == 0) {

        return callHttp('POST', 'Admin/competenceQuestion', competenceQuestion);

      } else {

        return callHttp('PUT', 'Admin/competenceQuestion', competenceQuestion);

      }

    }

    /**
     * Admin user get competence answer value.
     */
    function adminGetCompetenceAnswerValue(competenceAnswerValue) {

      var id = httpService.extractId(competenceAnswerValue);
      return callHttp('GET', 'Admin/competenceAnswerValue/' + id);

    }

    /**
     * Admin user update competence answer value.
     */
    function adminUpdateCompetenceAnswerValue(competenceAnswerValue) {

      var id = httpService.extractId(competenceAnswerValue);
      if (id == 0) {

        return callHttp('POST', 'Admin/competenceAnswerValue', competenceAnswerValue);

      } else {

        return callHttp('PUT', 'Admin/competenceAnswerValue', competenceAnswerValue);

      }

    }

    /**
     * Admin user get the competence answer values.
     */
    function adminGetCompetenceAnswerValues(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'Admin/competenceAnswerValue', params);

    }

    /**
     * Admin user update student group.
     */
    function adminUpdateStudentGroup(studentGroup) {

      var id = httpService.extractId(studentGroup);
      if (id == 0) {

        return callHttp('POST', 'Admin/studentGroup', studentGroup);

      } else {

        return callHttp('PUT', 'Admin/studentGroup', studentGroup);
      }

    }

    /**
     * Admin user get student group.
     */
    function adminGetStudentGroup(studentGroup) {

      var id = httpService.extractId(studentGroup);
      return callHttp('GET', 'Admin/studentGroup/' + id);

    }

    /**
     * Admin user get some student groups.
     */
    function adminGetStudentGroups(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'Admin/studentGroup', params);

    }

    /**
     * Admin user remove an student group.
     */
    function adminRemoveStudentGroup(studentGroup) {

      var id = httpService.extractId(studentGroup);
      return callHttp('DELETE', 'Admin/studentGroup/' + id);

    }

    /**
     * Admin user get or create the student group session.
     */
    function adminGetSessionOfStudentGroup(studentGroup, create) {

      var id = httpService.extractId(studentGroup);
      var params = {};
      if (typeof create !== 'undefined') {

        params.create = create;
      }
      return callHttp('GET', 'admin/session/studentGroup/' + id, params);

    }

    /**
     * Teacher user update student group.
     */
    function teacherUpdateStudentGroup(studentGroup) {

      var id = httpService.extractId(studentGroup);
      return callHttp('PUT', 'teacher/studentGroup/' + id, studentGroup);

    }

    /**
     * Teacher user get student group.
     */
    function teacherGetStudentGroup(studentGroup) {

      var id = httpService.extractId(studentGroup);
      return callHttp('GET', 'teacher/studentGroup/' + id);

    }

    /**
     * Teacher user get some student groups.
     */
    function teacherGetStudentGroups(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'teacher/studentGroup', params);

    }

    /**
     * Teacher user remove an student group.
     */
    function teacherRemoveStudentGroup(studentGroup) {

      var id = httpService.extractId(studentGroup);
      return callHttp('DELETE', 'teacher/studentGroup/' + id);

    }

    /**
     * Teacher user get or create the student group session.
     */
    function teacherGetSessionOfStudentGroup(studentGroup, create) {

      var id = httpService.extractId(studentGroup);
      var params = {};
      if (typeof create !== 'undefined') {

        params.create = create;
      }
      return callHttp('GET', 'teacher/session/studentGroup/' + id, params);

    }

    /**
     * Teacher update session.
     */
    function teacherUpdateStudentGroupSession(session) {

      var id = httpService.extractId(session);
      return callHttp('PUT', 'teacher/session/studentGroup/' + id, session);

    }

    /**
     * Teacher remove session.
     */
    function teacherRemoveStudentGroupSession(session) {

      var id = httpService.extractId(session);
      return callHttp('DELETE', 'teacher/session/studentGroup/' + id);

    }

    /**
     * Admin update session.
     */
    function adminUpdateStudentGroupSession(session) {

      var id = httpService.extractId(session);
      return callHttp('PUT', 'admin/session/studentGroup/' + id, session);

    }

    /**
     * Admin remove session.
     */
    function adminRemoveStudentGroupSession(session) {

      var id = httpService.extractId(session);
      return callHttp('DELETE', 'admin/session/studentGroup/' + id);

    }

    /**
     * Admin get student teams.
     */
    function adminGetStudentTeams(group, startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      var id = httpService.extractId(group);
      return callHttp('GET', 'admin/team/studentGroup/' + id, params);
    }

    /**
     * Admin congenial team composition.
     */
    function adminConteam(group, studentsPerTeam) {

      var params = {};
      if (angular.isNumber(studentsPerTeam)) {
        params.studentsPerTeam = studentsPerTeam;
      }
      var id = httpService.extractId(group);
      return callHttp('GET', 'admin/team/congenial/' + id, params);

    }

    /**
     * Teacher get student teams.
     */
    function teacherGetStudentTeams(group, startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      var id = httpService.extractId(group);
      return callHttp('GET', 'teacher/team/studentGroup/' + id, params);
    }

    /**
     * Teacher congenial team composition.
     */
    function teacherConteam(group, studentsPerTeam) {

      var params = {};
      if (angular.isNumber(studentsPerTeam)) {
        params.studentsPerTeam = studentsPerTeam;
      }
      var id = httpService.extractId(group);
      return callHttp('GET', 'teacher/team/congenial/' + id, params);

    }

    /**
     * Admin get assignment teams.
     */
    function adminGetAssignmentTeams(assignment, startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      var id = httpService.extractId(assignment);
      return callHttp('GET', 'admin/team/assignment/' + id, params);
    }

    /**
     * Admin synergistic team composition.
     */
    function adminSynteam(assignment, studentsPerTeam) {

      var params = {};
      if (angular.isNumber(studentsPerTeam)) {
        params.studentsPerTeam = studentsPerTeam;
      }
      var id = httpService.extractId(assignment);
      return callHttp('GET', 'admin/team/synergistic/' + id, params);

    }

    /**
     * Teacher get assignment teams.
     */
    function teacherGetAssignmentTeams(assignment, startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      var id = httpService.extractId(assignment);
      return callHttp('GET', 'teacher/team/assignment/' + id, params);
    }

    /**
     * Teacher synergistic team composition.
     */
    function teacherSynteam(assignment, studentsPerTeam) {

      var params = {};
      if (angular.isNumber(studentsPerTeam)) {
        params.studentsPerTeam = studentsPerTeam;
      }
      var id = httpService.extractId(assignment);
      return callHttp('GET', 'teacher/team/synergistic/' + id, params);

    }

    /**
     * Admin get the test status of a student.
     */
    function adminGetTestStatus(student) {

      var studentId = httpService.extractId(student);
      return callHttp('GET', 'admin/questionnaire/status/' + studentId);

    }

    /**
     * Teacher get the test status of a group.
     */
    function teacherGetTestStatus(group) {

      var groupId = httpService.extractId(group);
      return callHttp('GET', 'teacher/studentGroup/status/' + groupId);

    }

    /**
     * Teacher get assignment.
     */
    function teacherGetAssignment(assignment) {

      var id = httpService.extractId(assignment);
      return callHttp('GET', 'teacher/assignment/' + id);

    }

    /**
     * Teacher get some assignments.
     */
    function teacherGetAssignments(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'teacher/assignment', params);

    }

    /**
     * Teacher remove an assignment.
     */
    function teacherRemoveAssignment(assignment) {

      var id = httpService.extractId(assignment);
      return callHttp('DELETE', 'teacher/assignment/' + id);

    }

    /**
     * Teacher update assignment.
     */
    function teacherUpdateAssignment(assignment) {

      var id = httpService.extractId(assignment);
      return callHttp('PUT', 'teacher/assignment/' + id, assignment);

    }

    /**
     * Teacher get rubric.
     */
    function teacherGetRubric(rubric) {

      var id = httpService.extractId(rubric);
      return callHttp('GET', 'teacher/rubric/' + id);

    }

    /**
     * Teacher update rubric.
     */
    function teacherUpdateRubric(rubric) {

      var id = httpService.extractId(rubric);
      return callHttp('PUT', 'teacher/rubric/' + id, rubric);

    }

    /**
     * Teacher get some rubrics.
     */
    function teacherGetRubrics(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'teacher/rubric', params);

    }

    /**
     * Teacher remove a rubric.
     */
    function teacherRemoveRubric(rubric) {

      var id = httpService.extractId(rubric);
      return callHttp('DELETE', 'teacher/rubric/' + id);

    }

    /**
     * Teacher get criterion.
     */
    function teacherGetCriterion(criterion) {

      var id = httpService.extractId(criterion);
      return callHttp('GET', 'teacher/criterion/' + id);

    }

    /**
     * Teacher update criterion.
     */
    function teacherUpdateCriterion(criterion) {

      var id = httpService.extractId(criterion);
      return callHttp('PUT', 'teacher/criterion/' + id, criterion);

    }

    /**
     * Teacher remove a criterion.
     */
    function teacherRemoveCriterion(criterion) {

      var id = httpService.extractId(criterion);
      return callHttp('DELETE', 'teacher/criterion/' + id);

    }

    /**
     * Teacher get competence request.
     */
    function teacherGetCompetenceRequest(competenceRequest) {

      var id = httpService.extractId(competenceRequest);
      return callHttp('GET', 'teacher/competenceRequest/' + id);

    }

    /**
     * Teacher update competence request.
     */
    function teacherUpdateCompetenceRequest(competenceRequest) {

      var id = httpService.extractId(competenceRequest);
      return callHttp('PUT', 'teacher/competenceRequest/' + id, competenceRequest);

    }

    /**
     * Teacher remove a competence request.
     */
    function teacherRemoveCompetenceRequest(competenceRequest) {

      var id = httpService.extractId(competenceRequest);
      return callHttp('DELETE', 'teacher/competenceRequest/' + id);

    }

    /**
     * Remove user profile.
     */
    function removeProfile() {

      var deferred = $q.defer();

      callHttp('DELETE', 'user/profile').then(function() {
        vm.user = null;
        delete $http.defaults.headers.common['Session-Id'];
        deferred.resolve();
      }, function() {
        deferred.reject();
      });

      return deferred.promise;

    }

    /**
     * Update user profile.
     */
    function updateProfile(profile) {

      return callHttp('PUT', 'user/profile', profile);

    }

    /**
     * Teacher get assignment.
     */
    function adminGetAssignment(assignment) {

      var id = httpService.extractId(assignment);
      return callHttp('GET', 'Admin/assignment/' + id);

    }

    /**
     * Teacher get some assignments.
     */
    function adminGetAssignments(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'Admin/assignment', params);

    }

    /**
     * Teacher remove an assignment.
     */
    function adminRemoveAssignment(assignment) {

      var id = httpService.extractId(assignment);
      return callHttp('DELETE', 'Admin/assignment/' + id);

    }

    /**
     * Teacher update assignment.
     */
    function adminUpdateAssignment(assignment) {

      var id = httpService.extractId(assignment);
      if (id == 0) {

        return callHttp('POST', 'Admin/assignment', assignment);

      } else {

        return callHttp('PUT', 'Admin/assignment', assignment);

      }

    }

    /**
     * Teacher get rubric.
     */
    function adminGetRubric(rubric) {

      var id = httpService.extractId(rubric);
      return callHttp('GET', 'Admin/rubric/' + id);

    }

    /**
     * Teacher update rubric.
     */
    function adminUpdateRubric(rubric) {

      var id = httpService.extractId(rubric);
      if (id == 0) {

        return callHttp('POST', 'Admin/rubric', rubric);

      } else {

        return callHttp('PUT', 'Admin/rubric', rubric);

      }

    }

    /**
     * Teacher get some rubrics.
     */
    function adminGetRubrics(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'Admin/rubric', params);

    }

    /**
     * Teacher remove a rubric.
     */
    function adminRemoveRubric(rubric) {

      var id = httpService.extractId(rubric);
      return callHttp('DELETE', 'Admin/rubric/' + id);

    }

    /**
     * Teacher get criterion.
     */
    function adminGetCriterion(criterion) {

      var id = httpService.extractId(criterion);
      return callHttp('GET', 'Admin/criterion/' + id);

    }

    /**
     * Teacher update criterion.
     */
    function adminUpdateCriterion(criterion) {

      var id = httpService.extractId(criterion);
      if (id == 0) {

        return callHttp('POST', 'Admin/criterion', criterion);

      } else {

        return callHttp('PUT', 'Admin/criterion', criterion);

      }

    }

    /**
     * Teacher remove a criterion.
     */
    function adminRemoveCriterion(criterion) {

      var id = httpService.extractId(criterion);
      return callHttp('DELETE', 'Admin/criterion/' + id);

    }

    /**
     * Teacher get competence request.
     */
    function adminGetCompetenceRequest(competenceRequest) {

      var id = httpService.extractId(competenceRequest);
      return callHttp('GET', 'Admin/competenceRequest/' + id);

    }

    /**
     * Teacher update competence request.
     */
    function adminUpdateCompetenceRequest(competenceRequest) {

      var id = httpService.extractId(competenceRequest);
      if (id == 0) {

        return callHttp('POST', 'Admin/competenceRequest', competenceRequest);

      } else {

        return callHttp('PUT', 'Admin/competenceRequest', competenceRequest);

      }

    }

    /**
     * Teacher remove a competence request.
     */
    function adminRemoveCompetenceRequest(competenceRequest) {

      var id = httpService.extractId(competenceRequest);
      return callHttp('DELETE', 'Admin/competenceRequest/' + id);

    }

    /**
     * Admin get the personality answers of an student.
     */
    function adminGetStudentPersonalityAnswers(student, startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      var id = httpService.extractId(student);
      return callHttp('GET', 'admin/studentPersonalityAnswer/' + id, params);

    }

    /**
     * Admin get the competence answers of an student.
     */
    function adminGetStudentCompetenceAnswers(student, startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      var id = httpService.extractId(student);
      return callHttp('GET', 'admin/studentCompetenceAnswer/' + id, params);

    }

    /**
     * Admin update personality answer.
     */
    function adminUpdateStudentPersonalityAnswer(personalityAnswer) {

      var id = httpService.extractId(personalityAnswer);
      if (id == 0) {

        return callHttp('POST', 'admin/studentPersonalityAnswer', personalityAnswer);

      } else {

        return callHttp('PUT', 'admin/studentPersonalityAnswer/' + id, personalityAnswer.answer);

      }

    }

    /**
     * Admin update competence answer.
     */
    function adminUpdateStudentCompetenceAnswer(competenceAnswer) {

      var id = httpService.extractId(competenceAnswer);
      if (id == 0) {

        return callHttp('POST', 'admin/studentCompetenceAnswer', competenceAnswer);

      } else {

        return callHttp('PUT', 'admin/studentCompetenceAnswer/' + id, competenceAnswer.answer);

      }

    }

    /**
     * Admin get an student
     */
    function adminGetStudent(student) {

      var id = httpService.extractId(student);
      return callHttp('GET', 'admin/student/' + id);

    }

    /**
     * Student get groups that it plays
     */
    function studentGetStudentGroups(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'student/group', params);

    }

    /**
     * Student get assignments that it plays
     */
    function studentGetAssignments(startPosition, maxResult) {

      var params = httpService.toGetParams(startPosition, maxResult);
      return callHttp('GET', 'student/assignment', params);

    }

    /**
     * Join into a group
     */
    function studentJoinToStudentGroup(groupCode) {

      return callHttp('POST', 'student/group', groupCode);

    }

    /**
     * Return the team associated to a student group for an student.
     */
    function studentGetStudentTeam(group) {

      var id = httpService.extractId(group);
      return callHttp('GET', 'student/group/' + id + "/team");

    }

    /**
     * Return the team associated to a assignment for an student.
     */
    function studentGetAssignmentTeam(assignment) {

      var id = httpService.extractId(assignment);
      return callHttp('GET', 'student/assignment/' + id + "/team");

    }

    /**
     * Admin get default assignment of group.
     */
    function adminGetDefaultAssignmentOf(group) {

      var id = httpService.extractId(group);
      return callHttp('GET', 'Admin/studentGroup/' + id + '/defaultAssignment');

    }

    /**
     * Admin get groups where plays an student.
     */
    function adminGetGroupsOfStudent(student) {

      var id = httpService.extractId(student);
      return callHttp('GET', 'admin/student/' + id + '/studentGroup');
    }

    /**
     * Admin join an user to a group.
     */
    function adminJoinStudentToGroup(student, group) {

      var idStudent = httpService.extractId(student);
      var idGroup = httpService.extractId(group);
      return callHttp('POST', 'admin/student/' + idStudent + '/studentGroup/' + idGroup);

    }

    /**
     * Admin leave an user from a group.
     */
    function adminLeaveStudentFromGroup(student, group) {

      var idStudent = httpService.extractId(student);
      var idGroup = httpService.extractId(group);
      return callHttp('DELETE', 'admin/student/' + idStudent + '/studentGroup/' + idGroup);

    }

    /**
     * Teacher update assignment team.
     */
    function teacherUpdateAssignmentTeam(teamId, team) {

      if (angular.isUndefined(team)) {

        team = teamId;
        teamId = httpService.extractId(team);

      }
      return callHttp('PUT', 'teacher/team/assignment/' + teamId, team);

    }

    /**
     * Teacher update student team.
     */
    function teacherUpdateStudentTeam(teamId, team) {

      if (angular.isUndefined(team)) {

        team = teamId;
        teamId = httpService.extractId(team);

      }
      return callHttp('PUT', 'teacher/team/studentGroup/' + teamId, team);

    }

    /**
     * Admin lp team composition.
     */
    function adminLpteam(assignment, studentsPerTeam) {

      var params = {};
      if (angular.isNumber(studentsPerTeam)) {
        params.studentsPerTeam = studentsPerTeam;
      }
      var id = httpService.extractId(assignment);
      return callHttp('GET', 'admin/team/lp/' + id, params);

    }

    /**
     * Teacher lp team composition.
     */
    function teacherLpteam(assignment, studentsPerTeam) {

      var params = {};
      if (angular.isNumber(studentsPerTeam)) {
        params.studentsPerTeam = studentsPerTeam;
      }
      var id = httpService.extractId(assignment);
      return callHttp('GET', 'teacher/team/lp/' + id, params);

    }
  }

})();
(function() {
  'use strict';

  angular.module('Education').factory('httpService', httpService);

  /** @ngInject */
  function httpService($http, $q, $log) {

    var service = {
      extractId : extractId,
      addModelTo : addModelTo,
      removeModel : removeModel,
      addAllModelsTo : addAllModelsTo,
      callHttp : callHttp,
      toGetParams : toGetParams,
      removeAllModels:removeAllModels
    };

    return service;

    /**
     * Obtain the identifier of a model.
     */
    function extractId(model) {

      if (angular.isObject(model)) {

        return extractId(model.id);

      } else if (angular.isDefined(model)) {

        return model;

      } else {
        // no id defined
        return 0;
      }
    }

    /**
     * Add some model to a list of models.
     */
    function addAllModelsTo(models, list) {

      for ( var i in models) {

        addModelTo(models[i], list);

      }
    }

    /**
     * Add a model to a list of models.
     */
    function addModelTo(model, list) {

      var modelId = extractId(model);
      for ( var i in list) {

        if (list[i].id == modelId) {
          // already added => replace
          list[i] = model;
          return i;
        }
      }
      list.push(model);
      return list.length - 1;

    }

    /**
     * Remove a model to a list of models.
     */
    function removeModel(model, list) {

      var modelId = extractId(model);

      for ( var i in list) {

        if (list[i].id == modelId) {

          list.splice(i, 1);
          return true;
        }
      }

      return false;
    }

    /**
     * Remove all models.
     */
    function removeAllModels(source, target) {

      if (source && target) {

        for ( var i in source) {

          removeModel(source[i], target);
        }

      }

    }

    /**
     * Post the specified content to the http.
     * 
     * @param host
     *          address to the host.
     * @param path
     *          to the resource.
     * @param content
     *          to post or parameters if it is a 'GET'.
     */
    function callHttp(host, method, path, content) {

      var deferred = $q.defer();
      var params = {
        method : method,
        url : host + path
      };
      if (typeof content !== 'undefined' && content != null) {

        if (method === 'GET') {

          params.params = content;

        } else {

          params.data = content;
        }
      }
      var successCallback = function(response) {

        deferred.resolve(response.data);

      };
      var errorCallback = function(httpError) {
        $log.warn(httpError);
        deferred.reject(httpError);
      };
      $http(params).then(successCallback, errorCallback);

      return deferred.promise;
    }

    /**
     * Create the get parameters.
     * 
     * @param startPosition
     *          index of the first friend to return. If it is not defined it use
     *          {@code 0}.
     * @param maxResult
     *          the number maximum of friends to return. If it is not defined it
     *          use {@code 100}.
     */
    function toGetParams(startPosition, maxResult) {

      var params = {};
      if (typeof startPosition !== 'undefined') {

        params.startPosition = startPosition;

      } else {

        params.startPosition = 0;
      }
      if (typeof maxResult !== 'undefined') {

        params.maxResult = maxResult;

      } else {

        params.maxResult = 100;
      }

      return params;
    }

  }

})();
(function() {
	'use strict';

	angular.module('Education').filter('formatText', formatText);

	/** @ngInject */
	function formatText() {

		return function(input) {
			if (!input)
				return input;
			var output = input
			// replace possible line breaks.
			.replace(/\\n/g, '<br/>').replace(/\n/g, ' ').replace(/\r/g, ' ')
			// replace tabs
			.replace(/\t/g, '&nbsp;');
			// replace spaces..replace(/ /g, '&nbsp;');

			return output;
		}
	}

})();

(function() {
	'use strict';

	angular.module('Education').controller('EmptyViewController', EmptyViewController);

	/** @ngInject */
	function EmptyViewController() {
	}
})();
(function() {
  'use strict';

  angular.module('Education').run(runBlock);

  /** @ngInject */
  function runBlock($window, $locale, $translate) {

    angular.element($window).bind("load resize", function() {
      var topOffset = 50;
      var width = (this.window.innerWidth > 0) ? this.window.innerWidth : this.screen.width;
      if (width < 768) {
        angular.element('div.navbar-collapse').addClass('collapse');
        topOffset = 100; // 2-row-menu
      } else {
        angular.element('div.navbar-collapse').removeClass('collapse');
      }

      var height = ((this.window.innerHeight > 0) ? this.window.innerHeight : this.screen.height) - 1;
      height = height - topOffset;
      if (height < 1)
        height = 1;
      if (height > topOffset) {
        angular.element("#page-wrapper").css("min-height", (height) + "px");
      }
    });

    var url = $window.location;
    // var element = $('ul.nav a').filter(function() {
    // return this.href == url;
    // }).addClass('active').parent().parent().addClass('in').parent();
    var element = angular.element('ul.nav a').filter(function() {
      return this.href == url;
    }).addClass('active').parent();

    while (element.is('li')) {
      element = element.parent().addClass('in').parent();
    }

    $locale.id = $translate.proposedLanguage().substring(0, 2);
  }

})();

(function() {
  'use strict';

  angular.module('Education').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('welcome', {
      abstract : true,
      url : '/welcome',
      templateUrl : 'app/welcome/welcome.html',
      controller : 'WelcomeController',
      controllerAs : 'vm'
    }).state('welcome.main', {
      abstract : false,
      url : '/main',
      templateUrl : 'app/welcome/main/main.html',
      controller : 'WelcomeMainController',
      controllerAs : 'vm'
    }).state('welcome.assessments', {
      abstract : false,
      url : '/assessments',
      templateUrl : 'app/welcome/assessments/assessments.html',
      controller : 'WelcomeAssessmentsController',
      controllerAs : 'vm'
    }).state('welcome.teams', {
      abstract : false,
      url : '/teams',
      templateUrl : 'app/welcome/teams/teams.html',
      controller : 'WelcomeTeamsController',
      controllerAs : 'vm'
    }).state('welcome.lessonPlans', {
      abstract : false,
      url : '/lessonPlans',
      templateUrl : 'app/welcome/lessonPlans/lessonPlans.html',
      controller : 'WelcomeLessonPlansController',
      controllerAs : 'vm'
    }).state('welcome.platform', {
      abstract : false,
      url : '/platform',
      templateUrl : 'app/welcome/platform/platform.html',
      controller : 'WelcomePlatformController',
      controllerAs : 'vm'
    }).state('welcome.login', {
      abstract : false,
      url : '/login',
      templateUrl : 'app/welcome/login/login.html',
      controller : 'WelcomeLoginController',
      controllerAs : 'vm'
    }).state('tool', {
      abstract : true,
      url : '/tool',
      templateUrl : 'app/tool/tool.html',
      controller : 'ToolController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment', {
      abstract : true,
      url : '/collaborativeAssessment',
      templateUrl : 'app/components/emptyView.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.about', {
      abstract : false,
      url : '/about',
      templateUrl : 'app/tool/collaborativeAssessment/about/about.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.teachers', {
      abstract : false,
      url : '/teachers',
      templateUrl : 'app/tool/collaborativeAssessment/teachers/teachers.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.students', {
      abstract : false,
      url : '/students',
      templateUrl : 'app/tool/collaborativeAssessment/students/students.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.groups', {
      abstract : false,
      url : '/groups',
      templateUrl : 'app/tool/collaborativeAssessment/groups/groups.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.rubrics', {
      abstract : false,
      url : '/rubrics',
      templateUrl : 'app/tool/collaborativeAssessment/rubrics/rubrics.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.assessments', {
      abstract : false,
      url : '/assessments/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/tool/collaborativeAssessment/assessments/assessments.html',
      controller : 'CollaborativeAssessmentAssessmentsController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.criteria', {
      abstract : false,
      url : '/criteria',
      templateUrl : 'app/tool/collaborativeAssessment/criteria/criteria.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.competenceRequests', {
      abstract : false,
      url : '/competenceRequests',
      templateUrl : 'app/tool/collaborativeAssessment/competenceRequests/competenceRequests.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.assignments', {
      abstract : false,
      url : '/assignments',
      templateUrl : 'app/tool/collaborativeAssessment/assignments/assignments.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.evaluate', {
      cache : false,
      url : '/evaluate',
      templateUrl : 'app/tool/collaborativeAssessment/evaluate/evaluate.html',
      controller : 'CollaborativeAssessmentEvaluateController',
      controllerAs : 'vm'
    }).state('tool.collaborativeAssessment.comas', {
      cache : false,
      url : '/comas/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/tool/collaborativeAssessment/comas/comas.html',
      controller : 'CollaborativeAssessmentComasController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams', {
      abstract : true,
      url : '/congenialTeams',
      templateUrl : 'app/components/emptyView.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.about', {
      abstract : false,
      url : '/about',
      templateUrl : 'app/tool/congenialTeams/about/about.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.students', {
      abstract : false,
      url : '/students',
      templateUrl : 'app/tool/congenialTeams/students/students.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.groups', {
      abstract : false,
      url : '/groups',
      templateUrl : 'app/tool/congenialTeams/groups/groups.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.personalityTest', {
      abstract : false,
      url : '/personalityTest?:studentId&:questionnaireId',
      templateUrl : 'app/tool/congenialTeams/personalityTest/personalityTest.html',
      controller : 'CongenialTeamsPersonalityTestController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.conteam', {
      abstract : false,
      url : '/conteam',
      templateUrl : 'app/tool/congenialTeams/conteam/conteam.html',
      controller : 'CongenialTeamsConteamController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.questionnaires', {
      abstract : false,
      url : '/questionnaires',
      templateUrl : 'app/tool/congenialTeams/questionnaires/questionnaires.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.questions', {
      abstract : false,
      url : '/questions',
      templateUrl : 'app/tool/congenialTeams/questions/questions.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.congenialTeams.answers', {
      abstract : false,
      url : '/answers',
      templateUrl : 'app/tool/congenialTeams/answers/answers.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.lessonPlanEditor', {
      abstract : true,
      url : '/lessonPlanEditor',
      templateUrl : 'app/components/emptyView.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.lessonPlanEditor.about', {
      abstract : false,
      url : '/about',
      templateUrl : 'app/tool/lessonPlanEditor/about/about.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.lessonPlanExecution', {
      abstract : true,
      url : '/lessonPlanExecution',
      templateUrl : 'app/components/emptyView.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.lessonPlanExecution.about', {
      abstract : false,
      url : '/about',
      templateUrl : 'app/tool/lessonPlanExecution/about/about.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.synergisticTeams', {
      abstract : true,
      url : '/synergisticTeams',
      templateUrl : 'app/components/emptyView.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.synergisticTeams.about', {
      abstract : false,
      url : '/about',
      templateUrl : 'app/tool/synergisticTeams/about/about.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.synergisticTeams.personalityTest', {
      abstract : false,
      url : '/personalityTest?:studentId&:questionnaireId',
      templateUrl : 'app/tool/synergisticTeams/personalityTest/personalityTest.html',
      controller : 'SynergisticTeamsPersonalityTestController',
      controllerAs : 'vm'
    }).state('tool.synergisticTeams.competenceTest', {
      abstract : false,
      url : '/competenceTest?:studentId&:questionnaireId',
      templateUrl : 'app/tool/synergisticTeams/competenceTest/competenceTest.html',
      controller : 'SynergisticTeamsCompetenceTestController',
      controllerAs : 'vm'
    }).state('tool.synergisticTeams.synteam', {
      abstract : false,
      url : '/synteam',
      templateUrl : 'app/tool/synergisticTeams/synteam/synteam.html',
      controller : 'SynergisticTeamsSynteamController',
      controllerAs : 'vm'
    }).state('tool.data', {
      abstract : true,
      url : '/data',
      templateUrl : 'app/components/emptyView.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.assignments', {
      abstract : false,
      url : '/assignments',
      templateUrl : 'app/tool/data/assignments/assignments.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.teachers', {
      abstract : false,
      url : '/teachers',
      templateUrl : 'app/tool/data/teachers/teachers.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.rubrics', {
      abstract : false,
      url : '/rubrics',
      templateUrl : 'app/tool/data/rubrics/rubrics.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.criteria', {
      abstract : false,
      url : '/criteria',
      templateUrl : 'app/tool/data/criteria/criteria.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.groups', {
      abstract : false,
      url : '/groups',
      templateUrl : 'app/tool/data/groups/groups.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.students', {
      abstract : false,
      url : '/students',
      templateUrl : 'app/tool/data/students/students.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.competenceRequests', {
      abstract : false,
      url : '/competenceRequests',
      templateUrl : 'app/tool/data/competenceRequests/competenceRequests.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.personalityQuestionnaires', {
      abstract : false,
      url : '/personalityQuestionnaires',
      templateUrl : 'app/tool/data/personalityQuestionnaires/personalityQuestionnaires.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.personalityQuestions', {
      abstract : false,
      url : '/personalityQuestions',
      templateUrl : 'app/tool/data/personalityQuestions/personalityQuestions.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.personalityAnswers', {
      abstract : false,
      url : '/personalityAnswers',
      templateUrl : 'app/tool/data/personalityAnswers/personalityAnswers.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.competenceQuestionnaires', {
      abstract : false,
      url : '/competenceQuestionnaires',
      templateUrl : 'app/tool/data/competenceQuestionnaires/competenceQuestionnaires.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.competenceQuestions', {
      abstract : false,
      url : '/competenceQuestions',
      templateUrl : 'app/tool/data/competenceQuestions/competenceQuestions.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('tool.data.competenceAnswers', {
      abstract : false,
      url : '/competenceAnswers',
      templateUrl : 'app/tool/data/competenceAnswers/competenceAnswers.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform', {
      abstract : true,
      url : '/platform',
      templateUrl : 'app/platform/platform.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.admin', {
      abstract : true,
      url : '/admin',
      templateUrl : 'app/platform/admin/admin.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.admin.main', {
      abstract : false,
      url : '/main',
      templateUrl : 'app/platform/admin/main/main.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.admin.personalityTest', {
      abstract : false,
      url : '/personalityTest',
      templateUrl : 'app/platform/admin/personalityTest/personalityTest.html',
      controller : 'PlatformAdminPersonalityTestController',
      controllerAs : 'vm'
    }).state('platform.admin.personalityQuestion', {
      abstract : false,
      url : '/personalityQuestion/{questionId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/personalityTest/question.html',
      controller : 'PlatformAdminPersonalityQuestionController',
      controllerAs : 'vm'
    }).state('platform.admin.personalityAnswerValue', {
      abstract : false,
      url : '/personalityAnswer/{questionId:L?[0-9]+}/{answerValueId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/personalityTest/answerValue.html',
      controller : 'PlatformAdminPersonalityAnswerValueController',
      controllerAs : 'vm'
    }).state('platform.admin.competenceTest', {
      abstract : false,
      url : '/competenceTest',
      templateUrl : 'app/platform/admin/competenceTest/competenceTest.html',
      controller : 'PlatformAdminCompetenceTestController',
      controllerAs : 'vm'
    }).state('platform.admin.competenceQuestion', {
      abstract : false,
      url : '/competenceQuestion/{questionId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/competenceTest/question.html',
      controller : 'PlatformAdminCompetenceQuestionController',
      controllerAs : 'vm'
    }).state('platform.admin.competenceAnswerValue', {
      abstract : false,
      url : '/competenceAnswer/{questionId:L?[0-9]+}/{answerValueId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/competenceTest/answerValue.html',
      controller : 'PlatformAdminCompetenceAnswerValueController',
      controllerAs : 'vm'
    }).state('platform.admin.users', {
      abstract : false,
      url : '/users',
      templateUrl : 'app/platform/admin/users/users.html',
      controller : 'PlatformAdminUsersController',
      controllerAs : 'vm'
    }).state('platform.admin.user', {
      abstract : false,
      url : '/user/{userId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/users/user.html',
      controller : 'PlatformAdminUserController',
      controllerAs : 'vm'
    }).state('platform.admin.groups', {
      abstract : false,
      url : '/groups',
      templateUrl : 'app/platform/admin/groups/groups.html',
      controller : 'PlatformAdminGroupsController',
      controllerAs : 'vm'
    }).state('platform.admin.group', {
      abstract : false,
      url : '/group/{groupId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/groups/group.html',
      controller : 'PlatformAdminGroupController',
      controllerAs : 'vm'
    }).state('platform.admin.studentTeams', {
      abstract : false,
      url : '/studentTeams/{groupId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/groups/studentTeams.html',
      controller : 'PlatformAdminStudentTeamsController',
      controllerAs : 'vm'
    }).state('platform.admin.assignments', {
      abstract : false,
      url : '/assignments',
      templateUrl : 'app/platform/admin/assignments/assignments.html',
      controller : 'PlatformAdminAssignmentsController',
      controllerAs : 'vm'
    }).state('platform.admin.assignment', {
      abstract : false,
      url : '/assignment/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/assignments/assignment.html',
      controller : 'PlatformAdminAssignmentController',
      controllerAs : 'vm'
    }).state('platform.admin.competenceRequest', {
      abstract : false,
      url : '/competenceRequest/{competenceRequestId:L?[0-9]+}/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/assignments/competenceRequest.html',
      controller : 'PlatformAdminCompetenceRequestController',
      controllerAs : 'vm'
    }).state('platform.admin.assignmentTeams', {
      abstract : false,
      url : '/assignmentTeams/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/assignments/assignmentTeams.html',
      controller : 'PlatformAdminAssignmentTeamsController',
      controllerAs : 'vm'
    }).state('platform.admin.rubrics', {
      abstract : false,
      url : '/rubrics',
      templateUrl : 'app/platform/admin/rubrics/rubrics.html',
      controller : 'PlatformAdminRubricsController',
      controllerAs : 'vm'
    }).state('platform.admin.rubric', {
      abstract : false,
      url : '/rubric/{rubricId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/rubrics/rubric.html',
      controller : 'PlatformAdminRubricController',
      controllerAs : 'vm'
    }).state('platform.admin.criterion', {
      abstract : false,
      url : '/criterion/{criterionId:L?[0-9]+}/{rubricId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/rubrics/criterion.html',
      controller : 'PlatformAdminCriterionController',
      controllerAs : 'vm'
    }).state('platform.admin.studentPersonalityTest', {
      abstract : false,
      url : '/studentPersonalityTest/{groupId:L?[0-9]+}/{studentId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/groups/studentPersonalityTest.html',
      controller : 'PlatformAdminStudentPersonalityTestController',
      controllerAs : 'vm'
    }).state('platform.admin.studentCompetenceTest', {
      abstract : false,
      url : '/studentCompetenceTest/{groupId:L?[0-9]+}/{studentId:L?[0-9]+}',
      templateUrl : 'app/platform/admin/groups/studentCompetenceTest.html',
      controller : 'PlatformAdminStudentCompetenceTestController',
      controllerAs : 'vm'
    }).state('platform.teacher', {
      abstract : true,
      url : '/teacher',
      templateUrl : 'app/platform/teacher/teacher.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.teacher.groups', {
      abstract : false,
      url : '/groups',
      templateUrl : 'app/platform/teacher/groups/groups.html',
      controller : 'PlatformTeacherGroupsController',
      controllerAs : 'vm'
    }).state('platform.teacher.group', {
      abstract : false,
      url : '/group/{groupId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/groups/group.html',
      controller : 'PlatformTeacherGroupController',
      controllerAs : 'vm'
    }).state('platform.teacher.studentTeams', {
      abstract : false,
      url : '/studentTeams/{groupId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/groups/studentTeams.html',
      controller : 'PlatformTeacherStudentTeamsController',
      controllerAs : 'vm'
    }).state('platform.teacher.assignments', {
      abstract : false,
      url : '/assignments',
      templateUrl : 'app/platform/teacher/assignments/assignments.html',
      controller : 'PlatformTeacherAssignmentsController',
      controllerAs : 'vm'
    }).state('platform.teacher.assignment', {
      abstract : false,
      url : '/assignment/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/assignments/assignment.html',
      controller : 'PlatformTeacherAssignmentController',
      controllerAs : 'vm'
    }).state('platform.teacher.competenceRequest', {
      abstract : false,
      url : '/competenceRequest/{competenceRequestId:L?[0-9]+}/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/assignments/competenceRequest.html',
      controller : 'PlatformTeacherCompetenceRequestController',
      controllerAs : 'vm'
    }).state('platform.teacher.assignmentTeams', {
      abstract : false,
      url : '/assignmentTeams/{assignmentId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/assignments/assignmentTeams.html',
      controller : 'PlatformTeacherAssignmentTeamsController',
      controllerAs : 'vm'
    }).state('platform.teacher.rubrics', {
      abstract : false,
      url : '/rubrics',
      templateUrl : 'app/platform/teacher/rubrics/rubrics.html',
      controller : 'PlatformTeacherRubricsController',
      controllerAs : 'vm'
    }).state('platform.teacher.rubric', {
      abstract : false,
      url : '/rubric/{rubricId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/rubrics/rubric.html',
      controller : 'PlatformTeacherRubricController',
      controllerAs : 'vm'
    }).state('platform.teacher.criterion', {
      abstract : false,
      url : '/criterion/{criterionId:L?[0-9]+}/{rubricId:L?[0-9]+}',
      templateUrl : 'app/platform/teacher/rubrics/criterion.html',
      controller : 'PlatformTeacherCriterionController',
      controllerAs : 'vm'
    }).state('platform.teacher.main', {
      abstract : false,
      url : '/main',
      templateUrl : 'app/platform/teacher/main/main.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.teacher.profile', {
      abstract : false,
      url : '/profile',
      templateUrl : 'app/platform/teacher/profile/profile.html',
      controller : 'PlatformTeacherProfileController',
      controllerAs : 'vm'
    }).state('platform.student', {
      abstract : true,
      url : '/student',
      templateUrl : 'app/platform/student/student.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.student.main', {
      abstract : false,
      url : '/main',
      templateUrl : 'app/platform/student/main/main.html',
      controller : 'EmptyViewController',
      controllerAs : 'vm'
    }).state('platform.student.profile', {
      abstract : false,
      url : '/profile',
      templateUrl : 'app/platform/student/profile/profile.html',
      controller : 'PlatformStudentProfileController',
      controllerAs : 'vm'
    }).state('platform.student.personalityTest', {
      abstract : false,
      url : '/personalityTest',
      templateUrl : 'app/platform/student/personalityTest/personalityTest.html',
      controller : 'PlatformStudentPersonalityTestController',
      controllerAs : 'vm'
    }).state('platform.student.competenceTest', {
      abstract : false,
      url : '/competenceTest',
      templateUrl : 'app/platform/student/competenceTest/competenceTest.html',
      controller : 'PlatformStudentCompetenceTestController',
      controllerAs : 'vm'
    }).state('platform.student.groups', {
      abstract : false,
      url : '/groups',
      templateUrl : 'app/platform/student/groups/groups.html',
      controller : 'PlatformStudentGroupsController',
      controllerAs : 'vm'
    }).state('platform.student.assignments', {
      abstract : false,
      url : '/assignments',
      templateUrl : 'app/platform/student/assignments/assignments.html',
      controller : 'PlatformStudentAssignmentsController',
      controllerAs : 'vm'
    });

    $urlRouterProvider.otherwise('/welcome/main');
  }

})();

/* global  moment:false */
(function() {
  'use strict';

  angular.module('Education').constant('moment', moment);

  angular.module('Education').constant('SERVER', (function() {

    if (window.location.href.indexOf('education.iiia.csic.es') != -1) {

      return 'https://education.iiia.csic.es/api/';

    } else if (window.location.href.indexOf('ardid.iiia.csic.es') != -1) {

      return 'http://ardid.iiia.csic.es/educationapi/';

    } else if (window.location.href.indexOf('educationjc.iiia.csic.es') != -1) {

      return 'https://educationjc.iiia.csic.es/api/';

    } else if (window.location.href.indexOf('educationc.iiia.csic.es') != -1) {

      return 'https://educationc.iiia.csic.es/api/';

    } else {

      return 'https://education.iiia.csic.es/api/';
      //return 'http://localhost:9876/api/';
    }

  })());

  angular.module('Education').constant('PLATFORM', (function() {

    if (window.location.href.indexOf('education.iiia.csic.es') != -1) {

      return 'https://education.iiia.csic.es/sapi/';

    } else if (window.location.href.indexOf('ardid.iiia.csic.es') != -1) {

      return 'http://ardid.iiia.csic.es/educationsapi/';

    } else {

      return 'http://localhost:9877/api/';
    }

  })());

  angular.module('Education').constant('EDUCATION_EVENTS', {
    changedLanguage : 'changed-language',
    addedStudent : 'addedd-student',
    updatedStudent : 'updated-student',
    addedPersonalityQuestionnaire : 'added-personality-questionnaire',
    updatedPersonalityQuestionnaire : 'updated-personality-questionnaire',
    addedPersonalityQuestion : 'added-personality-question',
    updatedPersonalityQuestion : 'updated-personality-question',
    addedPersonalityAnswerValue : 'added-personality-answer-value',
    updatedPersonalityAnswerValue : 'updated-personality-answer-value',
    addedStudentGroup : 'addedd-student-group',
    updatedStudentGroup : 'updated-student-group',
    addedCriterion : 'addedd-criterion',
    updatedCriterion : 'updated-criterion',
    addedRubric : 'addedd-rubric',
    updatedRubric : 'updated-rubric',
    addedTeacher : 'addedd-teacher',
    updatedTeacher : 'updated-teacher',
    addedAssessment : 'addedd-assessment',
    updatedAssessment : 'updated-assessment',
    addedCompetenceQuestionnaire : 'added-competence-questionnaire',
    updatedCompetenceQuestionnaire : 'updated-competence-questionnaire',
    addedCompetenceQuestion : 'added-competence-question',
    updatedCompetenceQuestion : 'updated-competence-question',
    addedCompetenceAnswerValue : 'added-competence-answer-value',
    updatedCompetenceAnswerValue : 'updated-competence-answer-value'
  });

  angular.module('Education').constant('PERSONALITY_FACTORS', [ "PERCEPTION", "JUDGMENT", "EXTROVERT", "ATTITUDE" ]);
  angular.module('Education').constant('PERSON_SEX', [ "FEMALE", "MALE" ]);
  angular.module('Education').constant('COMPETENCE_FACTORS', [ "VERBAL", "LOGIC_MATHEMATICS", "VISUAL_SPATIAL", "KINESTESICA_CORPORAL", "MUSICAL_RHYTHMIC", "INTRAPERSONAL", "INTERPERSONAL" ]);
  angular.module('Education').constant('BASIC_SCALE', [ 0.0, 0.25, 0.5, 0.75, 1.0 ]);
  angular.module('Education').constant('FEEDBACK_FOR_TEAMS', [ 0.0, 0.25, 0.5, 0.75, 1.0 ]);

})();

(function() {
	'use strict';

	angular.module('Education').config(config);

	/** @ngInject */
	function config($logProvider, toastrConfig, $translateProvider, $analyticsProvider, progressButtonConfigProvider) {

		$analyticsProvider.firstPageview(true);
		$analyticsProvider.withAutoBase(true);

		// Enable log
		$logProvider.debugEnabled(true);

		// Set options third-party lib
		toastrConfig.allowHtml = true;
		toastrConfig.timeOut = 3000;
		toastrConfig.positionClass = 'toast-top-right';
		toastrConfig.preventDuplicates = true;
		toastrConfig.progressBar = true;

		$translateProvider.useStaticFilesLoader({
			'prefix' : 'assets/locales/',
			'suffix' : '.json'
		});
		$translateProvider.fallbackLanguage([ 'en' ]);
		$translateProvider.registerAvailableLanguageKeys([ 'en', 'es', 'ca' ], {
			'en_*' : 'en',
			'es_*' : 'es',
			'ca_*' : 'ca'
		});
		$translateProvider.determinePreferredLanguage();
		$translateProvider.useSanitizeValueStrategy('sanitizeParameters');

		progressButtonConfigProvider.profile('modelProfile', {
			style : 'shrink',
			direction : 'horizontal'
		});
	}

})();

angular.module("Education").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/emptyView.html","<div ui-view></div>");
$templateCache.put("app/platform/platform.html","<div id=wrapper><platform-navbar></platform-navbar><div id=page-wrapper style=\"min-height: 561px\"><div ui-view></div></div><main-footer></main-footer></div>");
$templateCache.put("app/platform/platformNavbar.html","<nav class=\"navbar navbar-default navbar-fixed-top\" role=navigation style=\"margin-bottom: 0\" id=mainNavbar><div class=navbar-header><button type=button class=navbar-toggle ng-click=\"vm.menuCollapsed = !vm.menuCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=welcome.main><span class=\"glyphicon icon-logo\"></span> {{\'navbar.title\'|translate}}</a></div><ul class=\"nav navbar-top-links navbar-right main-navbar-top\"><li uib-dropdown><a uib-dropdown-toggle>{{\'navbar.changeLanguage\'|translate}} <span class=caret></span></a><ul uib-dropdown-menu role=menu><li role=menuitem><a ng-click=\"vm.changeLanguage(\'ca\')\">Català</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'en\')\">English</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'es\')\">Español</a></li></ul></li><li><a ng-click=vm.logout()>{{\'platform.navbar.logout.title\'|translate}}</a></li></ul><div class=\"navbar-default sidebar\" role=navigation><div class=\"sidebar-nav navbar-collapse\" uib-collapse=vm.menuCollapsed><ul class=\"nav in main-navbar-top-sidebar\" id=side-menu><li class=btn-group uib-dropdown dropdown-append-to><a uib-dropdown-toggle>{{\'navbar.changeLanguage\'|translate}} <span class=caret></span></a><ul class=\"nav nav-second-level\" uib-dropdown-menu role=menu><li role=menuitem><a ng-click=\"vm.changeLanguage(\'ca\')\">Català</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'en\')\">English</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'es\')\">Español</a></li></ul></li><li><a ng-click=vm.logout()>{{\'platform.navbar.logout.title\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'platform.admin.\') != -1 \"><!-- Admin menu --><li role=menuitem class=menu-tool-title><a ui-sref=platform.admin.main ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.title\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.admin.users ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.users\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.admin.personalityTest ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.personalityTest\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.admin.competenceTest ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.competenceTest\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.admin.groups ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.groups\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.admin.assignments ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.assignments\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.admin.rubrics ng-click=vm.collapseMenu()>{{\'platform.admin.navbar.rubrics\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'platform.teacher.\') != -1 \"><!-- Teacher menu --><li role=menuitem class=menu-tool-title><a ui-sref=platform.teacher.main ng-click=vm.collapseMenu()>{{\'platform.teacher.navbar.title\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.teacher.profile ng-click=vm.collapseMenu()>{{\'platform.teacher.navbar.profile\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.teacher.groups ng-click=vm.collapseMenu()>{{\'platform.teacher.navbar.groups\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.teacher.assignments ng-click=vm.collapseMenu()>{{\'platform.teacher.navbar.assignments\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.teacher.rubrics ng-click=vm.collapseMenu()>{{\'platform.teacher.navbar.rubrics\'|translate}}</a></li><li role=menuitem><a ui-sref=\"welcome.platform({\'#\':\'teacher\'})\" ng-click=vm.collapseMenu()>{{\'platform.teacher.navbar.help\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'platform.student.\') != -1 \"><!-- Student menu --><li role=menuitem class=menu-tool-title><a ui-sref=platform.student.main ng-click=vm.collapseMenu()>{{\'platform.student.navbar.title\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.student.profile ng-click=vm.collapseMenu()>{{\'platform.student.navbar.profile\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.student.personalityTest ng-click=vm.collapseMenu()>{{\'platform.student.navbar.personalityTest\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.student.competenceTest ng-click=vm.collapseMenu()>{{\'platform.student.navbar.competenceTest\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.student.groups ng-click=vm.collapseMenu()>{{\'platform.student.navbar.groups\'|translate}}</a></li><li role=menuitem><a ui-sref=platform.student.assignments ng-click=vm.collapseMenu()>{{\'platform.student.navbar.assignments\'|translate}}</a></li><li role=menuitem><a ui-sref=\"welcome.platform({\'#\':\'student\'})\" ng-click=vm.collapseMenu()>{{\'platform.student.navbar.help\'|translate}}</a></li></ul></div></div><script type=text/ng-template id=confirmLogout.html><div class=\"modal-header\">\n            <h3 class=\"modal-title\" id=\"modal-title\">{{\'platform.navbar.logout.confirm\'|translate}}</h3>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">{{\'platform.navbar.logout.cancel\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">{{\'platform.navbar.logout.ok\'|translate}}</button>\n        </div></script></nav>");
$templateCache.put("app/tool/tool.html","<div id=wrapper><main-navbar></main-navbar><div id=page-wrapper style=\"min-height: 561px\"><div ui-view></div></div><main-footer></main-footer></div>");
$templateCache.put("app/welcome/welcome.html","<div class=container><main-navbar></main-navbar><div class=welcome-body ui-view></div><main-footer></main-footer></div>");
$templateCache.put("app/components/mainFooter/mainFooter.html","<footer class=\"footer main-footer navbar-fixed-bottom\"><div class=container-fluid><div class=main-footer-element><a class=logo href=https://www.iiia.csic.es/ ><img src=assets/images/iiia-logo.png></a></div><div class=main-footer-element><p class=text-muted>{{\'main.page_copyright\'|translate:\'{ year: \'+vm.year+\' }\'}}</p></div><div class=main-footer-element><a class=logo href=http://www.csic.es/ ><img src=assets/images/csic-logo.jpg></a></div></div></footer>");
$templateCache.put("app/components/mainNavbar/mainNavbar.html","<nav class=\"navbar navbar-default navbar-fixed-top\" role=navigation style=\"margin-bottom: 0\" id=mainNavbar><div class=navbar-header><button type=button class=navbar-toggle ng-click=\"vm.menuCollapsed = !vm.menuCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=welcome.main><span class=\"glyphicon icon-logo\"></span> {{\'navbar.title\'|translate}}</a></div><ul class=\"nav navbar-top-links navbar-right main-navbar-top\"><li><a ui-sref=\"welcome.main({\'#\':\'about\'})\" ng-click=vm.collapseMenu()>{{\'navbar.about\'|translate}}</a></li><li uib-dropdown><a uib-dropdown-toggle>{{\'navbar.tools\'|translate}} <span class=caret></span></a><ul uib-dropdown-menu role=menu><li role=menuitem><a ui-sref=welcome.assessments ng-click=vm.collapseMenu()>{{\'navbar.collaborativeAssessment\'|translate}}</a></li><li role=menuitem><a ui-sref=welcome.lessonPlans ng-click=vm.collapseMenu()>{{\'navbar.lessonPlanEditor\'|translate}}</a></li><li role=menuitem><a ui-sref=welcome.teams ng-click=vm.collapseMenu()>{{\'navbar.congenialTeams\'|translate}}</a></li></ul></li><li><a ui-sref=\"welcome.main({\'#\':\'contact\'})\" ng-click=vm.collapseMenu()>{{\'navbar.contact\'|translate}}</a></li><li uib-dropdown><a uib-dropdown-toggle>{{\'navbar.changeLanguage\'|translate}} <span class=caret></span></a><ul uib-dropdown-menu role=menu><li role=menuitem><a ng-click=\"vm.changeLanguage(\'ca\')\">Català</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'en\')\">English</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'es\')\">Español</a></li></ul></li><li><a ui-sref=welcome.login ng-click=vm.collapseMenu()>{{\'navbar.login\'|translate}}</a></li></ul><div class=\"navbar-default sidebar\" role=navigation><div class=\"sidebar-nav navbar-collapse\" uib-collapse=vm.menuCollapsed><ul class=\"nav in main-navbar-top-sidebar\" id=side-menu><li><a ui-sref=\"welcome.main({\'#\':\'about\'})\" ng-click=vm.collapseMenu()>{{\'navbar.about\'|translate}}</a></li><li uib-dropdown><a uib-dropdown-toggle>{{\'navbar.tools\'|translate}} <span class=caret></span></a><ul class=\"nav nav-second-level\" uib-dropdown-menu role=menu><li role=menuitem><a ui-sref=welcome.assessments ng-click=vm.collapseMenu()>{{\'navbar.collaborativeAssessment\'|translate}}</a></li><li role=menuitem><a ui-sref=welcome.lessonPlans ng-click=vm.collapseMenu()>{{\'navbar.lessonPlanEditor\'|translate}}</a></li><li role=menuitem><a ui-sref=welcome.teams ng-click=vm.collapseMenu()>{{\'navbar.congenialTeams\'|translate}}</a></li></ul></li><li><a ui-sref=\"welcome.main({\'#\':\'contact\'})\" ng-click=vm.collapseMenu()>{{\'navbar.contact\'|translate}}</a></li><li class=btn-group uib-dropdown dropdown-append-to><a uib-dropdown-toggle>{{\'navbar.changeLanguage\'|translate}} <span class=caret></span></a><ul class=\"nav nav-second-level\" uib-dropdown-menu role=menu><li role=menuitem><a ng-click=\"vm.changeLanguage(\'ca\')\">Català</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'en\')\">English</a></li><li role=menuitem><a ng-click=\"vm.changeLanguage(\'es\')\">Español</a></li></ul></li><li><a ui-sref=welcome.login ng-click=vm.collapseMenu()>{{\'navbar.login\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'tool.collaborativeAssessment.\') != -1 \"><li role=menuitem class=menu-tool-title>{{\'collaborativeAssessment.navbar.title\'|translate}}</li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.evaluate ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.evaluate\'|translate}}</a></li><li uib-dropdown><a uib-dropdown-toggle>{{\'collaborativeAssessment.navbar.data\'|translate}} <span class=caret></span></a><ul class=\"nav nav-second-level dropdown-menu\" uib-dropdown-menu role=menu><li role=menuitem><a ui-sref=tool.collaborativeAssessment.assignments ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.assignments\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.teachers ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.teachers\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.rubrics ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.rubrics\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.criteria ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.criteria\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.groups ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.groups\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.students ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.students\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.collaborativeAssessment.competenceRequests ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.competenceRequests\'|translate}}</a></li></ul></li><li><a ui-sref=tool.collaborativeAssessment.about ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.about\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'tool.congenialTeams.\') != -1 \"><li role=menuitem class=menu-tool-title>{{\'congenialTeams.navbar.title\'|translate}}</li><li role=menuitem><a ui-sref=tool.congenialTeams.students ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.students\'|translate}}</a></li><li><a ui-sref=tool.congenialTeams.personalityTest ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.personalityTest\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.congenialTeams.groups ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.groups\'|translate}}</a></li><li><a ui-sref=tool.congenialTeams.conteam ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.conteam\'|translate}}</a></li><li uib-dropdown><a uib-dropdown-toggle>{{\'congenialTeams.navbar.data\'|translate}} <span class=caret></span></a><ul class=\"nav nav-second-level dropdown-menu\" uib-dropdown-menu role=menu><li role=menuitem><a ui-sref=tool.congenialTeams.questionnaires ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.questionnaires\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.congenialTeams.questions ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.questions\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.congenialTeams.answers ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.answers\'|translate}}</a></li></ul></li><li><a ui-sref=tool.congenialTeams.about ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.about\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'tool.synergisticTeams.\') != -1 \"><li role=menuitem class=menu-tool-title>{{\'synergisticTeams.navbar.title\'|translate}}</li><li><a ui-sref=tool.synergisticTeams.personalityTest ng-click=vm.collapseMenu()>{{\'synergisticTeams.navbar.personalityTest\'|translate}}</a></li><li><a ui-sref=tool.synergisticTeams.competenceTest ng-click=vm.collapseMenu()>{{\'synergisticTeams.navbar.competenceTest\'|translate}}</a></li><li><a ui-sref=tool.synergisticTeams.synteam ng-click=vm.collapseMenu()>{{\'synergisticTeams.navbar.synteam\'|translate}}</a></li><li><a ui-sref=tool.data.assignments ng-click=vm.collapseMenu()>{{\'synergisticTeams.navbar.data\'|translate}}</a></li><li><a ui-sref=tool.synergisticTeams.about ng-click=vm.collapseMenu()>{{\'synergisticTeams.navbar.about\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'tool.lessonPlanEditor.\') != -1 \"><li role=menuitem class=menu-tool-title>{{\'lessonPlanEditor.navbar.title\'|translate}}</li><li><a href=http://peerflow.iiia.csic.es target=_blank>{{\'lessonPlanEditor.navbar.peerflow\'|translate}}</a></li><li><a ui-sref=tool.lessonPlanEditor.about>{{\'lessonPlanEditor.navbar.about\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'tool.lessonPlanExecution.\') != -1 \"><li role=menuitem class=menu-tool-title>{{\'lessonPlanExecution.navbar.title\'|translate}}</li><li><a href=http://peerflow.iiia.csic.es target=_blank>{{\'lessonPlanExecution.navbar.peerflow\'|translate}}</a></li><li><a ui-sref=tool.lessonPlanEditor.about>{{\'lessonPlanExecution.navbar.about\'|translate}}</a></li></ul><ul class=\"nav in\" id=side-menu ng-show=\"vm.stateName.indexOf(\'tool.data.\') != -1 \"><li role=menuitem class=menu-tool-title>{{\'data.navbar.title\'|translate}}</li><li uib-dropdown><a uib-dropdown-toggle>{{\'data.navbar.tools\'|translate}} <span class=caret></span></a><ul class=\"nav nav-second-level dropdown-menu\" uib-dropdown-menu role=menu><li role=menuitem><a ui-sref=tool.collaborativeAssessment.evaluate ng-click=vm.collapseMenu()>{{\'collaborativeAssessment.navbar.title\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.congenialTeams.conteam ng-click=vm.collapseMenu()>{{\'congenialTeams.navbar.title\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.synergisticTeams.synteam ng-click=vm.collapseMenu()>{{\'synergisticTeams.navbar.title\'|translate}}</a></li></ul></li><li role=menuitem><a ui-sref=tool.data.personalityQuestionnaires ng-click=vm.collapseMenu()>{{\'data.navbar.personalityQuestionnaires\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.personalityQuestions ng-click=vm.collapseMenu()>{{\'data.navbar.personalityQuestions\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.personalityAnswers ng-click=vm.collapseMenu()>{{\'data.navbar.personalityAnswers\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.competenceQuestionnaires ng-click=vm.collapseMenu()>{{\'data.navbar.competenceQuestionnaires\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.competenceQuestions ng-click=vm.collapseMenu()>{{\'data.navbar.competenceQuestions\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.competenceAnswers ng-click=vm.collapseMenu()>{{\'data.navbar.competenceAnswers\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.assignments ng-click=vm.collapseMenu()>{{\'data.navbar.assignments\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.teachers ng-click=vm.collapseMenu()>{{\'data.navbar.teachers\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.rubrics ng-click=vm.collapseMenu()>{{\'data.navbar.rubrics\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.criteria ng-click=vm.collapseMenu()>{{\'data.navbar.criteria\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.groups ng-click=vm.collapseMenu()>{{\'data.navbar.groups\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.students ng-click=vm.collapseMenu()>{{\'data.navbar.students\'|translate}}</a></li><li role=menuitem><a ui-sref=tool.data.competenceRequests ng-click=vm.collapseMenu()>{{\'data.navbar.competenceRequests\'|translate}}</a></li></ul></div></div></nav>");
$templateCache.put("app/platform/admin/admin.html","<div ui-view></div>");
$templateCache.put("app/platform/student/student.html","<div ui-view></div>");
$templateCache.put("app/platform/teacher/teacher.html","<div ui-view></div>");
$templateCache.put("app/welcome/assessments/assessments.html","<div><div class=row><div class=col-lg-12><h1 class=page-header translate=welcome.assessments.title></h1></div></div><div class=row><div class=col-lg-12 translate=welcome.assessments.more.description></div></div><hr><div class=row><div class=col-md-4><img class=\"img-responsive center-block tool-icon\" src=\"{{\'welcome.assessments.more.collaborative.image\'|translate}}\" alt=\"{{\'welcome.assessments.more.collaborative.title\'|translate}}\"></div><div class=col-md-8><h3 translate=welcome.assessments.more.collaborative.title></h3><p translate=welcome.assessments.more.collaborative.description></p><a class=\"btn btn-primary\" ui-sref=tool.collaborativeAssessment.evaluate>{{\'welcome.assessments.more.collaborative.demoButton\'|translate}} <span class=\"glyphicon glyphicon-chevron-right\"></span></a></div></div><hr></div>");
$templateCache.put("app/welcome/lessonPlans/lessonPlans.html","<div><div class=row><div class=col-lg-12><h1 class=page-header translate=welcome.lessonPlans.title></h1></div></div><div class=row><div class=col-lg-12 translate=welcome.lessonPlans.more.description></div></div><hr><div class=row><div class=col-md-4><img class=\"img-responsive center-block tool-icon\" src=../../../assets/images/welcome/lessonPlanEditor.png alt=\"{{\'welcome.lessonPlans.more.editor.title\'|translate}}\"></div><div class=col-md-8><h3 translate=welcome.lessonPlans.more.editor.title></h3><p translate=welcome.lessonPlans.more.editor.description></p><button class=\"btn btn-primary\" ui-sref=tool.lessonPlanEditor.about>{{\'welcome.lessonPlans.more.editor.demoButton\'|translate}} <span class=\"glyphicon glyphicon-chevron-right\"></span></button></div></div><hr><div class=row><div class=col-md-4><img class=\"img-responsive center-block tool-icon\" src=../../../assets/images/welcome/lessonPlanExecution.png alt=\"{{\'welcome.lessonPlans.more.execution.title\'|translate}}\"></div><div class=col-md-8><h3 translate=welcome.lessonPlans.more.execution.title></h3><p translate=welcome.lessonPlans.more.execution.description></p><button class=\"btn btn-primary\" ui-sref=tool.lessonPlanExecution.about>{{\'welcome.lessonPlans.more.execution.demoButton\'|translate}} <span class=\"glyphicon glyphicon-chevron-right\"></span></button></div></div><hr></div>");
$templateCache.put("app/welcome/login/login.html","<div class=header-background><div class=row><div class=\"col-md-4 col-md-offset-4 col-xs-10 col-xs-offset-1\"><section class=login-form><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate role=login class=form-horizontal><div ng-hide=vm.create><div class=form-group><input type=email name=id placeholder=\"{{\'welcome.login.email\'|translate}}\" required class=\"form-control input-lg\" ng-model=vm.model.email ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><input type=password name=password class=\"form-control input-lg\" placeholder=\"{{\'welcome.login.password\'|translate}}\" required ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.model.password></div><div class=\"alert alert-danger\" ng-show=vm.model.error><span class=\"glyphicon glyphicon-alert\"></span> {{\'welcome.login.error\'|translate}}</div><div class=\"form-group text-center login-form-buttons\"><button progress-button=vm.signIn(form)>{{\'welcome.login.signin\'|translate}}</button></div><div class=text-center><a ng-click=\"vm.create = \'student\'\">{{\'welcome.login.create.student\'|translate}}</a>, <a ng-click=\"vm.create = \'teacher\'\">{{\'welcome.login.create.teacher\'|translate}}</a> {{\'welcome.login.or\'|translate}} <a ng-click=vm.resetPassword()>{{\'welcome.login.reset.text\'|translate}}</a><div class=text-right><button ui-sref=welcome.platform class=\"btn-info btn\"><i class=\"fa fa-question-circle\"></i></button></div></div></div><div ng-show=vm.create><div class=form-group><input type=text name=newName placeholder=\"{{\'welcome.login.create.name\'|translate}}\" required class=\"form-control input-lg\" ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><input type=email name=newEmail placeholder=\"{{\'welcome.login.create.email\'|translate}}\" required class=\"form-control input-lg\" ng-model=vm.model.email ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=\"form-group text-center\"><label for=sex class=\"col-sm-3 control-label\">{{\'welcome.login.create.sex\'|translate}}</label><div class=\"input-group col-sm-9\"><md-radio-group ng-model=vm.model.sex class=md-primary layout=row><md-radio-button ng-repeat=\"sex in vm.PERSON_SEX\" value={{sex}}>{{sex|localizePersonSex}}</md-radio-button></md-radio-group></div></div><div class=form-group><label for=studentDateOfBirth class=\"col-sm-3 control-label\">{{\'welcome.login.create.dateOfBirth\'|translate}}</label><div class=input-group><div>{{vm.model.dateOfBirth|date}}</div><div uib-datepicker ng-model=vm.model.dateOfBirth class=\"well well-sm\"></div></div></div><div class=form-group><input type=password name=newPassword class=\"form-control input-lg\" placeholder=\"{{\'welcome.login.create.password\'|translate}}\" required ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.model.password></div><div class=form-group><input type=password name=checkpassword class=\"form-control input-lg\" placeholder=\"{{\'welcome.login.create.checkpassword\'|translate}}\" required ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.model.checkpassword></div><div class=form-group ng-show=\"vm.create==\'student\'\"><div class=\"input-group col-sm-12\"><input type=text name=newCode class=\"form-control input-lg\" placeholder=\"{{\'welcome.login.create.code.input\'|translate}}\" required ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.model.code> <span class=input-group-btn><button type=button class=\"btn btn-primary btn-lg\" ng-click=vm.showInfoCode()><span class=\"fa fa-info-circle\"></span></button></span></div></div><div class=\"form-group text-center login-form-buttons\"><button progress-button=vm.createAccount(form)>{{\'welcome.login.create.submit\'|translate}}</button></div><div class=text-center><a ng-click=\"vm.create = null\">{{\'welcome.login.returnToLogin\'|translate}}</a></div></div></form></section></div></div><script type=text/ng-template id=InfoCodeModal.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{\'welcome.login.create.code.header\'|translate}}</h3>\n        </div>\n    	<div class=\"modal-body\">{{\'welcome.login.create.code.body\'|translate}}\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.goToContacts()\">{{\'welcome.login.create.contacts\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.close()\">{{\'welcome.login.create.close\'|translate}}</button>\n        </div>\n	</div></script><script type=text/ng-template id=resetPassword.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{\'welcome.login.reset.header\'|translate}}</h3>\n        </div>\n    	<div class=\"modal-body\">{{\'welcome.login.reset.body\'|translate}}\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.goToContacts()\">{{\'welcome.login.reset.contacts\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.close()\">{{\'welcome.login.reset.close\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/welcome/main/main.html","<div><header class=\"welcome-main-header header-background\"></header><div class=\"container welcome-main-body\"><hr><div class=row><div class=col-sm-8 id=about><h2>{{\'welcome.main.about.title\'|translate}}</h2><p translate=welcome.main.about.text translate-compile></p></div><div class=col-sm-4 id=contact><h2>{{\'welcome.main.contact.title\'|translate}}</h2><address translate=welcome.main.contact.text translate-compile></address></div></div><hr><div class=row><div class=col-sm-4><a ui-sref=welcome.assessments><img class=\"img-circle img-responsive img-center\" src=../assets/images/welcome/assessments.png></a><h2>{{\'welcome.assessments.title\'|translate}}</h2><p>{{\'welcome.assessments.description\'|translate}}</p><p><a class=\"btn btn-default\" ui-sref=welcome.assessments role=button>{{\'welcome.main.more_info\'|translate}}</a></p></div><div class=col-sm-4><a ui-sref=welcome.lessonPlans><img class=\"img-circle img-responsive img-center\" src=../assets/images/welcome/lessonPlans.png></a><h2>{{\'welcome.lessonPlans.title\'|translate}}</h2><p>{{\'welcome.lessonPlans.description\'|translate}}</p><p><a class=\"btn btn-default\" ui-sref=welcome.lessonPlans role=button>{{\'welcome.main.more_info\'|translate}}</a></p></div><div class=col-sm-4><a ui-sref=welcome.teams><img class=\"img-circle img-responsive img-center\" src=../assets/images/welcome/teams.png></a><h2>{{\'welcome.teams.title\'|translate}}</h2><p>{{\'welcome.teams.description\'|translate}}</p><p><a class=\"btn btn-default\" ui-sref=welcome.teams role=button>{{\'welcome.main.more_info\'|translate}}</a></p></div></div></div></div>");
$templateCache.put("app/welcome/platform/faq.html","<div uib-accordion-group class=panel-default is-open=vm.open><uib-accordion-heading>{{question}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': vm.open, \'glyphicon-chevron-right\': !vm.open}\"></i></uib-accordion-heading><ng-transclude></ng-transclude></div>");
$templateCache.put("app/welcome/platform/platform.html","<div><div class=row><div class=col-lg-12><h1 class=page-header translate=welcome.platform.title></h1></div></div><div class=row><div class=col-lg-12 translate=welcome.platform.description></div></div><hr><div class=row id=teacher><div class=col-md-12><h3 translate=welcome.platform.faq.teacher.title></h3><div ng-switch=vm.lang><div ng-switch-when=ca><div ng-include=\"\'app/welcome/platform/teacherFaq_ca.html\'\"></div></div><div ng-switch-when=es><div ng-include=\"\'app/welcome/platform/teacherFaq_es.html\'\"></div></div><div ng-switch-default><div ng-include=\"\'app/welcome/platform/teacherFaq.html\'\"></div></div></div></div></div><hr><div class=row id=student><div class=col-md-12><h3 translate=welcome.platform.faq.student.title></h3><div ng-switch=vm.lang><div ng-switch-when=ca><div ng-include=\"\'app/welcome/platform/studentFaq_ca.html\'\"></div></div><div ng-switch-when=es><div ng-include=\"\'app/welcome/platform/studentFaq_es.html\'\"></div></div><div ng-switch-default><div ng-include=\"\'app/welcome/platform/studentFaq.html\'\"></div></div></div></div></div><hr></div>");
$templateCache.put("app/welcome/platform/studentFaq.html","<uib-accordion close-others=oneAtATime><div faq question=\"Register as a student?\">To register on the platform as a student you must click on the option <a ui-sref=welcome.login>Login</a> at the top right of the menu. Then select the option to <b>create an account as a student</b>, then you will see a form where you enter your name, email, date of birth and keyword. Finally you can create register.</div><div faq question=\"Sign as a student?\">If you have already registered just click on the option <a ui-sref=welcome.login>Login</a> at the top right of the menu, and enter the email form and the keyword used when you signed up.</div><div faq question=\"Waht is the group code?\">The teacher when creating a group generates a code that you use to register on it.</div><div faq question=\"How i get the group code?\">It has to be provided by the teacher who created the group.</div><div faq question=\"How to join into a group?\">If you have not registered you can do when you register using the code group. If you are already registered, once you have entered on the left and a menu where you must click on <a ui-sref=platform.teacher.groups>groups</a>. Then will see a table with all groups which participate. At the top you can write code group and clicking the next button to join.</div><div faq question=\"Why is necessari the personality test?\">With this information platform allows the teacher form teams with students with compatibility personalities.</div><div faq question=\"Why is necessari the competence test?\">With this information platform allows the teacher form teh best teams to do a task.</div></uib-accordion>");
$templateCache.put("app/welcome/platform/studentFaq_ca.html","<uib-accordion close-others=oneAtATime><div faq question=\"Registrar-se com a estudiant?\">Per poder registrar-se a la plataforma com a estudiant has de clicar a la opció d\'<a ui-sref=welcome.login>Entrar</a> a la part superior dreta del menú. A continuació selecciona la opció de <b>crear una conta com a estudiant</b>, llavors apareixera un formulari on has d\'introduir el teu nom, email, data de naixement i la paraula clau. Finalment pots crear la conta.</div><div faq question=\"Entrar com a estudiant?\">Si ja t\'has registrat només has de clicar a la opció d\'<a ui-sref=welcome.login>Entrar</a> a la part superior dreta del menú, i introduir al formulari el correu electrònic i la paraula clau utilitzades quan t\'has registrat.</div><div faq question=\"Que es el codi d\'un grup?\">El professor quan crea un grup genera un codi que has d\'utilitzar per registra-te al grup.</div><div faq question=\"Com obtinc el codi d\'un grup?\">Té la de proporcionar el professor que ha creat el grup.</div><div faq question=\"Com m\'ajunto a un grup?\">Si encara no t\'has registrat ho pots fer quan et registres utilitzant el codi del grup. Si ja estas registrat, un cop has entrat a la part esquerra i a un menú on heu de clicar sobre <a ui-sref=platform.teacher.groups>grups</a>. Llavors apareixerà una taula amb tots els grups on participes. A la part superior pots escriure en codi del grup i depres clicant el botó del costat t\'ajuntes al grup.</div><div faq question=\"Per que serveix el test de personalitat?\">Amb aquesta informació la plataforma permet al professor formar equips que tinguin sinèrgies personals.</div><div faq question=\"Per que serveix el test de competències?\">Amb aquesta informació la plataforma permet al professor formar equips equilibrats per realitzar alguna tasca.</div></uib-accordion>");
$templateCache.put("app/welcome/platform/studentFaq_es.html","<uib-accordion close-others=oneAtATime><div faq question=\"¿Registrar-se como estudiante?\">Para poder registrarse en la plataforma como estudiante tienes que clicar en la opción de <a ui-sref=welcome.login>Entrar</a> en la parte superior derecha del menú. A continuación selecciona la opción de <b>crear una cuenta como estudiante</b>, entonces aparecerá un formulario donde debes introducir tu nombre, email, fecha de nacimiento y la palabra clave. Finalmente puedes crear la cuenta.</div><div faq question=\"¿Entrar com a estudiante?\">Si ya se ha registrado sólo tienes que pinchar en la opción de <a ui-sref=welcome.login>Entrar</a> en la parte superior derecha del menú, e introducir en el formulario el correo electrónico y la palabra clave utilizadas cuando se registro.</div><div faq question=\"¿Que es el código de un grupo?\">El profesor cuando crea un grupo genera un código que debes utilizar para registra en el grupo.</div><div faq question=\"¿Como obtengo el código de un grupo?\">Te lo tiene lque proporcionar el profesor que ha creado el grupo.</div><div faq question=\"¿Como entro en un grupo?\">Si todavía no estás registrado puedes hacerlo cuando te registras utilizando el código del grupo. Si ya estas registrado, una vez has entrado en la parte izquierda y en un menú donde debe hacer clic sobre <a ui-sref=platform.teacher.groups>grupos</a>. Entonces aparecerá una tabla con todos los grupos donde participas. En la parte superior puedes escribir en código del grupo y depres pulsando el botón del lado te juntas al grupo.</div><div faq question=\"¿Para que sirve el test de personalidad?\">Con esta información la plataforma permite al profesor formar equipos que tengan sinergias personales.</div><div faq question=\"¿Para que sirve el test de competencias?\">Con esta información la plataforma permite al profesor formar equipos equilibrados para realizar alguna tarea.</div></uib-accordion>");
$templateCache.put("app/welcome/platform/teacherFaq.html","<uib-accordion close-others=oneAtATime><div faq question=\"Register as a teacher?\">To register on the platform as a teacher you must click on the option <a ui-sref=welcome.login>Login</a> at the top right of the menu. Then select the option to <b>create an account as a teacher</b>, then you will see a form where you enter your name, email, date of birth and keyword. Finally you can create register.</div><div faq question=\"Sign as a teacher?\">If you have already registered just click on the option <a ui-sref=welcome.login>Login</a> at the top right of the menu, and enter the email form and the keyword used when you signed up.</div><div faq question=\"How to define a group of students?\">Once you have entered on the left and a menu where you must click on <a ui-sref=platform.teacher.groups>groups</a>. Seed will see a table with all the groups you\'re a teacher. In the next supeior <b>defined groups</b> is a plus that you may click to add a new group. Just set the group name, and added that students themselves.</div><div faq question=\"How to add a student to a group?\">On the platform are the students that they enter groups either when or after registration as part of another group. In order to do so must provide students with the code group.</div><div faq question=\"Witch are the students on a group?\">Once you have entered on the left and a menu where you must click on <a ui-sref=platform.teacher.groups>group</a>. Then you will see a table with all the groups you\'re a teacher. If you click on <i class=\"fa fa-edit\"></i> edit part of the group will see students who are members.</div><div faq question=\"What is the group code?\">The group code is a sequence of characters that are provided to students that they can enter.</div><div faq question=\"How do I get / create the code of a group?\">To get or set the code you need anarr list of defined groups (menu on the left by clicking on <a ui-sref=platform.teacher.groups>groups</a> ), the second column is what we defined the group session that students can use to enter. The code has an associated expiry date so that once you have reached that date no other student will enter the group. The actions that can be done in the code are:<ul><li><i class=\"fa fa-refresh\"></i>: Clicking it generates a random code that has a shelf life of 24 hours.</li><li><i class=\"fa fa-trash-o\"></i>: Removes the session, so that no more students will enter the group.</li><li><i class=\"fa fa-pencil\"></i>: Clicking it you can edit the code and expiration date. Regarding the code you can write any word or phrase such as: <b>School IA - 3rd B</b>.</li></ul></div><div faq question=\"What are congenial teams?\">Teams formed by the student personality.</div><div faq question=\"How to form congenial teams?\">To do this you need to create a group where to add students. So if Seleción group will see a button that allows you to go to a form which will indicate the number of students per computer for training teams. Keep in mind that only students who have used the answer is completely personality test.</div><div faq question=\"Why an student in a group is not in any congenial team?\">This happens because it has not completed the personality test. Check the group student to verify that it not completed the test.</div><div faq question=\"What are synergic teams?\">Teams formed by the student competences.</div><div faq question=\"How to form synergic teams?\">To do this you must create a task where copentencies Necessary to define it. So if the task Seleción see a button that allows you to go to a form which will indicate the number of students per computer for training teams. Keep in mind that only students who have used the answer is completely test skills.</div><div faq question=\"Why an student in a task is not in any synergic team?\">This happens because it has not completed the competence test. Check the group student to verify that it not completed the test.</div></uib-accordion>");
$templateCache.put("app/welcome/platform/teacherFaq_ca.html","<uib-accordion close-others=oneAtATime><div faq question=\"Registrar-se com a professor?\">Per poder registrar-se a la plataforma com a professor has de clicar a la opció d\'<a ui-sref=welcome.login>Entrar</a> a la part superior dreta del menú. A continuació selecciona la opció de <b>crear una conta com a professor</b>, llavors apareixera un formulari on has d\'introduir el teu nom, email, data de naixement i la paraula clau. Finalment pots crear la conta.</div><div faq question=\"Entrar com a professor?\">Si ja t\'has registrat només has de clicar a la opció d\'<a ui-sref=welcome.login>Entrar</a> a la part superior dreta del menú, i introduir al formulari el correu electrònic i la paraula clau utilitzades quan t\'has registrat.</div><div faq question=\"Com definir un grup d\'estudiants?\">Un cop has entrat a la part esquerra i a un menú on heu de clicar sobre <a ui-sref=platform.teacher.groups>grups</a>. Llavors apareixerà una taula amb tots els grups on sou professor. A la part supeior al costat del <b>Grups definits</b> hi ha un signe més que deveu clicar per afegir un nou grup. Només cal que definiu el nom del grup, ja que els estudiants s\'afegeixen ells mateixos.</div><div faq question=\"Com afegir un estudiant a un grup?\">En la plataforma son els estudiants els que entran als grups ja sigui quan es registran o un cop ja formen part d\'un altre grup. Per poder-ho fer cal proporcionar als estudiants el codi del grup.</div><div faq question=\"Com puc saber els estudiants d\'un grup?\">Un cop has entrat a la part esquerra i a un menú on heu de clicar sobre <a ui-sref=platform.teacher.groups>grups</a>. Llavors apareixerà una taula amb tots els grups on sou professor. Si clickes sobre <i class=\"fa fa-edit\"></i> a part d\'editar el grup podrás veure els estudiants que hi formen part.</div><div faq question=\"Que es el codi d\'un grup?\">El codi d\'un grup es una seqüencia de caracters que es proporcionen als estudiants per que aquest puguin entra-hi.</div><div faq question=\"Com obtinc/creo el codi d\'un grup?\">Per obtenir o definir el codi has d\'anarr a la llista de grups definits ( menú de la esquerra clicant sobre <a ui-sref=platform.teacher.groups>grups</a> ), la segona columna es el que definieix la sessió de grup que poden utilizar els alumnes per entrar-hi. El codi te associada una data de caducitat de manera que un cop hagi arribat aquesta data cap més alumne podrà entrar al grup. Les accions que es poden fer en el codi son:<ul><li><i class=\"fa fa-refresh\"></i>: clicant-lo es genera un codi aleatori que té una caducitat de 24 hores.</li><li><i class=\"fa fa-trash-o\"></i>: elimina la sessió, de manera que cap més estudiant podrà entrar al grup.</li><li><i class=\"fa fa-pencil\"></i>: clicant-lo pots editar el codi i la data de caducitat. En quan el codi pots escriure qualsevol frase o paraula com per exemple: <b>Escola IA - 3er B</b>.</li></ul></div><div faq question=\"Que son equips benavinguts?\">Son equips d\'estudiants agrupants segons la seva personalitat.</div><div faq question=\"Com puc fer equips benavinguts?\">Per fer-ho has de crear un grup on s\'han d\'afegir els estudiants. Llavors si seleciones el grup veuràs un botó que permet anar a un formulari on indicaràs el número d\'estudiants per equip i fer la formació dels equips. Has de tenir en compte que només s\'utilitzen els estudiants que han respos completament el test de personalitat.</div><div faq question=\"Com es que un estudiant del grup no forma part de cap equip benavinguts?\">Això succeix perquè aquest no ha completat el test de personalitat. Si vas al grup podràs veure els estudiants i el seu estat si l\'han repost o no.</div><div faq question=\"Que son equips sinergístics?\">Son equips d\'estudiants agrupants segons les seves competències.</div><div faq question=\"Com puc fer equips sinergístics?\">Per fer-ho has de crear una tasca on defineixes les copentencies necesaries per fer-la. Llavors si seleciones la tasca veuràs un boto que permet anar a un formulari on indicaràs el número d\'estudiants per equip i fer la formació dels equips. Has de tenir en compte que només s\'utilitzen els estudiants que han respos completament el test de competències.</div><div faq question=\"Com es que un estudiant de una tasca no forma part de cap equip sinergístic?\">Això succeix perquè aquest no ha completat el test de competències. Si vas al grup podràs veure els estudiants i el seu estat si l\'han repost o no.</div></uib-accordion>");
$templateCache.put("app/welcome/platform/teacherFaq_es.html","<uib-accordion close-others=oneAtATime><div faq question=\"¿Registrarse como maestro?\">Para poder registrarse en la plataforma como profesor tienes que clicar en la opción de <a ui-sref=welcome.login>Entrar</a> en la parte superior derecha del menú. A continuación selecciona la opción de <b>crear una cuenta como profesor</b>, entonces aparecerá un formulario donde debes introducir tu nombre, email, fecha de nacimiento y la palabra clave. Finalmente puedes crear la cuenta.</div><div faq question=\"¿Registrar-se como maestro?\">Si ya se ha registrado sólo tienes que pinchar en la opción de <a ui-sref=welcome.login>Entrar</a> en la parte superior derecha del menú, e introducir en el formulario el correo electrónico y la palabra clave utilizadas cuando se registro.</div><div faq question=\"¿Cómo definir un grupo de estudiantes?\">Una vez has entrado en la parte izquierda y en un menú donde debe hacer clic sobre <a ui-sref=platform.teacher.groups>grupos</a>. Entonces aparecerá una tabla con todos los grupos donde sueldo profesor. En la parte supeior junto al <b>Grupos definidos</b> hay un signo más que debéis pulsar para añadir un nuevo grupo. Sólo debe definir el nombre del grupo, ya que los estudiantes se añaden ellos mismos.</div><div faq question=\"¿Cómo añadir un estudiante a un grupo?\">En la plataforma son los estudiantes los que entran a los grupos ya sea cuando se registro o una vez ya forman parte de otro grupo. Para poder hacerlo hay que proporcionar a los estudiantes el código del grupo.</div><div faq question=\"¿Cómo puedo saber los estudiantes de un grupo?\">Una vez has entrado en la parte izquierda y en un menú donde debe hacer clic sobre <a ui-sref=platform.teacher.groups>grupos</a>. Entonces aparecerá una tabla con todos los grupos donde sueldo profesor. Si click sobre <i class=\"fa fa-edit\"></i> aparte de editar el grupo podrás ver los estudiantes que forman parte.</div><div faq question=\"¿Que es el código de un grupo?\">El código de un grupo es una secuencia de caracteres que se proporcionan a los estudiantes para que éste puedan entra en ella.</div><div faq question=\"¿Como obtengo / creo el código de un grupo?\">Para obtener o definir el código debes Anarres en la lista de grupos definidos (menú de la izquierda haciendo clic sobre <a ui-sref=platform.teacher.groups>grupos</a> ), la segunda columna se lo definiré la sesión de grupo que pueden utilizar los alumnos para entrar. El código tiene asociada una fecha de caducidad de manera que una vez haya llegado esa fecha otra alumno podrá entrar en el grupo. Las acciones que se pueden hacer en el código son:<ul><li><i class=\"fa fa-refresh\"></i>: Clicando el se genera un código aleatorio que tiene una caducidad de 24 horas.</li><li><i class=\"fa fa-trash-o\"></i>: Elimina la sesión, por lo que ningún otro estudiante podrá entrar en el grupo.</li><li><i class=\"fa fa-pencil\"></i>: Clicando el puedes editar el código y la fecha de caducidad. En cuando el código puedes escribir cualquier frase o palabra como por ejemplo: <b>Escuela IA - 3º B</b>.</li></ul></div><div faq question=\"¿Que son equipos bienavenidos?\">Son equipos de estudiantes agrupados según su personalidad.</div><div faq question=\"¿Como puedo hacer equipos bienavenidos?\">Para ello tienes que crear un grupo donde hay que añadir los estudiantes. Entonces si selecionar el grupo verás un botón que permite ir a un formulario donde indicarás el número de estudiantes por equipo y hacer la formación de los equipos. Tienes que tener en cuenta que sólo se utilizan los estudiantes que han res completamente el test de personalidad.</div><div faq question=\"¿Como es que un estudiante del grupo no forma parte de ningún equipo bienavenido?\">Esto sucede porque este no ha completado el test de personalidad. Si vas al grupo podrás ver los estudiantes y su estado si la han repuesto o no.</div><div faq question=\"¿Que son equipos sinergéticos?\">Son equipos de estudiantes agrupants según sus competencias.</div><div faq question=\"¿Como puedo hacer equipos sinergéticos?\">Para ello tienes que crear una tarea donde defines las copentencies necesarias para hacerla. Entonces si selecionar la tarea verás un botón que permite ir a un formulario donde indicarás el número de estudiantes por equipo y hacer la formación de los equipos. Tienes que tener en cuenta que sólo se utilizan los estudiantes que han res completamente el test de competencias.</div><div faq question=\"¿Como es que un estudiante de una tarea no forma parte de ningún equipo sinergético?\">Esto sucede porque este no ha completado el test de competencias. Si vas al grupo podrás ver los estudiantes y su estado si la han repuesto o no.</div></uib-accordion>");
$templateCache.put("app/welcome/teams/teams.html","<div><div class=row><div class=col-lg-12><h1 class=page-header translate=welcome.teams.title></h1></div></div><div class=row><div class=col-lg-12 translate=welcome.teams.more.description></div></div><hr><div class=row><div class=col-md-4><img class=\"img-responsive center-block tool-icon\" src=./assets/images/welcome/conteam.png alt=\"{{\'welcome.teams.more.conteam.title\'|translate}}\"></div><div class=col-md-8><h3 translate=welcome.teams.more.conteam.title></h3><p translate=welcome.teams.more.conteam.description></p><button class=\"btn btn-primary\" ui-sref=tool.congenialTeams.conteam>{{\'welcome.teams.more.conteam.demoButton\'|translate}} <span class=\"glyphicon glyphicon-chevron-right\"></span></button></div></div><hr><div class=row><div class=col-md-4><img class=\"img-responsive center-block tool-icon\" src=./assets/images/welcome/synteam.png alt=\"{{\'welcome.teams.more.synteam.title\'|translate}}\"></div><div class=col-md-8><h3 translate=welcome.teams.more.synteam.title></h3><p translate=welcome.teams.more.synteam.description></p><button class=\"btn btn-primary\" ui-sref=tool.synergisticTeams.synteam>{{\'welcome.teams.more.synteam.demoButton\'|translate}} <span class=\"glyphicon glyphicon-chevron-right\"></span></button></div></div><hr></div>");
$templateCache.put("app/platform/admin/assignments/assignment.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.assignment.id==0\" class=panel-title>{{\'Assignment.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.assignment.id!=0\" class=panel-title>{{\'Assignment.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'Assignment.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'Assignment.att.name.tooltip\'|translate}}\" name=name ng-model=vm.assignment.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.name.error\'|translate}}</div></div><div class=form-group><label for=assignmentRubric>{{\'Assignment.att.rubric.title\'|translate}}</label><select class=form-control id=assignmentRubric name=rubric ng-model=vm.assignment.rubric ng-options=\"rubric.name for rubric in vm.rubrics track by rubric.id\"></select></div><div class=form-group><div ng-show=form.rubric.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.rubric.error\'|translate}}</div><div ng-if=\"vm.rubrics.length==0\" class=\"alert alert-danger\" role=alert>{{\'Rubric.list.noData\'|translate}}</div></div><div class=form-group><label for=modelTeacher>{{\'Assignment.att.teacher.title\'|translate}}</label><ui-select ng-model=vm.assignment.teacher ng-disabled=false close-on-select=true><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"teacher in vm.teachers\"><div ng-bind-html=\"teacher.name | highlight: $select.search\"></div><small>{{\'platform.admin.user.sex\'|translate}}: <span ng-bind-html=\"\'\'+teacher.sex | localizePersonSex| highlight: $select.search\"></span><br>{{\'platform.admin.user.dateOfBirth\'|translate}}: <span ng-bind-html=\"\'\'+teacher.dateOfBirth |date:\'shortDate\' | highlight: $select.search\"></span></small></ui-select-choices></ui-select></div><div class=form-group><div ng-show=form.teacher.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.teacher.error\'|translate}}</div></div><div class=form-group><label for=assignmentGroup>{{\'Assignment.att.group.title\'|translate}}</label><select class=form-control id=assignmentGroup name=group ng-model=vm.assignment.group ng-options=\"group.name for group in vm.groups track by group.id\"></select></div><div class=form-group><div ng-show=form.group.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.group.error\'|translate}}</div><div ng-if=\"vm.groups.length==0\" class=\"alert alert-danger\" role=alert>{{\'StudentGroup.list.noData\'|translate}}</div></div><div class=form-group><label for=modelRequests>{{\'Assignment.att.requests.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addCompetenceRequest()><span class=\"fa fa-plus-circle\"></span></button></label><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceRequest.att.factor.tooltip\'|translate}}\">{{\'CompetenceRequest.att.factor.title\'|translate}}</th><th title=\"{{\'CompetenceRequest.att.level.tooltip\'|translate}}\">{{\'CompetenceRequest.att.level.title\'|translate}}</th><th title=\"{{\'CompetenceRequest.att.importance.tooltip\'|translate}}\">{{\'CompetenceRequest.att.importance.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"competenceRequest in vm.assignment.requests\"><td>{{ competenceRequest.factor|localizeCompetenceFactor }}</td><td>{{ competenceRequest.level|localizeCompetenceRequestLevel }}</td><td>{{ competenceRequest.importance|localizeCompetenceRequestImportance }}</td><td><button type=button ng-click=vm.removeCompetenceRequest(competenceRequest) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.competenceRequest({assignmentId:vm.assignment.id,competenceRequestId:competenceRequest.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div><div class=form-group><div ng-show=form.requests.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.requests.error\'|translate}}</div><div ng-show=\"vm.competenceRequests.length==0\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceRequest.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.assignment.id==0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Assignment.action.add.submit\'|translate}}</button> <button ng-if=\"vm.assignment.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Assignment.action.update.submit\'|translate}}</button> <button type=button ng-if=\"vm.assignment.id!=0\" ui-sref=platform.admin.assignmentTeams({assignmentId:vm.assignment.id}) class=\"btn btn-primary btn-lg\"><i class=\"fa fa-users\">{{\'platform.admin.assignmentTeams.title\'|translate}}</i></button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div>");
$templateCache.put("app/platform/admin/assignments/assignmentTeams.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.admin.assignments>{{\'platform.admin.assignments.title\'|translate}}</a></li><li><a ui-sref=platform.admin.assignment({assignmentId:vm.assignmentId})>{{\'platform.admin.assignment.title\'|translate}}</a></li><li class=active>{{\'platform.admin.assignmentTeams.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.assignmentTeams.title\'|translate}}&nbsp;</h3></div><div class=panel-body><div ng-hide=\"vm.teams || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><form novalidate><div class=form-group><label for=studentsPerTeam>{{\'platform.admin.assignmentTeams.studentsPerTeam\'|translate}}</label><input class=form-control name=studentsPerTeam type=number min=2 ng-model=vm.studentsPerTeam ng-trim=true></div><div class=\"form-group row\"><div class=\"table-responsive col-sm-6\"><button progress-button=vm.synteamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.admin.assignmentTeams.synteam\'|translate}}</button></div><div class=\"table-responsive col-sm-6\"><button progress-button=vm.lpteamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.admin.assignmentTeams.lpteam\'|translate}}</button></div></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.assignmentTeams.name\'|translate}}</th><th>{{\'platform.admin.assignmentTeams.students\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams\"><td>{{ team.name }}</td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/platform/admin/assignments/assignments.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.assignments.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ui-sref=platform.admin.assignment({assignmentId:0})><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-hide=\"vm.assignments || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.assignments.name\'|translate}}</th><th>{{\'platform.admin.assignments.rubric\'|translate}}</th><th>{{\'platform.admin.assignments.group\'|translate}}</th><th>{{\'platform.admin.assignments.requests\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"assignment in vm.assignments\"><td>{{ assignment.name }}</td><td>{{ assignment.rubric.name }}</td><td>{{ assignment.grup.name }}</td><td><ul><li ng-repeat=\"request in assignment.requests track by request.id\">{{request.factor|localizeCompetenceFactor}}, {{request.level|localizeCompetenceRequestLevel}}, {{request.importance|localizeCompetenceRequestImportance}}</li></ul></td><td><button type=button ng-click=vm.remove(assignment) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.assignment({assignmentId:assignment.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button> <button type=button ui-sref=platform.admin.assignmentTeams({assignmentId:assignment.id}) class=\"btn btn-info\"><i class=\"fa fa-users\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/platform/admin/assignments/competenceRequest.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.admin.assignments>{{\'platform.admin.groups.title\'|translate}}</a></li><li><a ui-sref=platform.admin.assignment({assignmentId:vm.assignmentId})>{{\'Assignment.title\'|translate}}</a></li><li class=active>{{\'CompetenceRequest.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'CompetenceRequest.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form class=form-horizontal><div class=\"form-group row\"><label for=modelFactor class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.factor.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.competenceRequest.factor ng-options=\"factor as (factor|localizeCompetenceFactor) for factor in vm.COMPETENCE_FACTORS\"></select></div></div><div class=\"form-group row\"><div ng-show=form.factor.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.factor.error\'|translate}}</div></div><div class=\"form-group row\"><label for=modelLevel class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.level.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.competenceRequest.level ng-options=\" level as (level|localizeCompetenceRequestLevel) for level in vm.BASIC_SCALE\"></select></div></div><div class=\"form-group row\"><div ng-show=form.level.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.level.error\'|translate}}</div></div><div class=\"form-group row\"><label for=modelImportance class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.importance.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.competenceRequest.importance ng-options=\" importance as (importance|localizeCompetenceRequestImportance) for importance in vm.BASIC_SCALE\"></select></div></div><div class=\"form-group row\"><div ng-show=form.importance.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.importance.error\'|translate}}</div></div><div class=\"form-group row\"><div class=col-sm-12><button progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'CompetenceRequest.action.update.submit\'|translate}}</button></div></div><div class=\"form-group row\"><div ng-show=vm.error class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div></div>");
$templateCache.put("app/platform/admin/competenceTest/answerValue.html","<div><ol class=breadcrumb><li><a ui-sref=platform.admin.competenceTest>{{\'platform.admin.competenceTest.title\'|translate}}</a></li><li><a ui-sref=platform.admin.competenceQuestion({questionId:vm.questionId})>{{\'platform.admin.competenceQuestion.title\'|translate}}</a></li><li class=active>{{\'platform.admin.competenceAnswerValue.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.competenceAnswerValue.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'CompetenceAnswerValue.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'CompetenceAnswerValue.att.name.tooltip\'|translate}}\" name=name ng-model=vm.answerValue.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelDescription>{{\'CompetenceAnswerValue.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'CompetenceAnswerValue.att.description.tooltip\'|translate}}\" name=description ng-model=vm.answerValue.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><label for=modelValue>{{\'CompetenceAnswerValue.att.value.title\'|translate}}</label><input type=number class=form-control id=modelValue placeholder=\"{{\'CompetenceAnswerValue.att.value.tooltip\'|translate}}\" name=value ng-model=vm.answerValue.value ng-min=-1 ng-max=1></div><div class=form-group><button progress-button=vm.updateAnswerValue() pb-profile=modelProfile>{{\'CompetenceQuestion.action.update.submit\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/platform/admin/competenceTest/competenceTest.html","<div><div ng-show=vm.competenceQuestionnaire class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.navbar.competenceTest\'|translate}}</h3></div><div class=panel-body><div ng-if=\"vm.competenceQuestionnaire==null\" class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'CompetenceQuestionnaire.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'CompetenceQuestionnaire.att.name.tooltip\'|translate}}\" name=name ng-model=vm.competenceQuestionnaire.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelDescription>{{\'CompetenceQuestionnaire.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'CompetenceQuestionnaire.att.description.tooltip\'|translate}}\" name=description ng-model=vm.competenceQuestionnaire.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><label for=modelQuestions>{{\'CompetenceQuestionnaire.att.questions.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addQuestion()><span class=\"fa fa-plus-circle\"></span></button></label><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceQuestion.att.factor.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.factor.title\'|translate}}</th><th title=\"{{\'CompetenceQuestion.att.question.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.question.title\'|translate}}</th><th title=\"{{\'CompetenceQuestion.att.description.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.description.title\'|translate}}</th><th title=\"{{\'CompetenceQuestion.att.possibleAnswerValues.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.possibleAnswerValues.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"question in vm.competenceQuestionnaire.questions\"><td>{{ question.factor|localizeCompetenceFactor }}</td><td>{{ question.question }}</td><td>{{ question.description }}</td><td><ul><li ng-repeat=\"answer in question.possibleAnswerValues track by answer.id\" title={{answer.description}}><strong>{{answer.name}}</strong> : {{answer.value}}</li></ul></td><td><button type=button ng-click=vm.removeQuestion(question) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.competenceQuestion({questionId:question.id}) class=\"btn btn-primary\"><i class=\"fa fa-pencil\"></i></button></td></tr></tbody></table></div><div class=form-group><button progress-button=vm.updateCompetenceTest() pb-profile=modelProfile>{{\'CompetenceQuestionnaire.action.update.submit\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/platform/admin/competenceTest/question.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.competenceQuestion.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelFactor>{{\'CompetenceQuestion.att.factor.title\'|translate}}</label><md-radio-group ng-model=vm.question.factor class=md-primary layout=row><md-radio-button ng-repeat=\"factor in vm.COMPETENCE_FACTORS\" value={{factor}}>{{factor|localizeCompetenceFactor}}</md-radio-button></md-radio-group></div><div class=form-group><label for=modelQuestion>{{\'CompetenceQuestion.att.question.title\'|translate}}</label><input type=text class=form-control id=modelQuestion placeholder=\"{{\'CompetenceQuestion.att.question.tooltip\'|translate}}\" name=question ng-model=vm.question.question ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelDescription>{{\'CompetenceQuestion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'CompetenceQuestion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.question.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><label for=modelPossibleAnswerValues>{{\'CompetenceQuestion.att.possibleAnswerValues.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addAnswerValue()><span class=\"fa fa-plus-circle\"></span></button></label><ui-select multiple ng-model=vm.question.possibleAnswerValues theme=bootstrap ng-disabled=false close-on-select=true title=\"{{\'platform.admin.competenceQuestion.answerValueph\'|translate}}\" remove-selected=true><ui-select-match placeholder=\"{{\'platform.admin.competenceQuestion.answerValueph\'|translate}}\"><span title={{$item.description}}>{{$item.name}}</span>&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ui-sref=platform.admin.competenceAnswerValue({questionId:vm.question.id,answerValueId:$item.id})><span class=\"fa fa-pencil\"></span></button></ui-select-match><ui-select-choices repeat=\"answerValue in vm.answerValues \"><div ng-bind-html=\"answerValue.name | highlight: $select.search\"></div><small><span ng-bind-html=\"\'\'+answerValue.description | highlight: $select.search\"></span></small></ui-select-choices></ui-select></div><div class=form-group><button progress-button=vm.updateQuestion() pb-profile=modelProfile>{{\'CompetenceQuestion.action.update.submit\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/platform/admin/groups/group.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.group.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'StudentGroup.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'StudentGroup.att.name.tooltip\'|translate}}\" name=name ng-model=vm.group.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelTeachers>{{\'StudentGroup.att.teachers.title\'|translate}}</label><div class=\"input-group col-sm-12\"><ui-select ng-model=vm.selectedTeacher ng-disabled=false><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"teacher in vm.teachers\"><div ng-bind-html=\"teacher.name | highlight: $select.search\"></div><small>{{\'platform.admin.user.sex\'|translate}}: <span ng-bind-html=\"\'\'+teacher.sex | localizePersonSex| highlight: $select.search\"></span><br>{{\'platform.admin.user.dateOfBirth\'|translate}}: <span ng-bind-html=\"\'\'+teacher.dateOfBirth |date:\'shortDate\' | highlight: $select.search\"></span></small></ui-select-choices></ui-select><span class=input-group-btn><button type=button class=\"btn btn-primary\" ng-click=vm.addTeacher()><span class=\"fa fa-plus-circle\"></span></button></span></div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Teacher.att.name.tooltip\'|translate}}\">{{\'Teacher.att.name.title\'|translate}}</th><th title=\"{{\'Teacher.att.sex.tooltip\'|translate}}\">{{\'Teacher.att.sex.title\'|translate}}</th><th title=\"{{\'Teacher.att.dateOfBirth.tooltip\'|translate}}\">{{\'Teacher.att.dateOfBirth.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"teacher in vm.group.teachers\"><td>{{ teacher.name }}</td><td>{{ teacher.sex | localizePersonSex }}</td><td>{{ teacher.dateOfBirth |date:\'shortDate\' }}</td><td><button type=button ng-click=vm.removeTeacher(teacher) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div><div class=form-group><label for=modelStudents>{{\'StudentGroup.att.students.title\'|translate}}</label><div class=\"input-group col-sm-12\"><ui-select ng-model=vm.selectedStudent ng-disabled=false style=\"min-width: 300px\"><ui-select-match placeholder=\"Select a person in the list or search his name/age...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"student in vm.students\"><div ng-bind-html=\"student.name | highlight: $select.search\"></div><small>{{\'platform.admin.user.sex\'|translate}}: <span ng-bind-html=\"\'\'+student.sex | localizePersonSex| highlight: $select.search\"></span><br>{{\'platform.admin.user.dateOfBirth\'|translate}}: <span ng-bind-html=\"\'\'+student.dateOfBirth |date:\'shortDate\' | highlight: $select.search\"></span></small></ui-select-choices></ui-select><span class=input-group-btn><button type=button class=\"btn btn-primary\" ng-click=vm.addStudent()><span class=\"fa fa-plus-circle\"></span></button></span></div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Student.att.name.tooltip\'|translate}}\">{{\'Student.att.name.title\'|translate}}</th><th title=\"{{\'Student.att.sex.tooltip\'|translate}}\">{{\'Student.att.sex.title\'|translate}}</th><th title=\"{{\'Student.att.dateOfBirth.tooltip\'|translate}}\">{{\'Student.att.dateOfBirth.title\'|translate}}</th><th title=\"{{\'platform.admin.group.personalityTest\'|translate}}\">{{\'platform.admin.group.personalityTest\'|translate}}</th><th title=\"{{\'platform.admin.group.competenceTest\'|translate}}\">{{\'platform.admin.group.competenceTest\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"student in vm.group.students\"><td>{{ student.name }}</td><td>{{ student.sex | localizePersonSex }}</td><td>{{ student.dateOfBirth |date:\'shortDate\' }}</td><td><div class=row><div ng-switch=vm.personalityTestStatus[$index] class=col-sm-7><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'platform.admin.group.testStatus.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'platform.admin.group.testStatus.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.admin.group.testStatus.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div><div class=col-sm-2><button type=button ui-sref=platform.admin.studentPersonalityTest({studentId:student.id,groupId:vm.group.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></div></div></td><td><div class=row><div ng-switch=vm.competenceTestStatus[$index] class=col-sm-7><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'platform.admin.group.testStatus.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'platform.admin.group.testStatus.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.admin.group.testStatus.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div><div class=col-sm-2><button type=button ui-sref=platform.admin.studentCompetenceTest({studentId:student.id,groupId:vm.group.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></div></div></td><td><button type=button ng-click=vm.removeStudent(student) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ng-click=vm.moveStudent(student) class=\"btn btn-primary btn-lg\"><i class=\"fa fa-sign-out\">{{\'platform.admin.group.moveStudent.title\'|translate}}</i></button></td></tr></tbody></table></div><div class=form-group><button progress-button=vm.updateGroup() pb-profile=modelProfile>{{\'StudentGroup.action.update.submit\'|translate}}</button> <button type=button ui-sref=platform.admin.studentTeams({groupId:vm.group.id}) class=\"btn btn-primary btn-lg\"><i class=\"fa fa-users\">{{\'platform.admin.studentTeams.title\'|translate}}</i></button></div></form></div></div><script type=text/ng-template id=selectGroup.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{\'platform.admin.group.moveStudent.title\'|translate}}</h3>\n        </div>\n    	<div class=\"modal-body\">\n			<form novalidate name=\"form\">\n				<div class=\"form-group\">\n					<label for=\"group\">\n						{{\'platform.admin.group.moveStudent.label\'|translate:\'{student:$ctrl.student}\'}}\n					</label>\n					<ui-select ng-model=\"$ctrl.group\">\n						<ui-select-match>{{$select.selected.name}}</ui-select-match>\n						<ui-select-choices repeat=\"group in $ctrl.groups\">\n							<div ng-bind-html=\"group.name | highlight: $select.search\"></div>\n						</ui-select-choices>\n					</ui-select>\n				</div>\n			</form>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">{{\'common.cancel\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">{{\'common.ok\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/platform/admin/groups/groups.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.groups.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addGroup()><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-hide=\"vm.groups || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.groups.name\'|translate}}</th><th>{{\'platform.admin.groups.session.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td>{{ group.name }}</td><td><div class=row><div class=\"col-sm-2 btn-group-vertical\"><button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.updateSession($index,true)><span class=\"fa fa-refresh\"></span></button> <button ng-show=vm.sessions[$index].id type=button class=\"btn btn-danger btn-xs\" ng-click=vm.removeSession($index)><span class=\"fa fa-trash-o\"></span></button> <button ng-show=vm.sessions[$index].id type=button class=\"btn btn-primary btn-xs\" ng-click=vm.editSession($index)><span class=\"fa fa-pencil\"></span></button></div><div class=col-sm-8 ng-switch=vm.sessions[$index].status><div ng-switch-when=active class=\"alert alert-success\" role=alert><b>{{\'platform.admin.groups.editSession.code\'|translate}}:</b>&nbsp;{{vm.sessions[$index].code}}<br><b>{{\'platform.admin.groups.editSession.expiryDate\'|translate}}:</b>&nbsp;{{vm.sessions[$index].expiryDate|date:\'medium\'}}</div><div ng-switch-when=expired class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.teacher.groups.session.expired\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></div></td><td><button type=button ng-click=vm.remove(group) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.group({groupId:group.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button> <button type=button ui-sref=platform.admin.studentTeams({groupId:group.id}) class=\"btn btn-info\"><i class=\"fa fa-users\"></i></button></td></tr></tbody></table></div></div><script type=text/ng-template id=editSessionModal.html><div class=\"modal-header\">\n            <h3 class=\"modal-title\" id=\"modal-title\">{{\'platform.admin.groups.editSession.title\'|translate}}</h3>\n        </div>\n        <div class=\"modal-body\" id=\"modal-body\">\n            <form novalidate>\n                <div classs=\"form-group\">\n					<label for=\"code\">{{\'platform.admin.groups.editSession.code\'|translate}}</label>\n                    <input type=\"text\" name=\"code\" class=\"form-control input-lg\"\n									placeholder=\"{{\'welcome.login.create.code.input\'|translate}}\"\n									required=\"\" ng-maxlength=\"255\" ng-minlength=\"1\" ng-trim=\"true\"\n									ng-model=\"vm.session.code\" />\n                </div>\n                <div classs=\"form-group\">\n					<label for=\"expiryDate\">{{\'platform.admin.groups.editSession.expiryDate\'|translate}}</label>\n					<div uib-datepicker ng-model=\"vm.session.expiryDate\" class=\"well well-sm\" datepicker-options=\"vm.options\"></div>\n					<div uib-timepicker ng-model=\"vm.session.expiryDate\"  hour-step=\"1\" minute-step=\"5\" show-meridian=\"false\"></div>\n                </div>\n            </form>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">{{\'common.cancel\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">{{\'common.ok\'|translate}}</button>\n        </div></script></div>");
$templateCache.put("app/platform/admin/groups/studentCompetenceTest.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.admin.groups>{{\'platform.admin.groups.title\'|translate}}</a></li><li><a ui-sref=platform.admin.group({groupId:vm.groupId})>{{\'platform.admin.group.title\'|translate}}</a></li><li class=active>{{\'platform.admin.studentCompetenceTest.title\'|translate}}</li></ol><div ng-show=vm.student><h2>{{\'Student.title\'|translate}}</h2><ul><li><b>{{\'Student.att.name.title\'|translate}}</b>: {{vm.student.name}}</li><li><b>{{\'Student.att.sex.title\'|translate}}</b>: {{vm.student.sex|localizePersonSex}}</li><li><b>{{\'Student.att.dateOfBirth.title\'|translate}}</b>: {{vm.student.dateOfBirth|date}}</li></ul></div><div class=row><div ng-hide=vm.competenceQuestionnaire class=\"col-sm-offset-1 col-sm-10 row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert ng-show=vm.errorMsg><i class=\"fa fa-exclamation\"></i> {{vm.errorMsg|translate}}</div></div><div ng-show=vm.competenceQuestionnaire class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{vm.competenceQuestionnaire.name}}</h3></div><div class=panel-body><div class=\"row alert alert-info\" role=alert>{{vm.competenceQuestionnaire.description}}</div><form novalidate name=form ng-show=\"vm.studentCompetenceAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentCompetenceAnswers track by $index\" ng-class=\"{\'row alert alert-danger\':studentAnswer.answer==null}\" role=alert><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}</label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentCompetenceAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div></form></div></div></div>");
$templateCache.put("app/platform/admin/groups/studentPersonalityTest.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.admin.groups>{{\'platform.admin.groups.title\'|translate}}</a></li><li><a ui-sref=platform.admin.group({groupId:vm.groupId})>{{\'platform.admin.group.title\'|translate}}</a></li><li class=active>{{\'platform.admin.studentPersonalityTest.title\'|translate}}</li></ol><div ng-show=vm.student><h2>{{\'Student.title\'|translate}}</h2><ul><li><b>{{\'Student.att.name.title\'|translate}}</b>: {{vm.student.name}}</li><li><b>{{\'Student.att.sex.title\'|translate}}</b>: {{vm.student.sex|localizePersonSex}}</li><li><b>{{\'Student.att.dateOfBirth.title\'|translate}}</b>: {{vm.student.dateOfBirth|date}}</li></ul></div><div class=row><div ng-hide=vm.personalityQuestionnaire class=\"col-sm-offset-1 col-sm-10 row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert ng-show=vm.errorMsg><i class=\"fa fa-exclamation\"></i> {{vm.errorMsg|translate}}</div></div><div ng-show=vm.personalityQuestionnaire class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{vm.personalityQuestionnaire.name}}</h3></div><div class=panel-body><div class=\"row alert alert-info\" role=alert>{{vm.personalityQuestionnaire.description}}</div><form novalidate name=form ng-show=\"vm.studentPersonalityAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentPersonalityAnswers track by $index\" ng-class=\"{\'row alert alert-danger\':studentAnswer.answer==null}\" role=alert><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}</label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentPersonalityAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div></form></div></div></div>");
$templateCache.put("app/platform/admin/groups/studentTeams.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.admin.groups>{{\'platform.admin.groups.title\'|translate}}</a></li><li><a ui-sref=platform.admin.group({groupId:vm.groupId})>{{\'platform.admin.group.title\'|translate}}</a></li><li class=active>{{\'platform.admin.studentTeams.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.studentTeams.title\'|translate}}&nbsp;</h3></div><div class=panel-body><div ng-hide=\"vm.teams || vm.errorMessage\" class=\"alert alert-info row\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger row\" role=alert>{{vm.errorMessage|translate}}</div><form novalidate><div class=form-group><label for=studentsPerTeam>{{\'platform.admin.studentTeams.studentsPerTeam\'|translate}}</label><input class=form-control name=studentsPerTeam type=number min=2 ng-model=vm.studentsPerTeam ng-trim=true></div><div class=\"form-group row\"><div class=\"table-responsive col-sm-3\"><button progress-button=vm.conteamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.admin.studentTeams.conteam\'|translate}}</button></div><div class=\"table-responsive col-sm-3\"><button progress-button=vm.synteamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.admin.studentTeams.synteam\'|translate}}</button></div><div class=\"table-responsive col-sm-3\"><button progress-button=vm.lpteamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.admin.studentTeams.lpteam\'|translate}}</button></div></div></form><div class=row><div class=\"table-responsive col-sm-6\"><table class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.studentTeams.name\'|translate}}</th><th>{{\'platform.admin.studentTeams.students\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams\"><td>{{ team.name }}</td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td></tr></tbody></table></div><div class=\"table-responsive col-sm-6\"><table class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.studentTeams.name\'|translate}}</th><th>{{\'platform.admin.studentTeams.students\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.assignmentTeams\"><td>{{ team.name }}</td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/platform/admin/main/main.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=platform.admin.main.title></h1></div></div><div class=row><div class=col-lg-12 translate=platform.admin.main.description></div></div></div>");
$templateCache.put("app/platform/admin/personalityTest/answerValue.html","<div><ol class=breadcrumb><li><a ui-sref=platform.admin.personalityTest>{{\'platform.admin.personalityTest.title\'|translate}}</a></li><li><a ui-sref=platform.admin.personalityQuestion({questionId:vm.questionId})>{{\'platform.admin.personalityQuestion.title\'|translate}}</a></li><li class=active>{{\'platform.admin.personalityAnswerValue.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.personalityAnswerValue.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'PersonalityAnswerValue.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'PersonalityAnswerValue.att.name.tooltip\'|translate}}\" name=name ng-model=vm.answerValue.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelDescription>{{\'PersonalityAnswerValue.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'PersonalityAnswerValue.att.description.tooltip\'|translate}}\" name=description ng-model=vm.answerValue.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><label for=modelValue>{{\'PersonalityAnswerValue.att.value.title\'|translate}}</label><input type=number class=form-control id=modelValue placeholder=\"{{\'PersonalityAnswerValue.att.value.tooltip\'|translate}}\" name=value ng-model=vm.answerValue.value ng-min=-1 ng-max=1></div><div class=form-group><button progress-button=vm.updateAnswerValue() pb-profile=modelProfile>{{\'PersonalityQuestion.action.update.submit\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/platform/admin/personalityTest/personalityTest.html","<div><div ng-show=vm.personalityQuestionnaire class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.navbar.personalityTest\'|translate}}</h3></div><div class=panel-body><div ng-if=\"vm.personalityQuestionnaire==null\" class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'PersonalityQuestionnaire.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'PersonalityQuestionnaire.att.name.tooltip\'|translate}}\" name=name ng-model=vm.personalityQuestionnaire.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelDescription>{{\'PersonalityQuestionnaire.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'PersonalityQuestionnaire.att.description.tooltip\'|translate}}\" name=description ng-model=vm.personalityQuestionnaire.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><label for=modelQuestions>{{\'PersonalityQuestionnaire.att.questions.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addQuestion()><span class=\"fa fa-plus-circle\"></span></button></label><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'PersonalityQuestion.att.factor.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.factor.title\'|translate}}</th><th title=\"{{\'PersonalityQuestion.att.question.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.question.title\'|translate}}</th><th title=\"{{\'PersonalityQuestion.att.description.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.description.title\'|translate}}</th><th title=\"{{\'PersonalityQuestion.att.possibleAnswerValues.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.possibleAnswerValues.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"question in vm.personalityQuestionnaire.questions\"><td>{{ question.factor|localizePersonalityFactor }}</td><td>{{ question.question }}</td><td>{{ question.description }}</td><td><ul><li ng-repeat=\"answer in question.possibleAnswerValues track by answer.id\" title={{answer.description}}><strong>{{answer.name}}</strong> : {{answer.value}}</li></ul></td><td><button type=button ng-click=vm.removeQuestion(question) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.personalityQuestion({questionId:question.id}) class=\"btn btn-primary\"><i class=\"fa fa-pencil\"></i></button></td></tr></tbody></table></div><div class=form-group><button progress-button=vm.updatePersonalityTest() pb-profile=modelProfile>{{\'PersonalityQuestionnaire.action.update.submit\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/platform/admin/personalityTest/question.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.personalityQuestion.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelFactor>{{\'PersonalityQuestion.att.factor.title\'|translate}}</label><md-radio-group ng-model=vm.question.factor class=md-primary layout=row><md-radio-button ng-repeat=\"factor in vm.PERSONALITY_FACTORS\" value={{factor}}>{{factor|localizePersonalityFactor}}</md-radio-button></md-radio-group></div><div class=form-group><label for=modelQuestion>{{\'PersonalityQuestion.att.question.title\'|translate}}</label><input type=text class=form-control id=modelQuestion placeholder=\"{{\'PersonalityQuestion.att.question.tooltip\'|translate}}\" name=question ng-model=vm.question.question ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelDescription>{{\'PersonalityQuestion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'PersonalityQuestion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.question.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><label for=modelPossibleAnswerValues>{{\'PersonalityQuestion.att.possibleAnswerValues.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addAnswerValue()><span class=\"fa fa-plus-circle\"></span></button></label><ui-select multiple ng-model=vm.question.possibleAnswerValues theme=bootstrap ng-disabled=false close-on-select=true title=\"{{\'platform.admin.personalityQuestion.answerValueph\'|translate}}\" remove-selected=true><ui-select-match placeholder=\"{{\'platform.admin.personalityQuestion.answerValueph\'|translate}}\"><span title={{$item.description}}>{{$item.name}}</span>&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ui-sref=platform.admin.personalityAnswerValue({questionId:vm.question.id,answerValueId:$item.id})><span class=\"fa fa-pencil\"></span></button></ui-select-match><ui-select-choices repeat=\"answerValue in vm.answerValues \"><div ng-bind-html=\"answerValue.name | highlight: $select.search\"></div><small><span ng-bind-html=\"\'\'+answerValue.description | highlight: $select.search\"></span></small></ui-select-choices></ui-select></div><div class=form-group><button progress-button=vm.updateQuestion() pb-profile=modelProfile>{{\'PersonalityQuestion.action.update.submit\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/platform/admin/rubrics/criterion.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.admin.rubrics>{{\'platform.admin.groups.title\'|translate}}</a></li><li><a ui-sref=platform.admin.rubric({rubricId:vm.rubricId})>{{\'Rubric.title\'|translate}}</a></li><li class=active>{{\'Criterion.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Criterion.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'Criterion.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'Criterion.att.name.tooltip\'|translate}}\" name=name ng-model=vm.criterion.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Criterion.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'Criterion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'Criterion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.criterion.description ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Criterion.att.description.error\'|translate}}</div></div><div class=form-group><button progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Criterion.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div></div>");
$templateCache.put("app/platform/admin/rubrics/rubric.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Rubric.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate ng-submit=vm.addRubric(form) name=form><div class=form-group><label for=rubricName>{{\'Rubric.att.name.title\'|translate}}</label><input type=text class=form-control id=rubricName placeholder=\"{{\'Rubric.att.name.tooltip\'|translate}}\" name=name ng-model=vm.rubric.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.name.error\'|translate}}</div></div><div class=form-group><label for=rubricMinMark>{{\'Rubric.att.minMark.title\'|translate}}</label><input type=number class=form-control id=rubricMinMark placeholder=\"{{\'Rubric.att.minMark.tooltip\'|translate}}\" name=minMark ng-model=vm.rubric.minMark required ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=form.minMark.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.minMark.error\'|translate}}</div></div><div class=form-group><label for=rubricMaxMark>{{\'Rubric.att.maxMark.title\'|translate}}</label><input type=number class=form-control id=rubricMaxMark placeholder=\"{{\'Rubric.att.maxMark.tooltip\'|translate}}\" name=maxMark ng-model=vm.rubric.maxMark required ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=form.maxMark.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.maxMark.error\'|translate}}</div></div><div class=form-rubric><label for=rubricCriteria>{{\'Rubric.att.criteria.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addCriterion()><span class=\"fa fa-plus-circle\"></span></button></label><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Criterion.att.name.tooltip\'|translate}}\">{{\'Criterion.att.name.title\'|translate}}</th><th title=\"{{\'Criterion.att.description.tooltip\'|translate}}\">{{\'Criterion.att.description.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"criterion in vm.rubric.criteria\"><td>{{ criterion.name }}</td><td>{{ criterion.description }}</td><td><button type=button ng-click=vm.removeCriterion(criterion) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.criterion({rubricId:vm.rubric.id,criterionId:criterion.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div><div class=form-rubric><div ng-show=form.criteria.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.criteria.error\'|translate}}</div></div><br><div class=form-group><button progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Rubric.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div>");
$templateCache.put("app/platform/admin/rubrics/rubrics.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Rubric.list.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addRubric()><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-hide=\"vm.rubrics || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><table datatable=ng class=\"table table-striped\"><thead><th title=\"{{\'Rubric.att.name.tooltip\'|translate}}\">{{\'Rubric.att.name.title\'|translate}}</th><th title=\"{{\'Rubric.att.minMark.tooltip\'|translate}}\">{{\'Rubric.att.minMark.title\'|translate}}</th><th title=\"{{\'Rubric.att.maxMark.tooltip\'|translate}}\">{{\'Rubric.att.maxMark.title\'|translate}}</th><th title=\"{{\'Rubric.att.criteria.tooltip\'|translate}}\">{{\'Rubric.att.criteria.title\'|translate}}</th><th></th></thead><tbody><tr ng-repeat=\"rubric in vm.rubrics\"><td>{{ rubric.name }}</td><td>{{ rubric.minMark|number }}</td><td>{{ rubric.maxMark|number }}</td><td><ul><li ng-repeat=\"criterion in rubric.criteria track by criterion.id\"><strong>{{ criterion.name }}</strong></li></ul></td><td><button type=button ng-click=vm.removeRubric(rubric) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.rubric({rubricId:rubric.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/platform/admin/users/user.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.user.title\'|translate}}</h3></div><div class=panel-body><div ng-if=\"vm.user == null && vm.errorMessage==null\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form ng-show=vm.user><div class=form-group><label for=modelEmail>{{\'platform.admin.user.email\'|translate}}</label><input type=email class=form-control id=modelEmail placeholder=\"{{\'platform.admin.user.emailph\'|translate}}\" name=email ng-model=vm.user.email ng-maxlength=255 ng-minlength=3 ng-trim=true></div><div class=form-group><label for=modelPassword>{{\'platform.admin.user.password\'|translate}}</label><input type=password class=form-control id=modelPassword placeholder=\"{{\'platform.admin.user.passwordph\'|translate}}\" name=password ng-model=vm.user.password ng-maxlength=255 ng-minlength=3 ng-trim=true></div><div class=form-group><label for=modelRepeatpassword>{{\'platform.admin.user.repeatpassword\'|translate}}</label><input type=password class=form-control id=modelRepeatpassword placeholder=\"{{\'platform.admin.user.repeatpasswordph\'|translate}}\" name=repeatpassword ng-model=vm.user.repeatpassword ng-maxlength=255 ng-minlength=3 ng-trim=true></div><div class=form-group ng-show=\"vm.user.id == 0\"><label>{{\'platform.admin.user.role\'|translate}}</label><md-radio-group ng-model=vm.user.person.type class=md-primary layout=row><md-radio-button value=admin>{{\'platform.role.admin\'|translate}}</md-radio-button><md-radio-button value=student>{{\'platform.role.student\'|translate}}</md-radio-button><md-radio-button value=teacher>{{\'platform.role.teacher\'|translate}}</md-radio-button></md-radio-group></div><div class=form-group ng-show=\"vm.user.id != 0\"><label>{{\'platform.admin.user.role\'|translate}}</label><div>{{ vm.user | localizePlatformUserRole }}</div></div><div class=form-group ng-show=\"vm.user.person.type == \'teacher\' ||vm.user.person.type == \'student\'\"><label for=studentName>{{\'platform.admin.user.name\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'platform.admin.user.nameth\'|translate}}\" name=name ng-model=vm.user.person.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group ng-show=\"vm.user.person.type == \'teacher\' ||vm.user.person.type == \'student\'\"><label>{{\'platform.admin.user.sex\'|translate}}</label><md-radio-group ng-model=vm.user.person.sex class=md-primary layout=row><md-radio-button ng-repeat=\"sex in vm.PERSON_SEX\" value={{sex}}>{{sex|localizePersonSex}}</md-radio-button></md-radio-group></div><div class=form-group ng-show=\"vm.user.person.type == \'teacher\' ||vm.user.person.type == \'student\'\"><label for=studentDateOfBirth>{{\'platform.admin.user.dateOfBirth\'|translate}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=vm.user.person.dateOfBirth is-open=showDateOfBirthPicker datepicker-options=dateOfBirthOptions ng-required=true close-text=\"{{\'common.close\'|translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"showDateOfBirthPicker=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=form-group><button progress-button=vm.updateUser() pb-profile=modelProfile><span ng-if=\"vm.user.id==0\">{{\'platform.admin.user.add\'|translate}}</span> <span ng-if=\"vm.user.id!=0\">{{\'platform.admin.user.update\'|translate}}</span></button></div></form><div ng-if=\"vm.user.person.type == \'student\'\" class=panel><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.user.groupTitle\'|translate}}</h3></div><div class=panel-body><div ng-hide=\"vm.groups || vm.errorGroupMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorGroupMessage class=\"alert alert-danger\" role=alert>{{vm.errorGroupMessage|translate}}</div><form novalidate class=form ng-show=\"vm.definedGroups && vm.definedGroups.length > 0\"><div class=\"form-group row\"><div class=col-sm-6><ui-select ng-model=vm.selectedGroup ng-disabled=false close-on-select=true title=\"{{\'platform.admin.user.groupSelect\'|translate}}\"><ui-select-match placeholder=\"{{\'platform.admin.user.groupSelect\'|translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"group in vm.definedGroups\"><div ng-bind-html=\"group.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-sm-6><button progress-button=vm.joinToGroup() pb-profile=modelProfile ng-disabled=\"vm.selectedGroup == null\"><i class=\"fa fa-gears\"></i> {{\'platform.admin.user.groupJoin\'|translate}}</button></div></div></form><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.groups.name\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"group in vm.playingGroups\"><td>{{ group.name }}</td><td><button type=button ng-click=vm.removeFromGroup(group) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/platform/admin/users/users.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.admin.users.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ui-sref=platform.admin.user({userId:0})><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-if=\"vm.users.length == 0 && vm.errorMessage == null\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><div class=\"row text-center\"><div class=btn-group role=group><button type=button ng-click=vm.previousUsers() class=\"btn btn-primary btn-lg\" ng-show=\"vm.firstUserIndex != 0\"><i class=\"fa fa-chevron-left\"></i> {{\'platform.admin.users.previousUsers\'|translate}}</button> <button type=button ng-click=vm.nextUsers() class=\"btn btn-primary btn-lg\" ng-show=\"vm.users.length == vm.MAX_RESULT\">{{\'platform.admin.users.nextUsers\'|translate}} <i class=\"fa fa-chevron-right\"></i></button></div></div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.admin.users.email\'|translate}}</th><th>{{\'platform.admin.users.name\'|translate}}</th><th>{{\'platform.admin.users.role\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td>{{ user.email }}</td><td>{{ user.person.name }}</td><td>{{ user | localizePlatformUserRole }}</td><td><button type=button ng-click=vm.remove(user) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.admin.user({userId:user.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/platform/student/assignments/assignments.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.student.assignments.title\'|translate}}</h3></div><div class=panel-body><div ng-hide=\"vm.assignments || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.student.assignments.name\'|translate}}</th><th>{{\'platform.student.assignments.rubric\'|translate}}</th><th>{{\'platform.student.assignments.group\'|translate}}</th><th>{{\'platform.student.assignments.requests\'|translate}}</th><th>{{\'platform.student.assignments.team\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"assignment in vm.assignments\"><td>{{ assignment.name }}</td><td>{{ assignment.rubric.name }}</td><td>{{ assignment.grup.name }}</td><td><ul><li ng-repeat=\"request in assignment.requests track by request.id\">{{request.factor|localizeCompetenceFactor}}, {{request.level|localizeCompetenceRequestLevel}}, {{request.importance|localizeCompetenceRequestImportance}}</li></ul></td><td><div ng-hide=vm.teams[$index] class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-hide=vm.teams[$index].type class=\"alert alert-info\" role=alert>{{\'platform.student.assignments.teamAny\'|translate}}</div><div ng-show=vm.teams[$index].type>{{vm.teams[$index].name}}<ul><li ng-repeat=\"student in vm.teams[$index].students track by student.id\">{{student.name}}</li></ul></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/platform/student/competenceTest/competenceTest.html","<div><div class=row ng-hide=vm.competenceQuestionnaire><div ng-hide=vm.studentCompetenceAnswersError class=\"col-sm-offset-1 col-sm-10 row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert ng-show=vm.studentCompetenceAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentCompetenceAnswersError|translate}}</div></div><div ng-show=vm.competenceQuestionnaire class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{vm.competenceQuestionnaire.name}}</h3></div><div class=panel-body><div class=\"row alert alert-info\" role=alert>{{vm.competenceQuestionnaire.description}}</div><div class=\"row alert alert-danger\" role=alert ng-show=vm.studentCompetenceAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentCompetenceAnswersError|translate}}</div><form novalidate name=form ng-show=\"vm.studentCompetenceAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentCompetenceAnswers track by $index\"><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}&nbsp; <button ng-if=\"studentAnswer.question.description && studentAnswer.question.description.length >0\" ng-click=vm.showQuestionInfo(studentAnswer.question) class=\"btn btn-primary btn-xs\"><i class=\"fa fa-info-circle\"></i></button></label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentCompetenceAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div></form><div class=\"row alert alert-danger\" role=alert ng-show=\"vm.answered == 0\"><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.student.personalityTest.toDo\'|translate}}</div><div class=\"row alert alert-warning\" role=alert ng-show=\"vm.answered != 0 && vm.answered < vm.studentCompetenceAnswers.length\"><i class=\"fa fa-exclamation-triangle\"></i> {{\'platform.student.personalityTest.partial\'|translate}}</div><div class=\"row alert alert-success\" role=alert ng-show=\"vm.answered >= vm.studentCompetenceAnswers.length\"><i class=\"fa fa-check\"></i> {{\'platform.student.personalityTest.done\'|translate}}</div></div></div><script type=text/ng-template id=questionInfoModal.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{$ctrl.question.question}}</h3>\n        </div>\n    	<div class=\"modal-body\">\n			<p>{{$ctrl.question.description}}</p>\n			<p>\n				<ul>\n					<li	ng-repeat=\"answer in $ctrl.question.possibleAnswerValues track by answer.id\"><b>{{answer.name}}</b>:{{answer.description}}</li>\n				</ul>\n			</p>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.close()\">{{\'common.close\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/platform/student/groups/groups.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.student.groups.title\'|translate}}</h3></div><div class=panel-body><div ng-hide=\"vm.groups || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><form novalidate class=form-inline><div class=form-group><label for=groupCode>{{\'platform.student.groups.code.label\'|translate}}</label><div class=\"input-group col-sm-12\"><input type=text name=groupCode class=\"form-control input-lg\" placeholder=\"{{\'platform.student.groups.code.placeholder\'|translate}}\" required ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.groupCode> <span class=input-group-btn><button type=button class=\"btn btn-primary btn-lg\" ng-click=vm.showInfoCode()><span class=\"fa fa-info-circle\"></span></button></span></div></div><div class=form-group><button progress-button=vm.joinGroup()><i class=\"fa fa-sign-in\"></i> {{\'platform.student.groups.join\'|translate}}</button></div></form><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.student.groups.name\'|translate}}</th><th>{{\'platform.student.groups.team\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td>{{ group.name }}</td><td><div ng-hide=vm.teams[$index] class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-hide=vm.teams[$index].type class=\"alert alert-info\" role=alert>{{\'platform.student.groups.teamAny\'|translate}}</div><div ng-show=vm.teams[$index].type>{{vm.teams[$index].name}}<ul><li ng-repeat=\"student in vm.teams[$index].students track by student.id\">{{student.name}}</li></ul></div></td></tr></tbody></table></div></div></div><script type=text/ng-template id=InfoCodeModal.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{\'platform.student.groups.code.header\'|translate}}</h3>\n        </div>\n    	<div class=\"modal-body\">{{\'platform.student.groups.code.body\'|translate}}\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.close()\">{{\'common.close\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/platform/student/main/main.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=platform.student.main.title></h1></div></div><div class=row><div class=col-lg-12 translate=platform.student.main.description></div></div></div>");
$templateCache.put("app/platform/student/personalityTest/personalityTest.html","<div><div class=row ng-hide=vm.personalityQuestionnaire><div ng-hide=vm.studentPersonalityAnswersError class=\"col-sm-offset-1 col-sm-10 row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert ng-show=vm.studentPersonalityAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentPersonalityAnswersError|translate}}</div></div><div ng-show=vm.personalityQuestionnaire class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{vm.personalityQuestionnaire.name}}</h3></div><div class=panel-body><div class=\"row alert alert-info\" role=alert>{{vm.personalityQuestionnaire.description}}</div><div class=\"row alert alert-danger\" role=alert ng-show=vm.studentPersonalityAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentPersonalityAnswersError|translate}}</div><form novalidate name=form ng-show=\"vm.studentPersonalityAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentPersonalityAnswers track by $index\"><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}&nbsp; <button ng-if=\"studentAnswer.question.description && studentAnswer.question.description.length >0\" ng-click=vm.showQuestionInfo(studentAnswer.question) class=\"btn btn-primary btn-xs\"><i class=\"fa fa-info-circle\"></i></button></label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentPersonalityAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div></form><div class=\"row alert alert-danger\" role=alert ng-show=\"vm.answered == 0\"><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.student.personalityTest.toDo\'|translate}}</div><div class=\"row alert alert-warning\" role=alert ng-show=\"vm.answered != 0 && vm.answered < vm.studentPersonalityAnswers.length\"><i class=\"fa fa-exclamation-triangle\"></i> {{\'platform.student.personalityTest.partial\'|translate}}</div><div class=\"row alert alert-success\" role=alert ng-show=\"vm.answered >= vm.studentPersonalityAnswers.length\"><i class=\"fa fa-check\"></i> {{\'platform.student.personalityTest.done\'|translate}}</div></div></div><script type=text/ng-template id=questionInfoModal.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{$ctrl.question.question}}</h3>\n        </div>\n    	<div class=\"modal-body\">\n			<p>{{$ctrl.question.description}}</p>\n			<p>\n				<ul>\n					<li	ng-repeat=\"answer in $ctrl.question.possibleAnswerValues track by answer.id\"><b>{{answer.name}}</b>:{{answer.description}}</li>\n				</ul>\n			</p>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.close()\">{{\'common.close\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/platform/student/profile/profile.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.student.group.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label>{{\'platform.student.profile.name\'|translate}}</label><input class=\"form-control input-lg\" type=text ng-model=vm.user.person.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label>{{\'platform.student.profile.email\'|translate}}</label><input class=\"form-control input-lg\" type=email ng-model=vm.email ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label>{{\'platform.student.profile.sex\'|translate}}</label><md-radio-group ng-model=vm.user.person.sex class=md-primary layout=row><md-radio-button ng-repeat=\"sex in vm.PERSON_SEX\" value={{sex}}>{{sex|localizePersonSex}}</md-radio-button></md-radio-group></div><div class=form-group><label>{{\'platform.student.profile.dateOfBirth\'|translate}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=vm.user.person.dateOfBirth is-open=showDateOfBirthPicker datepicker-options=dateOfBirthOptions ng-required=true close-text=\"{{\'common.close\'|translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"showDateOfBirthPicker=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=form-group><input type=password name=newPassword class=\"form-control input-lg\" placeholder=\"{{\'platform.student.profile.password\'|translate}}\" ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.password></div><div class=form-group><input type=password name=checkpassword class=\"form-control input-lg\" placeholder=\"{{\'platform.student.profile.confirmPassword\'|translate}}\" ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.confirmPassword></div><div class=form-group><button progress-button=vm.updateProfile() pb-profile=modelProfile>{{\'platform.student.profile.update.submit\'|translate}}</button></div><div class=form-group><button type=button ng-click=vm.removeProfile() class=\"btn btn-danger btn-lg\"><i class=\"fa fa-trash-o\">{{\'platform.student.profile.remove.submit\'|translate}}</i></button></div></form></div><script type=text/ng-template id=confirmRemove.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{\'platform.student.profile.remove.header\'|translate}}</h3>\n        </div>\n    	<div class=\"modal-body\">{{\'platform.student.profile.remove.body\'|translate}}\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">{{\'common.cancel\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">{{\'common.ok\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/platform/teacher/assignments/assignment.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.assignment.id==0\" class=panel-title>{{\'Assignment.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.assignment.id!=0\" class=panel-title>{{\'Assignment.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'Assignment.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'Assignment.att.name.tooltip\'|translate}}\" name=name ng-model=vm.assignment.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.name.error\'|translate}}</div></div><div class=form-group><label for=assignmentRubric>{{\'Assignment.att.rubric.title\'|translate}}</label><select class=form-control id=assignmentRubric name=rubric ng-model=vm.assignment.rubric ng-options=\"rubric.name for rubric in vm.rubrics track by rubric.id\"></select></div><div class=form-group><div ng-show=form.rubric.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.rubric.error\'|translate}}</div><div ng-if=\"vm.rubrics.length==0\" class=\"alert alert-danger\" role=alert>{{\'Rubric.list.noData\'|translate}}</div></div><div class=form-group><label for=assignmentGroup>{{\'Assignment.att.group.title\'|translate}}</label><select class=form-control id=assignmentGroup name=group ng-model=vm.assignment.group ng-options=\"group.name for group in vm.groups track by group.id\"></select></div><div class=form-group><div ng-show=form.group.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.group.error\'|translate}}</div><div ng-if=\"vm.groups.length==0\" class=\"alert alert-danger\" role=alert>{{\'StudentGroup.list.noData\'|translate}}</div></div><div class=form-group><label for=modelRequests>{{\'Assignment.att.requests.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addCompetenceRequest()><span class=\"fa fa-plus-circle\"></span></button></label><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceRequest.att.factor.tooltip\'|translate}}\">{{\'CompetenceRequest.att.factor.title\'|translate}}</th><th title=\"{{\'CompetenceRequest.att.level.tooltip\'|translate}}\">{{\'CompetenceRequest.att.level.title\'|translate}}</th><th title=\"{{\'CompetenceRequest.att.importance.tooltip\'|translate}}\">{{\'CompetenceRequest.att.importance.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"competenceRequest in vm.assignment.requests\"><td>{{ competenceRequest.factor|localizeCompetenceFactor }}</td><td>{{ competenceRequest.level|localizeCompetenceRequestLevel }}</td><td>{{ competenceRequest.importance|localizeCompetenceRequestImportance }}</td><td><button type=button ng-click=vm.removeCompetenceRequest(competenceRequest) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.teacher.competenceRequest({assignmentId:vm.assignment.id,competenceRequestId:competenceRequest.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div><div class=form-group><div ng-show=form.requests.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.requests.error\'|translate}}</div><div ng-show=\"vm.competenceRequests.length==0\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceRequest.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.assignment.id==0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Assignment.action.add.submit\'|translate}}</button> <button ng-if=\"vm.assignment.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Assignment.action.update.submit\'|translate}}</button> <button type=button ng-if=\"vm.assignment.id!=0\" ui-sref=platform.teacher.assignmentTeams({assignmentId:vm.assignment.id}) class=\"btn btn-primary btn-lg\"><i class=\"fa fa-users\">{{\'platform.teacher.assignmentTeams.title\'|translate}}</i></button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div>");
$templateCache.put("app/platform/teacher/assignments/assignmentTeams.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.teacher.assignments>{{\'platform.teacher.assignments.title\'|translate}}</a></li><li><a ui-sref=platform.teacher.assignment({assignmentId:vm.assignmentId})>{{\'platform.teacher.assignment.title\'|translate}}</a></li><li class=active>{{\'platform.teacher.assignmentTeams.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.teacher.assignmentTeams.title\'|translate}}&nbsp;</h3></div><div class=panel-body><div ng-hide=\"vm.teams || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><form novalidate><div class=form-group><label for=studentsPerTeam>{{\'platform.teacher.assignmentTeams.studentsPerTeam\'|translate}}</label><input class=form-control name=studentsPerTeam type=number min=2 ng-model=vm.studentsPerTeam ng-trim=true></div><div class=form-group><button progress-button=vm.teamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.teacher.assignmentTeams.composition\'|translate}}</button></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.teacher.assignmentTeams.name\'|translate}}</th><th>{{\'platform.teacher.assignmentTeams.students\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams\"><td>{{ team.name }}</td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td><td><ui-select ng-model=team.feedback theme=bootstrap on-select=vm.updateTeam(team)><ui-select-match>{{$select.selected|localizeFeedback}}</ui-select-match><ui-select-choices repeat=\"feedback in vm.FEEDBACK_FOR_TEAMS\">{{feedback|localizeFeedback}}</ui-select-choices></ui-select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/platform/teacher/assignments/assignments.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.teacher.assignments.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ui-sref=platform.teacher.assignment({assignmentId:0})><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-hide=\"vm.assignments || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.teacher.assignments.name\'|translate}}</th><th>{{\'platform.teacher.assignments.rubric\'|translate}}</th><th>{{\'platform.teacher.assignments.group\'|translate}}</th><th>{{\'platform.teacher.assignments.requests\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"assignment in vm.assignments\"><td>{{ assignment.name }}</td><td>{{ assignment.rubric.name }}</td><td>{{ assignment.grup.name }}</td><td><ul><li ng-repeat=\"request in assignment.requests track by request.id\">{{request.factor|localizeCompetenceFactor}}, {{request.level|localizeCompetenceRequestLevel}}, {{request.importance|localizeCompetenceRequestImportance}}</li></ul></td><td><button type=button ng-click=vm.remove(assignment) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.teacher.assignment({assignmentId:assignment.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button> <button type=button ui-sref=platform.teacher.assignmentTeams({assignmentId:assignment.id}) class=\"btn btn-info\"><i class=\"fa fa-users\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/platform/teacher/assignments/competenceRequest.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.teacher.assignments>{{\'platform.teacher.groups.title\'|translate}}</a></li><li><a ui-sref=platform.teacher.assignment({assignmentId:vm.assignmentId})>{{\'Assignment.title\'|translate}}</a></li><li class=active>{{\'CompetenceRequest.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'CompetenceRequest.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form class=form-horizontal><div class=\"form-group row\"><label for=modelFactor class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.factor.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.competenceRequest.factor ng-options=\"factor as (factor|localizeCompetenceFactor) for factor in vm.COMPETENCE_FACTORS\"></select></div></div><div class=\"form-group row\"><div ng-show=form.factor.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.factor.error\'|translate}}</div></div><div class=\"form-group row\"><label for=modelLevel class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.level.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.competenceRequest.level ng-options=\" level as (level|localizeCompetenceRequestLevel) for level in vm.BASIC_SCALE\"></select></div></div><div class=\"form-group row\"><div ng-show=form.level.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.level.error\'|translate}}</div></div><div class=\"form-group row\"><label for=modelImportance class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.importance.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.competenceRequest.importance ng-options=\" importance as (importance|localizeCompetenceRequestImportance) for importance in vm.BASIC_SCALE\"></select></div></div><div class=\"form-group row\"><div ng-show=form.importance.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.importance.error\'|translate}}</div></div><div class=\"form-group row\"><div class=col-sm-12><button progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'CompetenceRequest.action.update.submit\'|translate}}</button></div></div><div class=\"form-group row\"><div ng-show=vm.error class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div></div>");
$templateCache.put("app/platform/teacher/groups/group.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.teacher.group.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'StudentGroup.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'StudentGroup.att.name.tooltip\'|translate}}\" name=name ng-model=vm.group.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label for=modelStudents>{{\'StudentGroup.att.students.title\'|translate}}</label><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Student.att.name.tooltip\'|translate}}\">{{\'Student.att.name.title\'|translate}}</th><th title=\"{{\'Student.att.sex.tooltip\'|translate}}\">{{\'Student.att.sex.title\'|translate}}</th><th title=\"{{\'Student.att.dateOfBirth.tooltip\'|translate}}\">{{\'Student.att.dateOfBirth.title\'|translate}}</th><th title=\"{{\'platform.teacher.group.personalityTest\'|translate}}\">{{\'platform.teacher.group.personalityTest\'|translate}}</th><th title=\"{{\'platform.teacher.group.competenceTest\'|translate}}\">{{\'platform.teacher.group.competenceTest\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"student in vm.group.students\"><td>{{ student.name }}</td><td>{{ student.sex | localizePersonSex }}</td><td>{{ student.dateOfBirth |date:\'shortDate\' }}</td><td><div ng-switch=vm.personalityTestStatus[$index]><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'platform.teacher.group.testStatus.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'platform.teacher.group.testStatus.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.teacher.group.testStatus.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></td><td><div ng-switch=vm.competenceTestStatus[$index]><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'platform.teacher.group.testStatus.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'platform.teacher.group.testStatus.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.teacher.group.testStatus.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></td><td><button type=button ng-click=vm.removeStudent(student) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div><div class=form-group><button progress-button=vm.updateGroup() pb-profile=modelProfile>{{\'StudentGroup.action.update.submit\'|translate}}</button> <button type=button ui-sref=platform.teacher.studentTeams({groupId:vm.group.id}) class=\"btn btn-primary btn-lg\"><i class=\"fa fa-users\">{{\'platform.teacher.studentTeams.title\'|translate}}</i></button></div></form></div></div>");
$templateCache.put("app/platform/teacher/groups/groups.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.teacher.groups.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addGroup()><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-hide=\"vm.groups || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.teacher.groups.name\'|translate}}</th><th>{{\'platform.teacher.groups.session.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td>{{ group.name }}</td><td><div class=row><div class=\"col-sm-2 btn-group-vertical\"><button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.updateSession($index,true)><span class=\"fa fa-refresh\"></span></button> <button ng-show=vm.sessions[$index].id type=button class=\"btn btn-danger btn-xs\" ng-click=vm.removeSession($index)><span class=\"fa fa-trash-o\"></span></button> <button ng-show=vm.sessions[$index].id type=button class=\"btn btn-primary btn-xs\" ng-click=vm.editSession($index)><span class=\"fa fa-pencil\"></span></button></div><div class=col-sm-8 ng-switch=vm.sessions[$index].status><div ng-switch-when=active class=\"alert alert-success\" role=alert><b>{{\'platform.teacher.groups.editSession.code\'|translate}}:</b>&nbsp;{{vm.sessions[$index].code}}<br><b>{{\'platform.teacher.groups.editSession.expiryDate\'|translate}}:</b>&nbsp;{{vm.sessions[$index].expiryDate|date:\'medium\'}}</div><div ng-switch-when=expired class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'platform.teacher.groups.session.expired\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></div></td><td><button type=button ng-click=vm.remove(group) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.teacher.group({groupId:group.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button> <button type=button ui-sref=platform.teacher.studentTeams({groupId:group.id}) class=\"btn btn-info\"><i class=\"fa fa-users\"></i></button></td></tr></tbody></table></div></div><script type=text/ng-template id=editSessionModal.html><div class=\"modal-header\">\n            <h3 class=\"modal-title\" id=\"modal-title\">{{\'platform.teacher.groups.editSession.title\'|translate}}</h3>\n        </div>\n        <div class=\"modal-body\" id=\"modal-body\">\n            <form novalidate>\n                <div classs=\"form-group\">\n					<label for=\"code\">{{\'platform.teacher.groups.editSession.code\'|translate}}</label>\n                    <input type=\"text\" name=\"code\" class=\"form-control input-lg\"\n									placeholder=\"{{\'welcome.login.create.code.input\'|translate}}\"\n									required=\"\" ng-maxlength=\"255\" ng-minlength=\"1\" ng-trim=\"true\"\n									ng-model=\"vm.session.code\" />\n                </div>\n                <div classs=\"form-group\">\n					<label for=\"expiryDate\">{{\'platform.teacher.groups.editSession.expiryDate\'|translate}}</label>\n					<div uib-datepicker ng-model=\"vm.session.expiryDate\" class=\"well well-sm\" datepicker-options=\"vm.options\"></div>\n					<div uib-timepicker ng-model=\"vm.session.expiryDate\"  hour-step=\"1\" minute-step=\"5\" show-meridian=\"false\"></div>\n                </div>\n            </form>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">{{\'common.cancel\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">{{\'common.ok\'|translate}}</button>\n        </div></script></div>");
$templateCache.put("app/platform/teacher/groups/studentTeams.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.teacher.groups>{{\'platform.teacher.groups.title\'|translate}}</a></li><li><a ui-sref=platform.teacher.group({groupId:vm.groupId})>{{\'platform.teacher.group.title\'|translate}}</a></li><li class=active>{{\'platform.teacher.studentTeams.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.teacher.studentTeams.title\'|translate}}&nbsp;</h3></div><div class=panel-body><div ng-hide=\"vm.teams || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><form novalidate><div class=form-group><label for=studentsPerTeam>{{\'platform.teacher.studentTeams.studentsPerTeam\'|translate}}</label><input class=form-control name=studentsPerTeam type=number min=2 ng-model=vm.studentsPerTeam ng-trim=true></div><div class=form-group><button progress-button=vm.teamComposition() pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'platform.teacher.studentTeams.composition\'|translate}}</button></div></form><div class=table-responsive><table class=\"table table-striped\"><thead><tr role=row><th>{{\'platform.teacher.studentTeams.name\'|translate}}</th><th>{{\'platform.teacher.studentTeams.students\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams\"><td>{{ team.name }}</td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td><td><ui-select ng-model=team.feedback theme=bootstrap on-select=vm.updateTeam(team)><ui-select-match>{{$select.selected|localizeFeedback}}</ui-select-match><ui-select-choices repeat=\"feedback in vm.FEEDBACK_FOR_TEAMS\">{{feedback|localizeFeedback}}</ui-select-choices></ui-select></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/platform/teacher/main/main.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=platform.teacher.main.title></h1></div></div><div class=row><div class=col-lg-12 translate=platform.teacher.main.description></div></div></div>");
$templateCache.put("app/platform/teacher/profile/profile.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'platform.teacher.group.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label>{{\'platform.teacher.profile.name\'|translate}}</label><input class=\"form-control input-lg\" type=text ng-model=vm.user.person.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label>{{\'platform.teacher.profile.email\'|translate}}</label><input class=\"form-control input-lg\" type=email ng-model=vm.email ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><label>{{\'platform.teacher.profile.sex\'|translate}}</label><md-radio-group ng-model=vm.user.person.sex class=md-primary layout=row><md-radio-button ng-repeat=\"sex in vm.PERSON_SEX\" value={{sex}}>{{sex|localizePersonSex}}</md-radio-button></md-radio-group></div><div class=form-group><label>{{\'platform.teacher.profile.dateOfBirth\'|translate}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=vm.user.person.dateOfBirth is-open=showDateOfBirthPicker datepicker-options=dateOfBirthOptions ng-required=true close-text=\"{{\'common.close\'|translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"showDateOfBirthPicker=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=form-group><input type=password name=newPassword class=\"form-control input-lg\" placeholder=\"{{\'platform.teacher.profile.password\'|translate}}\" ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.password></div><div class=form-group><input type=password name=checkpassword class=\"form-control input-lg\" placeholder=\"{{\'platform.teacher.profile.confirmPassword\'|translate}}\" ng-maxlength=255 ng-minlength=1 ng-trim=true ng-model=vm.confirmPassword></div><div class=form-group><button progress-button=vm.updateProfile() pb-profile=modelProfile>{{\'platform.teacher.profile.update.submit\'|translate}}</button></div><div class=form-group><button type=button ng-click=vm.removeProfile() class=\"btn btn-danger btn-lg\"><i class=\"fa fa-trash-o\">{{\'platform.teacher.profile.remove.submit\'|translate}}</i></button></div></form></div><script type=text/ng-template id=confirmRemove.html><div>\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\">{{\'platform.teacher.profile.remove.header\'|translate}}</h3>\n        </div>\n    	<div class=\"modal-body\">{{\'platform.teacher.profile.remove.body\'|translate}}\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">{{\'common.cancel\'|translate}}</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">{{\'common.ok\'|translate}}</button>\n        </div>\n	</div></script></div>");
$templateCache.put("app/platform/teacher/rubrics/criterion.html","<div class=container><ol class=breadcrumb><li><a ui-sref=platform.teacher.rubrics>{{\'platform.teacher.groups.title\'|translate}}</a></li><li><a ui-sref=platform.teacher.rubric({rubricId:vm.rubricId})>{{\'Rubric.title\'|translate}}</a></li><li class=active>{{\'Criterion.title\'|translate}}</li></ol><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Criterion.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate name=form><div class=form-group><label for=modelName>{{\'Criterion.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'Criterion.att.name.tooltip\'|translate}}\" name=name ng-model=vm.criterion.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Criterion.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'Criterion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'Criterion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.criterion.description ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Criterion.att.description.error\'|translate}}</div></div><div class=form-group><button progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Criterion.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div></div>");
$templateCache.put("app/platform/teacher/rubrics/rubric.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Rubric.action.update.title\'|translate}}</h3></div><div class=panel-body><div class=\"row alert alert-danger\" role=alert ng-show=vm.errorMessage><i class=\"fa fa-exclamation\"></i> {{vm.errorMessage|translate}}</div><form novalidate ng-submit=vm.addRubric(form) name=form><div class=form-group><label for=rubricName>{{\'Rubric.att.name.title\'|translate}}</label><input type=text class=form-control id=rubricName placeholder=\"{{\'Rubric.att.name.tooltip\'|translate}}\" name=name ng-model=vm.rubric.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.name.error\'|translate}}</div></div><div class=form-group><label for=rubricMinMark>{{\'Rubric.att.minMark.title\'|translate}}</label><input type=number class=form-control id=rubricMinMark placeholder=\"{{\'Rubric.att.minMark.tooltip\'|translate}}\" name=minMark ng-model=vm.rubric.minMark required ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=form.minMark.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.minMark.error\'|translate}}</div></div><div class=form-group><label for=rubricMaxMark>{{\'Rubric.att.maxMark.title\'|translate}}</label><input type=number class=form-control id=rubricMaxMark placeholder=\"{{\'Rubric.att.maxMark.tooltip\'|translate}}\" name=maxMark ng-model=vm.rubric.maxMark required ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=form.maxMark.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.maxMark.error\'|translate}}</div></div><div class=form-rubric><label for=rubricCriteria>{{\'Rubric.att.criteria.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addCriterion()><span class=\"fa fa-plus-circle\"></span></button></label><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Criterion.att.name.tooltip\'|translate}}\">{{\'Criterion.att.name.title\'|translate}}</th><th title=\"{{\'Criterion.att.description.tooltip\'|translate}}\">{{\'Criterion.att.description.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"criterion in vm.rubric.criteria\"><td>{{ criterion.name }}</td><td>{{ criterion.description }}</td><td><button type=button ng-click=vm.removeCriterion(criterion) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.teacher.criterion({rubricId:vm.rubric.id,criterionId:criterion.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div><div class=form-rubric><div ng-show=form.criteria.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.criteria.error\'|translate}}</div></div><br><div class=form-group><button progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Rubric.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error|translate}}</div></div></form></div></div>");
$templateCache.put("app/platform/teacher/rubrics/rubrics.html","<div class=container><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Rubric.list.title\'|translate}}&nbsp; <button type=button class=\"btn btn-primary btn-xs\" ng-click=vm.addRubric()><span class=\"fa fa-plus-circle\"></span></button></h3></div><div class=table-responsive><div ng-hide=\"vm.rubrics || vm.errorMessage\" class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.errorMessage class=\"alert alert-danger\" role=alert>{{vm.errorMessage|translate}}</div><table datatable=ng class=\"table table-striped\"><thead><th title=\"{{\'Rubric.att.name.tooltip\'|translate}}\">{{\'Rubric.att.name.title\'|translate}}</th><th title=\"{{\'Rubric.att.minMark.tooltip\'|translate}}\">{{\'Rubric.att.minMark.title\'|translate}}</th><th title=\"{{\'Rubric.att.maxMark.tooltip\'|translate}}\">{{\'Rubric.att.maxMark.title\'|translate}}</th><th title=\"{{\'Rubric.att.criteria.tooltip\'|translate}}\">{{\'Rubric.att.criteria.title\'|translate}}</th><th></th></thead><tbody><tr ng-repeat=\"rubric in vm.rubrics\"><td>{{ rubric.name }}</td><td>{{ rubric.minMark|number }}</td><td>{{ rubric.maxMark|number }}</td><td><ul><li ng-repeat=\"criterion in rubric.criteria track by criterion.id\"><strong>{{ criterion.name }}</strong></li></ul></td><td><button type=button ng-click=vm.removeRubric(rubric) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ui-sref=platform.teacher.rubric({rubricId:rubric.id}) class=\"btn btn-info\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/tool/collaborativeAssessment/about/about.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=collaborativeAssessment.about.title></h1></div></div><div class=row><div class=col-lg-12 translate=collaborativeAssessment.about.description></div></div></div>");
$templateCache.put("app/tool/collaborativeAssessment/assessments/assessments.html","<div class=container-fluid><div ng-show=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i> {{\'collaborativeAssessment.assessments.loading\'|translate}}</div><div ng-show=vm.error class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'collaborativeAssessment.assessments.errorLoading\'|translate}}</div><div ng-show=vm.assignment class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ vm.assignment.name }}</h3></div><div class=panel-body><ul><li><span class=title>{{\'Assignment.att.teacher.title\'|translate}}</span> : {{ vm.assignment.teacher.name }}</li><li><span class=title>{{\'Assignment.att.rubric.title\'|translate}}</span> : {{ vm.assignment.rubric.name }}</li><li><span class=title>{{\'Assignment.att.group.title\'|translate}}</span> : {{ vm.assignment.group.name }}</li></ul></div></div><div ng-if=\"vm.loading == false\" ng-repeat=\"criterion in vm.assignment.rubric.criteria track by criterion.id\" class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ criterion.name }}</h3></div><div class=panel-body><span ng-bind-html=\"criterion.description | formatText\"></span></div><div class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr><th></th><th ng-repeat=\"student in vm.assignment.group.students\">{{student.name}}</th></tr></thead><tbody><tr class=info><td>{{vm.assignment.teacher.name}}</td><td ng-repeat=\"student in vm.assignment.group.students\"><mark-input assessment=vm.getTeacherAssessment(student) criterion=criterion></mark-input></td></tr><tr ng-repeat=\"assessor in vm.assignment.group.students\"><td>{{assessor.name}}</td><td ng-repeat=\"student in vm.assignment.group.students\"><mark-input ng-if=\"assessor.id!=student.id\" assessment=vm.getStudentAssessment(assessor,student) criterion=criterion></mark-input></td></tr></tbody></table></div></div><div ng-hide=\"vm.loading || vm.error != null\"><a type=button ui-sref=tool.collaborativeAssessment.comas({assignmentId:vm.assignment.id}) target=_blank class=\"btn btn-primary btn-lg btn-block\"><i class=\"fa fa-cogs\"></i> {{\'collaborativeAssessment.comas.submit\'|translate}}</a></div><div ng-hide=\"vm.loading || vm.error != null\"><a type=button ng-click=vm.removeAllAssesssments() class=\"btn btn-danger btn-lg btn-block\"><i class=\"fa fa-trash-o\"></i> {{\'collaborativeAssessment.assessments.removeAll.submit\'|translate}}</a></div><script type=text/ng-template id=confirmRemoveAll.html><div class=\"modal-header\">\n            <h3 class=\"modal-title\" id=\"modal-title\">{{\'collaborativeAssessment.assessments.removeAll.confirm\'|translate}}</h3>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n            <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">OK</button>\n        </div></script></div>");
$templateCache.put("app/tool/collaborativeAssessment/assignments/assignments.html","<div class=container-fluid><assignment-editor></assignment-editor><assignment-list></assignment-list></div>");
$templateCache.put("app/tool/collaborativeAssessment/comas/comas.html","<div class=container-fluid><div ng-show=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i> {{\'collaborativeAssessment.comas.loading\'|translate}}</div><div ng-show=vm.error class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'collaborativeAssessment.comas.errorLoading\'|translate}}</div><div ng-show=vm.assignment class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ vm.assignment.name }}</h3></div><div class=panel-body><ul><li><span class=title>{{\'Assignment.att.teacher.title\'|translate}}</span> : {{ vm.assignment.teacher.name }}</li><li><span class=title>{{\'Assignment.att.rubric.title\'|translate}}</span> : {{ vm.assignment.rubric.name }}</li><li><span class=title>{{\'Assignment.att.group.title\'|translate}}</span> : {{ vm.assignment.group.name }}</li></ul></div></div><div ng-show=vm.assignment class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'collaborativeAssessment.comas.assessments.title\'|translate}}</h3></div><div class=table-responsive><table datatable=ng class=\"table table-striped table-bordered\"><thead><tr><th>{{\'collaborativeAssessment.comas.assessments.students\'|translate}}</th><th>{{\'collaborativeAssessment.comas.assessments.type.title\'|translate}}</th><th ng-repeat=\"criterion in vm.assignment.rubric.criteria track by criterion.id\">{{criterion.name}}</th></tr></thead><tbody><tr ng-repeat=\"assessment in vm.assessments track by $index\" ng-class=\"{info:assessment.type==\'teacherAssessment\'}\"><td>{{assessment.evaluated.name}}</td><td>{{\'collaborativeAssessment.comas.assessments.type.\'+assessment.type|translate}}</td><td ng-repeat=\"mark in assessment.marks track by $index\" class=number>{{mark.value|number}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/tool/collaborativeAssessment/competenceRequests/competenceRequests.html","<div><competence-request-editor></competence-request-editor><competence-request-list></competence-request-list></div>");
$templateCache.put("app/tool/collaborativeAssessment/criteria/criteria.html","<div><criterion-editor></criterion-editor><criterion-list></criterion-list></div>");
$templateCache.put("app/tool/collaborativeAssessment/evaluate/evaluate.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'collaborativeAssessment.evaluate.list.title\'|translate}} <span ng-if=vm.loading><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span></h3><div ng-if=vm.error class=\"alert alert-danger\" role=alert>{{\'Assignment.list.noLoadData\'|translate}}</div></div><div class=table-responsive><table datatable=ng class=\"table table-striped table-bordered\"><thead><tr role=row><th title=\"{{\'Assignment.att.name.tooltip\'|translate}}\">{{\'Assignment.att.name.title\'|translate}}</th><th title=\"{{\'Assignment.att.teacher.tooltip\'|translate}}\">{{\'Assignment.att.teacher.title\'|translate}}</th><th title=\"{{\'Assignment.att.rubric.tooltip\'|translate}}\">{{\'Assignment.att.rubric.title\'|translate}}</th><th title=\"{{\'Assignment.att.group.tooltip\'|translate}}\">{{\'Assignment.att.group.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"assignment in vm.assignments\"><td>{{ assignment.name }}</td><td>{{ assignment.teacher.name }}</td><td>{{ assignment.rubric.name }}</td><td>{{ assignment.group.name }}</td><td><button type=button ui-sref=tool.collaborativeAssessment.assessments({assignmentId:assignment.id}) class=\"btn btn-primary\"><i class=\"fa fa-star\"></i> {{\'collaborativeAssessment.assessments.submit\'|translate}}</button> <button type=button ui-sref=tool.collaborativeAssessment.comas({assignmentId:assignment.id}) class=\"btn btn-primary\"><i class=\"fa fa-cogs\"></i> {{\'collaborativeAssessment.comas.submit\'|translate}}</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/tool/collaborativeAssessment/groups/groups.html","<div><student-group-editor></student-group-editor><student-group-list></student-group-list></div>");
$templateCache.put("app/tool/collaborativeAssessment/rubrics/rubrics.html","<div class=container-fluid><uib-tabset active=activeJustified justified=true><uib-tab index=0 heading=\"{{\'Rubric.action.add.title\'|translate}}\" classes=tab-primary><rubric-editor hide-heading=true></rubric-editor></uib-tab><uib-tab index=1 heading=\"{{\'Rubric.action.import.title\'|translate}}\" classes=tab-primary><import-rubric hide-heading=true></import-rubric></uib-tab></uib-tabset><rubric-list></rubric-list></div>");
$templateCache.put("app/tool/collaborativeAssessment/students/students.html","<div><student-editor></student-editor><student-list></student-list></div>");
$templateCache.put("app/tool/collaborativeAssessment/teachers/teachers.html","<div><teacher-editor></teacher-editor><teacher-list></teacher-list></div>");
$templateCache.put("app/tool/data/assignment/assignmentEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'Assignment.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'Assignment.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'Assignment.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'Assignment.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.name.error\'|translate}}</div></div><div class=form-group><label for=assignmentTeacher>{{\'Assignment.att.teacher.title\'|translate}}</label><select class=form-control id=assignmentTeacher name=teacher ng-model=vm.model.teacher ng-options=\"teacher.name for teacher in vm.teachers track by teacher.id\"></select></div><div class=form-group><div ng-show=form.teacher.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.teacher.error\'|translate}}</div><div ng-if=\"vm.teachers.length==0\" class=\"alert alert-danger\" role=alert>{{\'Teacher.list.noData\'|translate}}</div></div><div class=form-group><label for=assignmentRubric>{{\'Assignment.att.rubric.title\'|translate}}</label><select class=form-control id=assignmentRubric name=rubric ng-model=vm.model.rubric ng-options=\"rubric.name for rubric in vm.rubrics track by rubric.id\"></select></div><div class=form-group><div ng-show=form.rubric.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.rubric.error\'|translate}}</div><div ng-if=\"vm.rubrics.length==0\" class=\"alert alert-danger\" role=alert>{{\'Rubric.list.noData\'|translate}}</div></div><div class=form-group><label for=assignmentGroup>{{\'Assignment.att.group.title\'|translate}}</label><select class=form-control id=assignmentGroup name=group ng-model=vm.model.group ng-options=\"group.name for group in vm.groups track by group.id\"></select></div><div class=form-group><div ng-show=form.group.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.group.error\'|translate}}</div><div ng-if=\"vm.groups.length==0\" class=\"alert alert-danger\" role=alert>{{\'StudentGroup.list.noData\'|translate}}</div></div><div class=form-group><label for=modelRequests>{{\'Assignment.att.requests.title\'|translate}}</label><ui-select multiple ng-model=vm.model.requests><ui-select-match>{{$item.factor|localizeCompetenceFactor}}, {{$item.level|localizeCompetenceRequestLevel}}, {{$item.importance|localizeCompetenceRequestImportance}}</ui-select-match><ui-select-choices repeat=\"request in vm.competenceRequests\">{{request.factor|localizeCompetenceFactor}}, {{request.level|localizeCompetenceRequestLevel}}, {{request.importance|localizeCompetenceRequestImportance}}</ui-select-choices></ui-select></div><div class=form-group><div ng-show=form.requests.$error.required class=\"row alert alert-danger\" role=alert>{{\'Assignment.att.requests.error\'|translate}}</div><div ng-show=\"vm.competenceRequests.length==0\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceRequest.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'Assignment.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Assignment.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/assignment/assignmentList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Assignment.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Assignment.att.name.tooltip\'|translate}}\">{{\'Assignment.att.name.title\'|translate}}</th><th title=\"{{\'Assignment.att.teacher.tooltip\'|translate}}\">{{\'Assignment.att.teacher.title\'|translate}}</th><th title=\"{{\'Assignment.att.rubric.tooltip\'|translate}}\">{{\'Assignment.att.rubric.title\'|translate}}</th><th title=\"{{\'Assignment.att.group.tooltip\'|translate}}\">{{\'Assignment.att.group.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td>{{ model.teacher.name }}</td><td>{{ model.rubric.name }}</td><td>{{ model.group.name }}</td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/assignments/assignments.html","<div class=container-fluid><assignment-editor></assignment-editor><assignment-list></assignment-list></div>");
$templateCache.put("app/tool/data/competenceAnswerValue/competenceAnswerValueEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'CompetenceAnswerValue.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'CompetenceAnswerValue.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'CompetenceAnswerValue.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'CompetenceAnswerValue.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceAnswerValue.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'CompetenceAnswerValue.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'CompetenceAnswerValue.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceAnswerValue.att.description.error\'|translate}}</div></div><div class=form-group><label for=modelValue>{{\'CompetenceAnswerValue.att.value.title\'|translate}}</label><input type=number class=form-control id=modelValue placeholder=\"{{\'CompetenceAnswerValue.att.value.tooltip\'|translate}}\" name=value ng-model=vm.model.value ng-min=-1 ng-max=1></div><div class=form-group><div ng-show=\"form.value.$error.max || form.value.$error.min || form.value.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceAnswerValue.att.value.error\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'CompetenceAnswerValue.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'CompetenceAnswerValue.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/competenceAnswerValue/competenceAnswerValueList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'CompetenceAnswerValue.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceAnswerValue.att.name.tooltip\'|translate}}\">{{\'CompetenceAnswerValue.att.name.title\'|translate}}</th><th title=\"{{\'CompetenceAnswerValue.att.description.tooltip\'|translate}}\">{{\'CompetenceAnswerValue.att.description.title\'|translate}}</th><th title=\"{{\'CompetenceAnswerValue.att.value.tooltip\'|translate}}\">{{\'CompetenceAnswerValue.att.value.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td>{{ model.description }}</td><td>{{ model.value |number}}</td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/competenceAnswers/competenceAnswers.html","<div><competence-answer-value-editor></competence-answer-value-editor><competence-answer-value-list></competence-answer-value-list></div>");
$templateCache.put("app/tool/data/competenceQuestion/competenceQuestionEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'CompetenceQuestion.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'CompetenceQuestion.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelFactor>{{\'CompetenceQuestion.att.factor.title\'|translate}}</label><md-radio-group ng-model=vm.model.factor class=md-primary><md-radio-button ng-repeat=\"factor in vm.COMPETENCE_FACTORS\" value={{factor}}>{{factor|localizeCompetenceFactor}}</md-radio-button></md-radio-group></div><div class=form-group><div ng-show=form.factor.$error.required class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestion.att.factor.error\'|translate}}</div></div><div class=form-group><label for=modelQuestion>{{\'CompetenceQuestion.att.question.title\'|translate}}</label><input type=text class=form-control id=modelQuestion placeholder=\"{{\'CompetenceQuestion.att.question.tooltip\'|translate}}\" name=question ng-model=vm.model.question ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.question.$error.minlength || form.question.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestion.att.question.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'CompetenceQuestion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'CompetenceQuestion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestion.att.description.error\'|translate}}</div></div><div class=form-group><label for=modelPossibleAnswerValues>{{\'CompetenceQuestion.att.possibleAnswerValues.title\'|translate}}</label><multiple-autocomplete ng-model=vm.model.possibleAnswerValues suggestions-arr=vm.competenceAnswerValues object-property=name></multiple-autocomplete></div><div class=form-group><div ng-show=form.possibleAnswerValues.$error.required class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestion.att.possibleAnswerValues.error\'|translate}}</div><div ng-show=\"vm.competenceAnswerValues.length==0\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceAnswerValue.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'CompetenceQuestion.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'CompetenceQuestion.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/competenceQuestion/competenceQuestionList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'CompetenceQuestion.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceQuestion.att.factor.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.factor.title\'|translate}}</th><th title=\"{{\'CompetenceQuestion.att.question.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.question.title\'|translate}}</th><th title=\"{{\'CompetenceQuestion.att.description.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.description.title\'|translate}}</th><th title=\"{{\'CompetenceQuestion.att.possibleAnswerValues.tooltip\'|translate}}\">{{\'CompetenceQuestion.att.possibleAnswerValues.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.factor|localizeCompetenceFactor }}</td><td>{{ model.question }}</td><td>{{ model.description }}</td><td><ul><li ng-repeat=\"answer in model.possibleAnswerValues track by answer.id\" title={{answer.description}}><strong>{{answer.name}}</strong> : {{answer.value}}</li></ul></td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/competenceQuestionnaire/competenceQuestionnaireEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'CompetenceQuestionnaire.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'CompetenceQuestionnaire.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'CompetenceQuestionnaire.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'CompetenceQuestionnaire.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestionnaire.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'CompetenceQuestionnaire.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'CompetenceQuestionnaire.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestionnaire.att.description.error\'|translate}}</div></div><div class=form-group><label for=modelQuestions>{{\'CompetenceQuestionnaire.att.questions.title\'|translate}}</label><multiple-autocomplete ng-model=vm.model.questions suggestions-arr=vm.competenceQuestions object-property=question></multiple-autocomplete></div><div class=form-group><div ng-show=form.questions.$error.required class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestionnaire.att.questions.error\'|translate}}</div><div ng-show=\"vm.competenceQuestions.length==0\" class=\"row alert alert-danger\" role=alert>{{\'CompetenceQuestion.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'CompetenceQuestionnaire.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'CompetenceQuestionnaire.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/competenceQuestionnaire/competenceQuestionnaireList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'CompetenceQuestionnaire.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceQuestionnaire.att.name.tooltip\'|translate}}\">{{\'CompetenceQuestionnaire.att.name.title\'|translate}}</th><th title=\"{{\'CompetenceQuestionnaire.att.description.tooltip\'|translate}}\">{{\'CompetenceQuestionnaire.att.description.title\'|translate}}</th><th title=\"{{\'CompetenceQuestionnaire.att.questions.tooltip\'|translate}}\">{{\'CompetenceQuestionnaire.att.questions.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td>{{ model.description }}</td><td><ul><li ng-repeat=\"question in model.questions track by question.id\" title={{question.description}}><strong>{{question.question}}</strong> <em>({{question.factor|localizeCompetenceFactor}})</em><ul><li ng-repeat=\"answer in question.possibleAnswerValues track by answer.id\" title={{answer.description}}><strong>{{answer.name}}</strong> : {{answer.value}}</li></ul></li></ul></td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/competenceQuestionnaires/competenceQuestionnaires.html","<div><competence-questionnaire-editor></competence-questionnaire-editor><competence-questionnaire-list></competence-questionnaire-list></div>");
$templateCache.put("app/tool/data/competenceQuestions/competenceQuestions.html","<div><competence-question-editor></competence-question-editor><competence-question-list></competence-question-list></div>");
$templateCache.put("app/tool/data/competenceRequest/competenceRequestEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'CompetenceRequest.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'CompetenceRequest.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form class=form-horizontal><div class=\"form-group row\"><label for=modelFactor class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.factor.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.model.factor ng-options=\"factor as (factor|localizeCompetenceFactor) for factor in vm.COMPETENCE_FACTORS\"></select></div></div><div class=\"form-group row\"><div ng-show=form.factor.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.factor.error\'|translate}}</div></div><div class=\"form-group row\"><label for=modelLevel class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.level.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.model.level ng-options=\" level as (level|localizeCompetenceRequestLevel) for level in vm.BASIC_SCALE\"></select></div></div><div class=\"form-group row\"><div ng-show=form.level.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.level.error\'|translate}}</div></div><div class=\"form-group row\"><label for=modelImportance class=\"col-sm-2 control-label\">{{\'CompetenceRequest.att.importance.title\'|translate}}</label><div class=col-sm-10><select ng-model=vm.model.importance ng-options=\" importance as (importance|localizeCompetenceRequestImportance) for importance in vm.BASIC_SCALE\"></select></div></div><div class=\"form-group row\"><div ng-show=form.importance.$error.required class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{\'CompetenceRequest.att.importance.error\'|translate}}</div></div><div class=\"form-group row\"><div class=col-sm-12><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'CompetenceRequest.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'CompetenceRequest.action.update.submit\'|translate}}</button></div></div><div class=\"form-group row\"><div ng-show=vm.error class=\"col-sm-offset-1 col-sm-10 alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/competenceRequest/competenceRequestList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'CompetenceRequest.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'CompetenceRequest.att.factor.tooltip\'|translate}}\">{{\'CompetenceRequest.att.factor.title\'|translate}}</th><th title=\"{{\'CompetenceRequest.att.level.tooltip\'|translate}}\">{{\'CompetenceRequest.att.level.title\'|translate}}</th><th title=\"{{\'CompetenceRequest.att.importance.tooltip\'|translate}}\">{{\'CompetenceRequest.att.importance.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.factor|localizeCompetenceFactor }}</td><td>{{ model.level|localizeCompetenceRequestLevel }}</td><td>{{ model.importance|localizeCompetenceRequestImportance }}</td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/competenceRequests/competenceRequests.html","<div><competence-request-editor></competence-request-editor><competence-request-list></competence-request-list></div>");
$templateCache.put("app/tool/data/criteria/criteria.html","<div><criterion-editor></criterion-editor><criterion-list></criterion-list></div>");
$templateCache.put("app/tool/data/criterion/criterionEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'Criterion.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'Criterion.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'Criterion.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'Criterion.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Criterion.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'Criterion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'Criterion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Criterion.att.description.error\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'Criterion.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Criterion.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/criterion/criterionList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Criterion.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Criterion.att.name.tooltip\'|translate}}\">{{\'Criterion.att.name.title\'|translate}}</th><th title=\"{{\'Criterion.att.description.tooltip\'|translate}}\">{{\'Criterion.att.description.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td>{{ model.description }}</td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/groups/groups.html","<div><student-group-editor></student-group-editor><student-group-list></student-group-list></div>");
$templateCache.put("app/tool/data/personalityAnswerValue/personalityAnswerValueEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'PersonalityAnswerValue.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'PersonalityAnswerValue.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'PersonalityAnswerValue.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'PersonalityAnswerValue.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityAnswerValue.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'PersonalityAnswerValue.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'PersonalityAnswerValue.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityAnswerValue.att.description.error\'|translate}}</div></div><div class=form-group><label for=modelValue>{{\'PersonalityAnswerValue.att.value.title\'|translate}}</label><input type=number class=form-control id=modelValue placeholder=\"{{\'PersonalityAnswerValue.att.value.tooltip\'|translate}}\" name=value ng-model=vm.model.value ng-min=-1 ng-max=1></div><div class=form-group><div ng-show=\"form.value.$error.max || form.value.$error.min || form.value.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityAnswerValue.att.value.error\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'PersonalityAnswerValue.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'PersonalityAnswerValue.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/personalityAnswerValue/personalityAnswerValueList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'PersonalityAnswerValue.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'PersonalityAnswerValue.att.name.tooltip\'|translate}}\">{{\'PersonalityAnswerValue.att.name.title\'|translate}}</th><th title=\"{{\'PersonalityAnswerValue.att.description.tooltip\'|translate}}\">{{\'PersonalityAnswerValue.att.description.title\'|translate}}</th><th title=\"{{\'PersonalityAnswerValue.att.value.tooltip\'|translate}}\">{{\'PersonalityAnswerValue.att.value.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td>{{ model.description }}</td><td>{{ model.value |number}}</td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/personalityAnswers/personalityAnswers.html","<div><personality-answer-value-editor></personality-answer-value-editor><personality-answer-value-list></personality-answer-value-list></div>");
$templateCache.put("app/tool/data/personalityQuestion/personalityQuestionEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'PersonalityQuestion.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'PersonalityQuestion.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelFactor>{{\'PersonalityQuestion.att.factor.title\'|translate}}</label><md-radio-group ng-model=vm.model.factor class=md-primary layout=row><md-radio-button ng-repeat=\"factor in vm.PERSONALITY_FACTORS\" value={{factor}}>{{factor|localizePersonalityFactor}}</md-radio-button></md-radio-group></div><div class=form-group><div ng-show=form.factor.$error.required class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestion.att.factor.error\'|translate}}</div></div><div class=form-group><label for=modelQuestion>{{\'PersonalityQuestion.att.question.title\'|translate}}</label><input type=text class=form-control id=modelQuestion placeholder=\"{{\'PersonalityQuestion.att.question.tooltip\'|translate}}\" name=question ng-model=vm.model.question ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.question.$error.minlength || form.question.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestion.att.question.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'PersonalityQuestion.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'PersonalityQuestion.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestion.att.description.error\'|translate}}</div></div><div class=form-group><label for=modelPossibleAnswerValues>{{\'PersonalityQuestion.att.possibleAnswerValues.title\'|translate}}</label><multiple-autocomplete ng-model=vm.model.possibleAnswerValues suggestions-arr=vm.personalityAnswerValues object-property=name></multiple-autocomplete></div><div class=form-group><div ng-show=form.possibleAnswerValues.$error.required class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestion.att.possibleAnswerValues.error\'|translate}}</div><div ng-show=\"vm.personalityAnswerValues.length==0\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityAnswerValue.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'PersonalityQuestion.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'PersonalityQuestion.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/personalityQuestion/personalityQuestionList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'PersonalityQuestion.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'PersonalityQuestion.att.factor.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.factor.title\'|translate}}</th><th title=\"{{\'PersonalityQuestion.att.question.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.question.title\'|translate}}</th><th title=\"{{\'PersonalityQuestion.att.description.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.description.title\'|translate}}</th><th title=\"{{\'PersonalityQuestion.att.possibleAnswerValues.tooltip\'|translate}}\">{{\'PersonalityQuestion.att.possibleAnswerValues.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.factor|localizePersonalityFactor }}</td><td>{{ model.question }}</td><td>{{ model.description }}</td><td><ul><li ng-repeat=\"answer in model.possibleAnswerValues track by answer.id\" title={{answer.description}}><strong>{{answer.name}}</strong> : {{answer.value}}</li></ul></td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/personalityQuestionnaire/personalityQuestionnaireEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'PersonalityQuestionnaire.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'PersonalityQuestionnaire.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'PersonalityQuestionnaire.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'PersonalityQuestionnaire.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestionnaire.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelDescription>{{\'PersonalityQuestionnaire.att.description.title\'|translate}}</label><textarea class=form-control id=modelDescription placeholder=\"{{\'PersonalityQuestionnaire.att.description.tooltip\'|translate}}\" name=description ng-model=vm.model.description ng-maxlength=255 ng-minlength=1 ng-trim=true></textarea></div><div class=form-group><div ng-show=\"form.description.$error.minlength || form.description.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestionnaire.att.description.error\'|translate}}</div></div><div class=form-group><label for=modelQuestions>{{\'PersonalityQuestionnaire.att.questions.title\'|translate}}</label><multiple-autocomplete ng-model=vm.model.questions suggestions-arr=vm.personalityQuestions object-property=question></multiple-autocomplete></div><div class=form-group><div ng-show=form.questions.$error.required class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestionnaire.att.questions.error\'|translate}}</div><div ng-show=\"vm.personalityQuestions.length==0\" class=\"row alert alert-danger\" role=alert>{{\'PersonalityQuestion.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'PersonalityQuestionnaire.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'PersonalityQuestionnaire.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/personalityQuestionnaire/personalityQuestionnaireList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'PersonalityQuestionnaire.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'PersonalityQuestionnaire.att.name.tooltip\'|translate}}\">{{\'PersonalityQuestionnaire.att.name.title\'|translate}}</th><th title=\"{{\'PersonalityQuestionnaire.att.description.tooltip\'|translate}}\">{{\'PersonalityQuestionnaire.att.description.title\'|translate}}</th><th title=\"{{\'PersonalityQuestionnaire.att.questions.tooltip\'|translate}}\">{{\'PersonalityQuestionnaire.att.questions.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td>{{ model.description }}</td><td><ul><li ng-repeat=\"question in model.questions track by question.id\" title={{question.description}}><strong>{{question.question}}</strong> <em>({{question.factor|localizePersonalityFactor}})</em><ul><li ng-repeat=\"answer in question.possibleAnswerValues track by answer.id\" title={{answer.description}}><strong>{{answer.name}}</strong> : {{answer.value}}</li></ul></li></ul></td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/personalityQuestionnaires/personalityQuestionnaires.html","<div><personality-questionnaire-editor></personality-questionnaire-editor><personality-questionnaire-list></personality-questionnaire-list></div>");
$templateCache.put("app/tool/data/personalityQuestions/personalityQuestions.html","<div><personality-question-editor></personality-question-editor><personality-question-list></personality-question-list></div>");
$templateCache.put("app/tool/data/rubric/importRubric.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\" ng-hide=vm.hideHeading><h3 class=panel-title>{{\'Rubric.action.import.title\'|translate}}</h3></div><div class=panel-body><form novalidate ng-submit=vm.importRubric(importForm) name=importForm><div class=form-group><label for=rubricName>{{\'Rubric.att.name.title\'|translate}}</label><input type=text class=form-control id=rubricName placeholder=\"{{\'Rubric.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"importForm.name.$error.minlength || importForm.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.name.error\'|translate}}</div></div><div class=form-group><label>{{\'Rubric.action.import.file.title\'|translate}}</label><input id=importFile type=file nv-file-select uploader=vm.uploader></div><div class=form-group><div ng-show=importForm.file.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.action.import.required\'|translate}}</div></div><div class=form-group><button type=submit class=\"btn btn-default\">{{\'Rubric.action.import.submit\'|translate}}</button><div class=progress ng-show=vm.uploader.isUploading><div class=progress-bar role=progressbar ng-style=\"{ \'width\': vm.uploader.progress + \'%\' }\" style=\"width: 0%\"></div></div></div><div class=form-group ng-show=vm.importError><div class=\"alert alert-danger\" role=alert>{{\'Rubric.action.import.error\'|translate}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/rubric/rubricEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\" ng-hide=vm.hideHeading><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'Rubric.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'Rubric.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate ng-submit=vm.addRubric(form) name=form><div class=form-group><label for=rubricName>{{\'Rubric.att.name.title\'|translate}}</label><input type=text class=form-control id=rubricName placeholder=\"{{\'Rubric.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.name.error\'|translate}}</div></div><div class=form-group><label for=rubricMinMark>{{\'Rubric.att.minMark.title\'|translate}}</label><input type=number class=form-control id=rubricMinMark placeholder=\"{{\'Rubric.att.minMark.tooltip\'|translate}}\" name=minMark ng-model=vm.model.minMark required ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=form.minMark.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.minMark.error\'|translate}}</div></div><div class=form-group><label for=rubricMaxMark>{{\'Rubric.att.maxMark.title\'|translate}}</label><input type=number class=form-control id=rubricMaxMark placeholder=\"{{\'Rubric.att.maxMark.tooltip\'|translate}}\" name=maxMark ng-model=vm.model.maxMark required ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=form.maxMark.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.maxMark.error\'|translate}}</div></div><div class=form-rubric><label for=rubricCriteria>{{\'Rubric.att.criteria.title\'|translate}}</label><multiple-autocomplete ng-model=vm.model.criteria suggestions-arr=vm.criteria object-property=name></multiple-autocomplete></div><div class=form-rubric><div ng-show=form.criteria.$error.required class=\"row alert alert-danger\" role=alert>{{\'Rubric.att.criteria.error\'|translate}}</div></div><br><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'Rubric.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Rubric.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/rubric/rubricList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Rubric.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Rubric.att.name.tooltip\'|translate}}\">{{\'Rubric.att.name.title\'|translate}}</th><th title=\"{{\'Rubric.att.minMark.tooltip\'|translate}}\">{{\'Rubric.att.minMark.title\'|translate}}</th><th title=\"{{\'Rubric.att.maxMark.tooltip\'|translate}}\">{{\'Rubric.att.maxMark.title\'|translate}}</th><th title=\"{{\'Rubric.att.criteria.tooltip\'|translate}}\">{{\'Rubric.att.criteria.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"rubric in vm.models\"><td>{{ rubric.name }}</td><td>{{ rubric.minMark|number }}</td><td>{{ rubric.maxMark|number }}</td><td><ul><li ng-repeat=\"criterion in rubric.criteria track by criterion.id\"><strong>{{ criterion.name }}</strong> :{{ criterion.description }}</li></ul></td><td><button type=button ng-click=vm.remove(rubric) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/rubrics/rubrics.html","<div class=container-fluid><uib-tabset active=activeJustified justified=true><uib-tab index=0 heading=\"{{\'Rubric.action.add.title\'|translate}}\" classes=tab-primary><rubric-editor hide-heading=true></rubric-editor></uib-tab><uib-tab index=1 heading=\"{{\'Rubric.action.import.title\'|translate}}\" classes=tab-primary><import-rubric hide-heading=true></import-rubric></uib-tab></uib-tabset><rubric-list></rubric-list></div>");
$templateCache.put("app/tool/data/student/studentEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'Student.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'Student.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=studentName>{{\'Student.att.name.title\'|translate}}</label><input type=text class=form-control id=studentName placeholder=\"{{\'Student.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Student.att.name.error\'|translate}}</div></div><div class=form-group><label>{{\'Student.att.sex.title\'|translate}}</label><md-radio-group ng-model=vm.model.sex class=md-primary layout=row><md-radio-button ng-repeat=\"sex in vm.PERSON_SEX\" value={{sex}}>{{sex|localizePersonSex}}</md-radio-button></md-radio-group></div><div class=form-group><div ng-show=\"form.sex.$error.minlength || form.sex.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Student.att.sex.error\'|translate}}</div></div><div class=form-group><label for=studentDateOfBirth>{{\'Student.att.dateOfBirth.title\'|translate}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=vm.model.dateOfBirth is-open=showDateOfBirthPicker datepicker-options=dateOfBirthOptions ng-required=true close-text=\"{{\'common.close\'|translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"showDateOfBirthPicker=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=form-group><div ng-show=\"form.dateOfBirth.$error.minlength || form.dateOfBirth.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Student.att.dateOfBirth.error\'|translate}}</div></div><br><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'Student.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Student.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/student/studentList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Student.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Student.att.name.tooltip\'|translate}}\">{{\'Student.att.name.title\'|translate}}</th><th title=\"{{\'Student.att.sex.tooltip\'|translate}}\">{{\'Student.att.sex.title\'|translate}}</th><th title=\"{{\'Student.att.dateOfBirth.tooltip\'|translate}}\">{{\'Student.att.dateOfBirth.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"student in vm.models\"><td>{{ student.name }}</td><td>{{ student.sex|localizePersonSex }}</td><td>{{ student.dateOfBirth|date }}</td><td><button type=button ng-click=vm.remove(student) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/studentGroup/studentGroupEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'StudentGroup.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'StudentGroup.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=modelName>{{\'StudentGroup.att.name.title\'|translate}}</label><input type=text class=form-control id=modelName placeholder=\"{{\'StudentGroup.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'StudentGroup.att.name.error\'|translate}}</div></div><div class=form-group><label for=modelTeachers>{{\'StudentGroup.att.teachers.title\'|translate}}</label><ui-select multiple ng-model=vm.model.teachers theme=bootstrap ng-disabled=false close-on-select=false title=\"{{\'StudentGroup.att.teachers.tooltip\'|translate}}\"><ui-select-match placeholder=\"{{\'StudentGroup.att.teachers.placeholder\'|translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"teacher in vm.teachers | filter: $select.search track by teacher.id\"><div ng-bind-html=\"teacher.name | highlight: $select.search\"></div><small>{{\'Teacher.att.sex.title\'|translate}}: <span ng-bind-html=\"\'\'+teacher.sex | localizePersonSex| highlight: $select.search\"></span><br>{{\'Teacher.att.dateOfBirth.title\'|translate}}: <span ng-bind-html=\"\'\'+teacher.dateOfBirth |date:\'shortDate\' | highlight: $select.search\"></span></small></ui-select-choices></ui-select></div><div class=form-group><div ng-show=form.teachers.$error.required class=\"row alert alert-danger\" role=alert>{{\'StudentGroup.att.teachers.error\'|translate}}</div><div ng-show=\"vm.teachers.length==0\" class=\"row alert alert-danger\" role=alert>{{\'Teacher.list.noData\'|translate}}</div></div><div class=form-group><label for=modelStudents>{{\'StudentGroup.att.students.title\'|translate}}</label><ui-select multiple ng-model=vm.model.students theme=bootstrap ng-disabled=false close-on-select=false title=\"{{\'StudentGroup.att.students.tooltip\'|translate}}\"><ui-select-match placeholder=\"{{\'StudentGroup.att.students.placeholder\'|translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"student in vm.students\"><div ng-bind-html=\"student.name | highlight: $select.search\"></div><small>{{\'Student.att.sex.title\'|translate}}: <span ng-bind-html=\"\'\'+student.sex | localizePersonSex| highlight: $select.search\"></span><br>{{\'Student.att.dateOfBirth.title\'|translate}}: <span ng-bind-html=\"\'\'+student.dateOfBirth |date:\'shortDate\' | highlight: $select.search\"></span></small></ui-select-choices></ui-select></div><div class=form-group><div ng-show=form.students.$error.required class=\"row alert alert-danger\" role=alert>{{\'StudentGroup.att.students.error\'|translate}}</div><div ng-show=\"vm.students.length==0\" class=\"row alert alert-danger\" role=alert>{{\'Student.list.noData\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'StudentGroup.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'StudentGroup.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/studentGroup/studentGroupList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'StudentGroup.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'StudentGroup.att.factor.tooltip\'|translate}}\">{{\'StudentGroup.att.name.title\'|translate}}</th><th title=\"{{\'StudentGroup.att.question.tooltip\'|translate}}\">{{\'StudentGroup.att.students.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"model in vm.models\"><td>{{ model.name }}</td><td><ul><li ng-repeat=\"student in model.students track by student.id\">{{student.name}}</li></ul></td><td><button type=button ng-click=vm.remove(model) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/students/students.html","<div><student-editor></student-editor><student-list></student-list></div>");
$templateCache.put("app/tool/data/teacher/teacherEditor.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 ng-if=\"vm.model.id==0\" class=panel-title>{{\'Teacher.action.add.title\'|translate}}</h3><h3 ng-if=\"vm.model.id!=0\" class=panel-title>{{\'Teacher.action.update.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div class=form-group><label for=teacherName>{{\'Teacher.att.name.title\'|translate}}</label><input type=text class=form-control id=teacherName placeholder=\"{{\'Teacher.att.name.tooltip\'|translate}}\" name=name ng-model=vm.model.name ng-maxlength=255 ng-minlength=1 ng-trim=true></div><div class=form-group><div ng-show=\"form.name.$error.minlength || form.name.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Teacher.att.name.error\'|translate}}</div></div><div class=form-group><label>{{\'Teacher.att.sex.title\'|translate}}</label><md-radio-group ng-model=vm.model.sex class=md-primary layout=row><md-radio-button ng-repeat=\"sex in vm.PERSON_SEX\" value={{sex}}>{{sex|localizePersonSex}}</md-radio-button></md-radio-group></div><div class=form-group><div ng-show=\"form.sex.$error.minlength || form.sex.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Teacher.att.sex.error\'|translate}}</div></div><div class=form-group><label for=teacherDateOfBirth>{{\'Teacher.att.dateOfBirth.title\'|translate}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=vm.model.dateOfBirth is-open=showDateOfBirthPicker datepicker-options=dateOfBirthOptions ng-required=true close-text=\"{{\'common.close\'|translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"showDateOfBirthPicker=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=form-group><div ng-show=\"form.dateOfBirth.$error.minlength || form.dateOfBirth.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'Teacher.att.dateOfBirth.error\'|translate}}</div></div><div class=form-group><button ng-if=\"vm.model.id==0\" progress-button=vm.checkFormAndAdd(form) pb-profile=modelProfile>{{\'Teacher.action.add.submit\'|translate}}</button> <button ng-if=\"vm.model.id!=0\" progress-button=vm.checkFormAndUpdate(form) pb-profile=modelProfile>{{\'Teacher.action.update.submit\'|translate}}</button></div><div class=form-group><div ng-show=vm.error class=\"row alert alert-danger\" role=alert>{{vm.error}}</div></div></form></div></div>");
$templateCache.put("app/tool/data/teacher/teacherList.html","<div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'Teacher.list.title\'|translate}}</h3></div><div class=table-responsive><div ng-if=vm.loading class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Teacher.att.name.tooltip\'|translate}}\">{{\'Teacher.att.name.title\'|translate}}</th><th title=\"{{\'Teacher.att.sex.tooltip\'|translate}}\">{{\'Teacher.att.sex.title\'|translate}}</th><th title=\"{{\'Teacher.att.dateOfBirth.tooltip\'|translate}}\">{{\'Teacher.att.dateOfBirth.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"teacher in vm.models\"><td>{{ teacher.name }}</td><td>{{ teacher.sex|localizePersonSex }}</td><td>{{ teacher.dateOfBirth|date }}</td><td><button type=button ng-click=vm.remove(teacher) class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/tool/data/teachers/teachers.html","<div><teacher-editor></teacher-editor><teacher-list></teacher-list></div>");
$templateCache.put("app/tool/synergisticTeams/about/about.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=synergisticTeams.about.title></h1></div></div><div class=row><div class=col-lg-12 translate=synergisticTeams.about.description></div></div></div>");
$templateCache.put("app/tool/synergisticTeams/competenceTest/competenceTest.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'synergisticTeams.competenceTest.student.title\'|translate }}</h3></div><div class=panel-body><form novalidate name=studentForm><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"vm.students.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Student.list.noData\'|translate}}</div><div class=form-group ng-hide=\"vm.students.length == 0\"><label>{{\'synergisticTeams.competenceTest.student.select\'|translate}}</label><div><select ng-model=vm.student ng-options=\"student.name for student in vm.students track by student.id\"></select></div></div></form><ul ng-show=vm.student><li><strong>{{\'Student.att.name.title\'|translate}}</strong> : {{ vm.student.name }}</li><li><strong>{{\'Student.att.sex.title\'|translate}}</strong> : {{ vm.student.sex |localizePersonSex }}</li><li><strong>{{\'Student.att.dateOfBirth.title\'|translate}}</strong> : {{ vm.student.dateOfBirth |date }}</li></ul></div></div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'synergisticTeams.competenceTest.questionnaire.title\'|translate }}</h3></div><div class=panel-body><form novalidate name=questionnaireForm><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"vm.questionnaires.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Questionnaire.list.noData\'|translate}}</div><div class=form-group ng-hide=\"vm.questionnaires.length == 0\"><label>{{\'synergisticTeams.competenceTest.questionnaire.select\'|translate}}</label><div><select ng-model=vm.questionnaire ng-options=\"questionnaire.name for questionnaire in vm.questionnaires track by questionnaire.id\"></select></div></div></form><ul ng-show=vm.questionnaire><li><strong>{{\'CompetenceQuestionnaire.att.name.title\'|translate}}</strong> : {{ vm.questionnaire.name }}</li><li><strong>{{\'CompetenceQuestionnaire.att.description.title\'|translate}}</strong> : {{ vm.questionnaire.description }}</li></ul></div></div><div class=\"panel panel-default\" ng-show=\"vm.questionnaire && vm.student\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'synergisticTeams.competenceTest.title\'|translate }}</h3></div><div class=panel-body><span ng-if=\"vm.studentCompetenceAnswers.length == 0 && !vm.studentCompetenceAnswersError\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><div class=\"row alert alert-danger\" role=alert ng-show=vm.studentCompetenceAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentCompetenceAnswersError}}</div><form novalidate name=form ng-show=\"vm.studentCompetenceAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentCompetenceAnswers track by $index\"><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}</label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentCompetenceAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div><hr><div class=form-group><button type=button ng-click=vm.removeStudentCompetenceAnswers() class=\"btn btn-danger\"><i class=\"fa fa-eraser\"></i> {{\'synergisticTeams.competenceTest.clearAnswers\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/tool/synergisticTeams/personalityTest/personalityTest.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'congenialTeams.personalityTest.student.title\'|translate }}</h3></div><div class=panel-body><form novalidate name=studentForm><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"vm.students.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Student.list.noData\'|translate}}</div><div class=form-group ng-hide=\"vm.students.length == 0\"><label>{{\'congenialTeams.personalityTest.student.select\'|translate}}</label><div><select ng-model=vm.student ng-options=\"student.name for student in vm.students track by student.id\"></select></div></div></form><ul ng-show=vm.student><li><strong>{{\'Student.att.name.title\'|translate}}</strong> : {{ vm.student.name }}</li><li><strong>{{\'Student.att.sex.title\'|translate}}</strong> : {{ vm.student.sex |localizePersonSex }}</li><li><strong>{{\'Student.att.dateOfBirth.title\'|translate}}</strong> : {{ vm.student.dateOfBirth |date }}</li></ul></div></div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'congenialTeams.personalityTest.questionnaire.title\'|translate }}</h3></div><div class=panel-body><form novalidate name=questionnaireForm><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"vm.questionnaires.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Questionnaire.list.noData\'|translate}}</div><div class=form-group ng-hide=\"vm.questionnaires.length == 0\"><label>{{\'congenialTeams.personalityTest.questionnaire.select\'|translate}}</label><div><select ng-model=vm.questionnaire ng-options=\"questionnaire.name for questionnaire in vm.questionnaires track by questionnaire.id\"></select></div></div></form><ul ng-show=vm.questionnaire><li><strong>{{\'PersonalityQuestionnaire.att.name.title\'|translate}}</strong> : {{ vm.questionnaire.name }}</li><li><strong>{{\'PersonalityQuestionnaire.att.description.title\'|translate}}</strong> : {{ vm.questionnaire.description }}</li></ul></div></div><div class=\"panel panel-default\" ng-show=\"vm.questionnaire && vm.student\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'congenialTeams.personalityTest.title\'|translate }}</h3></div><div class=panel-body><span ng-if=\"vm.studentPersonalityAnswers.length == 0 && !vm.studentPersonalityAnswersError\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><div class=\"row alert alert-danger\" role=alert ng-show=vm.studentPersonalityAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentPersonalityAnswersError}}</div><form novalidate name=form ng-show=\"vm.studentPersonalityAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentPersonalityAnswers track by $index\"><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}</label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentPersonalityAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div><hr><div class=form-group><button type=button ng-click=vm.removeStudentPersonalityAnswers() class=\"btn btn-danger\"><i class=\"fa fa-eraser\"></i> {{\'congenialTeams.personalityTest.clearAnswers\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/tool/synergisticTeams/synteam/synteam.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'synergisticTeams.synteam.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><span ng-if=vm.loading><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><div class=form-group><label for=studentsPerTeam>{{\'synergisticTeams.synteam.studentsPerTeam.title\'|translate}}</label><input type=number class=form-control id=studentsPerTeam placeholder=\"{{\'synergisticTeams.synteam.studentsPerTeam.tooltip\'|translate}}\" name=studentsPerTeam ng-model=vm.studentsPerTeam ng-min=2></div><div class=form-group><div ng-show=\"form.studentsPerTeam.$error.max || form.studentsPerTeam.$error.min || form.studentsPerTeam.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'synergisticTeams.synteam.studentsPerTeam.error\'|translate}}</div></div><div class=form-group><label>{{\'synergisticTeams.synteam.personalityQuestionnaire.title\'|translate}}</label><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"!vm.loadingPersonalityQuestionnaires && vm.personalityQuestionnaires.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'PersonalityQuestionnaire.list.noData\'|translate}}</div><div ng-show=\"vm.personalityQuestionnaires.length > 0 \"><select ng-model=vm.personalityQuestionnaire ng-options=\"personalityQuestionnaire.name for personalityQuestionnaire in vm.personalityQuestionnaires track by personalityQuestionnaire.id\"></select></div></div><div ng-show=vm.personalityQuestionnaire class=\"alert alert-info\" role=alert>{{vm.personalityQuestionnaire.description}}</div><div class=form-group><label>{{\'synergisticTeams.synteam.competenceQuestionnaire.title\'|translate}}</label><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"!vm.loadingCompetenceQuestionnaires && vm.competenceQuestionnaires.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'CompetenceQuestionnaire.list.noData\'|translate}}</div><div ng-show=\"vm.competenceQuestionnaires.length > 0 \"><select ng-model=vm.competenceQuestionnaire ng-options=\"competenceQuestionnaire.name for competenceQuestionnaire in vm.competenceQuestionnaires track by competenceQuestionnaire.id\"></select></div></div><div ng-show=vm.competenceQuestionnaire class=\"alert alert-info\" role=alert>{{vm.competenceQuestionnaire.description}}</div><div class=form-group><label>{{\'synergisticTeams.synteam.assignment.title\'|translate}}</label><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"!vm.loadingAssignments && vm.assignments.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Assignment.list.noData\'|translate}}</div><div ng-show=\"vm.assignments.length > 0 \"><select ng-model=vm.assignment ng-options=\"assignment.name for assignment in vm.assignments track by assignment.id\"></select></div></div><div ng-show=vm.assignment class=\"alert alert-info\" role=alert>{{vm.assignment.description}}</div><div class=\"table-responsive synteam-students-table\"><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Student.att.name.tooltip\'|translate}}\">{{\'Student.att.name.title\'|translate}}</th><th title=\"{{\'Student.att.sex.tooltip\'|translate}}\">{{\'Student.att.sex.title\'|translate}}</th><th title=\"{{\'Student.att.dateOfBirth.tooltip\'|translate}}\">{{\'Student.att.dateOfBirth.title\'|translate}}</th><th title=\"{{\'synergisticTeams.synteam.personalityQuestionnaire.test.tooltip\'|translate}}\">{{\'synergisticTeams.synteam.personalityQuestionnaire.test.title\'|translate}}</th><th title=\"{{\'synergisticTeams.synteam.competenceQuestionnaire.test.tooltip\'|translate}}\">{{\'synergisticTeams.synteam.competenceQuestionnaire.test.title\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"student in vm.assignment.group.students track by student.id\"><td><strong>{{ student.name }}</strong></td><td>{{ student.sex |localizePersonSex}}</td><td><strong>{{ student.dateOfBirth | date}}</strong></td><td><div ng-switch=vm.personalityTestStatus[$index]><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'synergisticTeams.synteam.personalityQuestionnaire.test.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'synergisticTeams.synteam.personalityQuestionnaire.test.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'synergisticTeams.synteam.personalityQuestionnaire.test.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></td><td><div ng-switch=vm.competenceTestStatus[$index]><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'synergisticTeams.synteam.competenceQuestionnaire.test.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'synergisticTeams.synteam.competenceQuestionnaire.test.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'synergisticTeams.synteam.competenceQuestionnaire.test.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></td></tr></tbody></table></div><hr><div class=form-group><div class=\"table-responsive col-sm-6\"><button progress-button=vm.synergisticTeams(form) pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'synergisticTeams.synteam.submit.synteam\'|translate}}</button></div><div class=\"table-responsive col-sm-6\"><button progress-button=vm.lpTeams(form) pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'synergisticTeams.synteam.submit.lpteam\'|translate}}</button></div></div></form></div></div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'synergisticTeams.synteam.result.title\'|translate}}</h3></div><div class=panel-body><div ng-show=\"vm.teams.length > 0\" class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'StudentTeam.name.tooltip\'|translate}}\">{{\'StudentTeam.att.name.title\'|translate}}</th><th title=\"{{\'StudentTeam.att.students.tooltip\'|translate}}\">{{\'StudentTeam.att.students.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams track by team.id\"><td><strong>{{ team.name }}</strong></td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td><td></td></tr></tbody></table></div><div ng-show=\"vm.teams.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'synergisticTeams.synteam.result.noData\'|translate}}</div></div></div></div>");
$templateCache.put("app/tool/lessonPlanEditor/about/about.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=lessonPlanEditor.about.title></h1></div></div><div class=row><div class=col-lg-12 translate=lessonPlanEditor.about.description></div></div></div>");
$templateCache.put("app/tool/congenialTeams/answers/answers.html","<div><personality-answer-value-editor></personality-answer-value-editor><personality-answer-value-list></personality-answer-value-list></div>");
$templateCache.put("app/tool/congenialTeams/about/about.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=congenialTeams.about.title></h1></div></div><div class=row><div class=col-lg-12 translate=congenialTeams.about.description></div></div></div>");
$templateCache.put("app/tool/congenialTeams/conteam/conteam.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'congenialTeams.conteam.title\'|translate}}</h3></div><div class=panel-body><form novalidate name=form><div ng-show=vm.error class=\"alert alert-danger\" role=alert>{{vm.error}}</div><span ng-if=vm.loading><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><div class=form-group><label for=studentsPerGroup>{{\'congenialTeams.conteam.studentsPerGroup.title\'|translate}}</label><input type=number class=form-control id=studentsPerGroup placeholder=\"{{\'congenialTeams.conteam.studentsPerGroup.tooltip\'|translate}}\" name=studentsPerGroup ng-model=vm.studentsPerGroup ng-min=2></div><div class=form-group><div ng-show=\"form.studentsPerGroup.$error.max || form.studentsPerGroup.$error.min || form.studentsPerGroup.$error.required\" class=\"row alert alert-danger\" role=alert>{{\'congenialTeams.conteam.studentsPerGroup.error\'|translate}}</div></div><div class=form-group><label>{{\'congenialTeams.conteam.questionnaire.title\'|translate}}</label><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"!vm.loadingQuestionnaires && vm.questionnaires.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'PersonalityQuestionnaire.list.noData\'|translate}}</div><div ng-show=\"vm.questionnaires.length > 0 \"><select ng-model=vm.questionnaire ng-options=\"questionnaire.name for questionnaire in vm.questionnaires track by questionnaire.id\"></select></div></div><div ng-show=vm.questionnaire class=\"alert alert-info\" role=alert>{{vm.questionnaire.description}}</div><div class=form-group><label>{{\'congenialTeams.conteam.group.title\'|translate}}</label><div ng-show=vm.loadingGroups class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"!vm.loadingGroups && vm.groups.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'StudentGroup.list.noData\'|translate}}</div><div ng-show=\"vm.groups.length > 0 \"><select ng-model=vm.group ng-options=\"group.name for group in vm.groups track by group.id\"></select></div></div><div class=form-group><div ng-show=form.students.$error.required class=\"row alert alert-danger\" role=alert>{{\'congenialTeams.conteam.students.error\'|translate}}</div></div><div class=\"table-responsive conteam-group-students-table\"><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'Student.att.name.tooltip\'|translate}}\">{{\'Student.att.name.title\'|translate}}</th><th title=\"{{\'Student.att.sex.tooltip\'|translate}}\">{{\'Student.att.sex.title\'|translate}}</th><th title=\"{{\'Student.att.dateOfBirth.tooltip\'|translate}}\">{{\'Student.att.dateOfBirth.title\'|translate}}</th><th title=\"{{\'congenialTeams.conteam.group.test.tooltip\'|translate}}\">{{\'congenialTeams.conteam.group.test.title\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"student in vm.group.students track by student.id\"><td><strong>{{ student.name }}</strong></td><td>{{ student.sex |localizePersonSex}}</td><td><strong>{{ student.dateOfBirth | date}}</strong></td><td><div ng-switch=vm.testStatus[$index]><div ng-switch-when=done class=\"alert alert-success\" role=alert><i class=\"fa fa-check\"></i> {{\'congenialTeams.conteam.group.test.done\'|translate}}</div><div ng-switch-when=partial class=\"alert alert-warning\" role=alert><i class=\"fa fa-exclamation-triangle\"></i> {{\'congenialTeams.conteam.group.test.partial\'|translate}}</div><div ng-switch-when=toDo class=\"alert alert-danger\" role=alert><i class=\"fa fa-exclamation-circle\"></i> {{\'congenialTeams.conteam.group.test.toDo\'|translate}}</div><div ng-switch-default class=\"alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></td></tr></tbody></table></div><hr><div class=form-group><button progress-button=vm.congenialTeams(form) pb-profile=modelProfile><i class=\"fa fa-gears\"></i> {{\'congenialTeams.conteam.submit.title\'|translate}}</button></div></form></div></div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{\'congenialTeams.conteam.result.title\'|translate}}</h3></div><div class=panel-body><div ng-show=\"vm.teams.length > 0\" class=table-responsive><table datatable=ng class=\"table table-striped\"><thead><tr role=row><th title=\"{{\'StudentTeam.name.tooltip\'|translate}}\">{{\'StudentTeam.att.name.title\'|translate}}</th><th title=\"{{\'StudentTeam.att.students.tooltip\'|translate}}\">{{\'StudentTeam.att.students.title\'|translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams track by team.id\"><td><strong>{{ team.name }}</strong></td><td><ul><li ng-repeat=\"student in team.students track by student.id\">{{student.name}}</li></ul></td><td></td></tr></tbody></table></div><div ng-show=\"vm.teams.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'congenialTeams.conteam.result.noData\'|translate}}</div></div></div></div>");
$templateCache.put("app/tool/congenialTeams/groups/groups.html","<div><student-group-editor></student-group-editor><student-group-list></student-group-list></div>");
$templateCache.put("app/tool/congenialTeams/personalityTest/personalityTest.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'congenialTeams.personalityTest.student.title\'|translate }}</h3></div><div class=panel-body><form novalidate name=studentForm><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"vm.students.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Student.list.noData\'|translate}}</div><div class=form-group ng-hide=\"vm.students.length == 0\"><label>{{\'congenialTeams.personalityTest.student.select\'|translate}}</label><div><select ng-model=vm.student ng-options=\"student.name for student in vm.students track by student.id\"></select></div></div></form><ul ng-show=vm.student><li><strong>{{\'Student.att.name.title\'|translate}}</strong> : {{ vm.student.name }}</li><li><strong>{{\'Student.att.sex.title\'|translate}}</strong> : {{ vm.student.sex |localizePersonSex }}</li><li><strong>{{\'Student.att.dateOfBirth.title\'|translate}}</strong> : {{ vm.student.dateOfBirth |date }}</li></ul></div></div><div class=\"panel panel-default\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'congenialTeams.personalityTest.questionnaire.title\'|translate }}</h3></div><div class=panel-body><form novalidate name=questionnaireForm><div ng-show=vm.loadingQuestionnaires class=\"row alert alert-info\" role=alert><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div ng-show=\"vm.questionnaires.length == 0\" class=\"row alert alert-danger\" role=alert><i class=\"fa fa-exclamation\"></i> {{\'Questionnaire.list.noData\'|translate}}</div><div class=form-group ng-hide=\"vm.questionnaires.length == 0\"><label>{{\'congenialTeams.personalityTest.questionnaire.select\'|translate}}</label><div><select ng-model=vm.questionnaire ng-options=\"questionnaire.name for questionnaire in vm.questionnaires track by questionnaire.id\"></select></div></div></form><ul ng-show=vm.questionnaire><li><strong>{{\'PersonalityQuestionnaire.att.name.title\'|translate}}</strong> : {{ vm.questionnaire.name }}</li><li><strong>{{\'PersonalityQuestionnaire.att.description.title\'|translate}}</strong> : {{ vm.questionnaire.description }}</li></ul></div></div><div class=\"panel panel-default\" ng-show=\"vm.questionnaire && vm.student\"><div class=\"panel-heading panel-heading-primary\"><h3 class=panel-title>{{ \'congenialTeams.personalityTest.title\'|translate }}</h3></div><div class=panel-body><span ng-if=\"vm.studentPersonalityAnswers.length == 0 && !vm.studentPersonalityAnswersError\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span><div class=\"row alert alert-danger\" role=alert ng-show=vm.studentPersonalityAnswersError><i class=\"fa fa-exclamation\"></i> {{vm.studentPersonalityAnswersError}}</div><form novalidate name=form ng-show=\"vm.studentPersonalityAnswers.length > 0\"><div class=form-group ng-repeat=\"studentAnswer in vm.studentPersonalityAnswers track by $index\"><label title={{studentAnswer.question.description}}>{{studentAnswer.question.question}}</label><md-radio-group ng-model=studentAnswer.answer class=md-primary layout=row ng-change=vm.changedStudentPersonalityAnswer(studentAnswer) title={{answer.description}}><md-radio-button ng-repeat=\"answer in studentAnswer.question.possibleAnswerValues track by answer.id\" ng-value=answer aria-label={{answer.name}}>{{answer.name}}</md-radio-button></md-radio-group></div><hr><div class=form-group><button type=button ng-click=vm.removeStudentPersonalityAnswers() class=\"btn btn-danger\"><i class=\"fa fa-eraser\"></i> {{\'congenialTeams.personalityTest.clearAnswers\'|translate}}</button></div></form></div></div></div>");
$templateCache.put("app/tool/congenialTeams/questionnaires/questionnaires.html","<div><personality-questionnaire-editor></personality-questionnaire-editor><personality-questionnaire-list></personality-questionnaire-list></div>");
$templateCache.put("app/tool/congenialTeams/questions/questions.html","<div><personality-question-editor></personality-question-editor><personality-question-list></personality-question-list></div>");
$templateCache.put("app/tool/congenialTeams/students/students.html","<div><student-editor></student-editor><student-list></student-list></div>");
$templateCache.put("app/tool/lessonPlanExecution/about/about.html","<div class=container><div class=row><div class=col-lg-12><h1 class=page-header translate=lessonPlanExecution.about.title></h1></div></div><div class=row><div class=col-lg-12 translate=lessonPlanExecution.about.description></div></div></div>");}]);